import _defineProperty from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/docsworker-xlarge/repos/cloud-docs-osb/snooty/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/es.array.reduce.js";
import { jsx, jsxs, Fragment } from 'theme-ui/jsx-runtime';
import { ThemeProvider } from '@theme-ui/core';
import { Global, css, keyframes } from '@emotion/react';
import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle, useCallback, useMemo, Fragment as Fragment$1 } from 'react';
import { get, Grid, AspectRatio } from 'theme-ui';
import { css as css$1 } from '@emotion/css';
import factory from 'codemirror-ssr';
import useClike from 'codemirror-ssr/mode/clike/clike.js';
import useCSS from 'codemirror-ssr/mode/css/css.js';
import useGo from 'codemirror-ssr/mode/go/go.js';
import useHtml from 'codemirror-ssr/mode/htmlmixed/htmlmixed.js';
import useJavascript from 'codemirror-ssr/mode/javascript/javascript.js';
import useJSX from 'codemirror-ssr/mode/jsx/jsx.js';
import useMarkdown from 'codemirror-ssr/mode/markdown/markdown.js';
import usePHP from 'codemirror-ssr/mode/php/php.js';
import usePython from 'codemirror-ssr/mode/python/python.js';
import useRuby from 'codemirror-ssr/mode/ruby/ruby.js';
import useShell from 'codemirror-ssr/mode/shell/shell.js';
import useSwift from 'codemirror-ssr/mode/swift/swift.js';
import useXML from 'codemirror-ssr/mode/xml/xml.js';
import useSimpleScrollbars from 'codemirror-ssr/addon/scroll/simplescrollbars.js';
import ImgixClient from '@imgix/js-core';
import require$$0 from 'lazysizes';
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return _assign.apply(this, arguments);
};

function __rest(s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

function __spreadArray(to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
} // DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-tokens'
// ANY CHANGES YOU MAKE HERE WILL EVENTUALLY BE OVERWRITTEN


var colors$1 = {},
    fontFamilies$1 = {},
    lineHeights$1 = {},
    fontWeights$1 = {},
    fontSizes$1 = {},
    spacing$1 = {},
    sizing$1 = {},
    borderRadius$1 = {},
    boxShadow$1 = {},
    borderWidth$1 = {},
    motion$1 = {},
    opacity$1 = {},
    icons$1 = {},
    navigation = {},
    letterSpacings = {};
colors$1.black10 = '#fafbfc';
colors$1.black15 = '#f5f7fA';
colors$1.black20 = '#e7eeec';
colors$1.black30 = '#b8c4c2';
colors$1.black40 = '#9fa1a2';
colors$1.black50 = '#5d6c74';
colors$1.black60 = '#3d4f58';
colors$1.black70 = '#21313c';
colors$1.black80 = '#061621';
colors$1.black00 = '#ffffff';
colors$1.blue05 = '#EEFDFA';
colors$1.blue10 = '#E3FCF7';
colors$1.blue20 = '#A6FFEC';
colors$1.blue30 = '#53E9F6';
colors$1.blue40 = '#00D2FF';
colors$1.blue50 = '#009FFD';
colors$1.blue60 = '#006CFA';
colors$1.blue70 = '#0D427C';
colors$1.blue80 = '#001E2B';
colors$1.purple05 = '#FBF3FF';
colors$1.purple10 = '#F9EBFF';
colors$1.purple20 = '#F2C5EE';
colors$1.purple30 = '#D38FF0';
colors$1.purple40 = '#B45AF2';
colors$1.purple50 = '#983FF9';
colors$1.purple60 = '#7C25FF';
colors$1.purple70 = '#5400F8';
colors$1.purple80 = '#2A0F91';
colors$1.green05 = '#F8FFEA';
colors$1.green10 = '#F4FFDC';
colors$1.green20 = '#E9FF99';
colors$1.green30 = '#B1FF05';
colors$1.green40 = '#00ED64';
colors$1.green50 = '#00AA57';
colors$1.green60 = '#00684A';
colors$1.green70 = '#014E3D';
colors$1.green80 = '#023430';
colors$1.yellow05 = '#FEFAE9';
colors$1.yellow10 = '#FEF7DB';
colors$1.yellow20 = '#FFEC9E';
colors$1.yellow30 = '#FBDB5A';
colors$1.yellow40 = '#FFC010';
colors$1.yellow50 = '#F28900';
colors$1.yellow60 = '#944F01';
colors$1.yellow70 = '#4C2100';
colors$1.yellow80 = '#2F1400';
colors$1.red05 = '#FFF2EF';
colors$1.red10 = '#FFEAE5';
colors$1.red20 = '#FFCDC7';
colors$1.red30 = '#FF6960';
colors$1.red40 = '#F3461F';
colors$1.red50 = '#DB3030';
colors$1.red60 = '#970606';
colors$1.red70 = '#5B0000';
colors$1.red80 = '#430404';
colors$1.text = {
  default: colors$1.blue80,
  secondary: colors$1.black50,
  inverse: colors$1.black00,
  inverseSecondary: colors$1.black30,
  error: colors$1.red50,
  errorInverse: colors$1.red30,
  neutral: colors$1.black50,
  selected: colors$1.green70,
  inverseSelected: colors$1.green40,
  mark: colors$1.green60,
  inverseMark: colors$1.green40,
  eyebrowDefault: colors$1.green60,
  eyebrowInverse: colors$1.green40,
  eyebrowInverseSecondary: colors$1.black00,
  checkbox: colors$1.green40
};
colors$1.border = {
  default: colors$1.black30,
  inverse: colors$1.black50,
  inverseDarker: colors$1.black60
};
colors$1.icon = {
  error: colors$1.red50,
  errorInverse: colors$1.red30,
  warning: colors$1.yellow40,
  branded: {
    primary: colors$1.blue80,
    secondary: colors$1.green40,
    inversePrimary: colors$1.black00,
    inverseSecondary: colors$1.green40
  },
  system: {
    default: colors$1.black60,
    defaultNeutral: colors$1.black50,
    inverse: colors$1.black00,
    inverseNeutral: colors$1.black30,
    success: colors$1.green60,
    successInverse: colors$1.green40
  }
};
colors$1.background = {
  body: colors$1.black00,
  container: colors$1.black10,
  containerLight: colors$1.black15,
  containerLighter: colors$1.black00,
  containerInverse: colors$1.blue80,
  containerInverseDarker: colors$1.black80,
  selected: colors$1.green40,
  selectedLighter: colors$1.green10,
  panel: colors$1.black00,
  selectedInverseLighter: colors$1.black60
};
colors$1.button = {
  primary: {
    bg: colors$1.green40,
    bgDisabled: colors$1.black30,
    text: colors$1.blue80,
    textDisabled: colors$1.black50,
    border: colors$1.green60,
    borderDisabled: colors$1.black70
  },
  secondary: {
    bg: colors$1.blue80,
    text: colors$1.black00
  },
  inversePrimary: {
    bg: colors$1.green40,
    bgDisabled: colors$1.black60,
    text: colors$1.blue80,
    textDisabled: colors$1.black30,
    border: colors$1.green60,
    borderDisabled: colors$1.black70
  },
  inverseSecondary: {
    bg: colors$1.black00,
    text: colors$1.blue80
  },
  utility: {
    bg: colors$1.green40,
    border: colors$1.green60,
    icon: colors$1.green80,
    iconInverse: colors$1.black00,
    borderInverse: colors$1.green40,
    bgHover: colors$1.green80,
    bgHoverInverse: colors$1.black00
  }
};
colors$1.forms = {
  textInput: {
    default: {
      bg: colors$1.black10,
      bgDisabled: colors$1.black10,
      border: colors$1.blue80,
      text: colors$1.blue80,
      label: colors$1.black50,
      labelFilled: colors$1.black60,
      icon: colors$1.blue80,
      helpText: colors$1.blue80,
      focus: {
        border: colors$1.blue60,
        label: colors$1.blue60
      },
      error: {
        label: colors$1.red50,
        border: colors$1.red50,
        icon: colors$1.red50,
        labelFocus: colors$1.red60,
        borderFocus: colors$1.red60,
        iconFocus: colors$1.red60
      }
    },
    inverse: {
      bg: colors$1.black70,
      bgDisabled: colors$1.black70,
      border: colors$1.black00,
      text: colors$1.black00,
      label: colors$1.black30,
      labelFilled: colors$1.black10,
      icon: colors$1.black00,
      helpText: colors$1.black10,
      focus: {
        border: colors$1.blue40,
        label: colors$1.blue40
      },
      error: {
        label: colors$1.red30,
        border: colors$1.red30,
        icon: colors$1.red30,
        labelFocus: colors$1.red50,
        borderFocus: colors$1.red50,
        iconFocus: colors$1.red50
      }
    }
  },
  checkbox: {
    bgSelected: colors$1.green60,
    icon: colors$1.black00,
    boxBorder: colors$1.blue80,
    bg: colors$1.black00,
    bgDisabled: colors$1.black30,
    iconDisabled: colors$1.black50,
    focusBorder: colors$1.blue60
  },
  checkboxInverse: {
    bgSelected: colors$1.green40,
    icon: colors$1.blue80,
    boxBorder: colors$1.black00,
    bg: colors$1.blue80,
    bgDisabled: colors$1.black60,
    iconDisabled: colors$1.black30,
    focusBorder: colors$1.blue40
  }
};
colors$1.link = {
  cta: {
    default: {
      text: colors$1.blue80,
      icon: colors$1.green60,
      textDisabled: colors$1.black50,
      iconDisabled: colors$1.black50,
      textHover: colors$1.green60
    },
    inverse: {
      text: colors$1.black00,
      icon: colors$1.green40,
      textHover: colors$1.green40
    }
  },
  navigation: {
    text: colors$1.black70,
    textSelected: colors$1.green50
  },
  footer: {
    text: colors$1.black00,
    textSelected: colors$1.green40
  },
  inline: {
    default: {
      text: colors$1.blue60,
      underline: colors$1.black80
    },
    inverse: {
      text: colors$1.green40,
      underline: colors$1.black00
    }
  }
};
colors$1.pill = {
  identifier: {
    primary: {
      text: colors$1.blue80,
      bgInformational: colors$1.blue10
    },
    secondary: {
      textInformational: colors$1.black00,
      bgInformational: colors$1.blue60
    },
    inverse: {
      borderInformational: colors$1.blue10,
      inverseText: colors$1.blue10
    }
  },
  badge: {
    default: {
      bg: colors$1.green30,
      text: colors$1.green70
    },
    inverse: {
      bg: colors$1.green30,
      text: colors$1.green70
    }
  }
};
colors$1.tag = {
  border: colors$1.blue60,
  text: colors$1.blue60,
  bg: colors$1.blue10,
  inverseBorder: colors$1.blue40,
  inverseText: colors$1.blue40,
  inverseBG: colors$1.blue80
};
colors$1.panels = {
  default: {
    bg: colors$1.black10,
    bgLighter: colors$1.black00,
    border: colors$1.black30
  },
  inverse: {
    bg: colors$1.black70,
    bgDarker: colors$1.black80,
    border: colors$1.black50
  },
  navigation: {
    bg: colors$1.black00,
    border: colors$1.black30
  },
  card: {
    bg: colors$1.black00,
    bgDarker: colors$1.black10,
    border: colors$1.black30
  },
  modal: {
    bg: colors$1.black00,
    bgDarker: colors$1.black10,
    border: colors$1.black30
  },
  notification: {
    bgSuccess: colors$1.green10,
    borderSuccess: colors$1.green20,
    bgAlert: colors$1.yellow10,
    borderAlert: colors$1.yellow40,
    bgNote: colors$1.blue10,
    borderNote: colors$1.blue20,
    bgDanger: colors$1.yellow20,
    borderDanger: colors$1.yellow60,
    innerSuccess: colors$1.green80,
    innerNote: colors$1.blue80,
    innerDanger: colors$1.yellow50,
    innerAlert: colors$1.yellow30
  },
  tooltip: {
    bgInverse: colors$1.black70,
    borderInverse: colors$1.black50,
    bg: colors$1.black00,
    border: colors$1.black30
  },
  popover: {
    bg: colors$1.black00,
    border: colors$1.black30,
    bgInverse: colors$1.black70,
    borderInverse: colors$1.black50
  },
  select: {
    bg: colors$1.black00,
    bgInverse: colors$1.black70,
    borderInverse: colors$1.black50,
    border: colors$1.black30
  }
};
colors$1.tabs = {
  tertiary: {
    inverse: {
      borderHover: colors$1.blue60,
      bgActive: colors$1.blue60,
      bg: colors$1.black60,
      textActive: colors$1.black00,
      textInactive: colors$1.black00
    },
    default: {
      borderHover: colors$1.blue60,
      bgActive: colors$1.blue60,
      bg: colors$1.black20,
      textActive: colors$1.black00,
      textInactive: colors$1.black80
    }
  }
};
colors$1.code = {
  bg: colors$1.black80,
  bgLines: colors$1.black70,
  lines: colors$1.blue10,
  copyBG: colors$1.black70,
  operators: colors$1.black10,
  comments: colors$1.black40,
  definitions: colors$1.yellow20,
  numbers: colors$1.purple20,
  keywords: '#FFA1A1',
  variables: colors$1.blue20,
  type: colors$1.blue20,
  strings: colors$1.yellow20,
  attributes: colors$1.green20
};
colors$1.card = {
  default: {
    bg: colors$1.black00,
    border: colors$1.black20,
    textSub: colors$1.green60,
    borderDarker: colors$1.green80
  },
  inverse: {
    bg: colors$1.blue80,
    border: colors$1.black70,
    textSub: colors$1.green40,
    borderLighter: colors$1.green40
  }
};
colors$1.header = {
  default: {
    title: colors$1.blue80,
    text: colors$1.blue80,
    eyebrow: colors$1.green60,
    bg: colors$1.black00,
    bgDarker: colors$1.black10
  },
  inverse: {
    title: colors$1.black00,
    text: colors$1.black00,
    eyebrow: colors$1.green40,
    bg: colors$1.blue80,
    bgLighter: colors$1.green80
  }
};
colors$1.list = {
  default: {
    text: colors$1.blue80,
    bullet: colors$1.blue60,
    checkmark: colors$1.green40
  },
  inverse: {
    text: colors$1.black00,
    bullet: colors$1.green40,
    checkmark: colors$1.green40
  }
};
fontFamilies$1.menlo = 'Menlo';
fontFamilies$1['akzidenz-grotesk-std'] = 'Akzidenz-Grotesk Std';
fontFamilies$1['euclid-circular-a'] = 'Euclid Circular A';
fontFamilies$1['source-code-pro'] = 'Source Code Pro';
fontFamilies$1['mongodb-value-serif'] = 'MongoDB Value Serif';
fontFamilies$1.heading = fontFamilies$1['mongodb-value-serif'];
fontFamilies$1.body = fontFamilies$1['euclid-circular-a'];
fontFamilies$1.mono = fontFamilies$1['source-code-pro'];
lineHeights$1.inc00 = 16;
lineHeights$1.inc10 = 18;
lineHeights$1.inc20 = 24;
lineHeights$1.inc30 = 32;
lineHeights$1.inc40 = 40;
lineHeights$1.inc50 = 48;
lineHeights$1.inc60 = 56;
lineHeights$1.inc70 = 64;
lineHeights$1.inc80 = 72;
lineHeights$1.inc90 = 112;
lineHeights$1.headingXXL = lineHeights$1.inc90;
lineHeights$1.headingXL = lineHeights$1.inc80;
lineHeights$1.headingL = lineHeights$1.inc70;
lineHeights$1.headingM = lineHeights$1.inc60;
lineHeights$1.headingS = lineHeights$1.inc50;
lineHeights$1.headingXS = lineHeights$1.inc30;
lineHeights$1.headingXXLResponsive = lineHeights$1.inc60;
lineHeights$1.headingXLResponsive = lineHeights$1.inc50;
lineHeights$1.headingLResponsive = lineHeights$1.inc40;
lineHeights$1.headingMResponsive = lineHeights$1.inc30;
lineHeights$1.headingSResponsive = lineHeights$1.inc30;
lineHeights$1.headingXSResponsive = lineHeights$1.inc20;
lineHeights$1.bodyL = lineHeights$1.inc30;
lineHeights$1.bodyM = lineHeights$1.inc30;
lineHeights$1.bodyS = lineHeights$1.inc20;
lineHeights$1.bodyXS = lineHeights$1.inc00;
lineHeights$1.bodyLResponsive = lineHeights$1.inc30;
lineHeights$1.bodyMResponsive = lineHeights$1.inc30;
lineHeights$1.bodySResponsive = lineHeights$1.inc20;
lineHeights$1.bodyXSResponsive = lineHeights$1.inc00;
lineHeights$1.monoL = lineHeights$1.inc30;
lineHeights$1.monoM = lineHeights$1.inc20;
lineHeights$1.monoS = lineHeights$1.inc00;
lineHeights$1.monoLResponsive = lineHeights$1.inc30;
lineHeights$1.monoMResponsive = lineHeights$1.inc20;
lineHeights$1.monoSResponsive = lineHeights$1.inc00;
fontWeights$1.medium = 'Medium';
fontWeights$1.light = 'Light';
fontWeights$1.regular = 'Regular';
fontWeights$1.bold = 'Bold';
fontWeights$1.semibold = 'Semibold';
fontSizes$1.inc00 = 12;
fontSizes$1.inc10 = 14;
fontSizes$1.inc20 = 16;
fontSizes$1.inc30 = 18;
fontSizes$1.inc40 = 20;
fontSizes$1.inc50 = 24;
fontSizes$1.inc60 = 28;
fontSizes$1.inc70 = 32;
fontSizes$1.inc80 = 36;
fontSizes$1.inc90 = 40;
fontSizes$1.inc100 = 44;
fontSizes$1.inc110 = 48;
fontSizes$1.inc120 = 56;
fontSizes$1.inc130 = 64;
fontSizes$1.inc140 = 96;
fontSizes$1.headingXXL = fontSizes$1.inc140;
fontSizes$1.headingXL = fontSizes$1.inc130;
fontSizes$1.headingL = fontSizes$1.inc120;
fontSizes$1.headingM = fontSizes$1.inc100;
fontSizes$1.headingS = fontSizes$1.inc80;
fontSizes$1.headingXS = fontSizes$1.inc50;
fontSizes$1.headingXXLResponsive = fontSizes$1.inc110;
fontSizes$1.headingXLResponsive = fontSizes$1.inc90;
fontSizes$1.headingLResponsive = fontSizes$1.inc70;
fontSizes$1.headingMResponsive = fontSizes$1.inc60;
fontSizes$1.headingSResponsive = fontSizes$1.inc50;
fontSizes$1.headingXSResponsive = fontSizes$1.inc30;
fontSizes$1.bodyL = fontSizes$1.inc40;
fontSizes$1.bodyM = fontSizes$1.inc30;
fontSizes$1.bodyS = fontSizes$1.inc20;
fontSizes$1.bodyXS = fontSizes$1.inc10;
fontSizes$1.bodyLResponsive = fontSizes$1.inc30;
fontSizes$1.bodyMResponsive = fontSizes$1.inc20;
fontSizes$1.bodySResponsive = fontSizes$1.inc10;
fontSizes$1.bodyXSResponsive = fontSizes$1.inc10;
fontSizes$1.monoL = fontSizes$1.inc20;
fontSizes$1.monoM = fontSizes$1.inc10;
fontSizes$1.monoS = fontSizes$1.inc00;
fontSizes$1.monoLResponsive = fontSizes$1.inc20;
fontSizes$1.monoMResponsive = fontSizes$1.inc10;
fontSizes$1.monoSResponsive = fontSizes$1.inc00;
spacing$1.base = 8;
spacing$1.inc00 = 0;
spacing$1.neg00 = 0;
spacing$1.section00 = spacing$1.base;
spacing$1.section10 = spacing$1.base * 2;
spacing$1.section20 = spacing$1.base * 3;
spacing$1.section30 = spacing$1.base * 6;
spacing$1.section40 = spacing$1.base * 8;
spacing$1.section50 = spacing$1.base * 12;
spacing$1.section60 = spacing$1.base * 14;
spacing$1.inc10 = spacing$1.base * 0.5;
spacing$1.inc20 = spacing$1.base * 1;
spacing$1.inc30 = spacing$1.base * 2;
spacing$1.inc40 = spacing$1.base * 3;
spacing$1.inc50 = spacing$1.base * 4;
spacing$1.inc60 = spacing$1.base * 5;
spacing$1.inc70 = spacing$1.base * 6;
spacing$1.inc80 = spacing$1.base * 7;
spacing$1.inc90 = spacing$1.base * 8;
spacing$1.inc100 = spacing$1.base * 9;
spacing$1.inc110 = spacing$1.base * 10;
spacing$1.inc120 = spacing$1.base * 11;
spacing$1.inc130 = spacing$1.base * 12;
spacing$1.inc140 = spacing$1.base * 13;
spacing$1.inc150 = spacing$1.base * 14;
spacing$1.inc160 = spacing$1.base * 15;
spacing$1.neg10 = spacing$1.base * -0.5;
spacing$1.neg20 = spacing$1.base * -1;
spacing$1.neg30 = spacing$1.base * -2;
spacing$1.neg40 = spacing$1.base * -3;
spacing$1.neg50 = spacing$1.base * -4;
spacing$1.neg60 = spacing$1.base * -5;
spacing$1.neg70 = spacing$1.base * -6;
spacing$1.neg80 = spacing$1.base * -7;
spacing$1.neg90 = spacing$1.base * -8;
spacing$1.sectionGapZero = spacing$1.inc00;
spacing$1.sectionGapXXSmall = spacing$1.section00;
spacing$1.sectionGapXSmall = spacing$1.section10;
spacing$1.sectionGapSmall = spacing$1.section20;
spacing$1.sectionGapMedium = spacing$1.section30;
spacing$1.sectionGapLarge = spacing$1.section40;
spacing$1.sectionGapXLarge = spacing$1.section50;
spacing$1.sectionGapXXLarge = spacing$1.section60;
spacing$1.elementZero = spacing$1.inc00;
spacing$1.elementXSmall = spacing$1.inc30;
spacing$1.elementSmall = spacing$1.inc40;
spacing$1.elementMedium = spacing$1.inc50;
spacing$1.elementLarge = spacing$1.inc60;
spacing$1.elementXLarge = spacing$1.inc70;
spacing$1.colGapSmall = spacing$1.inc30;
spacing$1.colGapMedium = spacing$1.inc40;
spacing$1.outsideGutterSmall = spacing$1.inc40;
spacing$1.outsideGutterMedium = spacing$1.inc50;
spacing$1.outsideGutterLarge = spacing$1.inc70;
spacing$1.cards = {
  paddingXXS: spacing$1.inc40,
  paddingXS: spacing$1.inc50,
  paddingS: spacing$1.inc60,
  paddingM: spacing$1.inc70,
  paddingL: spacing$1.inc80,
  paddingXL: spacing$1.inc110,
  paddingXXL: spacing$1.inc160
};
spacing$1.responsive = {
  verticalGap: {
    sectionZero: {
      small: 0,
      medium: 0,
      large: 0,
      xlarge: 0,
      xxlarge: 0
    },
    sectionXXSmall: {
      small: spacing$1.section00,
      medium: spacing$1.section00,
      large: spacing$1.section00,
      xlarge: spacing$1.section00,
      xxlarge: spacing$1.section00
    },
    sectionXSmall: {
      small: spacing$1.section10,
      medium: spacing$1.section10,
      large: spacing$1.section10,
      xlarge: spacing$1.section10,
      xxlarge: spacing$1.section10
    },
    sectionSmall: {
      small: spacing$1.section20,
      medium: spacing$1.section20,
      large: spacing$1.section20,
      xlarge: spacing$1.section20,
      xxlarge: spacing$1.section20
    },
    sectionMedium: {
      small: spacing$1.section30,
      medium: spacing$1.section30,
      large: spacing$1.section30,
      xlarge: spacing$1.section30,
      xxlarge: spacing$1.section30
    },
    sectionLarge: {
      small: spacing$1.sectionGapMedium,
      medium: spacing$1.sectionGapMedium,
      large: spacing$1.section40,
      xlarge: spacing$1.section40,
      xxlarge: spacing$1.section40
    },
    sectionXLarge: {
      small: spacing$1.inc80,
      medium: spacing$1.inc80,
      large: spacing$1.section50,
      xlarge: spacing$1.section50,
      xxlarge: spacing$1.section50
    },
    sectionXXLarge: {
      small: spacing$1.sectionGapLarge,
      medium: spacing$1.sectionGapLarge,
      large: spacing$1.section60,
      xlarge: spacing$1.section60,
      xxlarge: spacing$1.section60
    }
  },
  columnGap: {
    tight: {
      small: spacing$1.inc20,
      medium: spacing$1.inc30,
      large: spacing$1.inc40,
      xlarge: spacing$1.inc40,
      xxlarge: spacing$1.inc40
    },
    normal: {
      small: spacing$1.inc30,
      medium: spacing$1.inc50,
      large: spacing$1.inc70,
      xlarge: spacing$1.inc70,
      xxlarge: spacing$1.inc70
    },
    loose: {
      small: spacing$1.inc40,
      medium: spacing$1.inc60,
      large: spacing$1.inc90,
      xlarge: spacing$1.inc90,
      xxlarge: spacing$1.inc90
    },
    huge: {
      small: spacing$1.inc60,
      medium: spacing$1.inc80,
      large: spacing$1.inc130,
      xlarge: spacing$1.inc130,
      xxlarge: spacing$1.inc130
    }
  },
  cells: {
    normal: {
      vertical: {
        small: spacing$1.inc40,
        medium: spacing$1.inc50,
        large: spacing$1.inc70,
        xlarge: spacing$1.inc70
      },
      left: {
        small: spacing$1.inc30,
        medium: spacing$1.inc30,
        large: spacing$1.inc30,
        xlarge: spacing$1.inc30,
        xxlarge: spacing$1.inc30
      },
      right: {
        small: spacing$1.inc30,
        medium: spacing$1.inc30,
        large: spacing$1.inc30,
        xlarge: spacing$1.inc30,
        xxlarge: spacing$1.inc30
      }
    },
    tight: {
      vertical: {
        small: spacing$1.inc20,
        medium: spacing$1.inc40,
        large: spacing$1.inc40,
        xlarge: spacing$1.inc40,
        xxlarge: spacing$1.inc40
      },
      left: {
        small: spacing$1.inc30,
        medium: spacing$1.inc30,
        large: spacing$1.inc30,
        xlarge: spacing$1.inc30,
        xxlarge: spacing$1.inc30
      },
      right: {
        small: spacing$1.inc30,
        medium: spacing$1.inc30,
        large: spacing$1.inc30,
        xlarge: spacing$1.inc30,
        xxlarge: spacing$1.inc30
      }
    }
  }
};
sizing$1.base = 8;
sizing$1.maxWidthDesktop = 1416;
sizing$1.inc00 = sizing$1.base * 0.5;
sizing$1.inc10 = sizing$1.base * 2;
sizing$1.inc20 = sizing$1.base * 3;
sizing$1.inc30 = sizing$1.base * 4;
sizing$1.inc40 = sizing$1.base * 5;
sizing$1.inc50 = sizing$1.base * 6;
sizing$1.inc60 = sizing$1.base * 7;
sizing$1.inc70 = sizing$1.base * 8;
sizing$1.inc80 = sizing$1.base * 9;
sizing$1.inc90 = sizing$1.base * 10;
sizing$1.inc100 = sizing$1.base * 11;
sizing$1.systemIconLarge = sizing$1.inc30;
sizing$1.systemIconMedium = sizing$1.inc20;
sizing$1.systemIconSmall = sizing$1.inc10;
sizing$1.systemIconXSmall = sizing$1.inc00 * 3;
sizing$1.codeSnippetSmall = sizing$1.base * 35;
sizing$1.codeSnippetMedium = sizing$1.base * 60;
sizing$1.codeSnippetLarge = sizing$1.base * 90;
sizing$1.brandedIconSmall = sizing$1.inc50;
sizing$1.brandedIconMedium = sizing$1.inc70;
sizing$1.brandedIconLarge = sizing$1.inc90;
sizing$1.breakpoint = {
  small: 460,
  medium: 768,
  large: 1024,
  xlarge: 1280,
  xxlarge: 1440
};
borderRadius$1.circle = 999;
borderRadius$1.inc00 = 0;
borderRadius$1.inc10 = 2;
borderRadius$1.inc20 = 4;
borderRadius$1.inc30 = 8;
borderRadius$1.inc40 = 16;
borderRadius$1.inc50 = 24;
borderRadius$1.inc60 = 32;
borderRadius$1.inc70 = 40;
borderRadius$1.inc80 = 56;
borderRadius$1.inc90 = 72;
borderRadius$1.inc100 = 88;
borderRadius$1.inc110 = 104;
borderRadius$1.buttons = borderRadius$1.inc20;
borderRadius$1.input = borderRadius$1.inc20;
borderRadius$1.modal = borderRadius$1.inc20;
borderRadius$1.tooltips = borderRadius$1.inc20;
borderRadius$1.notification = borderRadius$1.inc20;
borderRadius$1.card = borderRadius$1.inc70;
borderRadius$1.cardResponsive = borderRadius$1.inc50;
borderRadius$1.codePanel = borderRadius$1.inc60;
borderRadius$1.buttonHover = borderRadius$1.inc70;
borderRadius$1.scrollyStoryCard = borderRadius$1.inc50;
borderRadius$1.scrollyStoryCardResponsive = borderRadius$1.inc40;
boxShadow$1.level00 = {
  x: 0,
  y: 0,
  spread: 0,
  color: '#000000',
  blur: 0
};
boxShadow$1.level01 = {
  x: 0,
  y: 2,
  spread: 0,
  color: 'rgba(0,0,0,.1)',
  blur: 4
};
boxShadow$1.level02 = {
  x: 0,
  y: 3,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 9
};
boxShadow$1.level03 = {
  x: 0,
  y: 3,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 20
};
boxShadow$1.level04 = {
  x: 0,
  y: 6,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 30
};
boxShadow$1.buttonHover = {
  x: 0,
  y: 0,
  spread: 3,
  blur: 0,
  color: 'rgba(242, 197, 238, 1)'
};
boxShadow$1.buttonHoverInverse = {
  x: 0,
  y: 0,
  spread: 3,
  color: 'rgba(244, 255, 220, .4)',
  blur: 0
};
boxShadow$1.tagHover = {
  x: 0,
  y: 0,
  spread: 3,
  blur: 0,
  color: 'rgba(0, 108, 250, .4)'
};
boxShadow$1.tagHoverInverse = {
  x: 0,
  y: 0,
  spread: 3,
  color: 'rgba(166, 225, 236, .4)',
  blur: 0
};
borderWidth$1.inc00 = 0;
borderWidth$1.inc10 = 1;
borderWidth$1.inc20 = 2;
borderWidth$1.inc30 = 3;
borderWidth$1.ruleBreak = borderWidth$1.inc10;
borderWidth$1.inputs = borderWidth$1.inc10;
borderWidth$1.systemIconSmall = borderWidth$1.inc10;
borderWidth$1.systemIconMedium = borderWidth$1.inc20;
borderWidth$1.systemIconLarge = borderWidth$1.inc20;
motion$1.inc00 = 100;
motion$1.inc10 = 200;
motion$1.inc20 = 250;
motion$1.inc30 = 300;
motion$1.inc40 = 350;
motion$1.linkAnimation = motion$1.inc30;
motion$1.mobileNavPanel = motion$1.inc30;
motion$1.mobileNavItemExpand = motion$1.inc30;
motion$1.tag = motion$1.inc00;
motion$1.codeSnippetCopyFade = motion$1.inc30 * 10;
motion$1.accordion = motion$1.inc40;
opacity$1.inc00 = '0%';
opacity$1.inc10 = '8%';
opacity$1.inc20 = '20%';
opacity$1.inc30 = '30%';
opacity$1.inc40 = '40%';
opacity$1.inc50 = '50%';
opacity$1.inc60 = '60%';
opacity$1.inc70 = '70%';
opacity$1.inc80 = '80%';
opacity$1.inc90 = '90%';
opacity$1.inc100 = '100%';
opacity$1.modalScrim = opacity$1.inc50;
icons$1.branded = {
  thin: borderWidth$1.inc10,
  medium: borderWidth$1.inc20,
  thick: borderWidth$1.inc30
};
navigation.default = {
  activeIndicator: colors$1.green40,
  bgPanel: '#F5F7FA',
  rule: colors$1.green70,
  l1: {
    text: colors$1.blue80,
    textHover: colors$1.green60,
    bgHover: colors$1.green80,
    mobile: {
      icon: colors$1.green60,
      seperator: colors$1.black20
    }
  },
  l2: {
    link: colors$1.blue80,
    linkHover: colors$1.green60,
    icon: colors$1.green60,
    description: colors$1.green60,
    mobile: {
      link: colors$1.green60
    }
  },
  l3: {
    link: colors$1.blue80,
    linkHover: colors$1.green60,
    icon: colors$1.green60
  }
};
navigation.inverse = {
  activeIndicator: colors$1.green40,
  bgPanel: colors$1.black60,
  rule: colors$1.black00,
  l1: {
    text: colors$1.black00,
    textHover: colors$1.green40,
    bgHover: colors$1.black00,
    mobile: {
      icon: colors$1.green40,
      seperator: colors$1.black60
    }
  },
  l2: {
    link: colors$1.black00,
    linkHover: colors$1.green40,
    icon: colors$1.green40,
    description: colors$1.black30,
    mobile: {
      link: colors$1.green40
    }
  },
  l3: {
    link: colors$1.black00,
    linkHover: colors$1.green40,
    icon: colors$1.green40
  }
};
letterSpacings.eyebrow = 3;
var defaultTokens = /*#__PURE__*/Object.freeze({
  __proto__: null,
  colors: colors$1,
  fontFamilies: fontFamilies$1,
  lineHeights: lineHeights$1,
  fontWeights: fontWeights$1,
  fontSizes: fontSizes$1,
  spacing: spacing$1,
  sizing: sizing$1,
  borderRadius: borderRadius$1,
  boxShadow: boxShadow$1,
  borderWidth: borderWidth$1,
  motion: motion$1,
  opacity: opacity$1,
  icons: icons$1,
  navigation: navigation,
  letterSpacings: letterSpacings
});

var transformToUnit = function transformToUnit(token, unit) {
  return Object.entries(token).reduce(function (acc, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, typeof value === 'object' ? transformToUnit(value, unit) : "".concat(value).concat(unit)));
  }, {});
};

var transformToArrays = function transformToArrays(token) {
  return Object.entries(token).reduce(function (acc, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        name = _ref4[0],
        value = _ref4[1];

    var values = Object.values(value);
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, name, values.length > 0 && typeof values[0] === 'number' ? Object.values(value) : typeof value === 'object' ? transformToArrays(value) : []));
  }, {});
}; // format box shadow tokens to box shadow css shorthand


var formatToBoxShadow = function formatToBoxShadow(boxShadow) {
  return Object.entries(boxShadow).reduce(function (acc, _ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        name = _ref6[0],
        _ref6$ = _ref6[1],
        x = _ref6$.x,
        y = _ref6$.y,
        spread = _ref6$.spread,
        color = _ref6$.color,
        blur = _ref6$.blur;

    /* offset-x | offset-y | blur-radius | spread-radius | color */
    acc[name] = "".concat(x, "px ").concat(y, "px ").concat(blur, "px ").concat(spread, "px ").concat(color);
    return acc;
  }, {});
};

var convertToPx = function convertToPx(token) {
  return transformToUnit(token, 'px');
};

var convertToMs = function convertToMs(token) {
  return transformToUnit(token, 'ms');
};

var shadows$1 = formatToBoxShadow(boxShadow$1);
var borders$1 = convertToPx(borderWidth$1);
var defaultTheme = {
  colors: colors$1,
  shadows: shadows$1,
  borders: borders$1,
  fonts: fontFamilies$1,
  fontWeights: fontWeights$1,
  sizes: convertToPx(sizing$1),
  radii: convertToPx(borderRadius$1),
  lineHeights: convertToPx(lineHeights$1),
  fontSizes: convertToPx(fontSizes$1),
  space: convertToPx(spacing$1),
  responsive: transformToArrays(spacing$1.responsive),
  borderWidths: borders$1,
  breakpoints: Object.values(convertToPx(sizing$1.breakpoint)),
  motion: convertToMs(motion$1),
  opacity: opacity$1,
  letterSpacings: convertToPx(letterSpacings)
}; // DO NOT EDIT THIS FILE DIRECTLY. IT IS THE RESULT OF RUNNING 'npm run import-tokens'
// ANY CHANGES YOU MAKE HERE WILL EVENTUALLY BE OVERWRITTEN

var colors = {},
    fontFamilies = {},
    lineHeights = {},
    fontWeights = {},
    fontSizes = {},
    spacing = {},
    sizing = {},
    borderRadius = {},
    boxShadow = {},
    borderWidth = {},
    motion = {},
    opacity = {},
    icons = {};
colors.black10 = '#fafafa';
colors.black20 = '#e7eeec';
colors.black30 = '#b8c4c2';
colors.black40 = '#9fa1a2';
colors.black50 = '#5d6c74';
colors.black70 = '#3d4f58';
colors.black80 = '#21313c';
colors.black90 = '#061621';
colors.black00 = '#ffffff';
colors.blue10 = '#e1f2f6';
colors.blue20 = '#cfe4f2';
colors.blue40 = '#7acfdd';
colors.blue50 = '#2f9fc5';
colors.blue70 = '#007cad';
colors.blue80 = '#1a567e';
colors.blue90 = '#0d324f';
colors.purple10 = '#f1f0fc';
colors.purple20 = '#d5d4f9';
colors.purple40 = '#9795f9';
colors.purple50 = '#6e60f9';
colors.purple70 = '#4f4fbf';
colors.purple80 = '#36367f';
colors.purple90 = '#273359';
colors.green10 = '#e7f2eb';
colors.green20 = '#b9eacd';
colors.green30 = '#83dba7';
colors.green40 = '#0ad05b';
colors.green50 = '#13AA52';
colors.green70 = '#09804c';
colors.green80 = '#116149';
colors.green90 = '#0b3b35';
colors.red10 = '#ffe1ea';
colors.red20 = '#f4bdca';
colors.red40 = '#ef8f9d';
colors.red50 = '#ea5c76';
colors.red70 = '#d83a6c';
colors.red80 = '#a53060';
colors.red90 = '#70234a';
colors.orange10 = '#fcebe2';
colors.orange20 = '#f9d3c5';
colors.orange40 = '#f7a765';
colors.orange50 = '#f97216';
colors.orange70 = '#cf4a22';
colors.orange80 = '#8f221b';
colors.orange90 = '#570b08';
colors.yellow10 = '#fef7e3';
colors.yellow20 = '#fef2c8';
colors.yellow40 = '#ffeb99';
colors.yellow50 = '#ffdd49';
colors.yellow70 = '#a49437';
colors.yellow80 = '#86681d';
colors.yellow90 = '#543e07';
colors.magenta10 = '#f9edf3';
colors.magenta20 = '#f4bde5';
colors.magenta40 = '#dd85bb';
colors.magenta50 = '#d4459c';
colors.magenta70 = '#b2478e';
colors.magenta80 = '#7f336a';
colors.magenta90 = '#592446';
colors.text = {
  default: colors.black80,
  secondary: colors.black50,
  inverse: colors.black00,
  inverseSecondary: colors.black30,
  error: colors.red70,
  errorInverse: colors.red50,
  neutral: colors.black50,
  selected: colors.green70,
  inverseSelected: colors.green40,
  mark: colors.green70,
  inverseMark: colors.green40
};
colors.border = {
  default: colors.black30,
  inverse: colors.black50,
  inverseDarker: colors.black70
};
colors.icon = {
  error: colors.red70,
  errorInverse: colors.red50,
  warning: colors.yellow50,
  branded: {
    primary: colors.green50,
    secondary: colors.green80,
    tertiary: colors.purple50,
    inversePrimary: colors.green40,
    inverseSecondary: colors.black00
  },
  system: {
    default: colors.black70,
    defaultNeutral: colors.black50,
    inverse: colors.black00,
    inverseNeutral: colors.black30,
    success: colors.green50,
    successInverse: colors.green40
  }
};
colors.background = {
  body: colors.black00,
  container: colors.black10,
  containerLighter: colors.black00,
  containerInverse: colors.black80,
  containerInverseDarker: colors.black90,
  selected: colors.green50,
  selectedLighter: colors.green10,
  panel: colors.black00,
  selectedInverseLighter: colors.black70
};
colors.button = {
  primary: {
    bg: colors.green50,
    bgLighter: colors.green40,
    bgDarker: colors.green70,
    bgDisabled: colors.black30,
    text: colors.black00,
    textDisabled: colors.black50
  },
  secondary: {
    bg: colors.black00,
    bgDarker: colors.black10,
    bgDisabled: colors.black30,
    text: colors.green50,
    border: colors.green50
  },
  inversePrimary: {
    bg: colors.green40,
    bgDarker: colors.black10,
    bgDisabled: colors.black70,
    text: colors.black90,
    textDisabled: colors.black30,
    bgLighter: colors.green30
  },
  inverseSecondary: {
    bg: colors.black80,
    bgLighter: colors.black70,
    bgDisabled: colors.black70,
    text: colors.green40,
    textDisabled: colors.black30,
    border: colors.green40
  },
  faux: {
    text: colors.green50,
    textActive: colors.green80
  },
  inversefaux: {
    text: colors.green40,
    textActive: colors.green30
  }
};
colors.input = {
  default: {
    bg: colors.black00,
    bgDisabled: colors.black10,
    border: colors.black30,
    borderError: colors.red70,
    text: colors.text.default,
    textSecondary: colors.text.secondary,
    textError: colors.text.error
  },
  inverse: {
    bg: colors.black80,
    bgDisabled: colors.black70,
    border: colors.black50,
    borderError: colors.red50,
    text: colors.text.inverse,
    textSecondary: colors.text.inverseSecondary,
    textError: colors.text.errorInverse
  }
};
colors.link = {
  cta: {
    default: {
      text: colors.black80,
      icon: colors.green50,
      textDisabled: colors.black50,
      iconDisabled: colors.black50
    },
    inverse: {
      text: colors.black00,
      icon: colors.green40
    }
  },
  navigation: {
    text: colors.black80,
    textSelected: colors.green50
  },
  footer: {
    text: colors.black00,
    textSelected: colors.green40
  },
  inline: {
    default: {
      text: colors.green50,
      underline: colors.green50
    },
    inverse: {
      text: colors.green40,
      underline: colors.black00
    }
  }
};
colors.pill = {
  identifier: {
    primary: {
      text: colors.black90,
      bgInformational: colors.blue20,
      bgCritical: colors.red10
    },
    secondary: {
      textInformational: colors.black00,
      bgInformational: colors.blue70,
      bgCritical: colors.red70
    },
    inverse: {
      borderInformational: colors.blue20,
      inverseText: colors.blue20
    }
  },
  badge: {
    default: {
      bg: colors.green40,
      text: colors.green90
    },
    inverse: {
      bg: colors.green40,
      text: colors.black90
    }
  }
};
colors.tag = {
  border: colors.blue50,
  text: colors.blue50,
  bg: colors.blue20,
  inverseBorder: colors.blue20,
  inverseText: colors.blue20,
  inverseBG: colors.blue90
};
colors.panels = {
  default: {
    bg: colors.black10,
    bgLighter: colors.black00,
    border: colors.black30
  },
  inverse: {
    bg: colors.black80,
    bgDarker: colors.black90,
    border: colors.black50
  },
  navigation: {
    bg: colors.black00,
    border: colors.black30
  },
  card: {
    bg: colors.black00,
    bgDarker: colors.black10,
    border: colors.black30
  },
  modal: {
    bg: colors.black00,
    bgDarker: colors.black10,
    border: colors.black30
  },
  notification: {
    bgSuccess: colors.green10,
    borderSuccess: colors.green20,
    bgAlert: colors.yellow10,
    borderAlert: colors.yellow40,
    bgNote: colors.blue10,
    borderNote: colors.blue20,
    bgDanger: colors.orange10,
    borderDanger: colors.orange20,
    innerSuccess: colors.green80,
    innerNote: colors.blue80,
    innerDanger: colors.orange80,
    innerAlert: colors.yellow90
  },
  tooltip: {
    bgInverse: colors.black80,
    borderInverse: colors.black50,
    bg: colors.black00,
    border: colors.black30
  },
  popover: {
    bg: colors.black00,
    border: colors.black30,
    bgInverse: colors.black80,
    borderInverse: colors.black50
  },
  select: {
    bg: colors.black00,
    bgInverse: colors.black80,
    borderInverse: colors.black50,
    border: colors.black30
  }
};
colors.tabs = {
  tertiary: {
    borderHover: colors.blue70,
    bgActive: colors.blue70,
    bg: colors.black20,
    bgInverse: colors.black70
  }
};
colors.code = {
  bg: colors.black80,
  bgLines: colors.black90
};
colors.card = {
  default: {
    bg: colors.black00,
    border: colors.black30,
    textSub: colors.green70,
    borderDarker: colors.green90
  },
  inverse: {
    bg: colors.black80,
    border: colors.black70,
    textSub: colors.green40,
    borderLighter: colors.green40
  }
};
fontFamilies.menlo = 'Menlo';
fontFamilies['akzidenz-grotesk-std'] = 'Akzidenz-Grotesk Std';
fontFamilies['euclid-circular-a'] = 'Euclid Circular A';
fontFamilies['source-code-pro'] = 'Source Code Pro';
fontFamilies['mongodb-value-serif'] = 'MongoDB Value Serif';
fontFamilies.heading = fontFamilies['akzidenz-grotesk-std'];
fontFamilies.body = fontFamilies['akzidenz-grotesk-std'];
fontFamilies.mono = fontFamilies['source-code-pro'];
lineHeights.inc00 = 16;
lineHeights.inc10 = 18;
lineHeights.inc20 = 24;
lineHeights.inc30 = 32;
lineHeights.inc40 = 40;
lineHeights.inc50 = 48;
lineHeights.inc60 = 56;
lineHeights.inc70 = 64;
lineHeights.inc80 = 72;
lineHeights.inc90 = 112;
lineHeights.headingXXL = lineHeights.inc90;
lineHeights.headingXL = lineHeights.inc80;
lineHeights.headingL = lineHeights.inc70;
lineHeights.headingM = lineHeights.inc60;
lineHeights.headingS = lineHeights.inc50;
lineHeights.headingXS = lineHeights.inc30;
lineHeights.headingXXLResponsive = lineHeights.inc60;
lineHeights.headingXLResponsive = lineHeights.inc50;
lineHeights.headingLResponsive = lineHeights.inc40;
lineHeights.headingMResponsive = lineHeights.inc30;
lineHeights.headingSResponsive = lineHeights.inc30;
lineHeights.headingXSResponsive = lineHeights.inc20;
lineHeights.bodyL = lineHeights.inc30;
lineHeights.bodyM = lineHeights.inc30;
lineHeights.bodyS = lineHeights.inc20;
lineHeights.bodyXS = lineHeights.inc00;
lineHeights.bodyLResponsive = lineHeights.inc30;
lineHeights.bodyMResponsive = lineHeights.inc30;
lineHeights.bodySResponsive = lineHeights.inc20;
lineHeights.bodyXSResponsive = lineHeights.inc00;
lineHeights.monoL = lineHeights.inc30;
lineHeights.monoM = lineHeights.inc20;
lineHeights.monoS = lineHeights.inc00;
lineHeights.monoLResponsive = lineHeights.inc30;
lineHeights.monoMResponsive = lineHeights.inc20;
lineHeights.monoSResponsive = lineHeights.inc00;
fontWeights.medium = 'Medium';
fontWeights.light = 'Light';
fontWeights.regular = 'Regular';
fontWeights.bold = 'Bold';
fontWeights.semibold = 'Semibold';
fontSizes.inc00 = 12;
fontSizes.inc10 = 14;
fontSizes.inc20 = 16;
fontSizes.inc30 = 18;
fontSizes.inc40 = 20;
fontSizes.inc50 = 24;
fontSizes.inc60 = 28;
fontSizes.inc70 = 32;
fontSizes.inc80 = 36;
fontSizes.inc90 = 40;
fontSizes.inc100 = 44;
fontSizes.inc110 = 48;
fontSizes.inc120 = 56;
fontSizes.inc130 = 64;
fontSizes.inc140 = 96;
fontSizes.headingXXL = fontSizes.inc140;
fontSizes.headingXL = fontSizes.inc130;
fontSizes.headingL = fontSizes.inc120;
fontSizes.headingM = fontSizes.inc100;
fontSizes.headingS = fontSizes.inc80;
fontSizes.headingXS = fontSizes.inc50;
fontSizes.headingXXLResponsive = fontSizes.inc110;
fontSizes.headingXLResponsive = fontSizes.inc90;
fontSizes.headingLResponsive = fontSizes.inc70;
fontSizes.headingMResponsive = fontSizes.inc60;
fontSizes.headingSResponsive = fontSizes.inc50;
fontSizes.headingXSResponsive = fontSizes.inc30;
fontSizes.bodyL = fontSizes.inc40;
fontSizes.bodyM = fontSizes.inc30;
fontSizes.bodyS = fontSizes.inc20;
fontSizes.bodyXS = fontSizes.inc10;
fontSizes.bodyLResponsive = fontSizes.inc30;
fontSizes.bodyMResponsive = fontSizes.inc20;
fontSizes.bodySResponsive = fontSizes.inc10;
fontSizes.bodyXSResponsive = fontSizes.inc10;
fontSizes.monoL = fontSizes.inc20;
fontSizes.monoM = fontSizes.inc10;
fontSizes.monoS = fontSizes.inc00;
fontSizes.monoLResponsive = fontSizes.inc20;
fontSizes.monoMResponsive = fontSizes.inc10;
fontSizes.monoSResponsive = fontSizes.inc00;
spacing.base = 8;
spacing.inc00 = 0;
spacing.neg00 = 0;
spacing.section00 = spacing.base;
spacing.section10 = spacing.base * 2;
spacing.section20 = spacing.base * 3;
spacing.section30 = spacing.base * 6;
spacing.section40 = spacing.base * 8;
spacing.section50 = spacing.base * 12;
spacing.section60 = spacing.base * 14;
spacing.inc10 = spacing.base * 0.5;
spacing.inc20 = spacing.base * 1;
spacing.inc30 = spacing.base * 2;
spacing.inc40 = spacing.base * 3;
spacing.inc50 = spacing.base * 4;
spacing.inc60 = spacing.base * 5;
spacing.inc70 = spacing.base * 6;
spacing.inc80 = spacing.base * 7;
spacing.inc90 = spacing.base * 8;
spacing.inc100 = spacing.base * 9;
spacing.inc110 = spacing.base * 10;
spacing.inc120 = spacing.base * 11;
spacing.inc130 = spacing.base * 12;
spacing.inc140 = spacing.base * 13;
spacing.inc150 = spacing.base * 14;
spacing.inc160 = spacing.base * 15;
spacing.neg10 = spacing.base * -0.5;
spacing.neg20 = spacing.base * -1;
spacing.neg30 = spacing.base * -2;
spacing.neg40 = spacing.base * -3;
spacing.neg50 = spacing.base * -4;
spacing.neg60 = spacing.base * -5;
spacing.neg70 = spacing.base * -6;
spacing.neg80 = spacing.base * -7;
spacing.neg90 = spacing.base * -8;
spacing.sectionGapZero = spacing.inc00;
spacing.sectionGapXXSmall = spacing.section00;
spacing.sectionGapXSmall = spacing.section10;
spacing.sectionGapSmall = spacing.section20;
spacing.sectionGapMedium = spacing.section30;
spacing.sectionGapLarge = spacing.section40;
spacing.sectionGapXLarge = spacing.section50;
spacing.sectionGapXXLarge = spacing.section60;
spacing.elementZero = spacing.inc00;
spacing.elementXSmall = spacing.inc30;
spacing.elementSmall = spacing.inc40;
spacing.elementMedium = spacing.inc50;
spacing.elementLarge = spacing.inc60;
spacing.elementXLarge = spacing.inc70;
spacing.colGapSmall = spacing.inc30;
spacing.colGapMedium = spacing.inc40;
spacing.outsideGutterSmall = spacing.inc40;
spacing.outsideGutterMedium = spacing.inc50;
spacing.outsideGutterLarge = spacing.inc70;
spacing.cards = {
  paddingXXS: spacing.inc40,
  paddingXS: spacing.inc50,
  paddingS: spacing.inc60,
  paddingM: spacing.inc70,
  paddingL: spacing.inc80,
  paddingXL: spacing.inc110,
  paddingXXL: spacing.inc160
};
spacing.responsive = {
  verticalGap: {
    sectionZero: {
      small: 0,
      medium: 0,
      large: 0,
      xlarge: 0,
      xxlarge: 0
    },
    sectionXXSmall: {
      small: spacing.section00,
      medium: spacing.section00,
      large: spacing.section00,
      xlarge: spacing.section00,
      xxlarge: spacing.section00
    },
    sectionXSmall: {
      small: spacing.section10,
      medium: spacing.section10,
      large: spacing.section10,
      xlarge: spacing.section10,
      xxlarge: spacing.section10
    },
    sectionSmall: {
      small: spacing.section20,
      medium: spacing.section20,
      large: spacing.section20,
      xlarge: spacing.section20,
      xxlarge: spacing.section20
    },
    sectionMedium: {
      small: spacing.section30,
      medium: spacing.section30,
      large: spacing.section30,
      xlarge: spacing.section30,
      xxlarge: spacing.section30
    },
    sectionLarge: {
      small: spacing.sectionGapMedium,
      medium: spacing.sectionGapMedium,
      large: spacing.section40,
      xlarge: spacing.section40,
      xxlarge: spacing.section40
    },
    sectionXLarge: {
      small: spacing.inc80,
      medium: spacing.inc80,
      large: spacing.section50,
      xlarge: spacing.section50,
      xxlarge: spacing.section50
    },
    sectionXXLarge: {
      small: spacing.sectionGapLarge,
      medium: spacing.sectionGapLarge,
      large: spacing.section60,
      xlarge: spacing.section60,
      xxlarge: spacing.section60
    }
  },
  columnGap: {
    tight: {
      small: spacing.inc20,
      medium: spacing.inc30,
      large: spacing.inc40,
      xlarge: spacing.inc40,
      xxlarge: spacing.inc40
    },
    normal: {
      small: spacing.inc30,
      medium: spacing.inc50,
      large: spacing.inc70,
      xlarge: spacing.inc70,
      xxlarge: spacing.inc70
    },
    loose: {
      small: spacing.inc40,
      medium: spacing.inc60,
      large: spacing.inc90,
      xlarge: spacing.inc90,
      xxlarge: spacing.inc90
    },
    huge: {
      small: spacing.inc60,
      medium: spacing.inc80,
      large: spacing.inc130,
      xlarge: spacing.inc130,
      xxlarge: spacing.inc130
    }
  }
};
sizing.base = 8;
sizing.maxWidthDesktop = 1416;
sizing.inc00 = sizing.base * 0.5;
sizing.inc10 = sizing.base * 2;
sizing.inc20 = sizing.base * 3;
sizing.inc30 = sizing.base * 4;
sizing.inc40 = sizing.base * 5;
sizing.inc50 = sizing.base * 6;
sizing.inc60 = sizing.base * 7;
sizing.inc70 = sizing.base * 8;
sizing.inc80 = sizing.base * 9;
sizing.inc90 = sizing.base * 10;
sizing.inc100 = sizing.base * 11;
sizing.systemIconLarge = sizing.inc30;
sizing.systemIconMedium = sizing.inc20;
sizing.systemIconSmall = sizing.inc10;
sizing.codeSnippetSmall = sizing.base * 35;
sizing.codeSnippetMedium = sizing.base * 60;
sizing.codeSnippetLarge = sizing.base * 90;
sizing.brandedIconSmall = sizing.inc50;
sizing.brandedIconMedium = sizing.inc70;
sizing.brandedIconLarge = sizing.inc90;
sizing.breakpoint = {
  small: 460,
  medium: 768,
  large: 1024,
  xlarge: 1280,
  xxlarge: 1440
};
borderRadius.circle = 999;
borderRadius.inc00 = 0;
borderRadius.inc10 = 2;
borderRadius.inc20 = 4;
borderRadius.inc30 = 8;
borderRadius.inc40 = 16;
borderRadius.inc50 = 24;
borderRadius.inc60 = 32;
borderRadius.inc70 = 40;
borderRadius.inc80 = 56;
borderRadius.inc90 = 72;
borderRadius.inc100 = 88;
borderRadius.inc110 = 104;
borderRadius.buttons = borderRadius.inc20;
borderRadius.input = borderRadius.inc20;
borderRadius.modal = borderRadius.inc20;
borderRadius.tooltips = borderRadius.inc20;
borderRadius.notification = borderRadius.inc20;
borderRadius.card = borderRadius.inc70;
borderRadius.cardResponsive = borderRadius.inc50;
borderRadius.codePanel = borderRadius.inc60;
borderRadius.buttonHover = borderRadius.inc70;
borderRadius.scrollyStoryCard = borderRadius.inc50;
borderRadius.scrollyStoryCardResponsive = borderRadius.inc40;
boxShadow.level00 = {
  x: 0,
  y: 0,
  spread: 0,
  color: '#000000',
  blur: 0
};
boxShadow.level01 = {
  x: 0,
  y: 2,
  spread: 0,
  color: 'rgba(0,0,0,.1)',
  blur: 4
};
boxShadow.level02 = {
  x: 0,
  y: 3,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 9
};
boxShadow.level03 = {
  x: 0,
  y: 3,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 20
};
boxShadow.level04 = {
  x: 0,
  y: 6,
  spread: 0,
  color: 'rgba(0,0,0,.15)',
  blur: 30
};
boxShadow.buttonHover = {
  x: 0,
  y: 0,
  spread: 3,
  blur: 0,
  color: 'rgba(185, 234, 205, 1)'
};
boxShadow.buttonHoverInverse = {
  x: 0,
  y: 0,
  spread: 3,
  color: 'rgba(244, 255, 220, .4)',
  blur: 0
};
boxShadow.tagHover = {
  x: 0,
  y: 0,
  spread: 3,
  blur: 0,
  color: 'rgba(0, 108, 250, .4)'
};
boxShadow.tagHoverInverse = {
  x: 0,
  y: 0,
  spread: 3,
  color: 'rgba(166, 225, 236, .4)',
  blur: 0
};
borderWidth.inc00 = 0;
borderWidth.inc10 = 1;
borderWidth.inc20 = 2;
borderWidth.inc30 = 3;
borderWidth.ruleBreak = borderWidth.inc10;
borderWidth.inputs = borderWidth.inc10;
borderWidth.systemIconSmall = borderWidth.inc10;
borderWidth.systemIconMedium = borderWidth.inc20;
borderWidth.systemIconLarge = borderWidth.inc20;
motion.inc00 = 100;
motion.inc10 = 200;
motion.inc20 = 250;
motion.inc30 = 300;
motion.inc40 = 350;
motion.linkAnimation = motion.inc30;
motion.mobileNavPanel = motion.inc30;
motion.mobileNavItemExpand = motion.inc30;
motion.tag = motion.inc00;
motion.codeSnippetCopyFade = motion.inc30 * 10;
motion.accordion = motion.inc40;
opacity.inc00 = '0%';
opacity.inc10 = '10%';
opacity.inc20 = '20%';
opacity.inc30 = '30%';
opacity.inc40 = '40%';
opacity.inc50 = '50%';
opacity.inc60 = '60%';
opacity.inc70 = '70%';
opacity.inc80 = '80%';
opacity.inc90 = '90%';
opacity.inc100 = '100%';
opacity.modalScrim = opacity.inc50;
icons.branded = {
  thin: borderWidth.inc10,
  medium: borderWidth.inc20,
  thick: borderWidth.inc30
};
var legacyTokens = /*#__PURE__*/Object.freeze({
  __proto__: null,
  colors: colors,
  fontFamilies: fontFamilies,
  lineHeights: lineHeights,
  fontWeights: fontWeights,
  fontSizes: fontSizes,
  spacing: spacing,
  sizing: sizing,
  borderRadius: borderRadius,
  boxShadow: boxShadow,
  borderWidth: borderWidth,
  motion: motion,
  opacity: opacity,
  icons: icons
});
var shadows = formatToBoxShadow(boxShadow);
var borders = convertToPx(borderWidth);
var legacyTheme = {
  colors: colors,
  shadows: shadows,
  borders: borders,
  fonts: fontFamilies,
  fontWeights: fontWeights,
  sizes: convertToPx(sizing),
  radii: convertToPx(borderRadius),
  lineHeights: convertToPx(lineHeights),
  fontSizes: convertToPx(fontSizes),
  space: convertToPx(spacing),
  responsive: transformToArrays(spacing.responsive),
  borderWidths: borders,
  breakpoints: Object.values(convertToPx(sizing.breakpoint)),
  motion: convertToMs(motion),
  opacity: opacity,
  config: {
    useRootStyles: false
  }
};

var getVariantStyles$4 = function getVariantStyles$4(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      selectedTheme = _a.selectedTheme,
      theme = _a.theme;
  var primaryToken = inverse ? 'inversePrimary' : 'primary';
  var secondaryToken = inverse ? 'inverseSecondary' : 'secondary';

  if (variant === 'primary') {
    var color_1 = selectedTheme.colors.button[primaryToken].text;
    var disabledColor_1 = selectedTheme.colors.button[primaryToken].textDisabled;
    return {
      color: color_1,
      stroke: color_1,
      fill: color_1,
      borderColor: selectedTheme.colors.button[primaryToken].border,
      bg: selectedTheme.colors.button[primaryToken].bg,
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'none',
        borderRadius: 'buttonHover'
      },
      '&:active, &:focus': {
        bg: selectedTheme.colors.button[primaryToken].bgDarker,
        borderRadius: theme !== 'legacy' && 'circle',
        boxShadow: inverse ? selectedTheme.shadows.buttonHoverInverse : selectedTheme.shadows.buttonHover,
        transition: '.1s' // Need a token for this

      },
      '&:disabled, &disabled:hover': {
        bg: selectedTheme.colors.button[primaryToken].bgDisabled,
        cursor: 'not-allowed',
        color: disabledColor_1,
        stroke: disabledColor_1,
        fill: disabledColor_1,
        boxShadow: 'level00'
      }
    };
  }

  var color = selectedTheme.colors.button[secondaryToken].text;
  var disabledColor = selectedTheme.colors.button[primaryToken].textDisabled;
  return {
    color: color,
    stroke: color,
    fill: color,
    bg: selectedTheme.colors.button[secondaryToken].bg,
    borderWidth: 'inc10',
    borderStyle: 'solid',
    borderColor: inverse ? selectedTheme.colors.button.inverseSecondary.bg : selectedTheme.colors.button.secondary.border,
    '&:hover': {
      cursor: 'pointer',
      bg: inverse ? null : selectedTheme.colors.button.secondary.background,
      textDecoration: 'none',
      transition: '.1s' // Need a token for this

    },
    '&:active': {
      bg: inverse ? selectedTheme.colors.button.inverseSecondary.bgLighter : selectedTheme.colors.button.secondary.bgDarker,
      boxShadow: selectedTheme.shadows.buttonHover,
      transition: '.1s' // Need a token for this

    },
    '&:disabled, &disabled:hover': {
      bg: selectedTheme.colors.button[secondaryToken].bgDisabled,
      color: disabledColor,
      stroke: disabledColor,
      fill: disabledColor,
      borderColor: selectedTheme.colors.button[primaryToken].borderDisabled,
      borderWidth: 'inc10',
      borderRadius: selectedTheme.radii.buttons,
      cursor: 'not-allowed'
    }
  };
};

var Button = function Button(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.onClick,
      onClick = _c === void 0 ? function () {} : _c,
      _d = _a.onMouseEnter,
      onMouseEnter = _d === void 0 ? function () {} : _d,
      href = _a.href,
      target = _a.target,
      disabled = _a.disabled,
      _e = _a.hasIcon,
      hasIcon = _e === void 0 ? false : _e,
      _f = _a.iconPosition,
      iconPosition = _f === void 0 ? 'left' : _f,
      _g = _a.iconName,
      iconName = _g === void 0 ? ESystemIconNames.CHEVRON_RIGHT : _g,
      _h = _a.iconStrokeWeight,
      iconStrokeWeight = _h === void 0 ? 'small' : _h,
      _j = _a.theme,
      theme = _j === void 0 ? 'default' : _j,
      children = _a.children,
      _k = _a.inverse,
      inverse = _k === void 0 ? false : _k,
      variant = _a.variant,
      _l = _a.size,
      size = _l === void 0 ? 'small' : _l,
      _m = _a.type,
      type = _m === void 0 ? 'button' : _m,
      _o = _a.tabIndex,
      tabIndex = _o === void 0 ? 0 : _o,
      _p = _a.trackClick,
      trackClick = _p === void 0 ? true : _p,
      _q = _a.trackCategory,
      trackCategory = _q === void 0 ? '' : _q,
      customStyles = _a.customStyles,
      customWrapperStyles = _a.customWrapperStyles;
  var ButtonElement = href ? 'a' : 'button';
  var buttonType = href ? undefined : type;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var icon = jsx(SystemIcon, {
    strokeWeight: iconStrokeWeight,
    name: iconName,
    inheritColor: true
  }, void 0);
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("div", _assign({
      sx: _assign({
        display: 'inline-block',
        '&:hover > button, &:hover > a': {
          borderRadius: 'buttonHover'
        }
      }, customWrapperStyles)
    }, {
      children: jsxs(ButtonElement, _assign({
        type: buttonType,
        tabIndex: tabIndex,
        className: className,
        href: href,
        target: target,
        disabled: disabled,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        sx: _assign(_assign({
          width: ['100%', null, 'unset'],
          paddingY: 'inc30',
          paddingX: size === 'small' ? 'inc50' : 'inc70',
          fontFamily: 'body',
          fontSize: 'inc20',
          fontWeight: theme === 'legacy' ? '300' : '500',
          borderRadius: 'buttons',
          lineHeight: 'inc00',
          border: 'solid',
          borderWidth: 'inc10',
          textDecoration: 'none',
          display: hasIcon ? 'flex' : 'inline-block',
          gap: 'inc20',
          transition: 'border-radius .15s'
        }, getVariantStyles$4({
          inverse: inverse,
          variant: variant,
          selectedTheme: selectedTheme,
          theme: theme
        })), customStyles),
        "data-track": trackClick.toString(),
        "data-track-category": trackCategory === '' ? undefined : trackCategory
      }, {
        children: [hasIcon && iconPosition === 'left' && icon, children, hasIcon && iconPosition === 'right' && icon]
      }), void 0)
    }), void 0)
  }), void 0);
};

var getVariantStyles$3 = function getVariantStyles$3(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      _d = _a.keepMobileOutline,
      keepMobileOutline = _d === void 0 ? false : _d,
      selectedTheme = _a.selectedTheme;
  var primaryToken = inverse ? 'inversePrimary' : 'primary';
  var secondaryToken = inverse ? 'inverseSecondary' : 'secondary';

  if (variant === 'primary') {
    var normalColor_1 = selectedTheme.colors.button.utility.icon;
    var hoverColor = inverse ? null : selectedTheme.colors.button.utility.iconInverse;
    var disabledColor_1 = selectedTheme.colors.button[primaryToken].textDisabled;
    return {
      bg: selectedTheme.colors.button.utility.bg,
      stroke: normalColor_1,
      fill: normalColor_1,
      borderColor: inverse ? selectedTheme.colors.button.utility.borderInverse : selectedTheme.colors.button.utility.border,
      '&:hover': {
        cursor: 'pointer',
        bg: inverse ? selectedTheme.colors.button.utility.bgHoverInverse : selectedTheme.colors.button.utility.bgHover,
        stroke: hoverColor,
        fill: hoverColor
      },
      '&:active': {
        boxShadow: inverse ? selectedTheme.shadows.buttonHoverInverse : selectedTheme.shadows.buttonHover,
        transition: '.1s' // Need a token for this

      },
      '&:disabled, &disabled:hover': {
        cursor: 'not-allowed',
        bg: selectedTheme.colors.button[primaryToken].bgDisabled,
        stroke: disabledColor_1,
        fill: disabledColor_1,
        boxShadow: 'level00',
        borderColor: selectedTheme.colors.button[primaryToken].borderDisabled
      }
    };
  }

  if (variant === 'outline') {
    var normalColor_2 = inverse ? selectedTheme.colors.black10 : selectedTheme.colors.button.primary.border;
    var hoverColor = inverse ? [selectedTheme.colors.black10, null, null, selectedTheme.colors.black70] : [selectedTheme.colors.button.utility.icon, null, null, selectedTheme.colors.button.utility.iconInverse];
    var disabledColor_2 = inverse ? selectedTheme.colors.black10 : selectedTheme.colors.button.primary.border;
    var mobileBorderStyle = 'none';
    var mobileHoverBg = null;
    var mobileHoverBgInverse = null;

    if (keepMobileOutline) {
      mobileBorderStyle = 'solid';
      mobileHoverBg = selectedTheme.colors.button.primary.bg;
      mobileHoverBgInverse = selectedTheme.colors.button.primary.border;
    }

    return {
      bg: 'transparent',
      stroke: normalColor_2,
      fill: normalColor_2,
      borderStyle: [mobileBorderStyle, null, null, 'solid'],
      borderWidth: 'inc20',
      borderColor: inverse ? selectedTheme.colors.button.utility.borderInverse : selectedTheme.colors.button.primary.border,
      '&:hover': {
        cursor: 'pointer',
        bg: inverse ? [mobileHoverBg, null, null, selectedTheme.colors.button.primary.bg] : [mobileHoverBgInverse, null, null, selectedTheme.colors.button.primary.border],
        stroke: hoverColor,
        fill: hoverColor,
        opacity: [selectedTheme.colors.button.primary.border ? 1 : 0.5, null, null, 1]
      },
      '&:active': {
        bg: selectedTheme.colors.button[primaryToken].bgDarker,
        boxShadow: inverse ? selectedTheme.shadows.buttonHoverInverse : selectedTheme.shadows.buttonHover,
        transition: '.1s' // Need a token for this

      },
      '&:disabled, &disabled:hover': {
        cursor: 'not-allowed',
        bg: 'transparent',
        stroke: disabledColor_2,
        fill: disabledColor_2,
        boxShadow: 'level00',
        opacity: 0.5
      }
    };
  }

  var normalColor = selectedTheme.colors.button[secondaryToken].text;
  var disabledColor = inverse ? selectedTheme.colors.black70 : selectedTheme.colors.button.primary.textDisabled;
  return {
    bg: inverse ? selectedTheme.colors.button.inverseSecondary.bg : selectedTheme.colors.black70,
    stroke: normalColor,
    fill: normalColor,
    borderStyle: 'solid',
    borderWidth: 'inc10',
    borderColor: inverse ? selectedTheme.colors.button.inverseSecondary.bg : selectedTheme.colors.black70,
    '&:hover': {
      cursor: 'pointer',
      bg: inverse ? selectedTheme.colors.black20 : selectedTheme.colors.button.secondary.bg,
      transition: '.1s' // Need a token for this

    },
    '&:active': {
      bg: inverse ? selectedTheme.colors.button.inverseSecondary.bgLighter : selectedTheme.colors.button.secondary.bgDarker,
      boxShadow: inverse ? selectedTheme.shadows.buttonHoverInverse : selectedTheme.shadows.buttonHover,
      transition: '.1s' // Need a token for this

    },
    '&:disabled, &disabled:hover': {
      cursor: 'not-allowed',
      bg: inverse ? selectedTheme.colors.black40 : selectedTheme.colors.button.primary.bgDisabled,
      stroke: disabledColor,
      fill: disabledColor,
      borderColor: selectedTheme.colors.button[primaryToken].borderDisabled,
      boxShadow: 'level00'
    }
  };
};

var getSizeStyles$2 = function getSizeStyles$2(variant, size) {
  var outline = variant === 'outline';
  var Styles = {
    small: {
      width: '48px',
      height: '48px'
    },
    large: {
      width: outline ? ['48px', null, null, '56px'] : '56px',
      height: outline ? ['48px', null, null, '56px'] : '56px'
    },
    extraLarge: {
      width: outline ? ['48px', null, null, '88px'] : '88px',
      height: outline ? ['48px', null, null, '88px'] : '88px'
    }
  };
  return Styles[size];
};

var ButtonIcon = function ButtonIcon(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.onClick,
      onClick = _c === void 0 ? function () {} : _c,
      _d = _a.onMouseEnter,
      onMouseEnter = _d === void 0 ? function () {} : _d,
      href = _a.href,
      target = _a.target,
      disabled = _a.disabled,
      _e = _a.iconName,
      iconName = _e === void 0 ? ESystemIconNames.CHEVRON_RIGHT : _e,
      _f = _a.iconStrokeWeight,
      iconStrokeWeight = _f === void 0 ? 'medium' : _f,
      _g = _a.theme,
      theme = _g === void 0 ? 'default' : _g,
      _h = _a.inverse,
      inverse = _h === void 0 ? false : _h,
      _j = _a.variant,
      variant = _j === void 0 ? 'primary' : _j,
      _k = _a.size,
      size = _k === void 0 ? 'small' : _k,
      _l = _a.tabIndex,
      tabIndex = _l === void 0 ? 0 : _l,
      _m = _a.trackClick,
      trackClick = _m === void 0 ? true : _m,
      _o = _a.trackCategory,
      trackCategory = _o === void 0 ? '' : _o,
      customStyles = _a.customStyles,
      customWrapperStyles = _a.customWrapperStyles,
      _p = _a.keepMobileOutline,
      keepMobileOutline = _p === void 0 ? false : _p;
  var ButtonElement = href ? 'a' : 'button';
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("div", _assign({
      sx: _assign({
        display: 'inline-block'
      }, customWrapperStyles)
    }, {
      children: jsx(ButtonElement, _assign({
        tabIndex: tabIndex,
        className: className,
        href: href,
        target: target,
        disabled: disabled,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        sx: _assign(_assign(_assign({
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: 'solid',
          borderWidth: 'inc10',
          borderRadius: '50%',
          transition: '.15s'
        }, getVariantStyles$3({
          inverse: inverse,
          variant: variant,
          selectedTheme: selectedTheme,
          keepMobileOutline: keepMobileOutline
        })), getSizeStyles$2(variant, size)), customStyles),
        "data-track": trackClick.toString(),
        "data-track-category": trackCategory === '' ? undefined : trackCategory
      }, {
        children: jsx(SystemIcon, {
          strokeWeight: iconStrokeWeight,
          name: iconName,
          inheritColor: true
        }, void 0)
      }), void 0)
    }), void 0)
  }), void 0);
};

var _a$5;

var AKZIDENZ_FAMILY = 'Akzidenz-Grotesk Std';
var EUCLID_CIRCULAR_FAMILY = 'Euclid Circular A';
var MONGODB_VALUE_SERIF_FAMILY = 'MongoDB Value Serif';
var SOURCE_CODE_PRO_FAMILY = 'Source Code Pro';
var FONT_SRCS = (_a$5 = {}, _a$5[AKZIDENZ_FAMILY] = {
  light: 'https://static.mongodb.com/com/fonts/akzidenzgroteskbq_light-webfont.woff2',
  medium: 'https://static.mongodb.com/com/fonts/akzidenzgroteskbq_medium-webfont.woff2'
}, _a$5[EUCLID_CIRCULAR_FAMILY] = {
  regular: 'https://static.mongodb.com/com/fonts/EuclidCircularA-Regular-WebXL.woff2',
  medium: 'https://static.mongodb.com/com/fonts/EuclidCircularA-Medium-WebXL.woff2'
}, _a$5[MONGODB_VALUE_SERIF_FAMILY] = {
  regular: 'https://static.mongodb.com/com/fonts/MongoDBValueSerif-Regular.woff2',
  medium: 'https://static.mongodb.com/com/fonts/MongoDBValueSerif-Medium.woff2',
  bold: 'https://static.mongodb.com/com/fonts/MongoDBValueSerif-Bold.woff2'
}, _a$5[SOURCE_CODE_PRO_FAMILY] = {
  regular: 'https://static.mongodb.com/com/fonts/SourceCodePro-Regular.ttf',
  medium: 'https://static.mongodb.com/com/fonts/SourceCodePro-Medium.ttf'
}, _a$5);

var Globals = function Globals(_a) {
  var legacy = _a.legacy;

  if (legacy) {
    return jsx(Global, {
      styles: css(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n          @font-face {\n            font-family: ", ";\n            src: url(", ") format('woff2');\n            font-weight: 300;\n            font-style: normal;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ") format('woff2');\n            font-weight: 500;\n            font-style: normal;\n            font-display: swap;\n          }\n        "], ["\n          @font-face {\n            font-family: ", ";\n            src: url(", ") format('woff2');\n            font-weight: 300;\n            font-style: normal;\n            font-display: swap;\n          }\n\n          @font-face {\n            font-family: ", ";\n            src: url(", ") format('woff2');\n            font-weight: 500;\n            font-style: normal;\n            font-display: swap;\n          }\n        "])), AKZIDENZ_FAMILY, FONT_SRCS[AKZIDENZ_FAMILY].light, AKZIDENZ_FAMILY, FONT_SRCS[AKZIDENZ_FAMILY].medium)
    }, void 0);
  }

  return jsx(Global, {
    styles: css(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n        @font-face {\n          font-family: ", ";\n          src: url(", ") format('woff2');\n          font-weight: normal;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ") format('woff2');\n          font-weight: 500;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('woff2');\n          font-weight: normal;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('woff2');\n          font-weight: 500;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('woff2');\n          font-weight: bold;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('truetype');\n          font-weight: normal;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('truetype');\n          font-weight: 500;\n          font-display: swap;\n        }\n      "], ["\n        @font-face {\n          font-family: ", ";\n          src: url(", ") format('woff2');\n          font-weight: normal;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ") format('woff2');\n          font-weight: 500;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('woff2');\n          font-weight: normal;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('woff2');\n          font-weight: 500;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('woff2');\n          font-weight: bold;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('truetype');\n          font-weight: normal;\n          font-display: swap;\n        }\n\n        @font-face {\n          font-family: ", ";\n          src: url(", ")\n            format('truetype');\n          font-weight: 500;\n          font-display: swap;\n        }\n      "])), EUCLID_CIRCULAR_FAMILY, FONT_SRCS[EUCLID_CIRCULAR_FAMILY].regular, EUCLID_CIRCULAR_FAMILY, FONT_SRCS[EUCLID_CIRCULAR_FAMILY].medium, MONGODB_VALUE_SERIF_FAMILY, FONT_SRCS[MONGODB_VALUE_SERIF_FAMILY].regular, MONGODB_VALUE_SERIF_FAMILY, FONT_SRCS[MONGODB_VALUE_SERIF_FAMILY].medium, MONGODB_VALUE_SERIF_FAMILY, FONT_SRCS[MONGODB_VALUE_SERIF_FAMILY].bold, SOURCE_CODE_PRO_FAMILY, FONT_SRCS[SOURCE_CODE_PRO_FAMILY].regular, SOURCE_CODE_PRO_FAMILY, FONT_SRCS[SOURCE_CODE_PRO_FAMILY].medium)
  }, void 0);
};

var templateObject_1$2, templateObject_2$1;

var getSpacingStyles = function getSpacingStyles(spacing) {
  switch (spacing) {
    case 'none':
      return {
        marginTop: 'inc00',
        marginBottom: 'inc00'
      };

    case 'small':
      return {
        marginTop: 'section10',
        marginBottom: 'section10'
      };

    case 'medium':
      return {
        marginTop: 'section20',
        marginBottom: 'section20'
      };

    case 'large':
      return {
        marginTop: 'section30',
        marginBottom: 'section30'
      };

    case 'xlarge':
      return {
        marginTop: 'section40',
        marginBottom: 'section40'
      };

    case 'xxlarge':
      return {
        marginTop: 'section50',
        marginBottom: 'section50'
      };

    default:
      return {
        marginTop: 'section00',
        marginBottom: 'section00'
      };
  }
};

var getBorderWidthStyles = function getBorderWidthStyles(strokeWeight) {
  switch (strokeWeight) {
    case 'medium':
      return {
        borderTopWidth: 'inc20',
        borderBottomWidth: 'inc00',
        borderLeftWidth: 'inc00',
        borderRightWidth: 'inc00'
      };

    case 'large':
      return {
        borderTopWidth: 'inc30',
        borderBottomWidth: 'inc00',
        borderLeftWidth: 'inc00',
        borderRightWidth: 'inc00'
      };

    default:
      return {
        borderTopWidth: 'inc10',
        borderBottomWidth: 'inc00',
        borderLeftWidth: 'inc00',
        borderRightWidth: 'inc00'
      };
  }
};

var HorizontalRule = function HorizontalRule(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _d = _a.inverse,
      inverse = _d === void 0 ? false : _d,
      _e = _a.spacing,
      spacing = _e === void 0 ? 'xsmall' : _e,
      _f = _a.strokeWeight,
      strokeWeight = _f === void 0 ? 'small' : _f,
      customStyles = _a.customStyles;
  return jsx(ThemeProvider, _assign({
    theme: theme === 'legacy' ? legacyTheme : defaultTheme
  }, {
    children: jsx("hr", {
      className: className,
      sx: _assign(_assign(_assign(_assign({
        width: '100%'
      }, getSpacingStyles(spacing)), getBorderWidthStyles(strokeWeight)), {
        borderColor: inverse ? 'border.inverse' : 'border.default',
        borderStyle: 'solid'
      }), customStyles)
    }, void 0)
  }), void 0);
};

var ELinkVariant;

(function (ELinkVariant) {
  ELinkVariant["LARGE"] = "large";
  ELinkVariant["MEDIUM"] = "medium";
  ELinkVariant["SMALL"] = "small";
})(ELinkVariant || (ELinkVariant = {}));

var getVariantStyles$2 = function getVariantStyles$2(props) {
  var _a = props.variant,
      variant = _a === void 0 ? ELinkVariant.SMALL : _a,
      inverse = props.inverse,
      navItem = props.navItem,
      navTitle = props.navTitle,
      arrowOnly = props.arrowOnly,
      href = props.href,
      theme = props.theme,
      linkIcon = props.linkIcon;
  var isNav = navItem || navTitle;
  var defaultTheme = theme === 'default';

  var getColor = function getColor(navItem, navTitle, inverse, defaultTheme) {
    if (navItem === void 0) {
      navItem = false;
    }

    if (navTitle === void 0) {
      navTitle = false;
    }

    if (inverse === void 0) {
      inverse = false;
    }

    if (navItem || navTitle || !defaultTheme) {
      return inverse ? 'black00' : 'link.navigation.text';
    }

    return inverse ? 'link.inline.inverse.text' : 'link.inline.default.text';
  };

  var color = getColor(navItem, navTitle, inverse, defaultTheme);

  switch (variant) {
    case ELinkVariant.LARGE:
      {
        return {
          fontSize: 'inc40',
          lineHeight: 'inc60',
          color: color,
          '&:hover': {
            color: linkIcon && 'link.cta.default.textHover',
            textDecoration: href && (arrowOnly || isNav || defaultTheme ? 'none' : 'underline')
          }
        };
      }

    case ELinkVariant.MEDIUM:
      {
        return {
          fontSize: navTitle ? 'inc20' : 'inc30',
          lineHeight: navTitle ? 'inc30' : 'inc50',
          color: color,
          '&:hover': {
            color: linkIcon && 'link.cta.default.textHover',
            textDecoration: href && (arrowOnly || isNav || defaultTheme ? 'none' : 'underline')
          },
          '&:active': {
            color: navItem || navTitle && 'link.navigation.textSelected'
          }
        };
      }

    case ELinkVariant.SMALL:
      {
        return {
          fontSize: 'inc20',
          lineHeight: 'inc30',
          color: color,
          '&:hover': {
            color: linkIcon && 'link.cta.default.textHover',
            textDecoration: href && (arrowOnly || isNav || defaultTheme ? 'none' : 'underline')
          },
          '&:active': {
            color: navItem || navTitle && 'link.navigation.textSelected'
          }
        };
      }
  }
};

var getIconColor$1 = function getIconColor$1(linkIconColor, inverse, theme) {
  if (linkIconColor) {
    return linkIconColor;
  } else if (inverse) {
    return theme.colors.link.cta.inverse.icon;
  }

  return theme.colors.link.cta.default.icon;
};

var getArrowHeightVariants = function getArrowHeightVariants(props, theme) {
  var variant = props.variant,
      navTitle = props.navTitle;

  switch (variant) {
    case ELinkVariant.LARGE:
      {
        return {
          minHeight: theme.lineHeights.inc60
        };
      }

    case ELinkVariant.MEDIUM:
      {
        return {
          minHeight: navTitle ? theme.lineHeights.inc30 : theme.lineHeights.inc50
        };
      }

    case ELinkVariant.SMALL:
      {
        return {
          minHeight: theme.lineHeights.inc30
        };
      }
  }
};

var Arrow$2 = function Arrow$2(_a) {
  var isNav = _a.isNav,
      className = _a.className,
      inverse = _a.inverse,
      theme = _a.theme,
      props = __rest(_a, ["isNav", "className", "inverse", "theme"]);

  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("span", _assign({
      sx: _assign(_assign({
        minWidth: '24px'
      }, getArrowHeightVariants(props, selectedTheme)), {
        overflow: 'hidden',
        position: 'relative',
        display: 'inline-block',
        marginLeft: 'inc30',
        color: inverse ? 'link.cta.inverse.icon' : 'link.cta.default.icon'
      })
    }, {
      children: jsx("span", _assign({
        "aria-hidden": 'true',
        className: className,
        sx: _assign(_assign({
          display: 'inline-block',
          position: 'absolute',
          fontFamily: theme === 'legacy' ? 'Arial, sans-serif' : selectedTheme.fonts.body,
          left: props.navItem ? '-100px' : '0'
        }, getVariantStyles$2(_assign({}, props))), {
          color: isNav && 'green50'
        })
      }, {
        children: "\u2192"
      }), void 0)
    }), void 0)
  }), void 0);
};

var ArrowLeftIcon = function ArrowLeftIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M16 7.99999L1.91695 7.9999',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement("path", {
    d: 'M8.53345 14.717L1.81633 7.99989L8.53345 1.28278',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var ArrowRightIcon = function ArrowRightIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M1.06665 7.99999L15.1497 7.9999',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement("path", {
    d: 'M8.5332 14.717L15.2503 7.99989L8.5332 1.28278',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var CheckIcon = function CheckIcon() {
  return React.createElement("path", {
    d: 'M0.75 8.5L6.25 13.5L15.25 2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  });
};

var ChevronDownIcon = function ChevronDownIcon() {
  return React.createElement("path", {
    d: 'M1.06665 4.79999L7.99998 11.7333L14.9333 4.79999',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  });
};

var ChevronLeftIcon = function ChevronLeftIcon() {
  return React.createElement("path", {
    d: 'M11.4666 1.33331L4.53322 8.26665L11.4666 15.2',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  });
};

var ChevronRightIcon = function ChevronRightIcon() {
  return React.createElement("path", {
    d: 'M4.53345 15.2L11.4668 8.26668L4.53345 1.33334',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  });
};

var ChevronUpIcon = function ChevronUpIcon() {
  return React.createElement("path", {
    d: 'M14.9333 11.7333L8.00002 4.80001L1.06668 11.7333',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  });
};

var CircleIcon = function CircleIcon() {
  return React.createElement("path", {
    d: 'M10.1666 7.99998C10.1666 9.1966 9.19654 10.1666 7.99992 10.1666C6.8033 10.1666 5.83325 9.1966 5.83325 7.99998C5.83325 6.80336 6.8033 5.83331 7.99992 5.83331C9.19654 5.83331 10.1666 6.80336 10.1666 7.99998Z'
  });
};

var CircleAlertIcon = function CircleAlertIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M7.99991 11.1765C7.85372 11.1765 7.73521 11.295 7.73521 11.4412C7.73521 11.5874 7.85372 11.7059 7.99991 11.7059C8.14611 11.7059 8.26462 11.5874 8.26462 11.4412C8.26462 11.295 8.14611 11.1765 7.99991 11.1765V11.1765',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement("path", {
    d: 'M7.99991 9.05882V3.23529',
    strokeLinecap: 'round'
  }), React.createElement("path", {
    d: 'M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z'
  }));
};

var CircleCheckIcon = function CircleCheckIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z'
  }), React.createElement("path", {
    d: 'M4 8.3913L7.03448 11L12 5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var CircleCloseIcon = function CircleCloseIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z'
  }), React.createElement("path", {
    d: 'M10.0455 5.77875L5.77881 10.0454',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement("path", {
    d: 'M5.77881 5.77875L10.0455 10.0454',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var CircleInfoIcon = function CircleInfoIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8Z'
  }), React.createElement("path", {
    d: 'M9.45445 11.9561H8.43627C8.06138 11.9561 7.75748 11.6654 7.75748 11.3068V7.08654C7.75748 6.90725 7.60553 6.7619 7.41808 6.7619H6.3999',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement("path", {
    d: 'M7.80595 4.13992C7.71223 4.13992 7.63625 4.21259 7.63625 4.30224C7.63625 4.39188 7.71223 4.46456 7.80595 4.46456C7.89967 4.46456 7.97564 4.39188 7.97564 4.30224C7.97564 4.21259 7.89967 4.13992 7.80595 4.13992',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var CloseIcon = function CloseIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M2.1333 2.13336L13.8666 13.8667',
    strokeLinecap: 'round'
  }), React.createElement("path", {
    d: 'M2.1333 13.8667L13.8666 2.13336',
    strokeLinecap: 'round'
  }));
};

var DownloadIcon = function DownloadIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M11 13.5858V2C11 1.44771 11.4477 1 12 1C12.5523 1 13 1.44771 13 2V13.5858L16.2929 10.2929C16.6834 9.90237 17.3166 9.90237 17.7071 10.2929C18.0976 10.6834 18.0976 11.3166 17.7071 11.7071L12.7071 16.7071C12.3166 17.0976 11.6834 17.0976 11.2929 16.7071L6.29289 11.7071C5.90237 11.3166 5.90237 10.6834 6.29289 10.2929C6.68342 9.90237 7.31658 9.90237 7.70711 10.2929L11 13.5858Z',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement("path", {
    d: 'M2 15C2.55228 15 3 15.4477 3 16V20C3 20.5523 3.44772 21 4 21H20C20.5523 21 21 20.5523 21 20V16C21 15.4477 21.4477 15 22 15C22.5523 15 23 15.4477 23 16V20C23 21.6569 21.6569 23 20 23H4C2.34315 23 1 21.6569 1 20V16C1 15.4477 1.44772 15 2 15Z',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var HamburgerIcon = function HamburgerIcon() {
  return React.createElement(React.Fragment, null, React.createElement("rect", {
    width: '19',
    height: '2',
    rx: '1'
  }), React.createElement("rect", {
    y: '7',
    width: '19',
    height: '2',
    rx: '1'
  }), React.createElement("rect", {
    y: '14',
    width: '19',
    height: '2',
    rx: '1'
  }));
};

var LanguageIcon = function LanguageIcon() {
  return React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M15.4668 7.2562C15.4668 9.89325 13.2755 12.0508 10.5972 12.0508H8.64939L6.05229 14.608V12.0508H5.40301C2.72475 12.0508 0.533447 9.89325 0.533447 7.2562C0.533447 4.61914 2.72475 2.46155 5.40301 2.46155H10.5972C13.2755 2.46155 15.4668 4.61914 15.4668 7.2562Z',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  });
};

var MinusIcon = function MinusIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M11 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44771 13 5 13L11 13L13 13L19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11L13 11H11Z'
  }));
};

var PasswordHideIcon = function PasswordHideIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M13.1779 5.65572C14.3239 6.83687 14.9333 8.00001 14.9333 8.00001C14.9333 8.00001 12.4183 12.8 7.99998 12.8C7.22999 12.8 6.5178 12.6542 5.86665 12.4135M10.1333 3.58655C9.48217 3.3458 8.76998 3.20001 7.99998 3.20001C3.58171 3.20001 1.06665 8.00001 1.06665 8.00001C1.06665 8.00001 1.72312 9.25288 2.95446 10.4785',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement("path", {
    d: 'M13.8666 2.13336L2.1333 13.8667',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }), React.createElement("path", {
    d: 'M5.37047 8.44658C5.346 8.30138 5.33325 8.1522 5.33325 8.00004C5.33325 6.52728 6.52716 5.33337 7.99992 5.33337C8.12629 5.33337 8.25061 5.34216 8.3723 5.35917M10.6388 7.61349C10.6571 7.73969 10.6666 7.86876 10.6666 8.00004C10.6666 9.4728 9.47268 10.6667 7.99992 10.6667C7.89913 10.6667 7.79964 10.6611 7.70175 10.6502',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var PasswordViewIcon = function PasswordViewIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M14.9333 8.00001C14.9333 8.00001 12.4183 12.8 7.99998 12.8C3.58171 12.8 1.06665 8.00001 1.06665 8.00001C1.06665 8.00001 3.58171 3.20001 7.99998 3.20001C12.4183 3.20001 14.9333 8.00001 14.9333 8.00001Z',
    strokeLinejoin: 'round'
  }), React.createElement("circle", {
    cx: '7.99992',
    cy: '8.00004',
    r: '2.66667'
  }));
};

var PlayIcon = function PlayIcon() {
  return React.createElement("path", {
    d: 'M17.7349 13.9993L8.84297 20.5758C8.48406 20.8403 8.05883 21.0002 7.61452 21.0377C7.17021 21.0751 6.7242 20.9887 6.32605 20.788C5.92791 20.5872 5.59321 20.2801 5.35912 19.9006C5.12503 19.5211 5.00072 19.0841 5 18.6382V5.41293C4.99981 4.96535 5.12418 4.52654 5.35917 4.14561C5.59416 3.76468 5.93049 3.45665 6.33057 3.25599C6.73065 3.05532 7.17867 2.96994 7.62451 3.00939C8.07034 3.04884 8.49642 3.21157 8.85505 3.47937L17.7429 10.1322C18.0435 10.3574 18.2874 10.6496 18.4552 10.9856C18.6229 11.3217 18.7098 11.6922 18.709 12.0678C18.7083 12.4434 18.6198 12.8136 18.4507 13.1489C18.2815 13.4842 18.0364 13.7754 17.7349 13.9993V13.9993Z',
    strokeMiterlimit: '10'
  });
};

var PlusIcon = function PlusIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M8 1.06665V14.9333',
    strokeLinecap: 'round'
  }), React.createElement("path", {
    d: 'M1.06665 8H14.9333',
    strokeLinecap: 'round'
  }));
};

var SearchIcon = function SearchIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M14.9334 14.9334L10.6667 10.6667',
    strokeLinecap: 'round'
  }), React.createElement("path", {
    d: 'M12.3 6.4C12.3 9.65848 9.65848 12.3 6.4 12.3C3.14152 12.3 0.5 9.65848 0.5 6.4C0.5 3.14152 3.14152 0.5 6.4 0.5C9.65848 0.5 12.3 3.14152 12.3 6.4Z'
  }));
};

var UserIcon = function UserIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M11.3268 3.73333C11.3268 5.51905 9.87916 6.96667 8.09344 6.96667C6.30772 6.96667 4.86011 5.51905 4.86011 3.73333C4.86011 1.94761 6.30772 0.5 8.09344 0.5C9.87916 0.5 11.3268 1.94761 11.3268 3.73333Z'
  }), React.createElement("path", {
    d: 'M1.23999 15.5C1.23999 11.9101 4.26655 9 7.99999 9C11.7334 9 14.76 11.9101 14.76 15.5',
    strokeLinecap: 'round',
    strokeLinejoin: 'round'
  }));
};

var ShareOptionIcon = function ShareOptionIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    fillRule: 'evenodd',
    clipRule: 'evenodd',
    d: 'M19 9C21.2091 9 23 7.20914 23 5C23 2.79086 21.2091 1 19 1C16.7909 1 15 2.79086 15 5C15 5.28739 15.0303 5.5677 15.0879 5.83791L8.01688 9.37342C7.28357 8.53186 6.2039 8 5 8C2.79086 8 1 9.79086 1 12C1 14.2091 2.79086 16 5 16C6.32802 16 7.50488 15.3528 8.23241 14.3566L15.1009 18.1031C15.0349 18.3914 15 18.6916 15 19C15 21.2091 16.7909 23 19 23C21.2091 23 23 21.2091 23 19C23 16.7909 21.2091 15 19 15C17.8179 15 16.7556 15.5128 16.0233 16.328L8.97132 12.4815C8.99025 12.3236 9 12.163 9 12C9 11.7125 8.96968 11.4322 8.91206 11.1619L15.983 7.62643C16.7163 8.46808 17.796 9 19 9ZM19 7C20.1046 7 21 6.10457 21 5C21 3.89543 20.1046 3 19 3C17.8954 3 17 3.89543 17 5C17 6.10457 17.8954 7 19 7ZM5 14C6.10457 14 7 13.1046 7 12C7 10.8954 6.10457 10 5 10C3.89543 10 3 10.8954 3 12C3 13.1046 3.89543 14 5 14ZM21 19C21 20.1046 20.1046 21 19 21C17.8954 21 17 20.1046 17 19C17 17.8954 17.8954 17 19 17C20.1046 17 21 17.8954 21 19Z',
    fill: '#001E2B'
  }));
};

var MeatballsIcon = function MeatballsIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M8.0013 15C8.0013 16.3807 6.80739 17.5 5.33464 17.5C3.86188 17.5 2.66797 16.3807 2.66797 15C2.66797 13.6193 3.86188 12.5 5.33464 12.5C6.80739 12.5 8.0013 13.6193 8.0013 15Z'
  }), React.createElement("path", {
    d: 'M18.668 15C18.668 16.3807 17.4741 17.5 16.0013 17.5C14.5285 17.5 13.3346 16.3807 13.3346 15C13.3346 13.6193 14.5285 12.5 16.0013 12.5C17.4741 12.5 18.668 13.6193 18.668 15Z'
  }), React.createElement("path", {
    d: 'M26.668 17.5C28.1407 17.5 29.3346 16.3807 29.3346 15C29.3346 13.6193 28.1407 12.5 26.668 12.5C25.1952 12.5 24.0013 13.6193 24.0013 15C24.0013 16.3807 25.1952 17.5 26.668 17.5Z'
  }));
};

var GoogleIcon = function GoogleIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M15.9919 8.1497C15.9919 7.49419 15.9374 7.01584 15.8196 6.51978H8.15967V9.47843H12.6559C12.5653 10.2137 12.0758 11.321 10.9879 12.0651L10.9727 12.1641L13.3946 13.9976L13.5624 14.0139C15.1035 12.6232 15.9919 10.5769 15.9919 8.1497Z',
    fill: '#4285F4'
  }), React.createElement("path", {
    d: 'M8.1594 15.9451C10.3622 15.9451 12.2114 15.2364 13.5622 14.014L10.9877 12.0651C10.2987 12.5346 9.37409 12.8624 8.1594 12.8624C6.00194 12.8624 4.17082 11.4716 3.51807 9.54938L3.42239 9.55732L0.904028 11.4619L0.871094 11.5513C2.21271 14.1557 4.96848 15.9451 8.1594 15.9451Z',
    fill: '#34A853'
  }), React.createElement("path", {
    d: 'M3.51769 9.54924C3.34546 9.05318 3.24578 8.52164 3.24578 7.97245C3.24578 7.42319 3.34546 6.89171 3.50863 6.39565L3.50406 6.29L0.95414 4.35486L0.870711 4.39364C0.317768 5.47437 0.000488281 6.68799 0.000488281 7.97245C0.000488281 9.2569 0.317768 10.4705 0.870711 11.5512L3.51769 9.54924Z',
    fill: '#FBBC05'
  }), React.createElement("path", {
    d: 'M8.1594 3.08269C9.69137 3.08269 10.7248 3.72934 11.314 4.26974L13.6165 2.07286C12.2024 0.788397 10.3622 0 8.1594 0C4.96848 0 2.21271 1.78937 0.871094 4.39371L3.50901 6.39573C4.17082 4.47347 6.00194 3.08269 8.1594 3.08269Z',
    fill: '#EB4335'
  }));
};

var MegaphoneIcon = function MegaphoneIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M3.13206 12.8001L3.58006 11.6251L2.53406 8.8811C2.45896 8.68318 2.45371 8.46554 2.51918 8.26422C2.58464 8.06291 2.7169 7.88999 2.89406 7.7741L5.35206 6.1691L6.11906 3.3351C6.17447 3.13072 6.29812 2.95144 6.46947 2.82702C6.64082 2.7026 6.84956 2.64053 7.06106 2.6511L9.99306 2.8001L12.2791 0.955101C12.4441 0.822063 12.6496 0.749512 12.8616 0.749512C13.0735 0.749512 13.2791 0.822063 13.4441 0.955101L15.7301 2.8001L18.6621 2.6541C18.8736 2.64353 19.0823 2.7056 19.2536 2.83002C19.425 2.95444 19.5486 3.13372 19.6041 3.3381L20.3711 6.1721L22.8291 7.7771C23.0064 7.89286 23.1387 8.06578 23.2042 8.26714C23.2697 8.4685 23.2643 8.6862 23.1891 8.8841L22.1441 11.6281L23.1891 14.3711C23.2644 14.5692 23.2698 14.787 23.2043 14.9885C23.1388 15.1901 23.0064 15.3632 22.8291 15.4791L20.3711 17.0791L19.6001 19.9141C19.545 20.1188 19.4215 20.2984 19.2501 20.423C19.0787 20.5477 18.8697 20.6098 18.6581 20.5991L15.7261 20.4531L13.4401 22.2941'
  }), React.createElement("path", {
    d: 'M0.75 19.769L2.406 22.378'
  }), React.createElement("path", {
    d: 'M9.90796 8.14697L16.202 18.063'
  }), React.createElement("path", {
    d: 'M15.8711 17.5409L2.07505 21.8569L1.08105 20.2909L10.2391 8.66895L15.8711 17.5409Z'
  }), React.createElement("path", {
    d: 'M5.05615 20.9239L5.93215 22.2699C6.077 22.5074 6.26885 22.7127 6.49593 22.8733C6.72301 23.034 6.98052 23.1465 7.25266 23.204C7.5248 23.2615 7.80582 23.2628 8.07847 23.2077C8.35111 23.1527 8.60963 23.0425 8.83815 22.8839C9.30533 22.5477 9.62634 22.0456 9.73546 21.4805C9.84459 20.9154 9.73358 20.3299 9.42515 19.8439L9.26215 19.6079'
  }));
};

var LightbulbIcon = function LightbulbIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M12 2.25244V0.752441'
  }), React.createElement("path", {
    d: 'M18.3643 4.88595L19.4253 3.82495'
  }), React.createElement("path", {
    d: 'M21 11.2524H22.5'
  }), React.createElement("path", {
    d: 'M18.3643 17.6157L19.4253 18.6767'
  }), React.createElement("path", {
    d: 'M5.6362 4.88595L4.5752 3.82495'
  }), React.createElement("path", {
    d: 'M3 11.2524H1.5'
  }), React.createElement("path", {
    d: 'M5.6362 17.6157L4.5752 18.6767'
  }), React.createElement("path", {
    d: 'M9 16.4485V18.7485C9 19.5441 9.31607 20.3072 9.87868 20.8698C10.4413 21.4324 11.2044 21.7485 12 21.7485C12.7956 21.7485 13.5587 21.4324 14.1213 20.8698C14.6839 20.3072 15 19.5441 15 18.7485V16.4485'
  }), React.createElement("path", {
    d: 'M12 17.2524C15.3137 17.2524 18 14.5662 18 11.2524C18 7.93873 15.3137 5.25244 12 5.25244C8.68629 5.25244 6 7.93873 6 11.2524C6 14.5662 8.68629 17.2524 12 17.2524Z'
  }));
};

var AcademicCapIcon = function AcademicCapIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M12 14L21 9L12 4L3 9L12 14Z'
  }), React.createElement("path", {
    d: 'M12.0001 13.9999L18.1601 10.5779C18.9706 12.636 19.2006 14.8771 18.8251 17.0569C16.2886 17.3031 13.8973 18.3535 12.0001 20.0549C10.1031 18.3537 7.71216 17.3033 5.17608 17.0569C4.80028 14.8771 5.03031 12.6359 5.84108 10.5779L12.0001 13.9999Z'
  }), React.createElement("path", {
    d: 'M8 20V12.5L12 10.278M12 14L21 9L12 4L3 9L12 14ZM12 14L18.16 10.578C18.9705 12.6361 19.2005 14.8772 18.825 17.057C16.2886 17.3032 13.8972 18.3536 12 20.055C10.1031 18.3538 7.71208 17.3034 5.176 17.057C4.8002 14.8772 5.03023 12.636 5.841 10.578L12 14Z'
  }));
};

var ExternalIcon = function ExternalIcon() {
  return React.createElement(React.Fragment, null, React.createElement("path", {
    d: 'M13,1h6V7',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '2'
  }), React.createElement("line", {
    x1: '8',
    y1: '12',
    x2: '18.6',
    y2: '1.4',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '2'
  }), React.createElement("path", {
    d: 'M16,11v6a2,2,0,0,1-2,2H3a2,2,0,0,1-2-2V6A2,2,0,0,1,3,4H9',
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeWidth: '2'
  }));
};

var _a$4;

var ESystemIconNames;

(function (ESystemIconNames) {
  ESystemIconNames["PASSWORD_VIEW"] = "password-view";
  ESystemIconNames["PASSWORD_HIDE"] = "password-hide";
  ESystemIconNames["CHEVRON_DOWN"] = "chevron-down";
  ESystemIconNames["CHEVRON_RIGHT"] = "chevron-right";
  ESystemIconNames["CHEVRON_LEFT"] = "chevron-left";
  ESystemIconNames["CHEVRON_UP"] = "chevron-up";
  ESystemIconNames["PLUS"] = "plus";
  ESystemIconNames["CLOSE"] = "close";
  ESystemIconNames["ARROW_LEFT"] = "arrow-left";
  ESystemIconNames["ARROW_RIGHT"] = "arrow-right";
  ESystemIconNames["CHECK"] = "check";
  ESystemIconNames["DOWNLOAD"] = "download";
  ESystemIconNames["CIRCLE"] = "circle";
  ESystemIconNames["CIRCLE_CHECK"] = "circle-check";
  ESystemIconNames["USER"] = "user";
  ESystemIconNames["CIRCLE_INFO"] = "circle-info";
  ESystemIconNames["CIRCLE_ALERT"] = "circle-alert";
  ESystemIconNames["CIRCLE_CLOSE"] = "circle-close";
  ESystemIconNames["SEARCH"] = "search";
  ESystemIconNames["LANGUAGE"] = "language";
  ESystemIconNames["SHARE_OPTION"] = "share-option";
  ESystemIconNames["PLAY"] = "play";
  ESystemIconNames["MEATBALLS"] = "meatballs";
  ESystemIconNames["MINUS"] = "minus";
  ESystemIconNames["HAMBURGER"] = "hamburger";
  ESystemIconNames["GOOGLE"] = "google";
  ESystemIconNames["MEGAPHONE"] = "megaphone";
  ESystemIconNames["LIGHTBULB"] = "lightbulb";
  ESystemIconNames["ACADEMIC_CAP"] = "academic-cap";
  ESystemIconNames["EXTERNAL"] = "external";
})(ESystemIconNames || (ESystemIconNames = {}));

var IconComponent = (_a$4 = {}, _a$4[ESystemIconNames.ARROW_LEFT] = ArrowLeftIcon, _a$4[ESystemIconNames.ARROW_RIGHT] = ArrowRightIcon, _a$4[ESystemIconNames.CHECK] = CheckIcon, _a$4[ESystemIconNames.CHEVRON_DOWN] = ChevronDownIcon, _a$4[ESystemIconNames.CHEVRON_LEFT] = ChevronLeftIcon, _a$4[ESystemIconNames.CHEVRON_RIGHT] = ChevronRightIcon, _a$4[ESystemIconNames.CHEVRON_UP] = ChevronUpIcon, _a$4[ESystemIconNames.CIRCLE] = CircleIcon, _a$4[ESystemIconNames.CIRCLE_ALERT] = CircleAlertIcon, _a$4[ESystemIconNames.CIRCLE_CHECK] = CircleCheckIcon, _a$4[ESystemIconNames.CIRCLE_CLOSE] = CircleCloseIcon, _a$4[ESystemIconNames.CIRCLE_INFO] = CircleInfoIcon, _a$4[ESystemIconNames.CLOSE] = CloseIcon, _a$4[ESystemIconNames.DOWNLOAD] = DownloadIcon, _a$4[ESystemIconNames.LANGUAGE] = LanguageIcon, _a$4[ESystemIconNames.PASSWORD_HIDE] = PasswordHideIcon, _a$4[ESystemIconNames.PASSWORD_VIEW] = PasswordViewIcon, _a$4[ESystemIconNames.PLUS] = PlusIcon, _a$4[ESystemIconNames.SEARCH] = SearchIcon, _a$4[ESystemIconNames.USER] = UserIcon, _a$4[ESystemIconNames.SHARE_OPTION] = ShareOptionIcon, _a$4[ESystemIconNames.PLAY] = PlayIcon, _a$4[ESystemIconNames.MEATBALLS] = MeatballsIcon, _a$4[ESystemIconNames.MEGAPHONE] = MegaphoneIcon, _a$4[ESystemIconNames.MINUS] = MinusIcon, _a$4[ESystemIconNames.HAMBURGER] = HamburgerIcon, _a$4[ESystemIconNames.GOOGLE] = GoogleIcon, _a$4[ESystemIconNames.LIGHTBULB] = LightbulbIcon, _a$4[ESystemIconNames.ACADEMIC_CAP] = AcademicCapIcon, _a$4[ESystemIconNames.EXTERNAL] = ExternalIcon, _a$4);

var getViewBox = function getViewBox(icon) {
  switch (icon) {
    case ESystemIconNames.SHARE_OPTION:
    case ESystemIconNames.PLAY:
    case ESystemIconNames.DOWNLOAD:
    case ESystemIconNames.MEGAPHONE:
    case ESystemIconNames.LIGHTBULB:
    case ESystemIconNames.ACADEMIC_CAP:
      return '0 0 24 24';

    case ESystemIconNames.MEATBALLS:
      return '0 0 32 30';

    case ESystemIconNames.EXTERNAL:
      return '0 0 20 20';

    default:
      return '0 0 16 16';
  }
};

var iconIsFilled = function iconIsFilled(iconName) {
  switch (iconName) {
    case ESystemIconNames.DOWNLOAD:
    case ESystemIconNames.MINUS:
    case ESystemIconNames.HAMBURGER:
    case ESystemIconNames.MEATBALLS:
      return true;

    default:
      return false;
  }
};

var getSizeStyles$1 = function getSizeStyles$1(size) {
  switch (size) {
    case 'medium':
      {
        return {
          width: 'systemIconMedium',
          height: 'systemIconMedium'
        };
      }

    case 'large':
      {
        return {
          width: 'systemIconLarge',
          height: 'systemIconLarge'
        };
      }

    default:
      {
        return {
          width: 'systemIconSmall',
          height: 'systemIconSmall'
        };
      }
  }
};

var getColor$4 = function getColor$4(color, inverse) {
  var Color = {
    warning: 'icon.warning',
    neutral: inverse ? 'icon.system.inverseNeutral' : 'icon.system.defaultNeutral',
    success: inverse ? 'icon.system.successInverse' : 'icon.system.success',
    error: inverse ? 'icon.errorInverse' : 'icon.error',
    default: inverse ? 'icon.system.inverse' : 'icon.system.default',
    secondaryError: '#EF5752' // missing token

  };
  return Color[color];
};

var getStrokeWeightToken = function getStrokeWeightToken(strokeWeight, icon) {
  var filled = iconIsFilled(icon);

  switch (strokeWeight) {
    case 'medium':
      {
        return filled ? 'systemIconSmall' : 'systemIconMedium';
      }

    case 'large':
      {
        return filled ? 'systemIconSmall' : 'systemIconLarge';
      }

    default:
      {
        return filled ? null : 'systemIconSmall';
      }
  }
};

var SystemIcon = function SystemIcon(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _d = _a.size,
      size = _d === void 0 ? 'small' : _d,
      _e = _a.color,
      color = _e === void 0 ? 'default' : _e,
      _f = _a.inverse,
      inverse = _f === void 0 ? false : _f,
      _g = _a.strokeWeight,
      strokeWeight = _g === void 0 ? 'small' : _g,
      customStyles = _a.customStyles,
      _h = _a.inheritColor,
      inheritColor = _h === void 0 ? false : _h,
      name = _a.name;
  var Icon = IconComponent[name];
  var strokeWeightToken = getStrokeWeightToken(strokeWeight, name);
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var viewBox = getViewBox(name);
  var filled = iconIsFilled(name);
  var iconColor = inheritColor ? 'inherit' : getColor$4(color, inverse);
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("svg", _assign({
      className: className,
      viewBox: viewBox,
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      sx: _assign(_assign(_assign({}, getSizeStyles$1(size)), {
        // The external icon is weird, combines fills with transparent strokes and visible strokes.
        stroke: filled && strokeWeight === 'small' ? 'none' : iconColor,
        fill: filled ? iconColor : 'none',
        strokeWidth: get(selectedTheme, "borderWidths." + strokeWeightToken, '1px')
      }), customStyles)
    }, {
      children: [jsx("title", {
        children: name
      }, void 0), jsx(Icon, {}, void 0)]
    }), void 0)
  }), void 0);
};

var LinkIcon = function LinkIcon(_a) {
  var _b, _c, _d, _e, _f, _g;

  _a.inverse;

  var linkIcon = _a.linkIcon,
      _h = _a.linkIconSize,
      linkIconSize = _h === void 0 ? 'large' : _h,
      linkIconColor = _a.linkIconColor,
      arrowOnly = _a.arrowOnly,
      props = __rest(_a, ["inverse", "linkIcon", "linkIconSize", "linkIconColor", "arrowOnly"]);

  var legacy = props.theme === 'legacy';
  var selectedTheme = legacy ? legacyTheme : defaultTheme;
  var iconStyles = props.iconStyles;
  var Icon;

  switch (linkIcon) {
    case 'arrow':
      Icon = jsx("span", _assign({
        "aria-label": arrowOnly ? 'Arrow' : undefined,
        "data-testid": 'arrow-container',
        sx: {
          display: 'flex',
          height: '100%',
          minHeight: arrowOnly ? '48px' : '16px',
          alignItems: 'center',
          width: (_b = iconStyles.arrowBody) === null || _b === void 0 ? void 0 : _b.width,
          transition: "width " + selectedTheme.motion.linkAnimation + " ease"
        }
      }, {
        children: jsx("span", _assign({
          "data-testid": 'arrow-body',
          sx: {
            display: 'flex',
            height: '2px',
            position: 'relative',
            background: linkIconColor,
            width: '100%',
            transition: "width " + selectedTheme.motion.linkAnimation + " ease"
          }
        }, {
          children: jsx("span", {
            "data-testid": 'arrow-head',
            sx: {
              border: "2px solid",
              borderColor: linkIconColor,
              borderRadius: '2px',
              width: '12px',
              position: 'absolute',
              borderTop: 'none',
              borderLeft: 'none',
              height: '12px',
              transform: 'rotate(-45deg)',
              right: 0,
              top: '-5px'
            }
          }, void 0)
        }), void 0)
      }), void 0);
      break;

    case 'chevron':
      Icon = jsx("span", _assign({
        "aria-label": arrowOnly ? 'Chevron right' : undefined,
        "data-testid": 'chevron-container',
        sx: {
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          width: (_c = iconStyles.chevronBody) === null || _c === void 0 ? void 0 : _c.width,
          transition: "width " + selectedTheme.motion.linkAnimation + " ease"
        }
      }, {
        children: jsx("span", _assign({
          "data-testid": 'chevron-body',
          sx: {
            display: 'flex',
            height: '2px',
            position: 'relative',
            background: (_d = iconStyles.chevron) === null || _d === void 0 ? void 0 : _d.background,
            marginTop: '16px',
            marginBottom: '16px',
            width: '100%',
            transition: "width " + selectedTheme.motion.linkAnimation + " ease, background " + selectedTheme.motion.linkAnimation + " ease"
          }
        }, {
          children: jsx("span", {
            "data-testid": 'chevron-head',
            sx: {
              border: "2px solid",
              borderColor: linkIconColor,
              borderRadius: '2px',
              width: (_e = iconStyles.chevron) === null || _e === void 0 ? void 0 : _e.width,
              height: (_f = iconStyles.chevron) === null || _f === void 0 ? void 0 : _f.height,
              top: (_g = iconStyles.chevron) === null || _g === void 0 ? void 0 : _g.top,
              transition: "width " + selectedTheme.motion.linkAnimation + " ease,height " + selectedTheme.motion.linkAnimation + " ease,top " + selectedTheme.motion.linkAnimation + " ease",
              position: 'absolute',
              borderTop: 'none',
              borderLeft: 'none',
              transform: 'rotate(-45deg)',
              right: 0
            }
          }, void 0)
        }), void 0)
      }), void 0);
      break;

    case 'chevron-left':
      Icon = jsx("span", _assign({
        "aria-label": arrowOnly ? 'Chevron left' : undefined,
        "data-testid": 'chevron-container',
        sx: {
          display: 'flex',
          height: '100%',
          alignItems: 'center',
          width: '9px'
        }
      }, {
        children: jsx("span", _assign({
          "data-testid": 'chevron-body',
          sx: {
            display: 'flex',
            height: '2px',
            position: 'relative',
            background: 'transparent',
            marginTop: 'inc30',
            marginBottom: 'inc30',
            width: '100%'
          }
        }, {
          children: jsx("span", {
            "data-testid": 'chevron-head',
            sx: {
              border: "2px solid",
              borderColor: linkIconColor,
              borderRadius: '2px',
              width: '14px',
              height: '14px',
              top: '-6px',
              position: 'absolute',
              borderTop: 'none',
              borderLeft: 'none',
              transform: 'rotate(135deg)',
              right: '-6px'
            }
          }, void 0)
        }), void 0)
      }), void 0);
      break;

    default:
      Icon = jsx("div", _assign({
        sx: {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          fill: linkIconColor,
          stroke: linkIconColor
        }
      }, {
        children: jsx(SystemIcon, {
          size: linkIconSize,
          name: linkIcon,
          inheritColor: true
        }, void 0)
      }), void 0);
  }

  var isFirst = linkIcon === 'chevron-left';
  return jsx("div", _assign({
    "data-testid": 'link-icon-container',
    onMouseOver: props.onMouseOver,
    onMouseLeave: props.onMouseLeave,
    sx: {
      marginLeft: arrowOnly || isFirst ? 0 : 'inc30',
      order: isFirst && -1,
      marginRight: isFirst && 'inc30'
    }
  }, {
    children: Icon || null
  }), void 0);
};

var Text = function Text(_a) {
  var children = _a.children,
      href = _a.href,
      className = _a.className,
      theme = _a.theme,
      props = __rest(_a, ["children", "href", "className", "theme"]);

  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("span", _assign({
      className: className,
      sx: _assign({
        display: 'flex',
        maxWidth: props.textContentMaxWidth,
        alignItems: 'center'
      }, getVariantStyles$2(_assign(_assign({}, props), {
        href: href,
        theme: theme
      })))
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var LinkContent = function LinkContent(props) {
  var _a;

  var theme = props.theme,
      defaultArrow = props.defaultArrow,
      href = props.href,
      children = props.children,
      isNav = props.isNav,
      arrowOnly = props.arrowOnly,
      linkIcon = props.linkIcon,
      linkIconSize = props.linkIconSize,
      linkIconColor = props.linkIconColor,
      linkIconDisableExpand = props.linkIconDisableExpand,
      navItem = props.navItem,
      navTitle = props.navTitle,
      inverse = props.inverse;
  var content;
  var textClass = 'textlink-text-class';
  var arrowClass = 'textlink-arrow-class';
  var linkIconClass = 'textlink-link-icon-class';
  var defaultTextClass = 'textlink-default-text-class';
  var legacy = theme === 'legacy';
  var selectedTheme = legacy ? legacyTheme : defaultTheme;
  var arrowBody = {
    width: arrowOnly ? selectedTheme.sizes.inc50 : selectedTheme.sizes.inc30
  };
  var chevronBody = {
    width: '9px'
  };
  var chevron = {
    width: '12px',
    height: '12px',
    background: 'transparent',
    top: '-6px'
  };
  var initialStyles = {
    arrowBody: arrowBody,
    chevronBody: chevronBody,
    chevron: chevron
  };

  var _b = useState(initialStyles),
      iconStyles = _b[0],
      setIconStyles = _b[1];

  var iconColor = getIconColor$1(linkIconColor, inverse, selectedTheme);

  var changeIconStyles = function changeIconStyles(styles) {
    setIconStyles(styles);
  };

  var resetIconStyles = function resetIconStyles() {
    return setIconStyles(initialStyles);
  };

  if (defaultArrow) {
    content = jsxs(Fragment, {
      children: [jsx(Text, _assign({
        className: textClass
      }, props, {
        href: href
      }, {
        children: children
      }), void 0), ' ', jsx(Arrow$2, _assign({
        className: arrowClass
      }, props, {
        isNav: isNav
      }), void 0)]
    }, void 0);
  } else if (arrowOnly) {
    content = jsx(Fragment, {
      children: linkIcon ? jsx(LinkIcon, _assign({
        className: linkIconClass
      }, props, {
        linkIcon: linkIcon,
        linkIconSize: linkIconSize,
        linkIconColor: iconColor,
        iconStyles: iconStyles,
        onMouseOver: function onMouseOver() {
          return changeIconStyles({
            arrowBody: {
              width: selectedTheme.sizes.inc70
            },
            chevronBody: {
              width: selectedTheme.sizes.inc70
            },
            chevron: {
              background: iconColor,
              width: '12px',
              height: '12px',
              top: '-5px'
            }
          });
        },
        onMouseLeave: resetIconStyles
      }), void 0) : jsx(Arrow$2, _assign({
        className: arrowClass
      }, props, {
        isNav: isNav,
        navItem: navItem
      }), void 0)
    }, void 0);
  } else if (linkIcon) {
    content = jsxs("div", _assign({
      sx: {
        alignItems: 'center',
        display: 'flex',
        width: '100%',
        '&:hover': {
          color: navItem || navTitle ? inverse ? 'link.cta.inverse.text' : 'link.navigation.text' : inverse ? 'link.cta.inverse.text' : 'link.cta.default.text',
          span: {
            color: inverse ? 'link.cta.inverse.icon' : 'link.cta.default.textHover'
          }
        }
      },
      onMouseOver: function onMouseOver() {
        return !linkIconDisableExpand && changeIconStyles({
          arrowBody: {
            width: selectedTheme.sizes.inc50
          },
          chevronBody: {
            width: selectedTheme.sizes.inc40
          },
          chevron: {
            background: iconColor,
            width: '12px',
            height: '12px',
            top: '-5px'
          }
        });
      },
      onMouseLeave: resetIconStyles
    }, {
      children: [jsx(Text, _assign({
        className: linkIconClass
      }, props, {
        href: href
      }, {
        children: children
      }), void 0), jsx(LinkIcon, _assign({
        className: arrowClass
      }, props, {
        linkIcon: linkIcon,
        linkIconColor: iconColor,
        iconStyles: iconStyles
      }), void 0)]
    }), void 0);
  } else {
    content = jsx(Fragment, {
      children: jsx(Text, _assign({
        className: legacy ? textClass : defaultTextClass
      }, props, {
        href: href
      }, {
        children: children
      }), void 0)
    }, void 0);
  }

  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("div", _assign({
      sx: (_a = {
        display: 'flex',
        alignItems: navTitle ? 'flex-end' : 'center',
        textAlign: 'left'
      }, _a["& ." + defaultTextClass] = {
        color: isNav ? inverse ? 'black00' : 'link.navigation.text' : inverse ? selectedTheme.colors.link.inline.inverse.text : selectedTheme.colors.link.inline.default.text,
        lineHeight: !isNav && 'inc30',
        borderBottom: "2px solid transparent",
        '&:hover': {
          borderBottom: inverse ? "2px solid " + selectedTheme.colors.link.inline.inverse.underline : "2px solid " + selectedTheme.colors.link.inline.default.underline
        }
      }, _a["& ." + arrowClass] = {
        color: isNav ? 'green50' : selectedTheme.colors.link.cta.default.text,
        lineHeight: !isNav && 'inc30'
      }, _a["& ." + linkIconClass] = {
        color: isNav ? 'link.navigation.text' : inverse ? selectedTheme.colors.link.cta.inverse.text : selectedTheme.colors.link.cta.default.text,
        lineHeight: !isNav && 'inc30'
      }, _a["&:hover ." + textClass] = isNav && {
        color: 'green50',
        WebkitAnimation: 'linear 1 alternate',
        WebkitAnimationName: 'color',
        WebkitAnimationDuration: selectedTheme.motion.linkAnimation,
        '@-webkit-keyframes color': {
          '0%': {
            color: 'black80'
          },
          '100%': {
            left: 'green50'
          }
        }
      }, _a["&:hover ." + arrowClass] = isNav && {
        left: navItem && '0',
        WebkitAnimation: 'linear 1 alternate',
        WebkitAnimationName: navItem ? 'runLink' : 'runTitle',
        WebkitAnimationDuration: selectedTheme.motion.linkAnimation,
        '@-webkit-keyframes runTitle': {
          '0%': {
            left: '0'
          },
          '33%': {
            left: '25px'
          },
          '66%': {
            left: '-25px'
          },
          '100%': {
            left: '0'
          }
        },
        '@-webkit-keyframes runLink': {
          '0%': {
            left: '-100px'
          },
          '100%': {
            left: '0'
          }
        }
      }, _a)
    }, {
      children: content
    }), void 0)
  }), void 0);
};

var Link = function Link(_a) {
  var href = _a.href,
      target = _a.target,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _d = _a.onClick,
      onClick = _d === void 0 ? function () {} : _d,
      _e = _a.onTouchStart,
      onTouchStart = _e === void 0 ? function () {} : _e,
      _f = _a.onMouseEnter,
      onMouseEnter = _f === void 0 ? function () {} : _f,
      _g = _a.onMouseLeave,
      onMouseLeave = _g === void 0 ? function () {} : _g,
      _h = _a.tabIndex,
      tabIndex = _h === void 0 ? 0 : _h,
      arrowOnly = _a.arrowOnly,
      defaultArrow = _a.defaultArrow,
      linkIcon = _a.linkIcon,
      linkIconSize = _a.linkIconSize,
      // Will only affect ESystemIconNames icons.
  linkIconColor = _a.linkIconColor,
      _j = _a.linkIconDisableExpand,
      linkIconDisableExpand = _j === void 0 ? false : _j,
      children = _a.children,
      _k = _a.trackClick,
      trackClick = _k === void 0 ? true : _k,
      _l = _a.trackCategory,
      trackCategory = _l === void 0 ? '' : _l,
      customStyles = _a.customStyles,
      itemProp = _a.itemProp,
      props = __rest(_a, ["href", "target", "className", "theme", "onClick", "onTouchStart", "onMouseEnter", "onMouseLeave", "tabIndex", "arrowOnly", "defaultArrow", "linkIcon", "linkIconSize", "linkIconColor", "linkIconDisableExpand", "children", "trackClick", "trackCategory", "customStyles", "itemProp"]);

  var isNav = props.navItem || props.navTitle;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;

  var contentProps = _assign(_assign({}, props), {
    defaultArrow: defaultArrow,
    linkIcon: linkIcon,
    linkIconSize: linkIconSize,
    linkIconColor: linkIconColor,
    linkIconDisableExpand: linkIconDisableExpand,
    arrowOnly: arrowOnly,
    href: href,
    target: target,
    isNav: isNav,
    theme: theme
  });

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onClick();
  };

  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: href ? jsx("a", _assign({
      itemProp: itemProp,
      tabIndex: tabIndex,
      href: href,
      target: target,
      className: className,
      onClick: handleClick,
      sx: _assign(_assign({
        fontFamily: 'body',
        fontWeight: props.navItem ? '300' : '500',
        cursor: 'pointer',
        textDecoration: 'none'
      }, getVariantStyles$2(_assign(_assign({}, props), {
        href: href,
        theme: theme
      }))), customStyles),
      "data-track": trackClick.toString(),
      "data-track-category": trackCategory === '' ? undefined : trackCategory
    }, {
      children: jsx(LinkContent, _assign({}, contentProps, {
        children: children
      }), void 0)
    }), void 0) : jsx("button", _assign({
      tabIndex: tabIndex,
      className: className,
      onClick: handleClick,
      onTouchStart: onTouchStart,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      sx: _assign({
        fontFamily: 'body',
        fontWeight: props.navItem ? '300' : '500',
        cursor: 'pointer',
        background: 'none',
        border: 'none',
        px: 'inc00'
      }, getVariantStyles$2(_assign(_assign({}, props), {
        href: href,
        theme: theme
      }))),
      "data-track": trackClick.toString(),
      "data-track-category": trackCategory === '' ? undefined : trackCategory
    }, {
      children: jsx(LinkContent, _assign({}, contentProps, {
        children: children
      }), void 0)
    }), void 0)
  }), void 0);
};

var Container$1 = function Container$1(_a) {
  var children = _a.children;
  return jsx("div", _assign({
    sx: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'center',
      flexDirection: 'column',
      zIndex: 99999,
      padding: "0 inc20",
      width: ['100%', null, '600px', '800px'],
      height: ['350px', '500px', '600px', '600px']
    }
  }, {
    children: children
  }), void 0);
};

var IconButton = function IconButton(_a) {
  var children = _a.children,
      theme = _a.theme,
      onClick = _a.onClick;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx("button", _assign({
    "aria-label": 'lightbox-close',
    onClick: onClick,
    sx: {
      width: 'inc40',
      height: 'inc40',
      border: 'none',
      marginBottom: 'inc20',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bg: 'background.containerLighter',
      zIndex: 1,
      '&:hover': {
        opacity: "" + selectedTheme.opacity.inc80
      },
      boxShadow: 'level01',
      borderRadius: 'circle',
      stroke: 'icon.system.default',
      cursor: 'pointer'
    }
  }, {
    children: children
  }), void 0);
};

var LightboxElement = function LightboxElement(_a) {
  var children = _a.children,
      className = _a.className,
      isOpen = _a.isOpen,
      theme = _a.theme;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx("div", _assign({
    "aria-label": 'lightbox',
    className: className,
    sx: {
      position: 'fixed',
      display: isOpen ? 'flex' : 'none',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      zIndex: 9999,
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      '&::after': {
        content: '""',
        width: '100%',
        height: '100%',
        backgroundColor: 'background.containerInverseDarker',
        opacity: "" + selectedTheme.opacity.modalScrim,
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 9999,
        display: isOpen ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }
    }
  }, {
    children: children
  }), void 0);
};

var Lightbox = function Lightbox(_a) {
  var isOpen = _a.isOpen,
      _b = _a.onClose,
      onClose = _b === void 0 ? function () {} : _b,
      children = _a.children,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      _d = _a.theme,
      theme = _d === void 0 ? 'default' : _d;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx(LightboxElement, _assign({
      className: className,
      isOpen: isOpen,
      theme: theme
    }, {
      children: jsxs(Container$1, {
        children: [jsx(IconButton, _assign({
          onClick: onClose,
          theme: theme
        }, {
          children: jsxs("svg", _assign({
            width: '16',
            height: '16',
            viewBox: '0 0 16 16',
            fill: 'none',
            xmlns: 'http://www.w3.org/2000/svg'
          }, {
            children: [jsx("path", {
              d: 'M2.13379 2.1333L13.8671 13.8666',
              strokeLinecap: 'round'
            }, void 0), jsx("path", {
              d: 'M2.13379 13.8666L13.8671 2.1333',
              strokeLinecap: 'round'
            }, void 0)]
          }), void 0)
        }), void 0), children]
      }, void 0)
    }), void 0)
  }), void 0);
};

var useDimension = function useDimension(ref) {
  var getDimensions = function getDimensions() {
    var _a, _b;

    return {
      width: ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0,
      height: ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0
    };
  };

  var _a = useState({
    width: 0,
    height: 0
  }),
      dimensions = _a[0],
      setDimensions = _a[1];

  var handleResize = function handleResize() {
    setDimensions(getDimensions());
  };

  useEffect(function () {
    if (ref.current) {
      setDimensions(getDimensions());
    }

    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [ref]);
  return dimensions;
};

var PADDING = 8;

var topCalc = function topCalc(_a) {
  var height = _a.height,
      direction = _a.direction,
      parentHeight = _a.parentHeight,
      isMobile = _a.isMobile;

  if ((direction === ARROW_DIRECTION.LeftCenter || direction === ARROW_DIRECTION.LeftTop || direction === ARROW_DIRECTION.RightCenter || direction === ARROW_DIRECTION.RightTop || direction === ARROW_DIRECTION.LeftBottom || direction === ARROW_DIRECTION.RightBottom) && !isMobile) {
    return -PADDING;
  }

  if (direction === ARROW_DIRECTION.TopCenter || direction === ARROW_DIRECTION.TopLeft || direction === ARROW_DIRECTION.TopRight) {
    return parentHeight;
  }

  return (height + PADDING) * -1;
};

var bottomCalc = function bottomCalc(_a) {
  var direction = _a.direction,
      isMobile = _a.isMobile;

  if ((direction === ARROW_DIRECTION.LeftBottom || direction === ARROW_DIRECTION.RightBottom) && !isMobile) {
    return 0;
  }

  return;
};

var leftCalc = function leftCalc(_a) {
  var width = _a.width,
      direction = _a.direction,
      parentWidth = _a.parentWidth,
      isMobile = _a.isMobile;

  if ((direction === ARROW_DIRECTION.LeftCenter || direction === ARROW_DIRECTION.LeftBottom || direction === ARROW_DIRECTION.LeftTop) && !isMobile) {
    return parentWidth + PADDING;
  }

  if (direction === ARROW_DIRECTION.TopLeft || direction === ARROW_DIRECTION.BottomLeft) {
    return 0;
  }

  if (direction === ARROW_DIRECTION.TopCenter || direction === ARROW_DIRECTION.BottomCenter || direction === ARROW_DIRECTION.LeftCenter) {
    return (parentWidth - width) / 2;
  }

  return;
};

var rightCalc = function rightCalc(_a) {
  var direction = _a.direction,
      parentWidth = _a.parentWidth,
      isMobile = _a.isMobile,
      width = _a.width;

  if ((direction === ARROW_DIRECTION.RightBottom || direction === ARROW_DIRECTION.RightCenter || direction === ARROW_DIRECTION.RightTop) && !isMobile) {
    return parentWidth + PADDING;
  }

  if (direction === ARROW_DIRECTION.RightCenter) {
    return (parentWidth - width) / 2;
  }

  if (direction === ARROW_DIRECTION.TopRight || direction === ARROW_DIRECTION.BottomRight || direction === ARROW_DIRECTION.LeftBottom || direction === ARROW_DIRECTION.RightBottom) {
    return 0;
  }

  return;
};

var isFlexStart = function isFlexStart(_a) {
  var direction = _a.direction;
  return direction === ARROW_DIRECTION.TopLeft || direction === ARROW_DIRECTION.BottomLeft || direction === ARROW_DIRECTION.LeftTop || direction === ARROW_DIRECTION.RightTop;
};

var isFlexEnd = function isFlexEnd(_a) {
  var direction = _a.direction;
  return direction === ARROW_DIRECTION.TopRight || direction === ARROW_DIRECTION.LeftBottom || direction === ARROW_DIRECTION.BottomRight || direction === ARROW_DIRECTION.RightBottom;
};

var isRowReverse = function isRowReverse(_a) {
  var direction = _a.direction;
  return direction === ARROW_DIRECTION.LeftBottom || direction === ARROW_DIRECTION.LeftCenter || direction === ARROW_DIRECTION.LeftTop;
};

var isRow = function isRow(_a) {
  var direction = _a.direction;
  return direction === ARROW_DIRECTION.RightBottom || direction === ARROW_DIRECTION.RightCenter || direction === ARROW_DIRECTION.RightTop;
};

var isColumnReverse = function isColumnReverse(_a) {
  var direction = _a.direction;
  return direction === ARROW_DIRECTION.TopCenter || direction === ARROW_DIRECTION.TopRight || direction === ARROW_DIRECTION.TopLeft;
};

var alignItems = function alignItems(direction) {
  if (isFlexStart({
    direction: direction
  })) {
    return 'flex-start';
  }

  if (isFlexEnd({
    direction: direction
  })) {
    return 'flex-end';
  }

  return 'center';
};

var flexDirection = function flexDirection(direction, isMobile) {
  if (!isMobile && isRowReverse({
    direction: direction
  })) {
    return 'row-reverse';
  }

  if (isColumnReverse({
    direction: direction
  })) {
    return 'column-reverse';
  }

  if (!isMobile && isRow({
    direction: direction
  })) {
    return 'row';
  }

  return 'column';
};

var Content$2 = function Content$2(_a) {
  var _b;

  var direction = _a.direction,
      children = _a.children,
      theme = _a.theme;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var tabletBreakpoint = selectedTheme.breakpoints[1];
  var desktopMediaQuerySelector = "@media screen and (min-width: " + tabletBreakpoint + ")";
  return jsx("div", _assign({
    "aria-label": 'tooltip-content',
    sx: (_b = {
      position: 'relative',
      display: 'flex',
      flexDirection: flexDirection(direction, true),
      alignItems: alignItems(direction)
    }, _b[desktopMediaQuerySelector] = {
      flexDirection: flexDirection(direction, false),
      alignItems: alignItems(direction)
    }, _b)
  }, {
    children: children
  }), void 0);
};

var Shared = function Shared(_a) {
  var style = _a.style;
  return jsx("div", {
    sx: _assign({
      width: 0,
      height: 0
    }, style)
  }, void 0);
};

var tabletBreakpoint = defaultTheme.breakpoints[1];
var tabletMediaQuerySelector = "@media screen and (max-width: " + tabletBreakpoint + ")";

var ArrowDown = function ArrowDown(_a) {
  var direction = _a.direction,
      inverse = _a.inverse;
  return jsx(Shared, {
    style: {
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      marginLeft: direction === ARROW_DIRECTION.BottomLeft ? 'base' : '0',
      marginRight: direction === ARROW_DIRECTION.BottomRight ? 'base' : '0',
      borderTop: "8px solid " + (inverse ? defaultTheme.colors.background.containerLighter : defaultTheme.colors.background.containerInverse)
    }
  }, void 0);
};

var ArrowTop = function ArrowTop(_a) {
  var direction = _a.direction,
      inverse = _a.inverse;
  return jsx(Shared, {
    style: {
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      marginLeft: direction === ARROW_DIRECTION.TopLeft ? 'base' : '0',
      marginRight: direction === ARROW_DIRECTION.TopRight ? 'base' : '0',
      borderBottom: "8px solid " + (inverse ? defaultTheme.colors.background.containerLighter : defaultTheme.colors.background.containerInverse)
    }
  }, void 0);
};

var ArrowLeft = function ArrowLeft(_a) {
  var _b;

  var inverse = _a.inverse,
      direction = _a.direction;
  return jsx(Shared, {
    style: (_b = {
      borderTop: '8px solid transparent',
      borderRight: "8px solid " + (inverse ? defaultTheme.colors.background.containerLighter : defaultTheme.colors.background.containerInverse),
      borderBottom: '8px solid transparent',
      marginTop: direction === ARROW_DIRECTION.LeftTop ? 'base' : 0,
      marginBottom: direction === ARROW_DIRECTION.LeftBottom ? 'base' : 0
    }, _b[tabletMediaQuerySelector] = {
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: 'none',
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 'base',
      marginRight: 'base',
      borderTop: "8px solid " + (inverse ? defaultTheme.colors.background.containerLighter : defaultTheme.colors.background.containerInverse)
    }, _b)
  }, void 0);
};

var ArrowRight = function ArrowRight(_a) {
  var _b;

  var inverse = _a.inverse,
      direction = _a.direction;
  return jsx(Shared, {
    style: (_b = {
      borderTop: '8px solid transparent',
      borderLeft: "8px solid " + (inverse ? defaultTheme.colors.background.containerLighter : defaultTheme.colors.background.containerInverse),
      borderBottom: '8px solid transparent',
      marginTop: direction === ARROW_DIRECTION.RightTop ? 'base' : 0,
      marginBottom: direction === ARROW_DIRECTION.RightBottom ? 'base' : 0
    }, _b[tabletMediaQuerySelector] = {
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderBottom: 'none',
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 'base',
      marginRight: 'base',
      borderTop: "8px solid " + (inverse ? defaultTheme.colors.background.containerLighter : defaultTheme.colors.background.containerInverse)
    }, _b)
  }, void 0);
};

var Arrow$1 = function Arrow$1(_a) {
  var _b = _a.direction,
      direction = _b === void 0 ? ARROW_DIRECTION.BottomCenter : _b,
      inverse = _a.inverse;

  switch (direction) {
    case ARROW_DIRECTION.LeftCenter:
    case ARROW_DIRECTION.LeftBottom:
    case ARROW_DIRECTION.LeftTop:
      return jsx(ArrowLeft, {
        direction: direction,
        inverse: inverse
      }, void 0);

    case ARROW_DIRECTION.RightCenter:
    case ARROW_DIRECTION.RightTop:
    case ARROW_DIRECTION.RightBottom:
      return jsx(ArrowRight, {
        direction: direction,
        inverse: inverse
      }, void 0);

    case ARROW_DIRECTION.TopCenter:
    case ARROW_DIRECTION.TopRight:
    case ARROW_DIRECTION.TopLeft:
      return jsx(ArrowTop, {
        direction: direction,
        inverse: inverse
      }, void 0);

    default:
      return jsx(ArrowDown, {
        direction: direction,
        inverse: inverse
      }, void 0);
  }
};

var Container = function Container(_a) {
  var _b;

  var children = _a.children,
      props = __rest(_a, ["children"]);

  var ref = useRef(null);

  var _c = useDimension(ref),
      width = _c.width,
      height = _c.height;

  var tabletBreakpoint = defaultTheme.breakpoints[1];
  var desktopMediaQuerySelector = "@media screen and (min-width: " + tabletBreakpoint + ")";
  return jsx("div", _assign({
    ref: ref,
    "aria-label": 'tooltip-container',
    sx: (_b = {
      position: 'absolute',
      zIndex: 999,
      maxWidth: 272,
      width: 'max-content',
      top: topCalc(_assign(_assign({}, props), {
        height: height,
        isMobile: true
      })),
      left: leftCalc(_assign(_assign({}, props), {
        width: width,
        isMobile: true
      })),
      right: rightCalc(_assign(_assign({}, props), {
        width: width,
        isMobile: true
      })),
      bottom: bottomCalc(_assign(_assign({}, props), {
        isMobile: true
      }))
    }, _b[desktopMediaQuerySelector] = {
      top: topCalc(_assign(_assign({}, props), {
        height: height,
        isMobile: false
      })),
      bottom: bottomCalc(_assign(_assign({}, props), {
        isMobile: false
      })),
      left: leftCalc(_assign(_assign({}, props), {
        width: width,
        isMobile: false
      })),
      right: rightCalc(_assign(_assign({}, props), {
        width: width,
        isMobile: false
      }))
    }, _b)
  }, {
    children: children
  }), void 0);
};

var Box = function Box(_a) {
  var _b;

  var children = _a.children,
      inverse = _a.inverse;
  var tabletBreakpoint = defaultTheme.breakpoints[1];
  var desktopMediaQuerySelector = "@media screen and (min-width: " + tabletBreakpoint + ")";
  return jsx("div", _assign({
    "aria-label": 'tooltip-box',
    sx: (_b = {
      bg: inverse ? 'background.containerLighter' : 'background.containerInverse',
      color: inverse ? 'text.default' : 'text.inverse',
      borderRadius: 'tooltips',
      padding: 'inc10',
      textAlign: 'left',
      fontSize: 'inc00',
      lineHeight: 'inc10',
      fontFamily: 'body',
      width: '100%',
      boxShadow: 'level01'
    }, _b[desktopMediaQuerySelector] = {
      fontSize: 'inc10',
      lineHeight: 'inc20',
      padding: 'inc20'
    }, _b)
  }, {
    children: children
  }), void 0);
};

var ARROW_DIRECTION;

(function (ARROW_DIRECTION) {
  ARROW_DIRECTION["BottomCenter"] = "bottom-center";
  ARROW_DIRECTION["BottomLeft"] = "bottom-left";
  ARROW_DIRECTION["BottomRight"] = "bottom-right";
  ARROW_DIRECTION["TopCenter"] = "top-center";
  ARROW_DIRECTION["TopLeft"] = "top-left";
  ARROW_DIRECTION["TopRight"] = "top-right";
  ARROW_DIRECTION["LeftCenter"] = "left-center";
  ARROW_DIRECTION["LeftTop"] = "left-top";
  ARROW_DIRECTION["LeftBottom"] = "left-bottom";
  ARROW_DIRECTION["RightCenter"] = "right-center";
  ARROW_DIRECTION["RightTop"] = "right-top";
  ARROW_DIRECTION["RightBottom"] = "right-bottom";
})(ARROW_DIRECTION || (ARROW_DIRECTION = {}));

var fadeIn = keyframes(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"], ["\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n"])));
var fadeOut = keyframes(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"], ["\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n"])));

var Fade = function Fade(_a) {
  var children = _a.children,
      visible = _a.visible;
  return jsx("div", _assign({
    sx: {
      display: 'inline-block',
      visibility: visible ? 'visible' : 'hidden',
      animation: (visible ? fadeIn : fadeOut) + " 0.2s linear"
    }
  }, {
    children: children
  }), void 0);
};

var TooltipBlock = function TooltipBlock(_a) {
  var text = _a.text,
      arrowDirection = _a.arrowDirection,
      parentWidth = _a.parentWidth,
      parentHeight = _a.parentHeight,
      visible = _a.visible,
      theme = _a.theme,
      inverse = _a.inverse;
  return jsx(Container, _assign({}, {
    parentHeight: parentHeight,
    parentWidth: parentWidth,
    direction: arrowDirection
  }, {
    children: jsx(Fade, _assign({}, {
      visible: visible
    }, {
      children: jsxs(Content$2, _assign({
        direction: arrowDirection,
        theme: theme
      }, {
        children: [jsx(Box, _assign({
          inverse: inverse
        }, {
          children: text
        }), void 0), jsx(Arrow$1, {
          direction: arrowDirection,
          inverse: inverse
        }, void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
};

var templateObject_1$1, templateObject_2;

var useOnClickOutside = function useOnClickOutside(ref, handler) {
  useEffect(function () {
    var listener = function listener(event) {
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);
    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

var Tooltip = function Tooltip(_a) {
  var children = _a.children,
      text = _a.text,
      _b = _a.arrowDirection,
      arrowDirection = _b === void 0 ? ARROW_DIRECTION.BottomCenter : _b,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      _d = _a.theme,
      theme = _d === void 0 ? 'default' : _d;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;

  var _e = useState(false),
      visible = _e[0],
      setVisible = _e[1];

  var ref = useRef(null);

  var _f = useDimension(ref),
      width = _f.width,
      height = _f.height;

  useOnClickOutside(ref, function () {
    return setVisible(false);
  });

  var mobileStateHandler = function mobileStateHandler(value) {
    setVisible(value);
  };

  var onTouch = function onTouch() {
    return mobileStateHandler(!visible);
  };

  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      "aria-label": 'tooltip-wrapper',
      sx: {
        position: 'relative',
        display: 'inline-flex',
        color: inverse ? 'text.inverse' : 'text.default'
      },
      ref: ref,
      onMouseEnter: function onMouseEnter() {
        setVisible(true);
      },
      onMouseLeave: function onMouseLeave() {
        setVisible(false);
      },
      onTouchStart: onTouch
    }, {
      children: [text && visible && jsx(TooltipBlock, _assign({}, {
        text: text,
        arrowDirection: arrowDirection,
        parentWidth: width,
        parentHeight: height,
        visible: visible,
        inverse: inverse,
        theme: theme
      }), void 0), children]
    }), void 0)
  }), void 0);
};

var _a$3, _b;

var ELogoVariant;

(function (ELogoVariant) {
  ELogoVariant["STACKED_DEFAULT"] = "Stacked Default";
  ELogoVariant["STACKED_INVERSE"] = "Stacked Inverse";
  ELogoVariant["STACKED_SPRING_GREEN"] = "Stacked Spring Green";
  ELogoVariant["STACKED_FOREST_GREEN"] = "Stacked Forest Green";
  ELogoVariant["STACKED_ALL_BLACK"] = "Stacked All Black";
  ELogoVariant["STACKED_ALL_WHITE"] = "Stacked All White";
  ELogoVariant["HORIZONTAL_DEFAULT"] = "Horizontal Default";
  ELogoVariant["HORIZONTAL_INVERSE"] = "Horizontal Inverse";
  ELogoVariant["HORIZONTAL_FOREST_GREEN"] = "Horizontal Forest Green";
  ELogoVariant["HORIZONTAL_SPRING_GREEN"] = "Horizontal Spring Green";
  ELogoVariant["HORIZONTAL_ALL_BLACK"] = "Horizontal All Black";
  ELogoVariant["HORIZONTAL_ALL_WHITE"] = "Horizontal All White";
  ELogoVariant["LEAF_DEFAULT"] = "Leaf Default";
  ELogoVariant["LEAF_ALL_BLACK"] = "Leaf All Black";
  ELogoVariant["LEAF_ALL_WHITE"] = "Leaf All White";
})(ELogoVariant || (ELogoVariant = {}));

var LogoPaths$1 = (_a$3 = {}, _a$3[ELogoVariant.LEAF_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj2focmkbxv7gh3-stacked_default_slate_blue.svg?auto=format%252Ccompress', _a$3[ELogoVariant.LEAF_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjcnyx8tghdv3ya-stacked_white.svg?auto=format%252Ccompress', _a$3[ELogoVariant.STACKED_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjcnyx8tghdv3ya-stacked_white.svg?auto=format%252Ccompress', _a$3[ELogoVariant.STACKED_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj2focmkbxv7gh3-stacked_default_slate_blue.svg?auto=format%252Ccompress', _a$3[ELogoVariant.STACKED_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjcnyx8tghdv3ya-stacked_white.svg?auto=format%252Ccompress', _a$3[ELogoVariant.STACKED_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj2focmkbxv7gh3-stacked_default_slate_blue.svg?auto=format%252Ccompress', _a$3[ELogoVariant.HORIZONTAL_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj3d95v5vbmm2f4-horizontal_white.svg?auto=format%252Ccompress', _a$3[ELogoVariant.HORIZONTAL_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjf3vea2hg34taa-horizontal_default_slate_blue.svg?auto=format%252Ccompress', _a$3[ELogoVariant.HORIZONTAL_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjf3vea2hg34taa-horizontal_default_slate_blue.svg?auto=format%252Ccompress', _a$3[ELogoVariant.HORIZONTAL_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj3d95v5vbmm2f4-horizontal_white.svg?auto=format%252Ccompress', _a$3[ELogoVariant.LEAF_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kuyj2focmkbxv7gh3-stacked_default_slate_blue.svg?auto=format%252Ccompress', _a$3[ELogoVariant.HORIZONTAL_SPRING_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjaqno04qecjezz-horizontal_spring_green.svg?auto=format%252Ccompress', _a$3[ELogoVariant.STACKED_FOREST_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjc2nyso711vv9y-stacked_forest_green.svg?auto=format%252Ccompress', _a$3[ELogoVariant.HORIZONTAL_FOREST_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjdssznhgeuje6g-horizontal_forest_green.svg?auto=format%252Ccompress', _a$3[ELogoVariant.STACKED_SPRING_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kuyjefaguj6vxb77f-stacked_spring_green.svg?auto=format%252Ccompress', _a$3);
var LegacyLogoPaths = (_b = {}, _b[ELogoVariant.LEAF_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5tquvsd872oci1-Leaf_AllBlack.svg?auto=format%252Ccompress', _b[ELogoVariant.LEAF_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo66lvkvhd3f3b2e-Leaf_AllWhite.svg?auto=format%252Ccompress', _b[ELogoVariant.STACKED_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5i82g0bmzw0af5-Stacked_AllWhite.svg?auto=format%252Ccompress', _b[ELogoVariant.STACKED_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5nndrayrczjmgb-Stacked_AllBlack.svg?auto=format%252Ccompress', _b[ELogoVariant.STACKED_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo67f03j7lysjkc7-Stacked_Inverse.svg?auto=format%252Ccompress', _b[ELogoVariant.STACKED_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5vhhgq7u6e0ot6-Stacked_Default.svg?auto=format%252Ccompress', _b[ELogoVariant.HORIZONTAL_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5u9my2lllbpclj-Horizontal_Inverse.svg?auto=format%252Ccompress', _b[ELogoVariant.HORIZONTAL_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5kblefbjq79065-Horizontal_Default.svg?auto=format%252Ccompress', _b[ELogoVariant.HORIZONTAL_ALL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5loumhtiy9kgdw-Horizontal_AllBlack.svg?auto=format%252Ccompress', _b[ELogoVariant.HORIZONTAL_ALL_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5v3dveeadn53k2-Horizontal_AllWhite.svg?auto=format%252Ccompress', _b[ELogoVariant.LEAF_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5n3t3t4msf5ys6-Leaf_Default.svg?auto=format%252Ccompress', _b[ELogoVariant.HORIZONTAL_SPRING_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5kblefbjq79065-Horizontal_Default.svg?auto=format%252Ccompress', _b[ELogoVariant.STACKED_FOREST_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5n3t3t4msf5ys6-Leaf_Default.svg?auto=format%252Ccompress', _b[ELogoVariant.HORIZONTAL_FOREST_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5kblefbjq79065-Horizontal_Default.svg?auto=format%252Ccompress', _b[ELogoVariant.STACKED_SPRING_GREEN] = 'https://webimages.mongodb.com/_com_assets/cms/kpo5n3t3t4msf5ys6-Leaf_Default.svg?auto=format%252Ccompress', _b);

var MDBLogo = function MDBLogo(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      href = _a.href,
      target = _a.target,
      imageWidth = _a.imageWidth,
      _d = _a.variant,
      variant = _d === void 0 ? ELogoVariant.HORIZONTAL_DEFAULT : _d;
  var selectedLogoPaths = theme === 'legacy' ? LegacyLogoPaths : LogoPaths$1;

  var getVariantStyles = function getVariantStyles() {
    switch (variant) {
      case ELogoVariant.HORIZONTAL_DEFAULT:
      case ELogoVariant.HORIZONTAL_INVERSE:
      case ELogoVariant.HORIZONTAL_ALL_BLACK:
      case ELogoVariant.HORIZONTAL_ALL_WHITE:
        {
          return {
            minWidth: 100
          };
        }

      case ELogoVariant.LEAF_ALL_BLACK:
      case ELogoVariant.LEAF_DEFAULT:
      case ELogoVariant.LEAF_ALL_WHITE:
        {
          return {
            maxHeight: 50
          };
        }
    }
  };

  return jsx(ThemeProvider, _assign({
    theme: theme === 'legacy' ? legacyTheme : defaultTheme
  }, {
    children: jsx("a", _assign({
      href: href,
      target: target,
      className: className
    }, {
      children: jsx("img", {
        src: selectedLogoPaths[variant],
        className: className,
        alt: 'MongoDB logo',
        sx: _assign({
          width: imageWidth || 384
        }, getVariantStyles())
      }, void 0)
    }), void 0)
  }), void 0);
};

var getColor$3 = function getColor$3(color, inverse) {
  var Color = {
    default: "forms.textInput." + (inverse ? 'inverse' : 'default') + ".text",
    secondary: "text." + (inverse ? 'inverseSecondary' : 'secondary')
  };
  return Color[color];
};

var HelperText = function HelperText(_a) {
  var text = _a.text,
      inverse = _a.inverse,
      _b = _a.color,
      color = _b === void 0 ? 'default' : _b;
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsx("span", _assign({
      "aria-label": 'helper-text',
      sx: {
        display: 'inline-block',
        margin: 0,
        marginTop: 'inc20',
        marginLeft: 'inc40',
        fontFamily: 'body',
        fontSize: 'bodyXS',
        lineHeight: '20px',
        color: getColor$3(color, inverse)
      }
    }, {
      children: text
    }), void 0)
  }), void 0);
};

var getStyles$7 = function getStyles$7(state, selectedTheme) {
  var inverse = state.inverse,
      invalid = state.invalid,
      onTop = state.onTop,
      focus = state.focus;
  var textInputColors = selectedTheme.colors.forms.textInput;
  var inputColors = textInputColors[inverse ? 'inverse' : 'default'];
  var focusColors = inputColors.focus,
      errorColors = inputColors.error;
  var textColor = inputColors.label;

  if (focus) {
    if (invalid) {
      textColor = errorColors.labelFocus;
    } else if (onTop) {
      textColor = focusColors.label;
    }
  } else if (invalid) {
    textColor = errorColors.label;
  }

  return {
    width: '100%',
    overflowX: 'hidden',
    display: 'block',
    pointerEvents: onTop ? null : 'none',
    fontFamily: 'body',
    textTransform: 'capitalize',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    cursor: 'inherit',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    height: 'fit-content',
    margin: 'auto',
    willChange: 'transform, color, font-size',
    transitionProperty: 'transform, color, font-size',
    transitionTimingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
    transitionDuration: '200ms',
    transitionDelay: '0ms',
    transform: "translateY(-" + (onTop ? selectedTheme.space.inc30 : '0px') + ")",
    color: textColor,
    fontSize: onTop ? 'inc10' : 'inc40',
    lineHeight: onTop ? 'inc20' : 'inc40'
  };
};

var Label = function Label(_a) {
  var onTop = _a.onTop,
      focus = _a.focus,
      htmlFor = _a.htmlFor,
      inverse = _a.inverse,
      invalid = _a.invalid,
      children = _a.children,
      selectedTheme = _a.selectedTheme,
      customStyles = _a.customStyles;
  var state = {
    invalid: invalid,
    inverse: inverse,
    onTop: onTop,
    focus: focus
  };
  var styles = getStyles$7(state, selectedTheme);
  return jsx("label", _assign({
    "aria-label": htmlFor,
    htmlFor: htmlFor,
    sx: _assign(_assign({}, styles), customStyles)
  }, {
    children: children
  }), void 0);
};

var getStyles$6 = function getStyles$6(state, theme) {
  var disabled = state.disabled,
      invalid = state.invalid,
      inverse = state.inverse,
      focus = state.focus,
      clickableIcon = state.clickableIcon;
  var textInputColors = theme.colors.forms.textInput;
  var inputColors = textInputColors[inverse ? 'inverse' : 'default'];
  var focusColors = inputColors.focus,
      errorColors = inputColors.error;
  var borderColor = inputColors.border,
      rightIconColor = 'inherit';

  if (focus) {
    if (invalid) {
      borderColor = errorColors.borderFocus;
      rightIconColor = errorColors.iconFocus;
    } else {
      borderColor = focusColors.border;
    }
  } else if (invalid) {
    borderColor = errorColors.border;
    rightIconColor = errorColors.icon;
  }

  return {
    wrapper: {
      maxWidth: ['100%', null, 441, 456],
      display: 'flex',
      flexDirection: 'column'
    },
    inputRow: {
      width: '100%',
      display: 'flex',
      alignItems: 'center'
    },
    inputBox: {
      width: '100%',
      height: 80,
      flexGrow: 1,
      display: 'flex',
      alignItems: 'center',
      backgroundColor: inputColors.bg,
      padding: "0px " + theme.space.inc40,
      borderBottom: "4px solid " + borderColor,
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
      cursor: disabled ? 'not-allowed' : 'text',
      opacity: disabled ? 0.6 : 1
    },
    inputText: {
      width: 'inherit',
      fontSize: ['bodyLResponsive', null, null, 'bodyL'],
      marginTop: 'inc30',
      marginRight: 'inc40',
      color: inputColors.text,
      '&, &:focus, &:active': {
        background: 'transparent',
        border: 'none',
        outline: 'none'
      },
      '&:-webkit-autofill': {
        '-webkit-box-shadow': "0 0 0 16px " + inputColors.bg + " inset",
        '-webkit-text-fill-color': inputColors.text,
        filter: 'none'
      }
    },
    valueContainer: {
      width: 'inherit',
      flexGrow: 1,
      paddingRight: 'inc10',
      position: 'relative'
    },
    leftIconContainer: {
      margin: 'auto',
      marginTop: 'inc50',
      marginRight: 'inc20',
      marginLeft: 0,
      cursor: clickableIcon ? 'pointer' : 'inherit'
    },
    rightIconContainer: {
      margin: 'auto',
      marginTop: 'inc50',
      marginLeft: 'inc10',
      marginRight: 0,
      stroke: rightIconColor,
      cursor: clickableIcon ? 'pointer' : 'inherit'
    },
    button: {
      marginLeft: 'inc20'
    }
  };
};

var TextInput = forwardRef(function (_a, ref) {
  var _b = _a.iconPosition,
      iconPosition = _b === void 0 ? 'left' : _b,
      inverse = _a.inverse,
      invalid = _a.invalid,
      disabled = _a.disabled,
      iconName = _a.iconName,
      helper = _a.helper,
      buttonText = _a.buttonText,
      onChange = _a.onChange,
      onIconClick = _a.onIconClick,
      onButtonClick = _a.onButtonClick,
      label = _a.label,
      theme = _a.theme,
      name = _a.name,
      _c = _a.type,
      type = _c === void 0 ? 'text' : _c,
      autoComplete = _a.autoComplete,
      autoFocus = _a.autoFocus,
      props = __rest(_a, ["iconPosition", "inverse", "invalid", "disabled", "iconName", "helper", "buttonText", "onChange", "onIconClick", "onButtonClick", "label", "theme", "name", "type", "autoComplete", "autoFocus"]);

  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var inputRef = useRef(null);
  useImperativeHandle(ref, function () {
    return inputRef.current;
  });

  var _d = useState(props.value || ''),
      value = _d[0],
      setValue = _d[1];

  var _e = useState(false),
      focus = _e[0],
      setFocus = _e[1];

  var clickableIcon = !!onIconClick;
  var styles = getStyles$6({
    disabled: disabled,
    invalid: invalid,
    inverse: inverse,
    focus: focus,
    clickableIcon: clickableIcon
  }, selectedTheme);

  var setInputFocus = function setInputFocus() {
    var _a;

    if (!disabled) {
      (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      setFocus(true);
    }
  };

  var handleChange = function handleChange(event) {
    var value = event.target.value;
    setValue(value);
    if (onChange) onChange(event);
  };

  var renderLeftIcon = function renderLeftIcon() {
    if (iconName && iconPosition === 'left') {
      return jsx("span", _assign({
        "aria-label": 'left-icon',
        sx: styles.leftIconContainer,
        onClick: onIconClick
      }, {
        children: jsx(SystemIcon, {
          inverse: inverse,
          name: iconName,
          color: 'neutral'
        }, void 0)
      }), void 0);
    }

    return null;
  };

  var renderRightIcon = function renderRightIcon() {
    if (invalid) {
      return jsx("span", _assign({
        onClick: onIconClick,
        "aria-label": 'alert-icon',
        sx: styles.rightIconContainer
      }, {
        children: jsx(SystemIcon, {
          name: ESystemIconNames.CIRCLE_ALERT,
          inheritColor: true
        }, void 0)
      }), void 0);
    }

    if (iconName && iconPosition === 'right') {
      return jsx("span", _assign({
        "aria-label": 'right-icon',
        sx: styles.rightIconContainer,
        onClick: onIconClick
      }, {
        children: jsx(SystemIcon, {
          name: iconName,
          color: 'neutral',
          inverse: inverse
        }, void 0)
      }), void 0);
    }

    return null;
  };

  var renderButton = function renderButton() {
    if (!!buttonText && !!onButtonClick) {
      return jsx(Button, _assign({
        "aria-label": 'button',
        sx: styles.button,
        variant: 'secondary',
        onClick: onButtonClick,
        inverse: inverse
      }, {
        children: buttonText
      }), void 0);
    }

    return null;
  };

  useEffect(function () {
    if (autoFocus) {
      setInputFocus();
    }
  }, []);
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      sx: styles.wrapper
    }, {
      children: [jsxs("div", _assign({
        sx: styles.inputRow
      }, {
        children: [jsxs("div", _assign({
          "aria-label": 'input-box',
          sx: styles.inputBox,
          onClick: setInputFocus
        }, {
          children: [renderLeftIcon(), jsxs("div", _assign({
            sx: styles.valueContainer
          }, {
            children: [jsx(Label, _assign({
              focus: focus,
              onTop: !!value || focus,
              htmlFor: name,
              invalid: invalid,
              inverse: inverse,
              selectedTheme: selectedTheme
            }, {
              children: label
            }), void 0), jsx("input", {
              id: name,
              sx: styles.inputText,
              ref: inputRef,
              onFocus: function onFocus() {
                return setFocus(true);
              },
              onBlur: function onBlur() {
                return setFocus(false);
              },
              onChange: handleChange,
              name: name,
              value: value,
              type: type,
              disabled: disabled,
              autoComplete: autoComplete,
              autoFocus: autoFocus
            }, void 0)]
          }), void 0), renderRightIcon()]
        }), void 0), renderButton()]
      }), void 0), !!helper && jsx(HelperText, {
        inverse: inverse,
        text: helper
      }, void 0)]
    }), void 0)
  }), void 0);
});
TextInput.displayName = 'TextInput';
var grabber = 'https://webimages.mongodb.com/_com_assets/cms/kwxrz5ki294m89td9-grabber.svg?auto=format%252Ccompress';
var defaultToken = defaultTheme.colors.forms.textInput.default;
var inverseToken = defaultTheme.colors.forms.textInput.inverse;

var getStyles$5 = function getStyles$5(_a) {
  var _b = _a.inverse,
      inverse = _b === void 0 ? false : _b,
      _c = _a.invalid,
      invalid = _c === void 0 ? false : _c,
      _d = _a.focus,
      focus = _d === void 0 ? false : _d,
      _e = _a.disabled,
      disabled = _e === void 0 ? false : _e,
      _f = _a.onTop,
      onTop = _f === void 0 ? false : _f;
  return {
    wrapper: _assign({
      display: 'flex',
      flexDirection: 'column',
      position: 'relative',
      width: '100%'
    }, getIconColor({
      invalid: invalid,
      focus: focus,
      inverse: inverse
    })),
    area: _assign(_assign({
      width: '100%',
      cursor: disabled ? 'not-allowed' : 'text',
      minWidth: ['100%', null, null, '456px'],
      minHeight: ['119px', null, null, '152px'],
      fontFamily: 'body',
      fontSize: ['bodyLResponsive', null, null, 'bodyL'],
      lineHeight: ['bodyLResponsive', null, null, 'bodyL'],
      outline: 'none',
      border: 'none',
      borderTopLeftRadius: 'input',
      borderTopRightRadius: 'input',
      borderBottomStyle: 'solid',
      borderBottomWidth: '4px',
      boxSizing: 'border-box',
      padding: 'inc40',
      paddingTop: 'inc50',
      opacity: disabled ? 0.6 : 1,
      resize: ['vertical', null, 'both'],
      zIndex: 10
    }, getColors({
      invalid: invalid,
      inverse: inverse,
      focus: focus
    })), {
      '::-webkit-resizer': {
        backgroundImage: "url(" + grabber + ")",
        backgroundRepeat: 'no-repeat'
      }
    }),
    icon: {
      position: 'absolute',
      right: 'inc40',
      top: onTop ? '12px' : 'inc50',
      transition: 'all 200ms' // need a token

    },
    labelCustomStyle: {
      left: 'inc40',
      top: 'inc40',
      margin: 0,
      width: "calc(100% - " + defaultTheme.space.inc40 + ")",
      zIndex: 20
    }
  };
};

var getColors = function getColors(_a) {
  var _b = _a.invalid,
      invalid = _b === void 0 ? false : _b,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      _d = _a.focus,
      focus = _d === void 0 ? false : _d;

  if (inverse) {
    return {
      color: inverseToken.text,
      bg: inverseToken.bg,
      borderColor: getInverseBorderColor(invalid, focus)
    };
  }

  return {
    color: defaultToken.text,
    bg: defaultToken.bg,
    borderColor: getDefaultBorderColor(invalid, focus)
  };
};

var getDefaultBorderColor = function getDefaultBorderColor(invalid, focus) {
  var errorToken = defaultToken.error;
  var focusToken = defaultToken.focus;
  if (invalid) return focus ? errorToken.borderFocus : errorToken.border;
  return focus ? focusToken.border : defaultToken.border;
};

var getInverseBorderColor = function getInverseBorderColor(invalid, focus) {
  var errorToken = inverseToken.error;
  var focusToken = inverseToken.focus;
  if (invalid) return focus ? errorToken.borderFocus : errorToken.border;
  return focus ? focusToken.border : inverseToken.border;
};

var getIconColor = function getIconColor(_a) {
  var _b = _a.invalid,
      invalid = _b === void 0 ? false : _b,
      _c = _a.focus,
      focus = _c === void 0 ? false : _c,
      _d = _a.inverse,
      inverse = _d === void 0 ? false : _d;

  if (invalid) {
    if (focus) {
      return {
        stroke: inverse ? inverseToken.error.iconFocus : defaultToken.error.iconFocus
      };
    } else {
      return {
        stroke: inverse ? inverseToken.error.icon : defaultToken.error.icon
      };
    }
  }

  return null;
};

var Area = forwardRef(function (_a, ref) {
  var id = _a.id,
      textAreaStyles = _a.textAreaStyles,
      name = _a.name,
      value = _a.value,
      invalid = _a.invalid,
      disabled = _a.disabled,
      inverse = _a.inverse,
      focus = _a.focus,
      autoComplete = _a.autoComplete,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      onChange = _a.onChange,
      autoFocus = _a.autoFocus;
  var textAreaHTMLAttributes = {
    id: id,
    disabled: disabled,
    name: name,
    value: value,
    autoComplete: autoComplete,
    onFocus: onFocus,
    onChange: onChange,
    onBlur: onBlur,
    autoFocus: autoFocus
  };
  var onTop = !!value || focus;
  var styles = getStyles$5({
    invalid: invalid,
    inverse: inverse,
    focus: focus,
    disabled: disabled,
    onTop: onTop
  });
  return jsxs(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: [jsx("textarea", _assign({
      ref: ref
    }, textAreaHTMLAttributes, {
      sx: _assign(_assign({}, styles.area), textAreaStyles)
    }), void 0), invalid && jsx(SystemIcon, {
      inheritColor: true,
      customStyles: styles.icon,
      name: ESystemIconNames.CIRCLE_ALERT
    }, void 0)]
  }), void 0);
});
Area.displayName = 'TextArea';
var TextArea = forwardRef(function (_a, ref) {
  var _b = _a.inverse,
      inverse = _b === void 0 ? false : _b,
      _c = _a.invalid,
      invalid = _c === void 0 ? false : _c,
      id = _a.id,
      textAreaStyles = _a.textAreaStyles,
      name = _a.name,
      label = _a.label,
      helper = _a.helper;
  _a.className;
  var disabled = _a.disabled,
      autoComplete = _a.autoComplete;
  _a.onFocus;
  _a.onBlur;

  var onChange = _a.onChange,
      wrapperStyles = _a.wrapperStyles,
      autoFocus = _a.autoFocus,
      props = __rest(_a, ["inverse", "invalid", "id", "textAreaStyles", "name", "label", "helper", "className", "disabled", "autoComplete", "onFocus", "onBlur", "onChange", "wrapperStyles", "autoFocus"]);

  var _d = useState(false),
      focus = _d[0],
      setFocus = _d[1];

  var _e = useState(props.value || ''),
      value = _e[0],
      setValue = _e[1];

  var idValue = id || name.toLowerCase().replace(/\s/g, '');
  var handleChange = useCallback(function (event) {
    var value = event.target.value;
    setValue(value);
    if (onChange) onChange(event);
  }, [setValue, onChange]);
  var styles = getStyles$5({
    invalid: invalid,
    focus: focus,
    inverse: inverse,
    disabled: disabled
  });
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs("div", _assign({
      sx: _assign(_assign({}, styles.wrapper), wrapperStyles)
    }, {
      children: [jsxs("div", _assign({
        sx: {
          display: 'flex'
        }
      }, {
        children: [jsx(Label, _assign({
          focus: focus,
          onTop: !!value || focus,
          htmlFor: idValue,
          invalid: invalid,
          inverse: inverse,
          selectedTheme: defaultTheme,
          customStyles: styles.labelCustomStyle
        }, {
          children: label
        }), void 0), jsx(Area, {
          ref: ref,
          id: idValue,
          inverse: inverse,
          invalid: invalid,
          focus: focus,
          textAreaStyles: textAreaStyles,
          value: value,
          name: name,
          label: label,
          disabled: disabled,
          autoComplete: autoComplete,
          onChange: handleChange,
          onFocus: function onFocus() {
            return setFocus(true);
          },
          onBlur: function onBlur() {
            return setFocus(false);
          },
          autoFocus: autoFocus
        }, void 0)]
      }), void 0), !!helper && jsx(HelperText, {
        inverse: inverse,
        text: helper
      }, void 0)]
    }), void 0)
  }), void 0);
});
TextArea.displayName = 'TextArea';

var _a$2;

var EThirdPartyLogoVariant;

(function (EThirdPartyLogoVariant) {
  // Programming Languages
  EThirdPartyLogoVariant["C"] = "C";
  EThirdPartyLogoVariant["C_PLUS_PLUS"] = "C++";
  EThirdPartyLogoVariant["C_SHARP"] = "C#";
  EThirdPartyLogoVariant["GO"] = "Go";
  EThirdPartyLogoVariant["JAVA"] = "Java";
  EThirdPartyLogoVariant["JAVA_RED"] = "Java Red";
  EThirdPartyLogoVariant["JAVA_LOGOMARK"] = "Java LogoMark";
  EThirdPartyLogoVariant["JAVA_LOGOMARK_RED"] = "Java LogoMark Red";
  EThirdPartyLogoVariant["JAVASCRIPT"] = "Javascript";
  EThirdPartyLogoVariant["JAVASCRIPT_WHITE"] = "Javascript White";
  EThirdPartyLogoVariant["PERL"] = "Perl";
  EThirdPartyLogoVariant["PHP"] = "PHP";
  EThirdPartyLogoVariant["PHP_KNOCKOUT"] = "PHP Knockout";
  EThirdPartyLogoVariant["PYTHON"] = "Python";
  EThirdPartyLogoVariant["PYTHON_LOGOMARK"] = "Python LogoMark";
  EThirdPartyLogoVariant["PYTHON_LOGOMARK_YELLOW"] = "Python LogoMark Yellow";
  EThirdPartyLogoVariant["PYTHON_STACKED"] = "Python Stacked";
  EThirdPartyLogoVariant["RUBY"] = "Ruby";
  EThirdPartyLogoVariant["RUBY_KNOCKOUT"] = "Ruby Knockout";
  EThirdPartyLogoVariant["RUBY_LOGOMARK"] = "Ruby LogoMark";
  EThirdPartyLogoVariant["RUBY_LOGOMARK_KNOCKOUT"] = "Ruby LogoMark Knockout";
  EThirdPartyLogoVariant["SCALA"] = "Scala";
  EThirdPartyLogoVariant["SCALA_LOGOMARK_KNOCKOUT"] = "Scala LogoMark Knockout"; // Partners

  EThirdPartyLogoVariant["AWS"] = "AWS";
  EThirdPartyLogoVariant["AZURE"] = "Azure";
  EThirdPartyLogoVariant["AZURE_OLD"] = "Azure Old";
  EThirdPartyLogoVariant["CARAHSOFT"] = "Carahsoft";
  EThirdPartyLogoVariant["FEATURESPACE"] = "Featurespace";
  EThirdPartyLogoVariant["GOOGLE_CLOUD"] = "Google Cloud";
  EThirdPartyLogoVariant["GOOGLE_CLOUD_LOGOMARK"] = "Google Cloud LogoMark";
  EThirdPartyLogoVariant["RED_HAT"] = "Red Hat";
  EThirdPartyLogoVariant["RED_HAT_KNOCKOUT"] = "Red Hat Knockout";
  EThirdPartyLogoVariant["TCS"] = "TCS";
  EThirdPartyLogoVariant["ZALONI"] = "Zaloni"; // Compliance

  EThirdPartyLogoVariant["AICPA_SOC"] = "AICPA SOC";
  EThirdPartyLogoVariant["FEDRAMP"] = "FedRAMP";
  EThirdPartyLogoVariant["GDPR"] = "GDPR";
  EThirdPartyLogoVariant["HIPAA"] = "HIPAA";
  EThirdPartyLogoVariant["ISO_27001"] = "ISO 27001";
  EThirdPartyLogoVariant["PCI"] = "PCI"; // Customers

  EThirdPartyLogoVariant["SEVEN_ELEVEN"] = "Seven Eleven";
  EThirdPartyLogoVariant["ACXIOM"] = "Acxiom";
  EThirdPartyLogoVariant["ACXIOM_WHITE"] = "Acxiom White";
  EThirdPartyLogoVariant["ADOBE_HORIZONTAL_BLACK"] = "Adobe Horizontal Black";
  EThirdPartyLogoVariant["ADOBE_HORIZONTAL_RED"] = "Adobe Horizontal Red";
  EThirdPartyLogoVariant["ADOBE_VERTICAL_BLACK"] = "Adobe Vertical Black";
  EThirdPartyLogoVariant["ADOBE_VERTICAL_RED"] = "Adobe Vertical Red";
  EThirdPartyLogoVariant["ADP"] = "ADP";
  EThirdPartyLogoVariant["ATD_WHITE"] = "ATD White";
  EThirdPartyLogoVariant["BARCLAYS"] = "Barclays";
  EThirdPartyLogoVariant["BORDERFREE"] = "Borderfree";
  EThirdPartyLogoVariant["BOSH"] = "Bosh";
  EThirdPartyLogoVariant["COINBASE"] = "Coinbase";
  EThirdPartyLogoVariant["COMPARE_THE_MARKET"] = "Compare the Market";
  EThirdPartyLogoVariant["EA"] = "EA";
  EThirdPartyLogoVariant["EBAY"] = "Ebay";
  EThirdPartyLogoVariant["EHARMONY"] = "eharmony";
  EThirdPartyLogoVariant["FORBES"] = "Forbes";
  EThirdPartyLogoVariant["GOOGLE"] = "Google";
  EThirdPartyLogoVariant["GOOGLE_ICON"] = "Google Icon";
  EThirdPartyLogoVariant["GOV_UK"] = "gov.uk";
  EThirdPartyLogoVariant["HUMANITIX"] = "humanitix";
  EThirdPartyLogoVariant["HUMANITIX_lOGOMARK"] = "humanitix LogoMark";
  EThirdPartyLogoVariant["INGENIQ"] = "Ingeniq";
  EThirdPartyLogoVariant["INTUIT"] = "Intuit";
  EThirdPartyLogoVariant["INVISION"] = "Invision";
  EThirdPartyLogoVariant["KPMG"] = "KPMG";
  EThirdPartyLogoVariant["LIBERTY_MUTUAL"] = "Liberty Mutual";
  EThirdPartyLogoVariant["MET_OFFICE"] = "Met Office";
  EThirdPartyLogoVariant["OXFORD_NANOPORE"] = "Oxford Nanopore";
  EThirdPartyLogoVariant["NESTO"] = "Nesto";
  EThirdPartyLogoVariant["PATHAO"] = "Pathao";
  EThirdPartyLogoVariant["PITNEY_BOWES"] = "Pitney Powes";
  EThirdPartyLogoVariant["PRACTICEFUSION"] = "Practicefusion";
  EThirdPartyLogoVariant["SANOMA"] = "Sanoma";
  EThirdPartyLogoVariant["SAP"] = "SAP";
  EThirdPartyLogoVariant["SEGA"] = "SEGA";
  EThirdPartyLogoVariant["SOFTWARE_AG"] = "Software AG";
  EThirdPartyLogoVariant["SQUARE_SPACE"] = "Square Space";
  EThirdPartyLogoVariant["SQUARE_SPACE_STACKED"] = "Square Space Stacked";
  EThirdPartyLogoVariant["SWIMLANE"] = "Swimlane";
  EThirdPartyLogoVariant["TOYOTA_MH1"] = "Toyota Material Handling 1";
  EThirdPartyLogoVariant["TOYOTA_MH2"] = "Toyota Material Handling 2";
  EThirdPartyLogoVariant["VERIZON"] = "Verizon";
  EThirdPartyLogoVariant["VSCO"] = "VSCO";
  EThirdPartyLogoVariant["YOU_GOV"] = "You Gov";
})(EThirdPartyLogoVariant || (EThirdPartyLogoVariant = {}));

var LogoPaths = (_a$2 = {}, _a$2[EThirdPartyLogoVariant.C] = 'https://webimages.mongodb.com/_com_assets/cms/ks66s0ohwdti1j4es-lang_c.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.C_PLUS_PLUS] = 'https://webimages.mongodb.com/_com_assets/cms/ks67kvzgzoi0g33va-lang_c_plus_plus.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.C_SHARP] = 'https://webimages.mongodb.com/_com_assets/cms/ks67l72x98g3whceo-lang_c_sharp.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.GO] = 'https://webimages.mongodb.com/_com_assets/cms/ks67n6mbb5spon689-lang_go.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.JAVA] = 'https://webimages.mongodb.com/_com_assets/cms/ks67o2jcxlujkbk0d-lang_java.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.JAVA_RED] = 'https://webimages.mongodb.com/_com_assets/cms/ks67ofl617k43nfbh-lang_java_red.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.JAVA_LOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks67or52h1vtq9spj-lang_java_logomark.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.JAVA_LOGOMARK_RED] = 'https://webimages.mongodb.com/_com_assets/cms/ks67p0pnlloxd7xqu-lang_java_logomark_red.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.JAVASCRIPT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67pb1b0pxch9df4-lang_javascript.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.JAVASCRIPT_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/ks67pjqmlkk6hbrt5-lang_javascript_white.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PERL] = 'https://webimages.mongodb.com/_com_assets/cms/ks67pv8yhrv81wc52-lang_pearl.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PHP] = 'https://webimages.mongodb.com/_com_assets/cms/ks67q3q71plcgkyrz-lang_php.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PHP_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67qmaunv56pjkcj-lang_php_knockout.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PYTHON] = 'https://webimages.mongodb.com/_com_assets/cms/ks67qw1a1whct10lb-lang_python.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PYTHON_LOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks67r63qo5kuxary0-lang_python_logomark.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PYTHON_LOGOMARK_YELLOW] = 'https://webimages.mongodb.com/_com_assets/cms/ks67rf0247qeyz7j4-lang_python_logomark_yellow.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PYTHON_STACKED] = 'https://webimages.mongodb.com/_com_assets/cms/ks67rpgpvz8v3c0fq-lang_python_stacked.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.RUBY] = 'https://webimages.mongodb.com/_com_assets/cms/ks67ry8jk1mga18vz-lang_ruby.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.RUBY_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67s5ujd11affu87-lang_ruby_knockout.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.RUBY_LOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks67sdtrn76jurziq-lang_ruby_logomark.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.RUBY_LOGOMARK_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67sptgens44qpkc-lang_ruby_logomark_knockout.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SCALA] = 'https://webimages.mongodb.com/_com_assets/cms/ks67swsruf8mrukfd-lang_scala.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SCALA_LOGOMARK_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks67t82pir7hv3ptl-lang_scala_logomark_knockout.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.AWS] = 'https://webimages.mongodb.com/_com_assets/cms/ks6id0fldyolj0yvv-aws.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.AZURE] = 'https://webimages.mongodb.com/_com_assets/cms/ks6idk2lqjypjk4t7-azure.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.AZURE_OLD] = 'https://webimages.mongodb.com/_com_assets/cms/ks6idsxqwglzueamt-azure_old.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.CARAHSOFT] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ie35g4ikheindg-carahsoft.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.FEATURESPACE] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ieehmj92claby0-featurespace.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.GOOGLE_CLOUD] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ientx6nxyanvfn-google_cloud.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.GOOGLE_CLOUD_LOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks6it6zwfg8u6nrjb-google_cloud_logomark.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.RED_HAT] = 'https://webimages.mongodb.com/_com_assets/cms/ks6if5nyi5vs50goc-redhat.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.RED_HAT_KNOCKOUT] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ifdbntwyt0rzu0-redhat_knockout.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.TCS] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ifk6ipbho8ewmu-tos.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ZALONI] = 'https://webimages.mongodb.com/_com_assets/cms/ks6ifqt4vg57ml6tz-zaloni.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.AICPA_SOC] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j7f0g0091y4irt-aicpa_soc.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.FEDRAMP] = 'https://webimages.mongodb.com/_com_assets/cms/kr6ft3y8m0xcur30n-fedramp-logo.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.GDPR] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j85vyqtkx742f3-gdpr.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.HIPAA] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j8f6cv32h18p0i-hipaa.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ISO_27001] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j8mjjj50e8zixu-iso_27001.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PCI] = 'https://webimages.mongodb.com/_com_assets/cms/ks6j8wuk84hx55up8-pci.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SEVEN_ELEVEN] = 'https://webimages.mongodb.com/_com_assets/cms/kr6es7jbos7hvv09w-7-Eleven.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ACXIOM] = 'https://webimages.mongodb.com/_com_assets/cms/kr6et2jascmp64ba4-Acxiom.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ACXIOM_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/ks6jmq5cufv26sqqc-acxiom_white.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ADOBE_HORIZONTAL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f16wp4j46qcbc1-Adobe-horizontal-black.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ADOBE_HORIZONTAL_RED] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f30ytyvhsl347z-Adobe-horizontal-red.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ADOBE_VERTICAL_BLACK] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f3b9tmt7jckx9b-Adobe-vertical-black.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ADOBE_VERTICAL_RED] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f3mmruyh3xf3fm-Adobe-vertical-red.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ADP] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f6pjpu3c0au7vk-ADP.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.ATD_WHITE] = 'https://webimages.mongodb.com/_com_assets/cms/ks6jtlv22ewtbxct3-atd_white.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.BARCLAYS] = 'https://webimages.mongodb.com/_com_assets/cms/kr6f7se6k5ax8fa3g-Barclays.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.BORDERFREE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fbqc6kbb4nkpw0-Borderfree.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.BOSH] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fc1009fao1f6in-Bosch.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.COINBASE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fcd51mwis3uv4z-Coinbase.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.COMPARE_THE_MARKET] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fcnjuo9t5h25x0-Compare%20the%20Market.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.EA] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fsegcpeuyw49aq-EA.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.EBAY] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fsnogsj8arp6vp-Ebay.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.EHARMONY] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fsweujn9sso6wi-eharmony.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.FORBES] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fuwe4n1ptbykc6-Forbes.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.GOOGLE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fv7u35e8f7ksql-Google.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.GOOGLE_ICON] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fvgdym4qzsgqo3-Google%20Icon.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.GOV_UK] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fvvdfx5091481o-gov.uk.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.HUMANITIX] = 'https://webimages.mongodb.com/_com_assets/cms/ks6kmbqzdycm59idh-humanitix.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.HUMANITIX_lOGOMARK] = 'https://webimages.mongodb.com/_com_assets/cms/ks6lsq1xj1l3gyghw-humanitix_logomark.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.INGENIQ] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fyk1whj88z80b5-Ingeniq.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.INTUIT] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fyvdyxnbb7hk6c-Intuit.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.INVISION] = 'https://webimages.mongodb.com/_com_assets/cms/kr6fz6q2gf69z4nzh-Invision.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.KPMG] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g1yj0qxcuh9g10-KPMG.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.LIBERTY_MUTUAL] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g28v57p1j6yss9-LibertyMutual.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.MET_OFFICE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g2yh5102dl9znd-Met%20Office.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.OXFORD_NANOPORE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g4smemfi3ed2t8-Oxford%20Nanopore.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.NESTO] = 'https://webimages.mongodb.com/_com_assets/cms/ks6lxdqpo7morksyp-nesto.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PATHAO] = 'https://webimages.mongodb.com/_com_assets/cms/ks6m2l4wtu84ffv4b-pathao.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PITNEY_BOWES] = 'https://webimages.mongodb.com/_com_assets/cms/ks6m2xrynwanj8ph6-pitney_bowes.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.PRACTICEFUSION] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g5cq2jtx1cuy3v-Practicefusion.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SANOMA] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g7mzgvgqpqm0ds-Sanoma.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SAP] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g7xek6crjapgl3-SAP.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SEGA] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g9cgdb0oyojhzh-Sega.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SOFTWARE_AG] = 'https://webimages.mongodb.com/_com_assets/cms/kr6g9yihl2d2rn9xz-software%20AG.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SQUARE_SPACE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gaa2dcm92ty4vt-Squarespace.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SQUARE_SPACE_STACKED] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gbvoyn2b51i55q-Squarespace-Stacked.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.SWIMLANE] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gc7jnqhscclq45-Swimlane.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.TOYOTA_MH1] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gcggixl0qp659i-ToyotaMH1.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.TOYOTA_MH2] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gcpxvmgfg2bat3-ToyotaMH2.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.VERIZON] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gez4jikdzp1e0m-verizon.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.VSCO] = 'https://webimages.mongodb.com/_com_assets/cms/kr6gg6ueye3a9ldmy-VSCO.svg?auto=format%252Ccompress', _a$2[EThirdPartyLogoVariant.YOU_GOV] = 'https://webimages.mongodb.com/_com_assets/cms/kr6ggflr1lky2rudf-YouGov.svg?auto=format%252Ccompress', _a$2);

var ThirdPartyLogo = function ThirdPartyLogo(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _d = _a.alt,
      alt = _d === void 0 ? '' : _d,
      href = _a.href,
      target = _a.target,
      _e = _a.imageWidth,
      imageWidth = _e === void 0 ? '150px' : _e,
      variant = _a.variant;
  return jsx(ThemeProvider, _assign({
    theme: theme === 'legacy' ? legacyTheme : defaultTheme
  }, {
    children: jsx("a", _assign({
      sx: {
        display: 'inline-block'
      },
      href: href,
      target: target,
      className: className
    }, {
      children: jsx("img", {
        src: LogoPaths[variant],
        className: className,
        alt: alt,
        sx: {
          width: imageWidth,
          display: 'inline-block'
        }
      }, void 0)
    }), void 0)
  }), void 0);
};

var getElementByVariant = function getElementByVariant(variant, customElement) {
  if (customElement) {
    return customElement;
  }

  return isBody(variant) || isMono(variant) ? 'span' : getAppropriateHeading(variant);
};

var isBody = function isBody(variant) {
  return variant.includes('body');
};

var isMono = function isMono(variant) {
  return variant.includes('mono');
};

var Heading = {
  heading1: 'h1',
  heading2: 'h2',
  heading3: 'h3',
  heading4: 'h4',
  heading5: 'h5',
  heading6: 'h6'
};

var getAppropriateHeading = function getAppropriateHeading(variant) {
  return Heading[variant];
};

var Color = {
  default: 'text.default',
  secondary: 'text.secondary',
  error: 'text.error',
  neutral: 'text.neutral',
  selected: 'text.selected',
  mark: 'text.mark'
};
var InverseColor = {
  default: 'text.inverse',
  secondary: 'text.inverseSecondary',
  error: 'text.errorInverse',
  neutral: 'text.neutral',
  selected: 'text.inverseSelected',
  mark: 'text.inverseMark'
};

var getColor$2 = function getColor$2(inverse, color) {
  return inverse ? InverseColor[color] : Color[color];
};

var getVariantStyles$1 = function getVariantStyles$1(variant) {
  var fontFamily = getFontFamily(variant);
  var sizes = getSizes(variant);
  var fontToken = variant.replace(/[0-9]/g, function (match) {
    return sizes[match] || 'M';
  }); // theme-ui handles responsiveness by passing fontSize/lineHeights as an array of values, the order is important!

  return {
    fontFamily: fontFamily,
    fontSize: [fontToken + "Responsive", fontToken + "Responsive", fontToken + "Responsive", "" + fontToken // size when screen is 1024px or greater
    ],
    lineHeight: [fontToken + "Responsive", fontToken + "Responsive", fontToken + "Responsive", "" + fontToken // size when screen is 1024px or greater
    ],
    letterSpacing: isMono(variant) ? '3px' : null
  };
};

var getFontFamily = function getFontFamily(variant) {
  if (variant === 'heading5' || variant === 'heading6') {
    return 'body';
  }

  return variant.replace(/[0-9]/g, '');
};

var getSizes = function getSizes(variant) {
  var monoSizes = {
    1: 'L',
    2: 'M',
    3: 'S'
  };
  var bodySizes = {
    1: 'L',
    2: 'M',
    3: 'S',
    4: 'XS'
  };
  var headingSizes = {
    1: 'XXL',
    2: 'XL',
    3: 'L',
    4: 'M',
    5: 'S',
    6: 'XS'
  };
  if (isMono(variant)) return monoSizes;
  if (isBody(variant)) return bodySizes;
  return headingSizes;
};

var TypographyScale = function TypographyScale(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      children = _a.children,
      _d = _a.variant,
      variant = _d === void 0 ? 'body1' : _d,
      _e = _a.inverse,
      inverse = _e === void 0 ? false : _e,
      _f = _a.color,
      color = _f === void 0 ? 'default' : _f,
      customStyles = _a.customStyles,
      customElement = _a.customElement;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var Element = getElementByVariant(variant, customElement);
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx(Element, _assign({
      className: className,
      sx: _assign(_assign({
        margin: 0,
        color: getColor$2(inverse, color)
      }, getVariantStyles$1(variant)), customStyles)
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var getStyles$4 = function getStyles$4(state) {
  var open = state.open,
      value = state.value,
      invalid = state.invalid,
      inverse = state.inverse,
      disabled = state.disabled,
      width = state.width,
      height = state.height,
      placement = state.placement,
      wrapperHeight = state.wrapperHeight;
  var colors = defaultTheme.colors,
      space = defaultTheme.space,
      fontSizes = defaultTheme.fontSizes;
  var inputColors = colors.forms.textInput[inverse ? 'inverse' : 'default'];
  var errorColors = inputColors.error;
  var bottomBorderColor = inputColors.border,
      labelColor = inputColors.label;

  if (open || value) {
    labelColor = inputColors.focus.label;
  }

  if (invalid && !value) {
    bottomBorderColor = errorColors.border;
    labelColor = errorColors.label;
  }

  if (invalid && value) {
    bottomBorderColor = errorColors.borderFocus;
    labelColor = errorColors.labelFocus;
  }

  return {
    bottomBorder: {
      position: 'absolute',
      left: 0,
      bottom: 0,
      width: '100%',
      height: '4px',
      bg: bottomBorderColor
    },
    button: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      width: ['100%', null, null, width],
      height: height,
      padding: 'inc40',
      bg: inputColors.bg,
      boxSizing: 'border-box',
      border: 0,
      borderTopLeftRadius: 'input',
      borderTopRightRadius: 'input',
      cursor: disabled ? 'not-allowed' : 'pointer',
      opacity: disabled ? '60%' : '1',
      '&:focus-visible': {
        outline: "1px solid " + inputColors.border
      }
    },
    dropdown: _assign({
      visibility: placement ? 'visible' : 'hidden',
      position: 'absolute',
      zIndex: 1000,
      display: open ? 'block' : 'none',
      width: '100%',
      maxHeight: 'calc(70px * 6)',
      overflowX: 'hidden',
      overflowY: 'auto',
      padding: space.inc30 + " " + space.inc40,
      bg: 'background.body',
      boxShadow: '0px 3px 9px rgba(0, 0, 0, 0.15)'
    }, placement === 'top' ? {
      borderTopLeftRadius: 'input',
      borderTopRightRadius: 'input',
      bottom: wrapperHeight
    } : {
      borderBottomLeftRadius: 'input',
      borderBottomRightRadius: 'input'
    }),
    label: {
      fontFamily: 'body',
      textTransform: 'capitalize',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      position: 'absolute',
      left: 0,
      marginLeft: space.inc40,
      whiteSpace: 'nowrap',
      willChange: 'transform, color, font-size',
      transitionProperty: 'transform, color, font-size',
      transitionTimingFunction: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      transitionDuration: '200ms',
      transitionDelay: '0ms',
      transform: "translateY(" + (open || value ? "-" + space.inc40 : '0px') + ")",
      fontSize: open || value ? fontSizes.inc10 : fontSizes.inc40,
      color: labelColor
    },
    value: {
      width: width || '100%',
      textAlign: 'left',
      color: inverse ? 'text.inverse' : 'text.default'
    },
    singleOption: {
      position: 'relative',
      padding: space.inc30 + " 0",
      listStyle: 'none',
      ':not(:last-child)': {
        borderBottom: "1px solid " + colors.black20
      },
      '&:hover': {
        borderRadius: 'input',
        bg: 'black20',
        width: 'auto',
        marginLeft: '-12px',
        paddingLeft: '12px',
        cursor: 'pointer'
      },
      '&:hover::before': {
        content: "''",
        position: 'absolute',
        bg: 'black20',
        height: '4px',
        top: '-1px',
        left: '0',
        width: '100%',
        borderTopLeftRadius: 'input',
        borderTopRightRadius: 'input'
      },
      '&:hover span': {
        color: 'text.default'
      }
    }
  };
};

var SelectButton = function SelectButton(_a) {
  var id = _a.id,
      name = _a.name,
      inverse = _a.inverse,
      invalid = _a.invalid,
      disabled = _a.disabled,
      open = _a.open,
      value = _a.value,
      width = _a.width,
      height = _a.height,
      children = _a.children,
      onKeyDown = _a.onKeyDown;
  var styles = getStyles$4({
    open: open,
    value: value,
    invalid: invalid,
    inverse: inverse,
    disabled: disabled,
    width: width,
    height: height
  });
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs("button", _assign({
      id: id,
      name: name,
      role: 'select',
      sx: styles.button,
      type: 'button',
      onKeyDown: onKeyDown
    }, {
      children: [value && jsx(TypographyScale, _assign({
        customStyles: _assign(_assign({}, styles.value), {
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          maxWidth: '93%'
        })
      }, {
        children: value
      }), void 0), jsx("label", _assign({
        htmlFor: id,
        sx: styles.label
      }, {
        children: children
      }), void 0), jsx(SystemIcon, {
        name: invalid && !value ? ESystemIconNames.CIRCLE_ALERT : ESystemIconNames.CHEVRON_DOWN,
        color: invalid && !value ? 'secondaryError' : 'default',
        inverse: inverse,
        customStyles: {
          transform: open && !invalid ? 'rotateZ(180deg)' : 'rotateZ(0.5deg)',
          transition: 'transform .15s ease-in-out',
          position: 'absolute',
          right: 'inc40'
        }
      }, void 0), jsx("div", {
        sx: styles.bottomBorder
      }, void 0)]
    }), void 0)
  }), void 0);
};

var ITEMS_PER_SCROLL = 40;

var Options = function Options(_a) {
  var options = _a.options,
      styles = _a.styles;
  return options.map(function (option, i) {
    return jsx("li", _assign({
      role: 'option',
      tabIndex: 0,
      sx: styles
    }, {
      children: jsx("span", _assign({
        sx: {
          width: '100%',
          color: 'text.secondary',
          fontSize: 'inc40',
          lineHeight: 'inc30',
          fontFamily: 'euclid-circular-a'
        }
      }, {
        children: option
      }), void 0)
    }), "dropdown-options-" + option + "--" + i);
  });
};

var Dropdown$1 = function Dropdown$1(_a) {
  var options = _a.options,
      open = _a.open,
      lazyLoad = _a.lazyLoad,
      _b = _a.itemsPerScroll,
      itemsPerScroll = _b === void 0 ? ITEMS_PER_SCROLL : _b,
      isSearching = _a.isSearching,
      menuPlacement = _a.menuPlacement,
      wrapperHeight = _a.wrapperHeight,
      wrapperOffsetTop = _a.wrapperOffsetTop,
      containerOffsetHeight = _a.containerOffsetHeight,
      onSelect = _a.onSelect;

  var _c = useState(options.slice(0, itemsPerScroll)),
      current = _c[0],
      setCurrent = _c[1];

  var _d = useState(current.length < options.length),
      hasMore = _d[0],
      setHasMore = _d[1];

  var _e = useState(false),
      loading = _e[0],
      setLoading = _e[1];

  var _f = useState(undefined),
      placement = _f[0],
      setPlacement = _f[1];

  var dropdownRef = useRef(null);

  var getValue = function getValue(event) {
    var el = event.target;
    return el.innerText;
  };

  var onClickHandler = function onClickHandler(e) {
    e.stopPropagation();
    var value = getValue(e);
    onSelect(value);
  };

  var onKeyPressHandler = function onKeyPressHandler(e) {
    if (e.key === 'Enter') {
      e.stopPropagation();
      var value = getValue(e);
      onSelect(value);
    }
  };

  var styles = getStyles$4({
    open: open,
    placement: placement,
    wrapperHeight: wrapperHeight
  });
  useEffect(function () {
    if (menuPlacement === 'auto') {
      if (open && dropdownRef && dropdownRef.current && wrapperOffsetTop && wrapperHeight) {
        var wrapperOffsetHeight = containerOffsetHeight || document.body.offsetHeight;
        var spaceAfterSelect = wrapperOffsetHeight - wrapperOffsetTop - wrapperHeight;

        if (spaceAfterSelect < dropdownRef.current.offsetHeight) {
          setPlacement('top');
        } else {
          setPlacement('bottom');
        }
      } else {
        setPlacement(undefined);
      }
    } else {
      setPlacement(menuPlacement);
    }
  }, [open]);

  var ListBox = function ListBox(_a) {
    var children = _a.children;
    return jsx("ul", _assign({
      role: 'listbox',
      sx: {
        listStyleType: 'none',
        margin: 0,
        padding: 0
      }
    }, {
      children: children
    }), void 0);
  };

  if (lazyLoad) {
    var showLoadingElement = loading && hasMore && !isSearching;

    var fetchMoreOptions_1 = function fetchMoreOptions_1() {
      if (current.length === options.length) {
        setHasMore(false);
        setLoading(false);
        return;
      }

      setCurrent(current.concat(options.slice(current.length, current.length + itemsPerScroll)));
      setLoading(true);
    };

    var handleScroll = function handleScroll(e) {
      var _a = e.currentTarget,
          scrollHeight = _a.scrollHeight,
          scrollTop = _a.scrollTop,
          clientHeight = _a.clientHeight;
      var bottom = scrollHeight - scrollTop === clientHeight;

      if (bottom) {
        hasMore && fetchMoreOptions_1();
      }
    };

    return jsx(ThemeProvider, _assign({
      theme: defaultTheme
    }, {
      children: jsxs("div", _assign({
        ref: dropdownRef,
        role: 'dropdown',
        sx: styles.dropdown,
        onScroll: handleScroll,
        onClick: onClickHandler,
        onKeyPress: onKeyPressHandler
      }, {
        children: [jsx(ListBox, {
          children: jsx(Options, {
            options: options,
            styles: styles.singleOption
          }, void 0)
        }, void 0), showLoadingElement && jsx(TypographyScale, _assign({
          color: 'secondary',
          variant: 'body2'
        }, {
          children: "Loading..."
        }), void 0)]
      }), void 0)
    }), void 0);
  }

  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsx("div", _assign({
      ref: dropdownRef,
      role: 'dropdown',
      sx: styles.dropdown,
      onClick: onClickHandler,
      onKeyPress: onKeyPressHandler
    }, {
      children: jsx(ListBox, {
        children: jsx(Options, {
          options: options,
          styles: styles.singleOption
        }, void 0)
      }, void 0)
    }), void 0)
  }), void 0);
};

var Select = function Select(_a) {
  var _b, _c;

  var _d = _a.inverse,
      inverse = _d === void 0 ? false : _d,
      _e = _a.invalid,
      invalid = _e === void 0 ? false : _e,
      _f = _a.disabled,
      disabled = _f === void 0 ? false : _f,
      _g = _a.lazyLoad,
      lazyLoad = _g === void 0 ? false : _g,
      itemsPerScroll = _a.itemsPerScroll,
      name = _a.name,
      label = _a.label,
      options = _a.options,
      id = _a.id,
      className = _a.className,
      onSelect = _a.onSelect,
      _h = _a.value,
      value = _h === void 0 ? undefined : _h,
      helper = _a.helper,
      _j = _a.width,
      width = _j === void 0 ? '456px' : _j,
      _k = _a.height,
      height = _k === void 0 ? '80px' : _k,
      _l = _a.menuPlacement,
      menuPlacement = _l === void 0 ? 'bottom' : _l,
      containerOffsetHeight = _a.containerOffsetHeight;
  var idValue = id || name.toLowerCase().replace(/\s/g, '');

  var _m = useState(false),
      isDropdownOpen = _m[0],
      setIsDropdownOpen = _m[1];

  var _o = useState(value),
      selectedValue = _o[0],
      setSelectedValue = _o[1];

  var _p = useState([]),
      filteredOptions = _p[0],
      setFilteredOptions = _p[1];

  var isSearching = !!filteredOptions.length;
  var wrapperRef = useRef(null);
  var wrapperHeight = (_b = wrapperRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight;
  var wrapperOffsetTop = (_c = wrapperRef.current) === null || _c === void 0 ? void 0 : _c.offsetTop;

  var handleSelect = function handleSelect(value) {
    setSelectedValue(value);
    if (onSelect) onSelect(value);
    setIsDropdownOpen(!isDropdownOpen);
  };

  var onSearch = function onSearch(key) {
    if (key === 'Tab') return;
    var filteredOptions = options.filter(function (option) {
      return option[0].toLowerCase() === key;
    });
    setFilteredOptions(filteredOptions);
  };

  useEffect(function () {
    if (value !== selectedValue) {
      setSelectedValue(value);
    }
  }, [value]);
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs("div", _assign({
      ref: wrapperRef,
      className: className,
      sx: {
        position: 'relative',
        width: ['100%', null, null, width],
        height: height
      },
      onClick: function onClick() {
        if (!disabled) {
          setIsDropdownOpen(!isDropdownOpen);
        }
      }
    }, {
      children: [jsx(SelectButton, _assign({
        id: idValue,
        name: name,
        inverse: inverse,
        invalid: invalid,
        disabled: disabled,
        open: isDropdownOpen,
        value: selectedValue,
        width: width,
        height: height,
        onKeyDown: function onKeyDown(e) {
          return onSearch(e.key);
        }
      }, {
        children: label
      }), void 0), jsx(Dropdown$1, {
        options: isSearching ? filteredOptions : options,
        isSearching: isSearching,
        open: isDropdownOpen,
        onSelect: handleSelect,
        lazyLoad: lazyLoad,
        itemsPerScroll: itemsPerScroll,
        menuPlacement: menuPlacement,
        wrapperHeight: wrapperHeight,
        wrapperOffsetTop: wrapperOffsetTop,
        containerOffsetHeight: containerOffsetHeight
      }, void 0), helper && jsx(HelperText, {
        text: helper,
        inverse: inverse
      }, void 0)]
    }), void 0)
  }), void 0);
};

var getVariantStyles = function getVariantStyles(variant) {
  var Style = {
    large: {
      padding: defaultTheme.space.inc20 + " " + defaultTheme.space.inc30,
      fontSize: 'inc20'
    },
    small: {
      padding: defaultTheme.space.inc10 + " " + defaultTheme.space.inc20,
      fontSize: 'inc00'
    }
  };
  return Style[variant];
};

var Tag = function Tag(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _d = _a.onClick,
      onClick = _d === void 0 ? function () {} : _d,
      href = _a.href,
      target = _a.target,
      _e = _a.inverse,
      inverse = _e === void 0 ? false : _e,
      _f = _a.variant,
      variant = _f === void 0 ? 'large' : _f,
      children = _a.children;
  var TagName = href ? 'a' : 'span';
  return jsx(ThemeProvider, _assign({
    theme: theme === 'legacy' ? legacyTheme : defaultTheme
  }, {
    children: jsx(TagName, _assign({
      "aria-label": 'tag-container',
      className: className,
      sx: _assign({
        cursor: href ? 'pointer' : 'default',
        textDecoration: 'none',
        display: 'inline-block',
        border: '1px solid',
        borderColor: inverse ? 'tag.inverseBorder' : 'tag.border',
        borderRadius: 'inc20',
        backgroundColor: inverse ? 'tag.inverseBG' : 'tag.bg',
        fontFamily: 'body',
        fontWeight: 500,
        lineHeight: 'inc00',
        color: inverse ? 'tag.inverseText' : 'tag.text',
        '&:hover': {
          boxShadow: inverse ? 'tagHoverInverse' : 'tagHover',
          transition: 'motion.tag'
        },
        '&:active': {
          boxShadow: 'none',
          transition: 'motion.tag'
        }
      }, getVariantStyles(variant)),
      onClick: onClick,
      href: href,
      target: target
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var GridLayout = function GridLayout(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      customStyles = _a.customStyles,
      children = _a.children;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx(Grid, _assign({
      columns: [6, null, 8, 12],
      gap: selectedTheme.space.inc40,
      className: className,
      sx: _assign({
        maxWidth: selectedTheme.sizes.maxWidthDesktop,
        margin: 'auto'
      }, customStyles)
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var getSizeStyles = function getSizeStyles(size) {
  switch (size) {
    case 'medium':
      {
        return {
          width: 'brandedIconMedium',
          height: 'brandedIconMedium'
        };
      }

    case 'large':
      {
        return {
          width: 'brandedIconLarge',
          height: 'brandedIconLarge'
        };
      }

    default:
      {
        return {
          width: 'brandedIconSmall',
          height: 'brandedIconSmall'
        };
      }
  }
};

var BrandedIcon = function BrandedIcon(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'small' : _c,
      _d = _a.inverse,
      inverse = _d === void 0 ? false : _d,
      _e = _a.theme,
      theme = _e === void 0 ? 'default' : _e,
      name = _a.name,
      alt = _a.alt,
      customStyles = _a.customStyles;
  var imgSource = "https://webimages.mongodb.com/_com_assets/icons/" + name + (inverse ? '_inverse' : '') + ".svg";
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("img", {
      className: className,
      src: imgSource,
      alt: alt || name,
      sx: _assign(_assign({}, getSizeStyles(size)), customStyles)
    }, void 0)
  }), void 0);
};

var EBrandedIcons;

(function (EBrandedIcons) {
  EBrandedIcons[EBrandedIcons["general_action_archive"] = 0] = "general_action_archive";
  EBrandedIcons[EBrandedIcons["general_action_archive_inverse"] = 1] = "general_action_archive_inverse";
  EBrandedIcons[EBrandedIcons["general_action_audit"] = 2] = "general_action_audit";
  EBrandedIcons[EBrandedIcons["general_action_audit_inverse"] = 3] = "general_action_audit_inverse";
  EBrandedIcons[EBrandedIcons["general_action_barriers"] = 4] = "general_action_barriers";
  EBrandedIcons[EBrandedIcons["general_action_barriers_inverse"] = 5] = "general_action_barriers_inverse";
  EBrandedIcons[EBrandedIcons["general_action_best_practices"] = 6] = "general_action_best_practices";
  EBrandedIcons[EBrandedIcons["general_action_best_practices_inverse"] = 7] = "general_action_best_practices_inverse";
  EBrandedIcons[EBrandedIcons["general_action_call"] = 8] = "general_action_call";
  EBrandedIcons[EBrandedIcons["general_action_call_inverse"] = 9] = "general_action_call_inverse";
  EBrandedIcons[EBrandedIcons["general_action_develop"] = 10] = "general_action_develop";
  EBrandedIcons[EBrandedIcons["general_action_develop_inverse"] = 11] = "general_action_develop_inverse";
  EBrandedIcons[EBrandedIcons["general_action_download"] = 12] = "general_action_download";
  EBrandedIcons[EBrandedIcons["general_action_download_inverse"] = 13] = "general_action_download_inverse";
  EBrandedIcons[EBrandedIcons["general_action_event_driven"] = 14] = "general_action_event_driven";
  EBrandedIcons[EBrandedIcons["general_action_event_driven_inverse"] = 15] = "general_action_event_driven_inverse";
  EBrandedIcons[EBrandedIcons["general_action_favorite"] = 16] = "general_action_favorite";
  EBrandedIcons[EBrandedIcons["general_action_favorite_inverse"] = 17] = "general_action_favorite_inverse";
  EBrandedIcons[EBrandedIcons["general_action_locked"] = 18] = "general_action_locked";
  EBrandedIcons[EBrandedIcons["general_action_locked_inverse"] = 19] = "general_action_locked_inverse";
  EBrandedIcons[EBrandedIcons["general_action_login"] = 20] = "general_action_login";
  EBrandedIcons[EBrandedIcons["general_action_login_inverse"] = 21] = "general_action_login_inverse";
  EBrandedIcons[EBrandedIcons["general_action_read"] = 22] = "general_action_read";
  EBrandedIcons[EBrandedIcons["general_action_read_inverse"] = 23] = "general_action_read_inverse";
  EBrandedIcons[EBrandedIcons["general_action_search"] = 24] = "general_action_search";
  EBrandedIcons[EBrandedIcons["general_action_search_inverse"] = 25] = "general_action_search_inverse";
  EBrandedIcons[EBrandedIcons["general_action_share"] = 26] = "general_action_share";
  EBrandedIcons[EBrandedIcons["general_action_share_inverse"] = 27] = "general_action_share_inverse";
  EBrandedIcons[EBrandedIcons["general_action_star"] = 28] = "general_action_star";
  EBrandedIcons[EBrandedIcons["general_action_star_inverse"] = 29] = "general_action_star_inverse";
  EBrandedIcons[EBrandedIcons["general_action_unlocked"] = 30] = "general_action_unlocked";
  EBrandedIcons[EBrandedIcons["general_action_unlocked_inverse"] = 31] = "general_action_unlocked_inverse";
  EBrandedIcons[EBrandedIcons["general_action_view"] = 32] = "general_action_view";
  EBrandedIcons[EBrandedIcons["general_action_view_inverse"] = 33] = "general_action_view_inverse";
  EBrandedIcons[EBrandedIcons["general_alert"] = 34] = "general_alert";
  EBrandedIcons[EBrandedIcons["general_alert_change_alert"] = 35] = "general_alert_change_alert";
  EBrandedIcons[EBrandedIcons["general_alert_change_alert_inverse"] = 36] = "general_alert_change_alert_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_error"] = 37] = "general_alert_error";
  EBrandedIcons[EBrandedIcons["general_alert_error_inverse"] = 38] = "general_alert_error_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_high_cost"] = 39] = "general_alert_high_cost";
  EBrandedIcons[EBrandedIcons["general_alert_high_cost_inverse"] = 40] = "general_alert_high_cost_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_incompatible"] = 41] = "general_alert_incompatible";
  EBrandedIcons[EBrandedIcons["cloud_blocker"] = 42] = "cloud_blocker";
  EBrandedIcons[EBrandedIcons["cloud_blocker_inverse"] = 43] = "cloud_blocker_inverse";
  EBrandedIcons[EBrandedIcons["cloud_disaster_recovery"] = 44] = "cloud_disaster_recovery";
  EBrandedIcons[EBrandedIcons["cloud_disaster_recovery_inverse"] = 45] = "cloud_disaster_recovery_inverse";
  EBrandedIcons[EBrandedIcons["cloud_global"] = 46] = "cloud_global";
  EBrandedIcons[EBrandedIcons["cloud_global_inverse"] = 47] = "cloud_global_inverse";
  EBrandedIcons[EBrandedIcons["cloud_iot"] = 48] = "cloud_iot";
  EBrandedIcons[EBrandedIcons["cloud_iot_inverse"] = 49] = "cloud_iot_inverse";
  EBrandedIcons[EBrandedIcons["cloud_manage_users"] = 50] = "cloud_manage_users";
  EBrandedIcons[EBrandedIcons["cloud_manage_users_inverse"] = 51] = "cloud_manage_users_inverse";
  EBrandedIcons[EBrandedIcons["cloud_managed"] = 52] = "cloud_managed";
  EBrandedIcons[EBrandedIcons["cloud_managed_inverse"] = 53] = "cloud_managed_inverse";
  EBrandedIcons[EBrandedIcons["general_content_blog"] = 54] = "general_content_blog";
  EBrandedIcons[EBrandedIcons["general_content_blog_inverse"] = 55] = "general_content_blog_inverse";
  EBrandedIcons[EBrandedIcons["general_content_collaborate"] = 56] = "general_content_collaborate";
  EBrandedIcons[EBrandedIcons["general_content_collaborate_inverse"] = 57] = "general_content_collaborate_inverse";
  EBrandedIcons[EBrandedIcons["general_content_community"] = 58] = "general_content_community";
  EBrandedIcons[EBrandedIcons["general_content_community_inverse"] = 59] = "general_content_community_inverse";
  EBrandedIcons[EBrandedIcons["general_content_ebook"] = 60] = "general_content_ebook";
  EBrandedIcons[EBrandedIcons["general_content_ebook_inverse"] = 61] = "general_content_ebook_inverse";
  EBrandedIcons[EBrandedIcons["general_content_expertise"] = 62] = "general_content_expertise";
  EBrandedIcons[EBrandedIcons["general_content_expertise_inverse"] = 63] = "general_content_expertise_inverse";
  EBrandedIcons[EBrandedIcons["general_content_learn"] = 64] = "general_content_learn";
  EBrandedIcons[EBrandedIcons["general_content_learn_inverse"] = 65] = "general_content_learn_inverse";
  EBrandedIcons[EBrandedIcons["general_content_play"] = 66] = "general_content_play";
  EBrandedIcons[EBrandedIcons["general_content_play_inverse"] = 67] = "general_content_play_inverse";
  EBrandedIcons[EBrandedIcons["general_content_presentations"] = 68] = "general_content_presentations";
  EBrandedIcons[EBrandedIcons["general_content_presentations_inverse"] = 69] = "general_content_presentations_inverse";
  EBrandedIcons[EBrandedIcons["general_content_pricing"] = 70] = "general_content_pricing";
  EBrandedIcons[EBrandedIcons["general_content_pricing_inverse"] = 71] = "general_content_pricing_inverse";
  EBrandedIcons[EBrandedIcons["general_content_tutorial"] = 72] = "general_content_tutorial";
  EBrandedIcons[EBrandedIcons["general_content_tutorial_inverse"] = 73] = "general_content_tutorial_inverse";
  EBrandedIcons[EBrandedIcons["general_content_user"] = 74] = "general_content_user";
  EBrandedIcons[EBrandedIcons["general_content_user_inverse"] = 75] = "general_content_user_inverse";
  EBrandedIcons[EBrandedIcons["general_content_users"] = 76] = "general_content_users";
  EBrandedIcons[EBrandedIcons["general_content_users_inverse"] = 77] = "general_content_users_inverse";
  EBrandedIcons[EBrandedIcons["general_content_white_paper"] = 78] = "general_content_white_paper";
  EBrandedIcons[EBrandedIcons["general_content_white_paper_inverse"] = 79] = "general_content_white_paper_inverse";
  EBrandedIcons[EBrandedIcons["general_events"] = 80] = "general_events";
  EBrandedIcons[EBrandedIcons["general_events_ask_the_experts"] = 81] = "general_events_ask_the_experts";
  EBrandedIcons[EBrandedIcons["general_events_ask_the_experts_inverse"] = 82] = "general_events_ask_the_experts_inverse";
  EBrandedIcons[EBrandedIcons["general_events_breakout"] = 83] = "general_events_breakout";
  EBrandedIcons[EBrandedIcons["general_events_breakout_inverse"] = 84] = "general_events_breakout_inverse";
  EBrandedIcons[EBrandedIcons["general_events_inverse"] = 85] = "general_events_inverse";
  EBrandedIcons[EBrandedIcons["general_events_keynote"] = 86] = "general_events_keynote";
  EBrandedIcons[EBrandedIcons["general_events_keynote_inverse"] = 87] = "general_events_keynote_inverse";
  EBrandedIcons[EBrandedIcons["general_events_register"] = 88] = "general_events_register";
  EBrandedIcons[EBrandedIcons["general_events_register_inverse"] = 89] = "general_events_register_inverse";
  EBrandedIcons[EBrandedIcons["general_events_restrooms"] = 90] = "general_events_restrooms";
  EBrandedIcons[EBrandedIcons["general_events_restrooms_inverse"] = 91] = "general_events_restrooms_inverse";
  EBrandedIcons[EBrandedIcons["general_events_session"] = 92] = "general_events_session";
  EBrandedIcons[EBrandedIcons["general_events_session_inverse"] = 93] = "general_events_session_inverse";
  EBrandedIcons[EBrandedIcons["general_events_ticketing"] = 94] = "general_events_ticketing";
  EBrandedIcons[EBrandedIcons["general_events_ticketing_inverse"] = 95] = "general_events_ticketing_inverse";
  EBrandedIcons[EBrandedIcons["general_events_vendor_lock_in"] = 96] = "general_events_vendor_lock_in";
  EBrandedIcons[EBrandedIcons["general_events_vendor_lock_in_inverse"] = 97] = "general_events_vendor_lock_in_inverse";
  EBrandedIcons[EBrandedIcons["general_features_api"] = 98] = "general_features_api";
  EBrandedIcons[EBrandedIcons["general_features_api_inverse"] = 99] = "general_features_api_inverse";
  EBrandedIcons[EBrandedIcons["general_features_automation"] = 100] = "general_features_automation";
  EBrandedIcons[EBrandedIcons["general_features_automation_inverse"] = 101] = "general_features_automation_inverse";
  EBrandedIcons[EBrandedIcons["general_features_build_faster"] = 102] = "general_features_build_faster";
  EBrandedIcons[EBrandedIcons["general_features_build_faster_inverse"] = 103] = "general_features_build_faster_inverse";
  EBrandedIcons[EBrandedIcons["general_features_commercial_license"] = 104] = "general_features_commercial_license";
  EBrandedIcons[EBrandedIcons["general_features_commercial_license_inverse"] = 105] = "general_features_commercial_license_inverse";
  EBrandedIcons[EBrandedIcons["general_features_complexity"] = 106] = "general_features_complexity";
  EBrandedIcons[EBrandedIcons["general_features_complexity_inverse"] = 107] = "general_features_complexity_inverse";
  EBrandedIcons[EBrandedIcons["general_features_conversion"] = 108] = "general_features_conversion";
  EBrandedIcons[EBrandedIcons["general_features_conversion_inverse"] = 109] = "general_features_conversion_inverse";
  EBrandedIcons[EBrandedIcons["general_features_data_analytics"] = 110] = "general_features_data_analytics";
  EBrandedIcons[EBrandedIcons["general_features_data_analytics_inverse"] = 111] = "general_features_data_analytics_inverse";
  EBrandedIcons[EBrandedIcons["general_features_data_silos"] = 112] = "general_features_data_silos";
  EBrandedIcons[EBrandedIcons["general_features_data_silos_inverse"] = 113] = "general_features_data_silos_inverse";
  EBrandedIcons[EBrandedIcons["general_features_dynamic"] = 114] = "general_features_dynamic";
  EBrandedIcons[EBrandedIcons["general_features_dynamic_inverse"] = 115] = "general_features_dynamic_inverse";
  EBrandedIcons[EBrandedIcons["general_features_faq"] = 116] = "general_features_faq";
  EBrandedIcons[EBrandedIcons["general_features_faq_inverse"] = 117] = "general_features_faq_inverse";
  EBrandedIcons[EBrandedIcons["general_features_flexibility"] = 118] = "general_features_flexibility";
  EBrandedIcons[EBrandedIcons["general_features_flexibility_inverse"] = 119] = "general_features_flexibility_inverse";
  EBrandedIcons[EBrandedIcons["general_features_global"] = 120] = "general_features_global";
  EBrandedIcons[EBrandedIcons["general_features_global_clusters"] = 121] = "general_features_global_clusters";
  EBrandedIcons[EBrandedIcons["general_features_global_clusters_inverse"] = 122] = "general_features_global_clusters_inverse";
  EBrandedIcons[EBrandedIcons["general_features_global_inverse"] = 123] = "general_features_global_inverse";
  EBrandedIcons[EBrandedIcons["general_features_insight"] = 124] = "general_features_insight";
  EBrandedIcons[EBrandedIcons["general_features_insight_inverse"] = 125] = "general_features_insight_inverse";
  EBrandedIcons[EBrandedIcons["general_features_intelligent_edge"] = 126] = "general_features_intelligent_edge";
  EBrandedIcons[EBrandedIcons["general_features_intelligent_edge_inverse"] = 127] = "general_features_intelligent_edge_inverse";
  EBrandedIcons[EBrandedIcons["general_features_list"] = 128] = "general_features_list";
  EBrandedIcons[EBrandedIcons["general_features_list_inverse"] = 129] = "general_features_list_inverse";
  EBrandedIcons[EBrandedIcons["general_features_management"] = 130] = "general_features_management";
  EBrandedIcons[EBrandedIcons["general_features_management_inverse"] = 131] = "general_features_management_inverse";
  EBrandedIcons[EBrandedIcons["general_features_marketing_support"] = 132] = "general_features_marketing_support";
  EBrandedIcons[EBrandedIcons["general_features_marketing_support_inverse"] = 133] = "general_features_marketing_support_inverse";
  EBrandedIcons[EBrandedIcons["general_features_multiple_formats"] = 134] = "general_features_multiple_formats";
  EBrandedIcons[EBrandedIcons["general_features_multiple_formats_inverse"] = 135] = "general_features_multiple_formats_inverse";
  EBrandedIcons[EBrandedIcons["general_features_on_demand"] = 136] = "general_features_on_demand";
  EBrandedIcons[EBrandedIcons["general_features_on_demand_inverse"] = 137] = "general_features_on_demand_inverse";
  EBrandedIcons[EBrandedIcons["general_features_realtime"] = 138] = "general_features_realtime";
  EBrandedIcons[EBrandedIcons["general_features_realtime_inverse"] = 139] = "general_features_realtime_inverse";
  EBrandedIcons[EBrandedIcons["general_features_scale_bigger"] = 140] = "general_features_scale_bigger";
  EBrandedIcons[EBrandedIcons["general_features_scale_bigger_inverse"] = 141] = "general_features_scale_bigger_inverse";
  EBrandedIcons[EBrandedIcons["general_features_support"] = 142] = "general_features_support";
  EBrandedIcons[EBrandedIcons["general_features_support_inverse"] = 143] = "general_features_support_inverse";
  EBrandedIcons[EBrandedIcons["general_features_table"] = 144] = "general_features_table";
  EBrandedIcons[EBrandedIcons["general_features_table_inverse"] = 145] = "general_features_table_inverse";
  EBrandedIcons[EBrandedIcons["general_features_tools"] = 146] = "general_features_tools";
  EBrandedIcons[EBrandedIcons["general_features_tools_inverse"] = 147] = "general_features_tools_inverse";
  EBrandedIcons[EBrandedIcons["general_features_transactions"] = 148] = "general_features_transactions";
  EBrandedIcons[EBrandedIcons["general_features_transactions_inverse"] = 149] = "general_features_transactions_inverse";
  EBrandedIcons[EBrandedIcons["industry_ai"] = 150] = "industry_ai";
  EBrandedIcons[EBrandedIcons["industry_ai_inverse"] = 151] = "industry_ai_inverse";
  EBrandedIcons[EBrandedIcons["industry_airline_app"] = 152] = "industry_airline_app";
  EBrandedIcons[EBrandedIcons["industry_airline_app_inverse"] = 153] = "industry_airline_app_inverse";
  EBrandedIcons[EBrandedIcons["industry_automotive"] = 154] = "industry_automotive";
  EBrandedIcons[EBrandedIcons["industry_automotive_inverse"] = 155] = "industry_automotive_inverse";
  EBrandedIcons[EBrandedIcons["industry_enterprise"] = 156] = "industry_enterprise";
  EBrandedIcons[EBrandedIcons["industry_enterprise_inverse"] = 157] = "industry_enterprise_inverse";
  EBrandedIcons[EBrandedIcons["industry_finance"] = 158] = "industry_finance";
  EBrandedIcons[EBrandedIcons["industry_finance_inverse"] = 159] = "industry_finance_inverse";
  EBrandedIcons[EBrandedIcons["industry_healthcare"] = 160] = "industry_healthcare";
  EBrandedIcons[EBrandedIcons["industry_healthcare_inverse"] = 161] = "industry_healthcare_inverse";
  EBrandedIcons[EBrandedIcons["misc_achievement"] = 162] = "misc_achievement";
  EBrandedIcons[EBrandedIcons["misc_achievement_inverse"] = 163] = "misc_achievement_inverse";
  EBrandedIcons[EBrandedIcons["misc_bug"] = 164] = "misc_bug";
  EBrandedIcons[EBrandedIcons["misc_bug_inverse"] = 165] = "misc_bug_inverse";
  EBrandedIcons[EBrandedIcons["misc_create"] = 166] = "misc_create";
  EBrandedIcons[EBrandedIcons["misc_create_inverse"] = 167] = "misc_create_inverse";
  EBrandedIcons[EBrandedIcons["misc_delete"] = 168] = "misc_delete";
  EBrandedIcons[EBrandedIcons["misc_delete_inverse"] = 169] = "misc_delete_inverse";
  EBrandedIcons[EBrandedIcons["misc_desktop"] = 170] = "misc_desktop";
  EBrandedIcons[EBrandedIcons["misc_desktop_inverse"] = 171] = "misc_desktop_inverse";
  EBrandedIcons[EBrandedIcons["misc_global"] = 172] = "misc_global";
  EBrandedIcons[EBrandedIcons["misc_global_inverse"] = 173] = "misc_global_inverse";
  EBrandedIcons[EBrandedIcons["number_plus"] = 174] = "number_plus";
  EBrandedIcons[EBrandedIcons["number_plus_inverse"] = 175] = "number_plus_inverse";
  EBrandedIcons[EBrandedIcons["number_minus"] = 176] = "number_minus";
  EBrandedIcons[EBrandedIcons["number_minus_inverse"] = 177] = "number_minus_inverse";
  EBrandedIcons[EBrandedIcons["number_0"] = 178] = "number_0";
  EBrandedIcons[EBrandedIcons["number_0_inverse"] = 179] = "number_0_inverse";
  EBrandedIcons[EBrandedIcons["number_1"] = 180] = "number_1";
  EBrandedIcons[EBrandedIcons["number_1_inverse"] = 181] = "number_1_inverse";
  EBrandedIcons[EBrandedIcons["number_2"] = 182] = "number_2";
  EBrandedIcons[EBrandedIcons["number_2_inverse"] = 183] = "number_2_inverse";
  EBrandedIcons[EBrandedIcons["number_3"] = 184] = "number_3";
  EBrandedIcons[EBrandedIcons["number_3_inverse"] = 185] = "number_3_inverse";
  EBrandedIcons[EBrandedIcons["number_4"] = 186] = "number_4";
  EBrandedIcons[EBrandedIcons["number_4_inverse"] = 187] = "number_4_inverse";
  EBrandedIcons[EBrandedIcons["number_5"] = 188] = "number_5";
  EBrandedIcons[EBrandedIcons["number_5_inverse"] = 189] = "number_5_inverse";
  EBrandedIcons[EBrandedIcons["number_6"] = 190] = "number_6";
  EBrandedIcons[EBrandedIcons["number_6_inverse"] = 191] = "number_6_inverse";
  EBrandedIcons[EBrandedIcons["number_7"] = 192] = "number_7";
  EBrandedIcons[EBrandedIcons["number_7_inverse"] = 193] = "number_7_inverse";
  EBrandedIcons[EBrandedIcons["number_8"] = 194] = "number_8";
  EBrandedIcons[EBrandedIcons["number_8_inverse"] = 195] = "number_8_inverse";
  EBrandedIcons[EBrandedIcons["number_secondary_node_inverse"] = 196] = "number_secondary_node_inverse";
  EBrandedIcons[EBrandedIcons["number_9"] = 197] = "number_9";
  EBrandedIcons[EBrandedIcons["number_9_inverse"] = 198] = "number_9_inverse";
  EBrandedIcons[EBrandedIcons["number_secondary_node"] = 199] = "number_secondary_node";
  EBrandedIcons[EBrandedIcons["number_primary_node_inverse"] = 200] = "number_primary_node_inverse";
  EBrandedIcons[EBrandedIcons["number_compute_node"] = 201] = "number_compute_node";
  EBrandedIcons[EBrandedIcons["number_compute_node_inverse"] = 202] = "number_compute_node_inverse";
  EBrandedIcons[EBrandedIcons["number_primary_node"] = 203] = "number_primary_node";
  EBrandedIcons[EBrandedIcons["general_security"] = 204] = "general_security";
  EBrandedIcons[EBrandedIcons["general_security_encrypted_storage"] = 205] = "general_security_encrypted_storage";
  EBrandedIcons[EBrandedIcons["general_security_encrypted_storage_inverse"] = 206] = "general_security_encrypted_storage_inverse";
  EBrandedIcons[EBrandedIcons["general_security_encryption"] = 207] = "general_security_encryption";
  EBrandedIcons[EBrandedIcons["general_security_encryption_inverse"] = 208] = "general_security_encryption_inverse";
  EBrandedIcons[EBrandedIcons["general_security_federated_identity"] = 209] = "general_security_federated_identity";
  EBrandedIcons[EBrandedIcons["general_security_federated_identity_inverse"] = 210] = "general_security_federated_identity_inverse";
  EBrandedIcons[EBrandedIcons["general_security_hipaa_compliance"] = 211] = "general_security_hipaa_compliance";
  EBrandedIcons[EBrandedIcons["general_security_hipaa_compliance_inverse"] = 212] = "general_security_hipaa_compliance_inverse";
  EBrandedIcons[EBrandedIcons["general_security_inverse"] = 213] = "general_security_inverse";
  EBrandedIcons[EBrandedIcons["general_security_privacy"] = 214] = "general_security_privacy";
  EBrandedIcons[EBrandedIcons["general_security_privacy_inverse"] = 215] = "general_security_privacy_inverse";
  EBrandedIcons[EBrandedIcons["general_security_secure_by_default"] = 216] = "general_security_secure_by_default";
  EBrandedIcons[EBrandedIcons["general_security_secure_by_default_inverse"] = 217] = "general_security_secure_by_default_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_incompatible_inverse"] = 218] = "general_alert_incompatible_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_info_inverse"] = 219] = "general_alert_info_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_inverse"] = 220] = "general_alert_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_mobile"] = 221] = "general_alert_mobile";
  EBrandedIcons[EBrandedIcons["general_alert_mobile_inverse"] = 222] = "general_alert_mobile_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_security"] = 223] = "general_alert_security";
  EBrandedIcons[EBrandedIcons["cloud_multicloud_inverse"] = 224] = "cloud_multicloud_inverse";
  EBrandedIcons[EBrandedIcons["cloud_private_link"] = 225] = "cloud_private_link";
  EBrandedIcons[EBrandedIcons["cloud_private_link_inverse"] = 226] = "cloud_private_link_inverse";
  EBrandedIcons[EBrandedIcons["cloud_settings"] = 227] = "cloud_settings";
  EBrandedIcons[EBrandedIcons["cloud_settings_inverse"] = 228] = "cloud_settings_inverse";
  EBrandedIcons[EBrandedIcons["industry_mobile_gaming"] = 229] = "industry_mobile_gaming";
  EBrandedIcons[EBrandedIcons["industry_mobile_gaming_inverse"] = 230] = "industry_mobile_gaming_inverse";
  EBrandedIcons[EBrandedIcons["industry_retail"] = 231] = "industry_retail";
  EBrandedIcons[EBrandedIcons["industry_retail_inverse"] = 232] = "industry_retail_inverse";
  EBrandedIcons[EBrandedIcons["misc_grow_inverse"] = 233] = "misc_grow_inverse";
  EBrandedIcons[EBrandedIcons["misc_mobile"] = 234] = "misc_mobile";
  EBrandedIcons[EBrandedIcons["misc_mobile_inverse"] = 235] = "misc_mobile_inverse";
  EBrandedIcons[EBrandedIcons["misc_send"] = 236] = "misc_send";
  EBrandedIcons[EBrandedIcons["misc_send_inverse"] = 237] = "misc_send_inverse";
  EBrandedIcons[EBrandedIcons["misc_transform"] = 238] = "misc_transform";
  EBrandedIcons[EBrandedIcons["misc_transform_inverse"] = 239] = "misc_transform_inverse";
  EBrandedIcons[EBrandedIcons["general_alert_info"] = 240] = "general_alert_info";
  EBrandedIcons[EBrandedIcons["general_alert_security_inverse"] = 241] = "general_alert_security_inverse";
  EBrandedIcons[EBrandedIcons["cloud_mobility"] = 242] = "cloud_mobility";
  EBrandedIcons[EBrandedIcons["cloud_mobility_inverse"] = 243] = "cloud_mobility_inverse";
  EBrandedIcons[EBrandedIcons["cloud_multicloud"] = 244] = "cloud_multicloud";
  EBrandedIcons[EBrandedIcons["cloud_schedule"] = 245] = "cloud_schedule";
  EBrandedIcons[EBrandedIcons["cloud_schedule_inverse"] = 246] = "cloud_schedule_inverse";
  EBrandedIcons[EBrandedIcons["cloud_transfer"] = 247] = "cloud_transfer";
  EBrandedIcons[EBrandedIcons["cloud_transfer_inverse"] = 248] = "cloud_transfer_inverse";
  EBrandedIcons[EBrandedIcons["industry_healthcare_query"] = 249] = "industry_healthcare_query";
  EBrandedIcons[EBrandedIcons["industry_healthcare_query_inverse"] = 250] = "industry_healthcare_query_inverse";
  EBrandedIcons[EBrandedIcons["industry_oil_gas_energy"] = 251] = "industry_oil_gas_energy";
  EBrandedIcons[EBrandedIcons["industry_oil_gas_energy_inverse"] = 252] = "industry_oil_gas_energy_inverse";
  EBrandedIcons[EBrandedIcons["industry_restaurant"] = 253] = "industry_restaurant";
  EBrandedIcons[EBrandedIcons["industry_restaurant_inverse"] = 254] = "industry_restaurant_inverse";
  EBrandedIcons[EBrandedIcons["industry_telecom"] = 255] = "industry_telecom";
  EBrandedIcons[EBrandedIcons["industry_telecom_inverse"] = 256] = "industry_telecom_inverse";
  EBrandedIcons[EBrandedIcons["misc_grow"] = 257] = "misc_grow";
  EBrandedIcons[EBrandedIcons["misc_laptop"] = 258] = "misc_laptop";
  EBrandedIcons[EBrandedIcons["misc_laptop_inverse"] = 259] = "misc_laptop_inverse";
  EBrandedIcons[EBrandedIcons["misc_sunrise"] = 260] = "misc_sunrise";
  EBrandedIcons[EBrandedIcons["misc_sunrise_inverse"] = 261] = "misc_sunrise_inverse";
})(EBrandedIcons || (EBrandedIcons = {}));

var getStyles$3 = function getStyles$3(state, theme) {
  var disabled = state.disabled,
      inverse = state.inverse,
      selected = state.selected,
      focused = state.focused,
      indeterminate = state.indeterminate;
  var colors = theme.colors.forms;
  var checkboxType = inverse ? 'checkboxInverse' : 'checkbox';
  var glyphColor = 'transparent',
      outlineColor = 'transparent',
      borderColor = colors[checkboxType].boxBorder,
      backgroundColor = 'transparent';

  if (selected) {
    borderColor = 'transparent';
    glyphColor = colors[checkboxType].icon;
    backgroundColor = colors[checkboxType].bgSelected;
  }

  if (focused) {
    outlineColor = colors[checkboxType].focusBorder;
  }

  return {
    input: {
      position: 'absolute',
      width: 0,
      height: 0,
      margin: 0,
      opacity: 0
    },
    label: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, auto)',
      gridTemplateAreas: "\n        \"checkbox  label-text\"\n        \".         helper-text\"\n      ",
      columnGap: 10,
      alignItems: 'center',
      justifyContent: 'flex-start',
      opacity: disabled ? 0.6 : 1
    },
    checkbox: {
      position: 'relative',
      display: 'inline-block',
      gridArea: 'checkbox',
      cursor: disabled ? 'not-allowed' : 'pointer',
      width: [16, null, null, 20],
      height: [16, null, null, 20],
      borderStyle: 'solid',
      borderWidth: 2,
      borderRadius: 4,
      borderColor: borderColor,
      backgroundColor: backgroundColor,
      outlineStyle: 'solid',
      outlineWidth: 2,
      outlineOffset: 2,
      outlineColor: outlineColor
    },
    glyph: {
      position: 'relative',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      height: 10,
      width: 10,
      '&::before': {
        content: '""',
        position: 'absolute',
        margin: 'auto',
        top: indeterminate ? 0 : ['10%', null, null, '0%'],
        bottom: indeterminate ? 0 : null,
        left: indeterminate ? 0 : null,
        right: indeterminate ? 0 : ['10%', null, null, '0%'],
        transform: indeterminate ? null : 'rotate(-45deg)',
        transformOrigin: '100% 0%',
        width: indeterminate ? [8, null, null, 10] : [8, null, null, 11],
        height: indeterminate ? 3 : [2, null, null, 2.5],
        borderRadius: '0.5rem',
        backgroundColor: glyphColor
      },
      '&::after': {
        content: indeterminate ? null : '""',
        position: 'absolute',
        bottom: '45%',
        left: ['10%', null, null, '0%'],
        transform: 'rotate(45deg)',
        transformOrigin: '0% 45%',
        width: [5, null, null, 6.5],
        height: [2, null, null, 2.5],
        borderRadius: '0.5rem',
        backgroundColor: glyphColor
      }
    }
  };
};

var Checkbox = function Checkbox(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.label,
      label = _c === void 0 ? '' : _c,
      _d = _a.helper,
      helper = _d === void 0 ? '' : _d,
      _e = _a.name,
      name = _e === void 0 ? '' : _e,
      _f = _a.theme,
      theme = _f === void 0 ? 'default' : _f;
  _a.children;

  var _g = _a.onToggle,
      onToggle = _g === void 0 ? function () {} : _g,
      props = __rest(_a, ["className", "label", "helper", "name", "theme", "children", "onToggle"]);

  var _h = props.checked,
      checked = _h === void 0 ? false : _h,
      _j = props.disabled,
      disabled = _j === void 0 ? false : _j,
      _k = props.inverse,
      inverse = _k === void 0 ? false : _k,
      _l = props.indeterminate,
      indeterminate = _l === void 0 ? false : _l;

  var _m = useState(checked),
      selected = _m[0],
      setSelected = _m[1];

  var _o = useState(false),
      focused = _o[0],
      setFocused = _o[1];

  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var checkboxState = {
    disabled: disabled,
    inverse: inverse,
    selected: selected,
    focused: focused,
    indeterminate: indeterminate
  };
  var styles = getStyles$3(checkboxState, selectedTheme); // updates the selected state to match the storybook checked control

  useEffect(function () {
    setSelected(checked);
  }, [checked]);

  var handleSelected = function handleSelected() {
    setSelected(function (s) {
      return !s;
    });

    if (onToggle) {
      onToggle(!selected);
    }
  };

  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      className: className,
      sx: props.customStyles
    }, {
      children: [jsx("input", {
        checked: selected,
        onChange: disabled ? function () {} : handleSelected,
        onFocus: function onFocus() {
          return setFocused(true);
        },
        onBlur: function onBlur() {
          return setFocused(false);
        },
        type: 'checkbox',
        id: name,
        name: name,
        sx: styles.input
      }, void 0), jsxs("label", _assign({
        "aria-label": name,
        htmlFor: name,
        sx: styles.label
      }, {
        children: [jsx("span", _assign({
          "aria-label": 'checkbox',
          sx: styles.checkbox
        }, {
          children: jsx("span", _assign({
            sx: {
              height: '100%',
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }
          }, {
            children: jsx("span", {
              sx: styles.glyph
            }, void 0)
          }), void 0)
        }), void 0), jsx(TypographyScale, _assign({
          inverse: inverse,
          variant: 'body3',
          sx: {
            gridArea: 'label-text '
          }
        }, {
          children: label
        }), void 0), jsx(TypographyScale, _assign({
          inverse: inverse,
          variant: 'body3',
          color: 'secondary',
          customStyles: {
            marginTop: selectedTheme.space.neg10,
            maxWidth: 300,
            gridArea: 'helper-text'
          }
        }, {
          children: label && helper
        }), void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
};

var getFontStyles = function getFontStyles(textSize) {
  var FontStyles = {
    small: {
      fontSize: ['inc10', 'inc10', 'inc10', 'inc20'],
      lineHeight: ['inc20', 'inc20', 'inc20', 'inc30']
    },
    medium: {
      fontSize: ['inc30', 'inc30', 'inc30', 'inc40'],
      lineHeight: ['inc30', 'inc30', 'inc30', 'inc30']
    },
    large: {
      fontSize: ['inc40', 'inc40', 'inc40', 'inc70'],
      lineHeight: ['inc30', 'inc30', 'inc30', 'inc40']
    }
  };
  return FontStyles[textSize];
};

var getGlyphStyles = function getGlyphStyles(glyph, textSize, inverse) {
  var large = textSize === 'large';
  var GlyphStyle = {
    circle: {
      width: '12px',
      height: '12px',
      bg: inverse ? 'list.inverse.bullet' : 'list.default.bullet',
      borderRadius: '50%',
      top: large ? ['10px', '10px', '10px', '14px'] : ['6px', '6px', '6px', '10px'],
      left: large ? ['3px', '3px', '3px', '8px'] : '2px'
    },
    checkmark: _assign(_assign({}, getCheckmarkStyles(textSize, inverse)), {
      transform: 'rotate(-45deg)'
    })
  };
  return GlyphStyle[glyph];
};

var getCheckmarkStyles = function getCheckmarkStyles(textSize, inverse) {
  var color = inverse ? defaultTheme.colors.list.inverse.checkmark : defaultTheme.colors.list.default.checkmark;
  var thinBorder = "2px solid " + color;
  var thickBorder = "3px solid " + color;
  var CheckmarkStyles = {
    small: {
      width: '15px',
      height: '6px',
      borderBottom: thinBorder,
      borderLeft: thinBorder,
      top: ['4px', '4px', '4px', '7px'],
      left: '1px'
    },
    medium: {
      width: ['15px', '15px', '15px', '22px'],
      height: ['7px', '7px', '7px', '9px'],
      borderBottom: [thinBorder, thinBorder, thinBorder, thickBorder],
      borderLeft: [thinBorder, thinBorder, thinBorder, thickBorder],
      top: '8px',
      left: '2px'
    },
    large: {
      width: ['15px', '15px', '15px', '22px'],
      height: ['7px', '7px', '7px', '9px'],
      borderBottom: [thinBorder, thinBorder, thinBorder, thickBorder],
      borderLeft: [thinBorder, thinBorder, thinBorder, thickBorder],
      top: '8px',
      left: '2px'
    }
  };
  return CheckmarkStyles[textSize];
};

var getMarginBottom = function getMarginBottom(textSize, description) {
  var MarginBottomStyles = {
    small: {
      marginBottom: description ? 'inc70' : 'inc30'
    },
    medium: {
      marginBottom: description ? 'inc70' : 'inc30'
    },
    large: {
      marginBottom: description ? 'inc70' : ['inc20', null, null, 'inc40']
    }
  };
  return MarginBottomStyles[textSize];
};

var Unordered = function Unordered(_a) {
  var _b = _a.glyph,
      glyph = _b === void 0 ? 'checkmark' : _b,
      items = _a.items,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      _d = _a.textSize,
      textSize = _d === void 0 ? 'small' : _d;
  var large = textSize === 'large';
  return jsx("ul", _assign({
    sx: {
      margin: 0,
      padding: 0,
      listStyleType: 'none'
    }
  }, {
    children: items.map(function (item, index) {
      return jsxs("li", _assign({
        sx: _assign(_assign({
          position: 'relative',
          marginBottom: large ? ['inc20', null, null, 'inc40'] : 'inc30',
          paddingLeft: large ? ['32px', '32px', '32px', '48px'] : ['32px', '32px', '32px', '40px']
        }, getFontStyles(textSize)), getMarginBottom(textSize, typeof item !== 'string' && item.description || ''))
      }, {
        children: [jsx("span", {
          "aria-label": 'glyph',
          sx: {
            position: 'absolute',
            left: 0,
            '&::before': _assign({
              content: '""',
              position: 'absolute',
              left: 0
            }, getGlyphStyles(glyph, textSize, inverse))
          }
        }, void 0), typeof item === 'string' && jsx("span", _assign({
          sx: _assign({}, getFontStyles(textSize))
        }, {
          children: item
        }), void 0), typeof item !== 'string' && item.title && jsx("span", _assign({
          sx: _assign(_assign({}, getFontStyles(textSize)), {
            display: 'block',
            fontWeight: 500
          })
        }, {
          children: item.title
        }), void 0), typeof item !== 'string' && item.description && jsx("span", _assign({
          sx: _assign(_assign({}, getFontStyles(textSize)), {
            color: inverse ? 'text.inverseSecondary' : 'text.secondary'
          })
        }, {
          children: item.description
        }), void 0)]
      }), index);
    })
  }), void 0);
};

var Ordered = function Ordered(_a) {
  var items = _a.items,
      _b = _a.textSize,
      textSize = _b === void 0 ? 'small' : _b,
      inverse = _a.inverse;
  return jsx("ol", _assign({
    sx: {
      margin: 0
    }
  }, {
    children: items.map(function (item, index) {
      return jsxs("li", _assign({
        sx: _assign(_assign({
          paddingLeft: 'inc40'
        }, getMarginBottom(textSize, typeof item !== 'string' && item.description || '')), getFontStyles(textSize))
      }, {
        children: [typeof item === 'string' && jsx("span", _assign({
          sx: _assign({}, getFontStyles(textSize))
        }, {
          children: item
        }), void 0), typeof item !== 'string' && item.title && jsx("span", _assign({
          sx: _assign(_assign({}, getFontStyles(textSize)), {
            display: 'block',
            fontWeight: 500
          })
        }, {
          children: item.title
        }), void 0), typeof item !== 'string' && item.description && jsx("span", _assign({
          sx: _assign(_assign({}, getFontStyles(textSize)), {
            color: inverse ? 'text.inverseSecondary' : 'text.secondary'
          })
        }, {
          children: item.description
        }), void 0)]
      }), index);
    })
  }), void 0);
};

var List = function List(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'unordered' : _c,
      _d = _a.theme,
      theme = _d === void 0 ? 'default' : _d,
      items = _a.items,
      _e = _a.glyph,
      glyph = _e === void 0 ? 'checkmark' : _e,
      _f = _a.textSize,
      textSize = _f === void 0 ? 'small' : _f,
      _g = _a.inverse,
      inverse = _g === void 0 ? false : _g;
  var sharedProps = {
    items: items,
    textSize: textSize,
    inverse: inverse
  };
  return jsx(ThemeProvider, _assign({
    theme: theme === 'legacy' ? legacyTheme : defaultTheme
  }, {
    children: jsx("div", _assign({
      className: className,
      sx: {
        color: inverse ? 'list.inverse.text' : 'list.default.text',
        fontFamily: 'body'
      }
    }, {
      children: variant === 'unordered' ? jsx(Unordered, _assign({}, sharedProps, {
        glyph: glyph
      }), void 0) : jsx(Ordered, _assign({}, sharedProps), void 0)
    }), void 0)
  }), void 0);
};

var Panel = function Panel(_a) {
  var bgColor = _a.bgColor,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      borderColor = _a.borderColor,
      borderWidth = _a.borderWidth,
      borderRadius = _a.borderRadius,
      _d = _a.borderStyle,
      borderStyle = _d === void 0 ? 'solid' : _d,
      _e = _a.gridColumn,
      gridColumn = _e === void 0 ? '1 / span 12' : _e,
      boxShadow = _a.boxShadow,
      children = _a.children;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("div", _assign({
      className: className,
      sx: {
        gridColumn: gridColumn,
        backgroundColor: bgColor || selectedTheme.colors.panels.default.bg,
        borderColor: borderColor || selectedTheme.colors.panels.default.border,
        borderRadius: borderRadius || selectedTheme.radii.inc50,
        borderWidth: borderWidth || selectedTheme.borderWidths.inc10,
        borderStyle: borderStyle,
        boxShadow: boxShadow
      }
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var _a$1;

var DEFAULT_OPTIONS = {
  theme: 'flora',
  readOnly: true,
  scrollbarStyle: 'simple'
};
var ELanguageModeMap;

(function (ELanguageModeMap) {
  ELanguageModeMap["C"] = "text/x-csrc";
  ELanguageModeMap["CSS"] = "css";
  ELanguageModeMap["C#"] = "text/x-csharp";
  ELanguageModeMap["C++"] = "text/x-c++src";
  ELanguageModeMap["Go"] = "text/x-go";
  ELanguageModeMap["HTML"] = "htmlmixed";
  ELanguageModeMap["Java"] = "text/x-java";
  ELanguageModeMap["JavaScript"] = "javascript";
  ELanguageModeMap["JSON"] = "application/json";
  ELanguageModeMap["Kotlin"] = "text/x-kotlin";
  ELanguageModeMap["Markdown"] = "markdown";
  ELanguageModeMap["MQL"] = "javascript";
  ELanguageModeMap["Node"] = "javascript";
  ELanguageModeMap["PHP"] = "php";
  ELanguageModeMap["Python"] = "python";
  ELanguageModeMap["React"] = "text/jsx";
  ELanguageModeMap["React Native"] = "text/jsx";
  ELanguageModeMap["Ruby"] = "ruby";
  /* rust is broke in codemirror-ssr as of 2021-08-30.
    so commenting this out until either the library gets updated
    or we propose a fix. */
  // Rust = 'rust',

  ELanguageModeMap["Shell"] = "text/x-sh";
  ELanguageModeMap["Swift"] = "text/x-swift";
  ELanguageModeMap["Simple"] = "simple";
  ELanguageModeMap["TypeScript"] = "application/typescript";
})(ELanguageModeMap || (ELanguageModeMap = {}));

var HeightMap = {
  small: defaultTheme.sizes.codeSnippetSmall,
  medium: defaultTheme.sizes.codeSnippetMedium,
  large: defaultTheme.sizes.codeSnippetLarge
};
var ECopyIconMap;

(function (ECopyIconMap) {
  ECopyIconMap["COPY"] = "Copy";
  ECopyIconMap["COPIED"] = "Copied";
})(ECopyIconMap || (ECopyIconMap = {}));

var ICONS$1 = (_a$1 = {}, _a$1[ECopyIconMap.COPY] = 'https://webimages.mongodb.com/_com_assets/cms/ks9ey91u6mgoo8on4-copyIcon.svg?auto=format%252Ccompress', _a$1[ECopyIconMap.COPIED] = 'https://webimages.mongodb.com/_com_assets/cms/ks9eylc6k5vu2cf1m-copiedIcon.svg?auto=format%252Ccompress', _a$1);

var getLanguageMode = function getLanguageMode(language) {
  return ELanguageModeMap[language];
};

var getHeight = function getHeight(height) {
  return HeightMap[height];
};

var msStringToInt = function msStringToInt(msString) {
  return Number(msString.split('ms')[0]);
};

var css_248z$2 = "/* BASICS */\n\n.CodeMirror {\n  /* Set height, width, borders, and global font properties here */\n  font-family: monospace;\n  height: 300px;\n  color: black;\n  direction: ltr;\n}\n\n/* PADDING */\n\n.CodeMirror-lines {\n  padding: 4px 0; /* Vertical padding around content */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  padding: 0 4px; /* Horizontal padding of content */\n}\n\n.CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  background-color: white; /* The little square between H and V scrollbars */\n}\n\n/* GUTTER */\n\n.CodeMirror-gutters {\n  border-right: 1px solid #ddd;\n  background-color: #f7f7f7;\n  white-space: nowrap;\n}\n.CodeMirror-linenumbers {}\n.CodeMirror-linenumber {\n  padding: 0 3px 0 5px;\n  min-width: 20px;\n  text-align: right;\n  color: #999;\n  white-space: nowrap;\n}\n\n.CodeMirror-guttermarker { color: black; }\n.CodeMirror-guttermarker-subtle { color: #999; }\n\n/* CURSOR */\n\n.CodeMirror-cursor {\n  border-left: 1px solid black;\n  border-right: none;\n  width: 0;\n}\n/* Shown when moving in bi-directional text */\n.CodeMirror div.CodeMirror-secondarycursor {\n  border-left: 1px solid silver;\n}\n.cm-fat-cursor .CodeMirror-cursor {\n  width: auto;\n  border: 0 !important;\n  background: #7e7;\n}\n.cm-fat-cursor div.CodeMirror-cursors {\n  z-index: 1;\n}\n.cm-fat-cursor-mark {\n  background-color: rgba(20, 255, 20, 0.5);\n  -webkit-animation: blink 1.06s steps(1) infinite;\n  -moz-animation: blink 1.06s steps(1) infinite;\n  animation: blink 1.06s steps(1) infinite;\n}\n.cm-animate-fat-cursor {\n  width: auto;\n  border: 0;\n  -webkit-animation: blink 1.06s steps(1) infinite;\n  -moz-animation: blink 1.06s steps(1) infinite;\n  animation: blink 1.06s steps(1) infinite;\n  background-color: #7e7;\n}\n@-moz-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@-webkit-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n\n/* Can style cursor different in overwrite (non-insert) mode */\n.CodeMirror-overwrite .CodeMirror-cursor {}\n\n.cm-tab { display: inline-block; text-decoration: inherit; }\n\n.CodeMirror-rulers {\n  position: absolute;\n  left: 0; right: 0; top: -50px; bottom: 0;\n  overflow: hidden;\n}\n.CodeMirror-ruler {\n  border-left: 1px solid #ccc;\n  top: 0; bottom: 0;\n  position: absolute;\n}\n\n/* DEFAULT THEME */\n\n.cm-s-default .cm-header {color: blue;}\n.cm-s-default .cm-quote {color: #090;}\n.cm-negative {color: #d44;}\n.cm-positive {color: #292;}\n.cm-header, .cm-strong {font-weight: bold;}\n.cm-em {font-style: italic;}\n.cm-link {text-decoration: underline;}\n.cm-strikethrough {text-decoration: line-through;}\n\n.cm-s-default .cm-keyword {color: #708;}\n.cm-s-default .cm-atom {color: #219;}\n.cm-s-default .cm-number {color: #164;}\n.cm-s-default .cm-def {color: #00f;}\n.cm-s-default .cm-variable,\n.cm-s-default .cm-punctuation,\n.cm-s-default .cm-property,\n.cm-s-default .cm-operator {}\n.cm-s-default .cm-variable-2 {color: #05a;}\n.cm-s-default .cm-variable-3, .cm-s-default .cm-type {color: #085;}\n.cm-s-default .cm-comment {color: #a50;}\n.cm-s-default .cm-string {color: #a11;}\n.cm-s-default .cm-string-2 {color: #f50;}\n.cm-s-default .cm-meta {color: #555;}\n.cm-s-default .cm-qualifier {color: #555;}\n.cm-s-default .cm-builtin {color: #30a;}\n.cm-s-default .cm-bracket {color: #997;}\n.cm-s-default .cm-tag {color: #170;}\n.cm-s-default .cm-attribute {color: #00c;}\n.cm-s-default .cm-hr {color: #999;}\n.cm-s-default .cm-link {color: #00c;}\n\n.cm-s-default .cm-error {color: #f00;}\n.cm-invalidchar {color: #f00;}\n\n.CodeMirror-composing { border-bottom: 2px solid; }\n\n/* Default styles for common addons */\n\ndiv.CodeMirror span.CodeMirror-matchingbracket {color: #0b0;}\ndiv.CodeMirror span.CodeMirror-nonmatchingbracket {color: #a22;}\n.CodeMirror-matchingtag { background: rgba(255, 150, 0, .3); }\n.CodeMirror-activeline-background {background: #e8f2ff;}\n\n/* STOP */\n\n/* The rest of this file contains styles related to the mechanics of\n   the editor. You probably shouldn't touch them. */\n\n.CodeMirror {\n  position: relative;\n  overflow: hidden;\n  background: white;\n}\n\n.CodeMirror-scroll {\n  overflow: scroll !important; /* Things will break if this is overridden */\n  /* 50px is the magic margin used to hide the element's real scrollbars */\n  /* See overflow: hidden in .CodeMirror */\n  margin-bottom: -50px; margin-right: -50px;\n  padding-bottom: 50px;\n  height: 100%;\n  outline: none; /* Prevent dragging from highlighting the element */\n  position: relative;\n}\n.CodeMirror-sizer {\n  position: relative;\n  border-right: 50px solid transparent;\n}\n\n/* The fake, visible scrollbars. Used to force redraw during scrolling\n   before actual scrolling happens, thus preventing shaking and\n   flickering artifacts. */\n.CodeMirror-vscrollbar, .CodeMirror-hscrollbar, .CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  position: absolute;\n  z-index: 6;\n  display: none;\n  outline: none;\n}\n.CodeMirror-vscrollbar {\n  right: 0; top: 0;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n.CodeMirror-hscrollbar {\n  bottom: 0; left: 0;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n.CodeMirror-scrollbar-filler {\n  right: 0; bottom: 0;\n}\n.CodeMirror-gutter-filler {\n  left: 0; bottom: 0;\n}\n\n.CodeMirror-gutters {\n  position: absolute; left: 0; top: 0;\n  min-height: 100%;\n  z-index: 3;\n}\n.CodeMirror-gutter {\n  white-space: normal;\n  height: 100%;\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: -50px;\n}\n.CodeMirror-gutter-wrapper {\n  position: absolute;\n  z-index: 4;\n  background: none !important;\n  border: none !important;\n}\n.CodeMirror-gutter-background {\n  position: absolute;\n  top: 0; bottom: 0;\n  z-index: 4;\n}\n.CodeMirror-gutter-elt {\n  position: absolute;\n  cursor: default;\n  z-index: 4;\n}\n.CodeMirror-gutter-wrapper ::selection { background-color: transparent }\n.CodeMirror-gutter-wrapper ::-moz-selection { background-color: transparent }\n\n.CodeMirror-lines {\n  cursor: text;\n  min-height: 1px; /* prevents collapsing before first draw */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  /* Reset some styles that the rest of the page might have set */\n  -moz-border-radius: 0; -webkit-border-radius: 0; border-radius: 0;\n  border-width: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  white-space: pre;\n  word-wrap: normal;\n  line-height: inherit;\n  color: inherit;\n  z-index: 2;\n  position: relative;\n  overflow: visible;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-variant-ligatures: contextual;\n  font-variant-ligatures: contextual;\n}\n.CodeMirror-wrap pre.CodeMirror-line,\n.CodeMirror-wrap pre.CodeMirror-line-like {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  word-break: normal;\n}\n\n.CodeMirror-linebackground {\n  position: absolute;\n  left: 0; right: 0; top: 0; bottom: 0;\n  z-index: 0;\n}\n\n.CodeMirror-linewidget {\n  position: relative;\n  z-index: 2;\n  padding: 0.1px; /* Force widget margins to stay inside of the container */\n}\n\n.CodeMirror-widget {}\n\n.CodeMirror-rtl pre { direction: rtl; }\n\n.CodeMirror-code {\n  outline: none;\n}\n\n/* Force content-box sizing for the elements where we expect it */\n.CodeMirror-scroll,\n.CodeMirror-sizer,\n.CodeMirror-gutter,\n.CodeMirror-gutters,\n.CodeMirror-linenumber {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.CodeMirror-measure {\n  position: absolute;\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.CodeMirror-cursor {\n  position: absolute;\n  pointer-events: none;\n}\n.CodeMirror-measure pre { position: static; }\n\ndiv.CodeMirror-cursors {\n  visibility: hidden;\n  position: relative;\n  z-index: 3;\n}\ndiv.CodeMirror-dragcursors {\n  visibility: visible;\n}\n\n.CodeMirror-focused div.CodeMirror-cursors {\n  visibility: visible;\n}\n\n.CodeMirror-selected { background: #d9d9d9; }\n.CodeMirror-focused .CodeMirror-selected { background: #d7d4f0; }\n.CodeMirror-crosshair { cursor: crosshair; }\n.CodeMirror-line::selection, .CodeMirror-line > span::selection, .CodeMirror-line > span > span::selection { background: #d7d4f0; }\n.CodeMirror-line::-moz-selection, .CodeMirror-line > span::-moz-selection, .CodeMirror-line > span > span::-moz-selection { background: #d7d4f0; }\n\n.cm-searching {\n  background-color: #ffa;\n  background-color: rgba(255, 255, 0, .4);\n}\n\n/* Used to force a border model for a node */\n.cm-force-border { padding-right: .1px; }\n\n@media print {\n  /* Hide the cursor when printing */\n  .CodeMirror div.CodeMirror-cursors {\n    visibility: hidden;\n  }\n}\n\n/* See issue #2901 */\n.cm-tab-wrap-hack:after { content: ''; }\n\n/* Help users use markselection to safely style text background */\nspan.CodeMirror-selectedtext { background: none; }\n";
var css_248z$1 = ".CodeMirror-simplescroll-horizontal div, .CodeMirror-simplescroll-vertical div {\n  position: absolute;\n  background: #ccc;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  border: 1px solid #bbb;\n  border-radius: 2px;\n}\n\n.CodeMirror-simplescroll-horizontal, .CodeMirror-simplescroll-vertical {\n  position: absolute;\n  z-index: 6;\n  background: #eee;\n}\n\n.CodeMirror-simplescroll-horizontal {\n  bottom: 0; left: 0;\n  height: 8px;\n}\n.CodeMirror-simplescroll-horizontal div {\n  bottom: 0;\n  height: 100%;\n}\n\n.CodeMirror-simplescroll-vertical {\n  right: 0; top: 0;\n  width: 8px;\n}\n.CodeMirror-simplescroll-vertical div {\n  right: 0;\n  width: 100%;\n}\n\n\n.CodeMirror-overlayscroll .CodeMirror-scrollbar-filler, .CodeMirror-overlayscroll .CodeMirror-gutter-filler {\n  display: none;\n}\n\n.CodeMirror-overlayscroll-horizontal div, .CodeMirror-overlayscroll-vertical div {\n  position: absolute;\n  background: #bcd;\n  border-radius: 3px;\n}\n\n.CodeMirror-overlayscroll-horizontal, .CodeMirror-overlayscroll-vertical {\n  position: absolute;\n  z-index: 6;\n}\n\n.CodeMirror-overlayscroll-horizontal {\n  bottom: 0; left: 0;\n  height: 6px;\n}\n.CodeMirror-overlayscroll-horizontal div {\n  bottom: 0;\n  height: 100%;\n}\n\n.CodeMirror-overlayscroll-vertical {\n  right: 0; top: 0;\n  width: 6px;\n}\n.CodeMirror-overlayscroll-vertical div {\n  right: 0;\n  width: 100%;\n}\n";
var css_248z = "/* Syntax Highlighting */\n.cm-s-flora span.cm-comment {\n  color: var(--comments);\n}\n.cm-s-flora span.cm-atom {\n  color: var(--numbers);\n}\n.cm-s-flora span.cm-number {\n  color: var(--numbers);\n}\n.cm-s-flora span.cm-property,\n.cm-s-flora span.cm-attribute {\n  color: var(--attributes);\n}\n.cm-s-flora span.cm-keyword {\n  color: var(--keywords);\n}\n.cm-s-flora span.cm-builtin {\n  color: var(--type);\n}\n.cm-s-flora span.cm-string {\n  color: var(--strings);\n}\n.cm-s-flora span.cm-variable {\n  color: var(--operators);\n}\n.cm-s-flora span.cm-variable-2 {\n  color: var(--variables-alt);\n}\n.cm-s-flora span.cm-variable-3,\n.cm-s-flora span.cm-type {\n  color: var(--type);\n}\n.cm-s-flora span.cm-def {\n  color: var(--definitions);\n}\n.cm-s-flora span.cm-bracket {\n  color: var(--operators);\n}\n.cm-s-flora span.cm-tag {\n  color: var(--keywords);\n}\n.cm-s-flora span.cm-header {\n  color: var(--numbers);\n}\n.cm-s-flora span.cm-link {\n  color: var(--numbers);\n}\n\n/* Scrollbars */\n.CodeMirror-simplescroll-horizontal div,\n.CodeMirror-simplescroll-vertical div {\n  background: transparent;\n  border: 1px solid transparent;\n}\n\n.CodeMirror-simplescroll-horizontal,\n.CodeMirror-simplescroll-vertical {\n  background: transparent;\n}\n\n.CodeMirror-overlayscroll-horizontal div,\n.CodeMirror-overlayscroll-vertical div {\n  background: transparent;\n}\n";

var loadModules = function loadModules(CodeMirror) {
  if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
    useClike(CodeMirror);
    useCSS(CodeMirror);
    useGo(CodeMirror);
    useHtml(CodeMirror);
    useJavascript(CodeMirror);
    useJSX(CodeMirror);
    useMarkdown(CodeMirror);
    usePHP(CodeMirror);
    usePython(CodeMirror);
    useRuby(CodeMirror);
    /* rust is broke in codemirror-ssr as of 2021-08-30.
    so commenting this out until either the library gets updated
    or we propose a fix. */
    // useRust(CodeMirror)

    useShell(CodeMirror);
    useSimpleScrollbars(CodeMirror);
    useSwift(CodeMirror);
    useXML(CodeMirror);
  }
};

var CodeSnippet = function CodeSnippet(_a) {
  var _b;

  var language = _a.language,
      code = _a.code,
      _c = _a.borderRadiusTop,
      borderRadiusTop = _c === void 0 ? true : _c,
      _d = _a.copyButton,
      copyButton = _d === void 0 ? true : _d,
      _e = _a.copyButtonPosition,
      copyButtonPosition = _e === void 0 ? 'bottom' : _e,
      _f = _a.lineNumbers,
      lineNumbers = _f === void 0 ? true : _f,
      _g = _a.lineWrapping,
      lineWrapping = _g === void 0 ? true : _g,
      _h = _a.height,
      height = _h === void 0 ? 'medium' : _h,
      _j = _a.theme,
      theme = _j === void 0 ? 'default' : _j;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var fromTextArea = useRef(null);
  var cmInstance = useRef(null);
  var textareaNode = useRef(null);

  var _k = useState(false),
      codeIsCopied = _k[0],
      setCodeIsCopied = _k[1];

  var options = _assign(_assign({}, DEFAULT_OPTIONS), {
    mode: getLanguageMode(language),
    lineNumbers: lineNumbers,
    lineWrapping: lineWrapping
  });

  var setOption = function setOption(optionName, newValue) {
    var codeMirror = cmInstance.current;
    var oldValue = codeMirror === null || codeMirror === void 0 ? void 0 : codeMirror.getOption(optionName);

    if (oldValue !== newValue) {
      codeMirror === null || codeMirror === void 0 ? void 0 : codeMirror.setOption(optionName, newValue);
    }
  };

  var handleCopyClick = function handleCopyClick() {
    var _a;

    if ((_a = navigator === null || navigator === void 0 ? void 0 : navigator.clipboard) === null || _a === void 0 ? void 0 : _a.writeText) {
      navigator.clipboard.writeText(code);
      setCodeIsCopied(true);
      window.setTimeout(function () {
        setCodeIsCopied(false);
      }, msStringToInt(selectedTheme.motion.codeSnippetCopyFade)); // token returns ms, which is invalid here
    }
  };

  useEffect(function () {
    /* eslint-disable @typescript-eslint/no-var-requires */
    var CodeMirror = factory();
    fromTextArea.current = CodeMirror.fromTextArea;
    loadModules(CodeMirror);
  }, []);
  useEffect(function () {
    if (fromTextArea.current && textareaNode.current instanceof HTMLTextAreaElement) {
      cmInstance.current = fromTextArea.current(textareaNode.current, options);
      if (!cmInstance.current) return;
    }

    return function () {
      var codeMirror = cmInstance.current;
      codeMirror && codeMirror.toTextArea();
    };
  }, [textareaNode.current]);
  useEffect(function () {
    var codeMirror = cmInstance.current;
    codeMirror && codeMirror.setValue(code);
  }, [code]);
  useEffect(function () {
    if (!cmInstance.current) return;
    Object.entries(options).forEach(function (_a) {
      var optionName = _a[0],
          optionValue = _a[1];
      return setOption(optionName, optionValue);
    });
  }, [options]);
  var codemirrorStyles = css$1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    ", "\n    ", "\n    ", "\n  "], ["\n    ", "\n    ", "\n    ", "\n  "])), css_248z$2, css_248z$1, css_248z);
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      "aria-label": 'code-snippet-container',
      style: {
        display: 'flex',
        position: 'relative'
      },
      className: codemirrorStyles,
      sx: {
        '--operators': selectedTheme.colors.code.operators,
        '--comments': selectedTheme.colors.code.comments,
        '--definitions': selectedTheme.colors.code.definitions,
        '--numbers': selectedTheme.colors.code.numbers,
        '--keywords': selectedTheme.colors.code.keywords,
        '--variables': selectedTheme.colors.code.variables,
        '--type': selectedTheme.colors.code.type,
        '--strings': selectedTheme.colors.code.strings,
        '--attributes': selectedTheme.colors.code.attributes,
        '.cm-s-flora.CodeMirror': {
          width: '100%',
          color: 'var(--operators)',
          height: getHeight(height),
          fontFamily: selectedTheme.fonts.mono,
          fontSize: selectedTheme.fontSizes.inc20,
          lineHeight: selectedTheme.lineHeights.inc30,
          borderRadius: borderRadiusTop ? selectedTheme.radii.inc60 : "0 0 " + selectedTheme.radii.inc60 + " " + selectedTheme.radii.inc60,
          background: selectedTheme.colors.code.bg
        },
        '.cm-s-flora .CodeMirror-lines': {
          padding: lineNumbers ? selectedTheme.space.inc40 + " 0" : selectedTheme.space.inc40
        },
        '.cm-s-flora .CodeMirror-linenumbers': {
          width: '58px'
        },
        '.cm-s-flora .CodeMirror-linenumber': {
          textAlign: 'center',
          color: selectedTheme.colors.black00
        },
        '.cm-s-flora .CodeMirror-scroll, .cm-s-flora .CodeMirror-sizer': {
          background: selectedTheme.colors.code.bg
        },
        '.cm-s-flora .CodeMirror-gutters': {
          background: selectedTheme.colors.code.bg,
          borderRight: selectedTheme.space.inc20 + " solid " + selectedTheme.colors.code.bg
        },
        '.cm-s-flora .CodeMirror-gutter, .cm-s-flora .CodeMirror-gutters, .cm-s-flora .CodeMirror-linenumber': {
          background: selectedTheme.colors.code.bgLines
        }
      }
    }, {
      children: [jsx("textarea", {
        "aria-label": 'code-snippet',
        ref: textareaNode,
        defaultValue: code,
        autoComplete: 'off'
      }, void 0), copyButton && jsx("div", _assign({
        "aria-label": 'code-snippet-copy-button-container',
        sx: (_b = {
          position: 'absolute',
          zIndex: 2,
          right: 0
        }, _b[copyButtonPosition === 'bottom' ? 'bottom' : 'top'] = 0, _b)
      }, {
        children: jsx("img", {
          "aria-label": 'code-snippet-copy-button',
          sx: {
            height: '40px',
            width: '40px',
            margin: selectedTheme.space.inc30,
            cursor: 'pointer'
          },
          src: codeIsCopied ? ICONS$1.Copied : ICONS$1.Copy,
          onClick: handleCopyClick
        }, void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
};

var templateObject_1;

var getBadgeStyles = function getBadgeStyles(size, theme) {
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;

  if (size === 'small') {
    return {
      borderRadius: 'inc20',
      padding: get(selectedTheme, 'spacing.inc10', '4px') + " " + get(selectedTheme, 'spacing.inc20', '8px'),
      fontSize: 'inc00'
    };
  }

  return {
    borderRadius: 'inc30',
    padding: get(selectedTheme, 'spacing.inc20', '8px') + " " + get(selectedTheme, 'spacing.inc30', '16px'),
    fontSize: 'inc10'
  };
};

var getBadgeColors = function getBadgeColors(inverse) {
  if (inverse) {
    return {
      backgroundColor: 'pill.badge.inverse.bg',
      color: 'pill.badge.inverse.text'
    };
  }

  return {
    backgroundColor: 'pill.badge.default.bg',
    color: 'pill.badge.default.text'
  };
};

var getIdentifierStyles = function getIdentifierStyles(size, theme) {
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;

  if (size === 'small') {
    return {
      padding: get(selectedTheme, 'spacing.inc10', '4px') + " " + get(selectedTheme, 'spacing.inc30', '16px'),
      letterSpacing: 2.5
    };
  }

  return {
    padding: get(selectedTheme, 'spacing.inc20', '8px') + " " + get(selectedTheme, 'spacing.inc40', '24px'),
    letterSpacing: 3
  };
};

var getIdentifierColorStyles = function getIdentifierColorStyles(color, inverse) {
  if (inverse) {
    return {
      color: 'pill.identifier.inverse.inverseText',
      background: 'transparent',
      borderWidth: 'inc10',
      borderStyle: 'solid',
      borderColor: 'pill.identifier.inverse.borderInformational'
    };
  }

  if (color === 'primary') {
    return {
      color: 'pill.identifier.primary.textInformational',
      backgroundColor: 'pill.identifier.primary.bgInformational'
    };
  }

  return {
    color: 'pill.identifier.secondary.textInformational',
    backgroundColor: 'pill.identifier.secondary.bgInformational'
  };
};

var Badge = function Badge(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 'large' : _b,
      _c = _a.className,
      className = _c === void 0 ? '' : _c,
      _d = _a.inverse,
      inverse = _d === void 0 ? false : _d,
      _e = _a.theme,
      theme = _e === void 0 ? 'default' : _e,
      text = _a.text;
  return jsx("span", _assign({
    className: className,
    sx: _assign(_assign({
      display: 'inline-block',
      fontWeight: 600,
      textTransform: 'uppercase',
      fontFamily: 'body',
      lineHeight: 'inc00'
    }, getBadgeColors(inverse)), getBadgeStyles(size, theme))
  }, {
    children: text
  }), void 0);
};

var Identifier = function Identifier(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      _d = _a.size,
      size = _d === void 0 ? 'large' : _d,
      _e = _a.color,
      color = _e === void 0 ? 'primary' : _e,
      _f = _a.theme,
      theme = _f === void 0 ? 'default' : _f,
      text = _a.text;
  return jsx("span", _assign({
    className: className,
    sx: _assign(_assign({
      fontWeight: 600,
      textTransform: 'uppercase',
      fontFamily: 'mono',
      lineHeight: 'inc00',
      fontSize: 'inc00',
      display: 'inline-block',
      borderRadius: 'circle'
    }, getIdentifierStyles(size, theme)), getIdentifierColorStyles(color, inverse))
  }, {
    children: text
  }), void 0);
};

var Pill = function Pill(props) {
  return jsxs(ThemeProvider, _assign({
    theme: props.theme === 'legacy' ? legacyTheme : defaultTheme
  }, {
    children: [props.variant === 'badge' && jsx(Badge, _assign({}, props), void 0), props.variant === 'identifier' && jsx(Identifier, _assign({}, props), void 0)]
  }), void 0);
};

var responsiveSpacingMap = {
  xxlarge: 'sectionXXLarge',
  xlarge: 'sectionXLarge',
  large: 'sectionLarge',
  medium: 'sectionMedium',
  small: 'sectionSmall',
  xsmall: 'sectionXSmall',
  xxsmall: 'sectionXXSmall',
  zero: 'sectionZero'
};

var VerticalSectionSpacing = function VerticalSectionSpacing(_a) {
  var children = _a.children,
      top = _a.top,
      bottom = _a.bottom,
      customStyles = _a.customStyles;
  var verticalGap = defaultTheme.responsive.verticalGap;
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsx("div", _assign({
      sx: _assign({
        paddingTop: verticalGap[responsiveSpacingMap[top]],
        paddingBottom: verticalGap[responsiveSpacingMap[bottom]]
      }, customStyles)
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var Mark = function Mark(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      _d = _a.theme,
      theme = _d === void 0 ? 'default' : _d,
      children = _a.children;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("mark", _assign({
      className: className,
      sx: {
        backgroundColor: 'transparent',
        color: inverse ? 'text.inverseMark' : 'text.mark'
      }
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var Eyebrow = function Eyebrow(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      _d = _a.theme,
      theme = _d === void 0 ? 'default' : _d,
      _e = _a.variant,
      variant = _e === void 0 ? 'primary' : _e,
      _f = _a.customElement,
      customElement = _f === void 0 ? 'h1' : _f,
      customStyles = _a.customStyles,
      children = _a.children;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var secondary = variant === 'secondary';
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx(TypographyScale, _assign({
      className: className,
      variant: 'mono3',
      customElement: customElement,
      inverse: inverse,
      customStyles: _assign({
        textTransform: 'uppercase',
        color: inverse ? "text.eyebrowInverse" + (secondary ? 'Secondary' : '') : 'text.eyebrowDefault',
        fontWeight: 600
      }, customStyles)
    }, {
      children: children
    }), void 0)
  }), void 0);
};

var ESingleImageVariant;

(function (ESingleImageVariant) {
  ESingleImageVariant["NO_RATIO"] = "no ratio";
  ESingleImageVariant["SQUARE"] = "square";
  ESingleImageVariant["DIAGRAM"] = "diagram";
  ESingleImageVariant["LETTERBOX"] = "letterbox";
  ESingleImageVariant["VIDEO"] = "video";
})(ESingleImageVariant || (ESingleImageVariant = {}));

var WEB_ASSETS_SUBDOMAIN = 'webassets.mongodb.com';
var IMGIX_SUBDOMAIN = 'webimages.mongodb.com';

var normalizeImageSource = function normalizeImageSource(imageSrc) {
  if (!imageSrc) {
    return undefined;
  }

  if (imageSrc.match(IMGIX_SUBDOMAIN)) {
    return imageSrc;
  } else if (imageSrc.match(WEB_ASSETS_SUBDOMAIN)) {
    // Decode and re-encode, src may or may not be encoded already
    return encodeURI(decodeURI(imageSrc.replace(WEB_ASSETS_SUBDOMAIN, IMGIX_SUBDOMAIN)));
  }

  return undefined;
};

var isGif = function isGif(url) {
  return /\.gif/.test(url);
};

var ls_attrchange = {
  exports: {}
};

(function (module) {
  (function (window, factory) {
    if (!window) {
      return;
    }

    var globalInstall = function globalInstall() {
      factory(window.lazySizes);
      window.removeEventListener('lazyunveilread', globalInstall, true);
    };

    factory = factory.bind(null, window, window.document);

    if (module.exports) {
      factory(require$$0);
    } else if (window.lazySizes) {
      globalInstall();
    } else {
      window.addEventListener('lazyunveilread', globalInstall, true);
    }
  })(typeof window != 'undefined' ? window : 0, function (window, document, lazySizes) {
    var addObserver = function addObserver() {
      var connect, disconnect, observer, connected;
      var lsCfg = lazySizes.cfg;
      var attributes = {
        'data-bgset': 1,
        'data-include': 1,
        'data-poster': 1,
        'data-bg': 1,
        'data-script': 1
      };
      var regClassTest = '(\\s|^)(' + lsCfg.loadedClass;
      var docElem = document.documentElement;

      var setClass = function setClass(target) {
        lazySizes.rAF(function () {
          lazySizes.rC(target, lsCfg.loadedClass);

          if (lsCfg.unloadedClass) {
            lazySizes.rC(target, lsCfg.unloadedClass);
          }

          lazySizes.aC(target, lsCfg.lazyClass);

          if (target.style.display == 'none' || target.parentNode && target.parentNode.style.display == 'none') {
            setTimeout(function () {
              lazySizes.loader.unveil(target);
            }, 0);
          }
        });
      };

      var onMutation = function onMutation(mutations) {
        var i, len, mutation, target;

        for (i = 0, len = mutations.length; i < len; i++) {
          mutation = mutations[i];
          target = mutation.target;

          if (!target.getAttribute(mutation.attributeName)) {
            continue;
          }

          if (target.localName == 'source' && target.parentNode) {
            target = target.parentNode.querySelector('img');
          }

          if (target && regClassTest.test(target.className)) {
            setClass(target);
          }
        }
      };

      if (lsCfg.unloadedClass) {
        regClassTest += '|' + lsCfg.unloadedClass;
      }

      regClassTest += '|' + lsCfg.loadingClass + ')(\\s|$)';
      regClassTest = new RegExp(regClassTest);
      attributes[lsCfg.srcAttr] = 1;
      attributes[lsCfg.srcsetAttr] = 1;

      if (window.MutationObserver) {
        observer = new MutationObserver(onMutation);

        connect = function connect() {
          if (!connected) {
            connected = true;
            observer.observe(docElem, {
              subtree: true,
              attributes: true,
              attributeFilter: Object.keys(attributes)
            });
          }
        };

        disconnect = function disconnect() {
          if (connected) {
            connected = false;
            observer.disconnect();
          }
        };
      } else {
        docElem.addEventListener('DOMAttrModified', function () {
          var runs;
          var modifications = [];

          var callMutations = function callMutations() {
            onMutation(modifications);
            modifications = [];
            runs = false;
          };

          return function (e) {
            if (connected && attributes[e.attrName] && e.newValue) {
              modifications.push({
                target: e.target,
                attributeName: e.attrName
              });

              if (!runs) {
                setTimeout(callMutations);
                runs = true;
              }
            }
          };
        }(), true);

        connect = function connect() {
          connected = true;
        };

        disconnect = function disconnect() {
          connected = false;
        };
      }

      addEventListener('lazybeforeunveil', disconnect, true);
      addEventListener('lazybeforeunveil', connect);
      addEventListener('lazybeforesizes', disconnect, true);
      addEventListener('lazybeforesizes', connect);
      connect();
      removeEventListener('lazybeforeunveil', addObserver);
    };

    addEventListener('lazybeforeunveil', addObserver);
  });
})(ls_attrchange);

var client = new ImgixClient({
  domain: 'webimages.mongodb.com'
});

var getRatio = function getRatio(variant) {
  switch (variant) {
    case ESingleImageVariant.NO_RATIO:
      return undefined;

    case ESingleImageVariant.DIAGRAM:
      return 5 / 4;

    case ESingleImageVariant.SQUARE:
      return 1;

    case ESingleImageVariant.LETTERBOX:
      return 3 / 2;

    case ESingleImageVariant.VIDEO:
      return 16 / 9;

    default:
      return undefined;
  }
};

var SingleImage = function SingleImage(_a) {
  var variant = _a.variant,
      _b = _a.theme,
      theme = _b === void 0 ? 'default' : _b,
      src = _a.src,
      lazyLoad = _a.lazyLoad,
      altText = _a.altText,
      customStyles = _a.customStyles,
      props = __rest(_a, ["variant", "theme", "src", "lazyLoad", "altText", "customStyles"]);

  var ratio = getRatio(variant);
  useEffect(function () {
    window.lazySizesConfig = {
      loadMode: 1
    };
  }, []);
  var normalizedSrc = normalizeImageSource(src);

  var urlObject = function () {
    try {
      return new URL(normalizedSrc || src);
    } catch (e) {
      return false;
    }
  }();

  if (!urlObject) return null;
  var srcSet = props.bleed ? undefined : normalizedSrc && client.buildSrcSet(decodeURI(urlObject.pathname), isGif(src) ? {} : {
    auto: 'format,compress'
  });
  var imageElement = lazyLoad ? jsx("img", {
    alt: altText,
    className: 'lazyload',
    sx: {
      width: '100%'
    },
    "data-src": urlObject.href,
    "data-srcset": srcSet,
    "data-sizes": 'auto'
  }, void 0) : jsx("img", {
    alt: altText,
    src: urlObject.href,
    srcSet: srcSet,
    sx: {
      width: '100%'
    }
  }, void 0);
  return jsx(ThemeProvider, _assign({
    theme: theme === 'legacy' ? legacyTheme : defaultTheme
  }, {
    children: ratio && !props.bleed ? jsx(AspectRatio, _assign({
      ratio: ratio,
      sx: _assign({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }, customStyles)
    }, {
      children: imageElement
    }), void 0) : jsx("div", _assign({
      sx: _assign(_assign({}, !props.bleed && {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }), customStyles)
    }, {
      children: imageElement
    }), void 0)
  }), void 0);
};

var getCTASpacing = function getCTASpacing(hasLinkCTA) {
  if (hasLinkCTA) {
    return {
      marginRight: ['inc00', null, 'inc50'],
      marginBottom: ['inc40', null, 'inc00']
    };
  }
};

var getMobileButtonStyle = function getMobileButtonStyle() {
  return {
    width: ['100%', null, 'auto'],
    textAlign: ['center', null, 'inherit']
  };
};

var CTALockup = function CTALockup(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.buttonHref,
      buttonHref = _c === void 0 ? '' : _c,
      _d = _a.buttonText,
      buttonText = _d === void 0 ? '' : _d,
      _e = _a.onButtonClick,
      onButtonClick = _e === void 0 ? function () {} : _e,
      buttonTarget = _a.buttonTarget,
      _f = _a.buttonSize,
      buttonSize = _f === void 0 ? 'small' : _f,
      _g = _a.linkHref,
      linkHref = _g === void 0 ? '' : _g,
      _h = _a.linkText,
      linkText = _h === void 0 ? '' : _h,
      _j = _a.linkIconDisableExpand,
      linkIconDisableExpand = _j === void 0 ? false : _j,
      _k = _a.linkIcon,
      linkIcon = _k === void 0 ? 'chevron' : _k,
      _l = _a.onLinkClick,
      onLinkClick = _l === void 0 ? function () {} : _l,
      linkTarget = _a.linkTarget,
      _m = _a.inverse,
      inverse = _m === void 0 ? false : _m,
      _o = _a.theme,
      theme = _o === void 0 ? 'default' : _o,
      centerLocked = _a.centerLocked;
  var hasLinkCTA = !!linkText;
  var hasButtonText = !!buttonText;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;

  var getLockupContent = function getLockupContent(centered) {
    var buttonElement = jsx(Button, _assign({
      variant: 'primary',
      href: buttonHref,
      onClick: onButtonClick,
      inverse: inverse,
      target: buttonTarget,
      size: buttonSize,
      customWrapperStyles: _assign(_assign({}, getMobileButtonStyle()), getCTASpacing(hasLinkCTA))
    }, {
      children: buttonText
    }), void 0);
    var ctaElement = jsx(Link, _assign({
      variant: ELinkVariant.SMALL,
      linkIcon: linkIcon,
      href: linkHref,
      linkIconDisableExpand: linkIconDisableExpand,
      onClick: onLinkClick,
      inverse: inverse,
      target: linkTarget
    }, {
      children: linkText
    }), void 0);

    if (centered) {
      return jsxs(Fragment, {
        children: [hasButtonText && jsx("div", _assign({
          sx: {
            width: ['100%', null, hasLinkCTA ? '50%' : '100%'],
            display: [null, null, 'flex'],
            justifyContent: [null, null, hasLinkCTA ? 'flex-end' : 'center']
          }
        }, {
          children: buttonElement
        }), void 0), hasLinkCTA && jsx("div", _assign({
          sx: {
            width: ['100%', null, hasButtonText ? '50%' : '100%'],
            display: ['flex', null, null],
            justifyContent: ['center', null, hasButtonText ? 'flex-start' : 'center']
          }
        }, {
          children: ctaElement
        }), void 0)]
      }, void 0);
    }

    return jsxs(Fragment, {
      children: [!!buttonText && buttonElement, !!hasLinkCTA && ctaElement]
    }, void 0);
  };

  var ctaLockupContent = getLockupContent(centerLocked);
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("div", _assign({
      className: className,
      sx: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: ['column', null, 'row']
      }
    }, {
      children: ctaLockupContent
    }), void 0)
  }), void 0);
};

var SectionIntro = function SectionIntro(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      title = _a.title,
      _c = _a.titleVariant,
      titleVariant = _c === void 0 ? 'heading2' : _c,
      _d = _a.titleColor,
      titleColor = _d === void 0 ? 'default' : _d,
      _e = _a.text,
      text = _e === void 0 ? '' : _e,
      _f = _a.inverse,
      inverse = _f === void 0 ? false : _f,
      buttonText = _a.buttonText,
      linkText = _a.linkText,
      _g = _a.linkIconDisableExpand,
      linkIconDisableExpand = _g === void 0 ? false : _g,
      _h = _a.buttonSize,
      buttonSize = _h === void 0 ? 'large' : _h,
      _j = _a.theme,
      theme = _j === void 0 ? 'default' : _j,
      customStyles = _a.customStyles,
      props = __rest(_a, ["className", "title", "titleVariant", "titleColor", "text", "inverse", "buttonText", "linkText", "linkIconDisableExpand", "buttonSize", "theme", "customStyles"]);

  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      className: className,
      sx: _assign({
        display: 'grid',
        gridTemplateColumns: ['repeat(6, 1fr)', null, 'repeat(8, 1fr)', 'repeat(12, 1fr)'],
        columnGap: 'inc40',
        textAlign: 'center'
      }, customStyles)
    }, {
      children: [jsx("div", _assign({
        sx: {
          gridColumn: ['1 / span 6', null, '2 / span 6', '3 / span 8']
        }
      }, {
        children: jsx(TypographyScale, _assign({
          variant: titleVariant,
          color: titleColor,
          inverse: inverse
        }, {
          children: title
        }), void 0)
      }), void 0), !!text && jsx("div", _assign({
        sx: {
          gridColumn: ['1 / span 6', null, '2 / span 6', '4 / span 6'],
          marginTop: ['inc30', null, 'inc40', 'inc60']
        }
      }, {
        children: jsx(TypographyScale, _assign({
          color: 'secondary',
          inverse: inverse,
          variant: 'body1'
        }, {
          children: text
        }), void 0)
      }), void 0), (buttonText || linkText) && jsx("div", _assign({
        sx: {
          gridColumn: ['1 / span 6', null, '2 / span 6', '3 / span 8'],
          marginTop: ['inc50', null, 'inc60', 'inc70']
        }
      }, {
        children: jsx(CTALockup, _assign({
          centerLocked: true,
          linkIcon: 'arrow',
          buttonText: buttonText,
          linkText: linkText,
          linkIconDisableExpand: linkIconDisableExpand,
          inverse: inverse,
          buttonSize: buttonSize
        }, props, {
          sx: {
            justifyContent: 'center'
          }
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
};

var ICONS = {
  INVERSE: {
    PLUS: 'https://webimages.mongodb.com/_com_assets/cms/ktei3afgrst841sdx-StatePlus.svg?auto=format%252Ccompress',
    MINUS: 'https://webimages.mongodb.com/_com_assets/cms/ktei3jh2ytadx4nj9-StateMinus.svg?auto=format%252Ccompress'
  },
  DEFAULT: {
    PLUS: 'https://webimages.mongodb.com/_com_assets/cms/kx0wvn02iwn4zu68z-plus.svg?auto=format%252Ccompress',
    MINUS: 'https://webimages.mongodb.com/_com_assets/cms/kx0wvr3ntqon8c7tp-minus.svg?auto=format%252Ccompress'
  }
};
var EColorType;

(function (EColorType) {
  EColorType[EColorType["background"] = 0] = "background";
  EColorType[EColorType["text"] = 1] = "text";
})(EColorType || (EColorType = {}));
/**
 * Returns a color for background or text, following few rules:
 * - Returns colorActive when a tab is selected, otherwise returns colorInactive
 * - When there isn't a color value defined, we use the token
 *
 * @param {EColorType} colorType color type
 * @param {boolean} isActive tab selection state
 * @param {boolean} inverse inverse color token
 * @param {string} colorActive (optional) color for a selected tab
 * @param {string} colorInactive (optional) color for an unselected tab
 * @return {string} a color for background or text
 */


var getColor$1 = function getColor$1(colorType, isActive, inverse, colorActive, colorInactive) {
  if (isActive && !!colorActive) {
    return colorActive;
  }

  if (!isActive && !!colorInactive) {
    return colorInactive;
  }

  return getTokenColor(colorType, isActive, inverse);
};

var getTokenColor = function getTokenColor(colorType, active, inverse) {
  var themeProp = inverse ? 'inverse' : 'default';

  if (colorType === EColorType.background) {
    return defaultTheme.colors.tabs.tertiary[themeProp][active ? 'bgActive' : 'bgInverse'];
  }

  return defaultTheme.colors.tabs.tertiary[themeProp][active ? 'textActive' : 'textInactive'];
};

var Tab = function Tab(_a) {
  var value = _a.value,
      bgInactive = _a.bgInactive,
      bgActive = _a.bgActive,
      colorInactive = _a.colorInactive,
      colorActive = _a.colorActive,
      borderRadius = _a.borderRadius,
      padding = _a.padding,
      active = _a.active,
      _b = _a.inverse,
      inverse = _b === void 0 ? false : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _onClick = _a.onClick;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx("div", _assign({
    sx: {
      WebkitUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none',
      fontFamily: selectedTheme.fonts.body,
      height: '40px',
      backgroundColor: getColor$1(EColorType.background, active, inverse, bgActive, bgInactive),
      padding: padding || selectedTheme.space.inc20 + " " + selectedTheme.space.inc40,
      color: getColor$1(EColorType.text, active, inverse, colorActive, colorInactive),
      lineHeight: selectedTheme.lineHeights.inc20,
      borderRadius: borderRadius || selectedTheme.radii.circle,
      cursor: 'pointer',
      boxSizing: 'border-box',
      '&:hover': {
        boxShadow: "0 0 0 1px " + selectedTheme.colors.blue60,
        transition: '.1s' // Need a token for this

      }
    },
    onClick: function onClick(e) {
      e.stopPropagation();

      _onClick(value);
    }
  }, {
    children: value
  }), void 0);
};

var Tabs = function Tabs(_a) {
  var items = _a.items,
      activeValue = _a.activeValue,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      gap = _a.gap,
      onSelect = _a.onSelect,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      fontSize = _a.fontSize,
      bgActive = _a.bgActive,
      bgInactive = _a.bgInactive,
      borderRadius = _a.borderRadius,
      padding = _a.padding,
      colorActive = _a.colorActive,
      colorInactive = _a.colorInactive,
      _d = _a.theme,
      theme = _d === void 0 ? 'default' : _d;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;

  var _e = useState(items[0]),
      selectedValue = _e[0],
      setSelectedValue = _e[1];

  useEffect(function () {
    activeValue && setSelectedValue(activeValue);
  }, [activeValue]);

  var isActive = function isActive(value) {
    return value === selectedValue;
  };

  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("div", _assign({
      "aria-label": 'tabs',
      className: className,
      sx: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: gap || selectedTheme.space.base,
        fontFamily: 'body',
        fontSize: fontSize || selectedTheme.fontSizes.inc20
      }
    }, {
      children: items.map(function (value, index) {
        var props = {
          value: value,
          active: isActive(value),
          onClick: function onClick(value) {
            setSelectedValue(value);
            onSelect && onSelect(value);
          },
          inverse: inverse,
          bgActive: bgActive,
          bgInactive: bgInactive,
          borderRadius: borderRadius,
          padding: padding,
          colorActive: colorActive,
          colorInactive: colorInactive
        };
        return jsx(Tab, _assign({}, props), index);
      })
    }), void 0)
  }), void 0);
};

var CodePanel = function CodePanel(_a) {
  var _b = _a.snippets,
      snippets = _b === void 0 ? [{
    code: '',
    language: 'JavaScript',
    alias: ''
  }] : _b,
      _c = _a.copyButton,
      copyButton = _c === void 0 ? true : _c,
      _d = _a.copyButtonPosition,
      copyButtonPosition = _d === void 0 ? 'bottom' : _d,
      _e = _a.lineNumbers,
      lineNumbers = _e === void 0 ? true : _e,
      _f = _a.lineWrapping,
      lineWrapping = _f === void 0 ? true : _f,
      _g = _a.height,
      height = _g === void 0 ? 'medium' : _g,
      _h = _a.theme,
      theme = _h === void 0 ? 'default' : _h;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var _j = snippets[0],
      code = _j.code,
      language = _j.language,
      alias = _j.alias;

  var _k = useState(language),
      currentLanguage = _k[0],
      setCurrentLanguage = _k[1];

  var _l = useState(code),
      currentCode = _l[0],
      setCurrentCode = _l[1];

  var _m = useState(alias),
      currentAlias = _m[0],
      setCurrentAlias = _m[1];

  useEffect(function () {
    setCurrentAlias(alias);
    setCurrentLanguage(language);
    setCurrentCode(code);
  }, [snippets]);
  var TAB_VALUES = snippets.map(function (_a) {
    var _b = _a.alias,
        alias = _b === void 0 ? '' : _b,
        _c = _a.language,
        language = _c === void 0 ? '' : _c;
    return alias || language;
  });
  var LANGUAGES = snippets.map(function (obj) {
    return obj.language;
  });

  var handleTabSelection = function handleTabSelection(selectedValue) {
    var idx = LANGUAGES.indexOf(selectedValue);

    if (idx >= 0) {
      // selectedValue is CodeSnippet-supported language
      setCurrentLanguage(selectedValue);
      setCurrentCode(snippets[idx].code);
      setCurrentAlias(snippets[idx].alias);
    } else {
      // selectedValue is an alias
      var snippet = snippets.find(function (_a) {
        var _b = _a.alias,
            alias = _b === void 0 ? '' : _b;
        return selectedValue === alias;
      });
      if (!snippet) return;
      setCurrentLanguage(snippet.language);
      setCurrentCode(snippet.code);
      setCurrentAlias(selectedValue);
    }
  };

  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      "aria-label": 'code-panel-wrapper',
      sx: {
        display: 'flex',
        flexDirection: 'column'
      }
    }, {
      children: [jsx("div", _assign({
        "aria-label": 'code-panel-tab-wrapper',
        sx: {
          background: selectedTheme.colors.black90,
          padding: selectedTheme.space.inc30 + " " + selectedTheme.space.inc40,
          borderTopLeftRadius: selectedTheme.radii.inc60,
          borderTopRightRadius: selectedTheme.radii.inc60,
          borderBottom: "1px solid " + selectedTheme.colors.black70
        }
      }, {
        children: jsx(Tabs, {
          bgActive: selectedTheme.colors.tabs.tertiary.bgActive,
          bgInactive: selectedTheme.colors.black70,
          colorActive: selectedTheme.colors.black00,
          colorInactive: selectedTheme.colors.black00,
          items: TAB_VALUES,
          activeValue: currentAlias || currentLanguage,
          onSelect: handleTabSelection
        }, void 0)
      }), void 0), jsx(CodeSnippet, {
        height: height,
        borderRadiusTop: false,
        language: currentLanguage,
        code: currentCode,
        copyButton: copyButton,
        copyButtonPosition: copyButtonPosition,
        lineNumbers: lineNumbers,
        lineWrapping: lineWrapping
      }, void 0)]
    }), void 0)
  }), void 0);
};

var AccordionIcon = function AccordionIcon(_a) {
  var _b = _a.src,
      src = _b === void 0 ? '' : _b,
      _c = _a.height,
      height = _c === void 0 ? '' : _c,
      _d = _a.width,
      width = _d === void 0 ? '' : _d;
  return jsx("img", {
    src: src,
    sx: {
      height: height,
      width: width
    }
  }, void 0);
};

var Accordion = function Accordion(_a) {
  var _b, _c;

  var tabs = _a.tabs,
      _d = _a.openFirstTab,
      openFirstTab = _d === void 0 ? true : _d,
      _e = _a.clickHandler,
      clickHandler = _e === void 0 ? function () {} : _e,
      _f = _a.embedCodePanels,
      embedCodePanels = _f === void 0 ? false : _f,
      _g = _a.theme,
      theme = _g === void 0 ? 'default' : _g,
      _h = _a.inverse,
      inverse = _h === void 0 ? true : _h,
      children = _a.children,
      customStyles = _a.customStyles;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;

  var _j = useState(openFirstTab ? 0 : -1),
      currentTabIndex = _j[0],
      setCurrentTabIndex = _j[1];

  var contentRef = useRef(null);

  var _k = useState(openFirstTab ? ((_b = contentRef.current) === null || _b === void 0 ? void 0 : _b.scrollHeight) + "px" : '0px'),
      contentHeight = _k[0],
      setContentHeight = _k[1];

  var handleTabSelection = function handleTabSelection(event, index) {
    if (index === currentTabIndex) {
      setCurrentTabIndex(-1);
    } else {
      setCurrentTabIndex(index);
    }

    clickHandler(event, index);
  };

  useEffect(function () {
    var _a;

    setContentHeight(((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollHeight) + "px");
  }, [(_c = contentRef.current) === null || _c === void 0 ? void 0 : _c.scrollHeight, children]);
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: tabs.map(function (tab, index) {
      var _a;

      var _b = tab.linkCta,
          linkCta = _b === void 0 ? {
        href: '',
        text: '',
        disableExpand: false
      } : _b;
      var activeTab = index === currentTabIndex;
      return jsxs("div", _assign({
        "aria-label": 'accordion-wrapper',
        onClick: function onClick(e) {
          e.stopPropagation();
          handleTabSelection(e, index);
        },
        sx: _assign({
          maxWidth: '100%',
          padding: selectedTheme.space.inc50 + " 0",
          background: 'transparent',
          borderBottom: selectedTheme.borderWidths.inc10 + " solid " + selectedTheme.colors.black70,
          cursor: 'pointer'
        }, customStyles)
      }, {
        children: [jsxs("div", _assign({
          "aria-label": 'accordion-tab-head',
          sx: {
            display: 'flex',
            WebkitUserSelect: 'none',
            msUserSelect: 'none',
            userSelect: 'none'
          }
        }, {
          children: [jsx(TypographyScale, _assign({
            inverse: inverse,
            variant: 'heading6',
            sx: {
              flex: '1',
              fontWeight: 500
            }
          }, {
            children: tab.header
          }), void 0), activeTab ? jsx(AccordionIcon, {
            src: inverse ? ICONS.INVERSE.MINUS : ICONS.DEFAULT.MINUS,
            height: selectedTheme.sizes.inc20,
            width: selectedTheme.sizes.inc20
          }, void 0) : jsx(AccordionIcon, {
            src: inverse ? ICONS.INVERSE.PLUS : ICONS.DEFAULT.PLUS,
            height: selectedTheme.sizes.inc20,
            width: selectedTheme.sizes.inc20
          }, void 0)]
        }), void 0), jsxs("div", _assign({
          ref: contentRef,
          "aria-label": activeTab ? 'active-tab-body' : 'accordion-tab-body',
          sx: {
            marginTop: selectedTheme.space.inc20,
            paddingRight: selectedTheme.space.inc40,
            height: activeTab ? '100%' : '0px',
            minHeight: activeTab ? contentHeight : '0px',
            transition: "min-height " + selectedTheme.motion.accordion + " ease",
            overflow: 'hidden'
          }
        }, {
          children: [jsx("div", _assign({
            sx: {
              marginTop: selectedTheme.space.inc30,
              marginBottom: selectedTheme.space.inc50,
              marginRight: selectedTheme.space.inc20
            }
          }, {
            children: jsx(TypographyScale, _assign({
              color: 'secondary',
              inverse: inverse,
              variant: 'body3'
            }, {
              children: tab.description
            }), void 0)
          }), void 0), linkCta.href && linkCta.text && jsx(Link, _assign({
            inverse: inverse,
            textContentMaxWidth: 'calc(100% - 85px)',
            linkIcon: 'chevron',
            theme: theme,
            href: linkCta.href,
            linkIconDisableExpand: linkCta.disableExpand === undefined ? false : linkCta.disableExpand
          }, {
            children: linkCta.text
          }), void 0), embedCodePanels && ((_a = tabs[currentTabIndex]) === null || _a === void 0 ? void 0 : _a.codeBlock) && jsx("div", _assign({
            sx: {
              marginTop: selectedTheme.space.inc30
            }
          }, {
            children: jsx(CodePanel, _assign({}, tabs[currentTabIndex].codeBlock, {
              copyButton: false,
              lineNumbers: false,
              lineWrapping: true
            }), void 0)
          }), void 0), children && React.Children.toArray(children)[currentTabIndex]]
        }), void 0)]
      }), index);
    })
  }), void 0);
};

var hasItems = function hasItems(array) {
  return array !== undefined && array !== null && array.length !== 0;
};

function debounce(fn, ms) {
  var timer;

  var debouncedFunc = function debouncedFunc(args) {
    return new Promise(function (resolve) {
      if (timer) {
        clearTimeout(timer);
      }

      timer = setTimeout(function () {
        resolve(fn(args));
      }, ms);
    });
  };

  var teardown = function teardown() {
    return clearTimeout(timer);
  };

  return [debouncedFunc, teardown];
}

var LeadPageInfoSideBar = function LeadPageInfoSideBar(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.article,
      article = _c === void 0 ? {
    url: ''
  } : _c,
      date = _a.date,
      duration = _a.duration,
      speakersTitle = _a.speakersTitle,
      _d = _a.speakers,
      speakers = _d === void 0 ? [] : _d,
      languagesTitle = _a.languagesTitle,
      _e = _a.languages,
      languages = _e === void 0 ? [] : _e,
      tagsTitle = _a.tagsTitle,
      _f = _a.tags,
      tags = _f === void 0 ? [] : _f,
      shareButtonsTitle = _a.shareButtonsTitle,
      _g = _a.theme,
      theme = _g === void 0 ? 'default' : _g,
      customStyles = _a.customStyles;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("aside", _assign({
      className: className,
      sx: _assign({
        display: 'flex',
        flexDirection: 'column'
      }, customStyles)
    }, {
      children: [jsx(Header, {
        date: date,
        duration: duration
      }, void 0), hasItems(speakers) && jsx(SpeakersSection, {
        speakersTitle: speakersTitle || 'speakers',
        speakers: speakers
      }, void 0), hasItems(languages) && jsx(LanguagesSection, {
        languagesTitle: languagesTitle || 'languages',
        languages: languages
      }, void 0), hasItems(tags) && jsx(TagsSection, {
        tagsTitle: tagsTitle || 'view more',
        tags: tags
      }, void 0), jsx(Eyebrow, _assign({
        customElement: 'span',
        customStyles: {
          marginTop: ['inc50', null, null, 'inc60'],
          display: 'block'
        }
      }, {
        children: shareButtonsTitle || 'share this'
      }), void 0), jsx(ShareButtonsGroup, {
        theme: selectedTheme,
        article: article
      }, void 0)]
    }), void 0)
  }), void 0);
};

var getDateAndDuration = function getDateAndDuration(date, duration) {
  if (date && duration) {
    return date + " \u2022 " + duration;
  }

  if (date) return date;
  if (duration) return duration;
  return '';
};

var Header = function Header(_a) {
  var _b = _a.date,
      date = _b === void 0 ? '' : _b,
      _c = _a.duration,
      duration = _c === void 0 ? '' : _c;
  return jsxs(Fragment, {
    children: [jsx(TypographyScale, _assign({
      variant: 'body3'
    }, {
      children: getDateAndDuration(date, duration)
    }), void 0), jsx(HorizontalRule, {
      customStyles: {
        marginTop: ['inc50', null, null, 'inc60'],
        marginBottom: 0
      }
    }, void 0)]
  }, void 0);
};

var LanguagesSection = function LanguagesSection(_a) {
  var languagesTitle = _a.languagesTitle,
      _b = _a.languages,
      languages = _b === void 0 ? [] : _b;
  return jsxs(Fragment, {
    children: [languagesTitle && jsx(Eyebrow, _assign({
      customElement: 'span',
      customStyles: {
        marginTop: ['inc50', null, null, 'inc60'],
        display: 'block'
      }
    }, {
      children: languagesTitle
    }), void 0), jsx("div", _assign({
      "aria-label": 'languages-container',
      sx: {
        display: 'flex',
        gap: 'inc10',
        flexWrap: 'wrap',
        marginTop: 'inc40'
      }
    }, {
      children: languages.map(function (language, index) {
        var lastItem = index === languages.length - 1;
        return jsx(TypographyScale, _assign({
          variant: 'body3',
          customStyles: {
            color: 'green80'
          }
        }, {
          children: "" + language + (lastItem ? '' : ',')
        }), language);
      })
    }), void 0)]
  }, void 0);
};

var _a;

var ESocialShareIcons;

(function (ESocialShareIcons) {
  ESocialShareIcons["TWITTER_DEFAULT"] = "Twitter Default";
  ESocialShareIcons["TWITTER_INVERSE"] = "Twitter Inverse";
  ESocialShareIcons["LINKEDIN_DEFAULT"] = "LinkedIn Default";
  ESocialShareIcons["LINKEDIN_INVERSE"] = "LinkedIn Inverse";
  ESocialShareIcons["FACEBOOK_DEFAULT"] = "Facebook Default";
  ESocialShareIcons["FACEBOOK_INVERSE"] = "Facebook Inverse";
})(ESocialShareIcons || (ESocialShareIcons = {}));

var IconPaths = (_a = {}, _a[ESocialShareIcons.TWITTER_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kw3glwqmuj32g2c5b-twitter-icon.svg?auto=format%252Ccompress', _a[ESocialShareIcons.TWITTER_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gqamik97awj25y-twitter-icon-inverse.svg?auto=format%252Ccompress', _a[ESocialShareIcons.LINKEDIN_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gk7f60aqudvzz7-linkedin-icon.svg?auto=format%252Ccompress', _a[ESocialShareIcons.LINKEDIN_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gpv4srls4oajgs-linkedin-icon-inverse.svg?auto=format%252Ccompress', _a[ESocialShareIcons.FACEBOOK_DEFAULT] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gim7t28ihobrpf-facebook-icon.svg?auto=format%252Ccompress', _a[ESocialShareIcons.FACEBOOK_INVERSE] = 'https://webimages.mongodb.com/_com_assets/cms/kw3gm784m1mmtfy9t-facebook-icon-inverse.svg?auto=format%252Ccompress', _a);

var ShareButtonsGroup = function ShareButtonsGroup(_a) {
  var _b = _a.article,
      article = _b === void 0 ? {} : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _d = _a.inverse,
      inverse = _d === void 0 ? false : _d;
  var heading = article.heading,
      subheading = article.subheading,
      url = article.url;
  var mode = inverse ? 'INVERSE' : 'DEFAULT';
  return jsx(ThemeProvider, _assign({
    theme: theme === 'legacy' ? legacyTheme : defaultTheme
  }, {
    children: jsxs("div", _assign({
      "aria-label": 'share-buttons-container',
      sx: {
        display: 'flex',
        gap: 'inc30',
        marginTop: 'inc40',
        a: {
          width: ['32px', null, null, '24px']
        },
        img: {
          width: '100%'
        }
      }
    }, {
      children: [jsx("a", _assign({
        target: '_blank',
        rel: 'noopener noreferrer',
        href: "https://twitter.com/intent/tweet?url=" + url + "&text=" + heading
      }, {
        children: jsx("img", {
          src: IconPaths[ESocialShareIcons["TWITTER_" + mode]],
          alt: 'twitter icon'
        }, void 0)
      }), void 0), jsx("a", _assign({
        target: '_blank',
        rel: 'noopener noreferrer',
        href: "https://www.linkedin.com/shareArticle?mini=true&url=" + url + "&title=" + heading + "&summary=" + subheading + "&source=MongoDB"
      }, {
        children: jsx("img", {
          src: IconPaths[ESocialShareIcons["LINKEDIN_" + mode]],
          alt: 'linkedin icon'
        }, void 0)
      }), void 0), jsx("a", _assign({
        target: '_blank',
        rel: 'noopener noreferrer',
        href: "https://www.facebook.com/sharer.php?u=" + url
      }, {
        children: jsx("img", {
          src: IconPaths[ESocialShareIcons["FACEBOOK_" + mode]],
          alt: 'facebook icon'
        }, void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
};

var SpeakersSection = function SpeakersSection(_a) {
  var speakersTitle = _a.speakersTitle,
      _b = _a.speakers,
      speakers = _b === void 0 ? [] : _b;
  return jsxs(Fragment, {
    children: [speakersTitle && jsx(Eyebrow, _assign({
      customElement: 'span',
      customStyles: {
        marginTop: ['inc50', null, null, 'inc60'],
        display: 'block'
      }
    }, {
      children: speakersTitle
    }), void 0), jsx("div", _assign({
      "aria-label": 'speakers-container',
      sx: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 'inc40',
        gap: 'inc30'
      }
    }, {
      children: speakers.map(function (_a) {
        var name = _a.name,
            title = _a.title,
            profileImage = _a.profileImage;
        return jsx(SpeakerLockup, {
          name: name,
          title: title,
          profileImage: profileImage
        }, name + "-" + title);
      })
    }), void 0)]
  }, void 0);
};

var TagsSection = function TagsSection(_a) {
  var tagsTitle = _a.tagsTitle,
      _b = _a.tags,
      tags = _b === void 0 ? [] : _b;
  return jsxs(Fragment, {
    children: [tagsTitle && jsx(Eyebrow, _assign({
      customElement: 'span',
      customStyles: {
        marginTop: ['inc50', null, null, 'inc60'],
        display: 'block'
      }
    }, {
      children: tagsTitle
    }), void 0), jsx("div", _assign({
      "aria-label": 'tags-container',
      sx: {
        display: 'flex',
        gap: 'inc20',
        flexWrap: 'wrap',
        marginTop: 'inc40'
      }
    }, {
      children: tags.map(function (_a) {
        var text = _a.text,
            href = _a.href,
            target = _a.target;
        return text && jsx(Tag, _assign({
          href: href,
          target: target
        }, {
          children: text
        }), text);
      })
    }), void 0)]
  }, void 0);
};

var getInitials = function getInitials(name) {
  var _a, _b;

  if (name === void 0) {
    name = '';
  }

  var fullName = name.split(' ');
  var firstNameInitial = (_a = fullName.shift()) === null || _a === void 0 ? void 0 : _a.charAt(0);
  var lastNameInitial = (_b = fullName.pop()) === null || _b === void 0 ? void 0 : _b.charAt(0);

  if (firstNameInitial && lastNameInitial) {
    var initials = firstNameInitial + lastNameInitial;
    return initials.toUpperCase();
  }

  if (firstNameInitial) {
    return firstNameInitial.toUpperCase();
  }

  return name;
};

var getStyles$2 = function getStyles$2() {
  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      gap: 'inc30'
    },
    profileImage: {
      borderRadius: '50%',
      width: ['40px', null, null, '64px'],
      height: ['40px', null, null, '64px']
    },
    avatarPlaceholder: {
      backgroundColor: 'blue80',
      borderRadius: '50%',
      width: ['40px', null, null, '64px'],
      height: ['40px', null, null, '64px'],
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    typographyContainer: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '256px'
    }
  };
};

var SpeakerLockup = function SpeakerLockup(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.profileImage,
      profileImage = _c === void 0 ? {} : _c,
      name = _a.name,
      title = _a.title,
      customStyles = _a.customStyles;
  var hasProfileImage = !!profileImage && !!profileImage.src;
  var styles = getStyles$2();

  var renderAvatar = function renderAvatar() {
    if (hasProfileImage) {
      return jsx("img", {
        sx: styles.profileImage,
        src: profileImage.src,
        alt: (profileImage === null || profileImage === void 0 ? void 0 : profileImage.alt) || ''
      }, void 0);
    }

    return jsx("div", _assign({
      sx: styles.avatarPlaceholder
    }, {
      children: jsx(TypographyScale, _assign({
        inverse: true,
        customStyles: {
          fontWeight: [400, null, null, 500],
          fontSize: ['16px', null, null, '24px']
        }
      }, {
        children: getInitials(name)
      }), void 0)
    }), void 0);
  };

  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs("div", _assign({
      "aria-label": 'speaker-lockup-container',
      className: className,
      sx: _assign(_assign({}, styles.container), customStyles)
    }, {
      children: [renderAvatar(), jsxs("div", _assign({
        sx: styles.typographyContainer
      }, {
        children: [jsx(TypographyScale, _assign({
          variant: 'body1',
          customStyles: {
            fontWeight: 500
          }
        }, {
          children: name
        }), void 0), jsx(TypographyScale, _assign({
          variant: 'body3',
          color: 'secondary'
        }, {
          children: title
        }), void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
};

var ShareLink = function ShareLink(_a) {
  var children = _a.children,
      href = _a.href,
      target = _a.target,
      _b = _a.isOpen,
      isOpen = _b === void 0 ? false : _b,
      label = _a.label;
  return jsx("a", _assign({
    "aria-label": label,
    sx: {
      height: [32, null, null, 24],
      marginLeft: 'elementXSmall',
      display: isOpen ? 'initial' : ['none', 'initial']
    },
    href: href,
    target: target
  }, {
    children: children
  }), void 0);
}; //exported for testing only


var getDocHeight = function getDocHeight() {
  return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight);
}; //exported for testing only


var calculateScrollDistance = function calculateScrollDistance(setScroll) {
  var scrollTop = window.scrollY;
  var windowHeight = window.innerHeight;
  var docHeight = getDocHeight();
  var totalDocScrollLength = docHeight - windowHeight;
  var scrollPosition = Math.floor(scrollTop / totalDocScrollLength * 100);
  setScroll(scrollPosition);
};

var listenToScrollEvent = function listenToScrollEvent(setScroll) {
  requestAnimationFrame(function () {
    // Calculates the scroll distance
    calculateScrollDistance(setScroll);
  });
};

var useDebounce = function useDebounce(fn, ms) {
  var _a = debounce(fn, ms),
      debouncedFun = _a[0],
      teardown = _a[1];

  useEffect(function () {
    return function () {
      return teardown();
    };
  }, []);
  return debouncedFun;
};

var FacebookIcon = function FacebookIcon() {
  return jsx("svg", _assign({
    sx: {
      width: [32, null, null, 24],
      height: [32, null, null, 24]
    },
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, {
    children: jsx("path", {
      d: 'M24 12.0724C24 5.40845 18.624 0 12 0C5.376 0 0 5.40845 0 12.0724C0 18.0966 4.392 23.0946 10.128 24V15.5614H7.08V12.0724H10.128V9.4165C10.128 6.38632 11.916 4.72032 14.664 4.72032C15.972 4.72032 17.352 4.96177 17.352 4.96177V7.93159H15.84C14.352 7.93159 13.884 8.86117 13.884 9.81489V12.0724H17.208L16.68 15.5614H13.884V24C19.608 23.0946 24 18.0966 24 12.0724Z',
      fill: '#001E2B'
    }, void 0)
  }), void 0);
};

var LinkedInIcon = function LinkedInIcon() {
  return jsx("svg", _assign({
    sx: {
      width: [32, null, null, 24],
      height: [32, null, null, 24]
    },
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, {
    children: jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.86487 6.17112C8.86487 6.91818 8.29604 7.52276 7.4065 7.52276C6.55162 7.52276 5.98279 6.91818 6.0004 6.17112C5.98279 5.38775 6.5516 4.80078 7.42354 4.80078C8.29603 4.80078 8.84781 5.38775 8.86487 6.17112ZM6.07192 17.2917V8.59053H8.77629V17.2917H6.07192ZM10.9446 11.3676C10.9446 10.2823 10.9088 9.35698 10.873 8.59177H13.222L13.3469 9.78387H13.4003C13.7562 9.23211 14.6457 8.39648 16.087 8.39648C17.8661 8.39648 19.2007 9.57098 19.2007 12.1323V17.2935H16.4963V12.4712C16.4963 11.3495 16.1052 10.5848 15.1265 10.5848C14.3789 10.5848 13.9344 11.1008 13.7568 11.5987C13.6852 11.7769 13.65 12.0256 13.65 12.2753V17.2935H10.9457V11.3676H10.9446Z',
      fill: '#001E2B'
    }, void 0)
  }), void 0);
};

var TwitterIcon = function TwitterIcon() {
  return jsx("svg", _assign({
    sx: {
      width: [32, null, null, 24],
      height: [32, null, null, 24]
    },
    viewBox: '0 0 24 24',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, {
    children: jsx("path", {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM17.5041 7.85027C18.1017 7.77876 18.6714 7.62037 19.2008 7.38519C18.8048 7.97747 18.3037 8.49776 17.7259 8.91533C17.7321 9.04156 17.7345 9.16922 17.7345 9.29738C17.7345 13.201 14.763 17.7026 9.32929 17.7026C7.66091 17.7026 6.10822 17.213 4.80078 16.375C5.03165 16.4028 5.26683 16.4167 5.50585 16.4167C6.89008 16.4167 8.16392 15.944 9.17474 15.152C7.88218 15.128 6.79073 14.2737 6.41492 13.1002C6.59538 13.1347 6.78065 13.1534 6.9712 13.1534C7.24046 13.1534 7.50156 13.117 7.74923 13.0498C6.3986 12.7776 5.37962 11.5839 5.37962 10.1522V10.1152C5.77848 10.3365 6.23349 10.4695 6.71826 10.4848C5.92487 9.95494 5.4041 9.05068 5.4041 8.02595C5.4041 7.48454 5.54953 6.97721 5.80392 6.54092C7.2611 8.32832 9.43776 9.50472 11.8933 9.6276C11.8429 9.41113 11.8165 9.18555 11.8165 8.9542C11.8165 7.32279 13.1393 6 14.7707 6C15.6198 6 16.3882 6.35902 16.9272 6.93306C17.5996 6.80011 18.2327 6.55484 18.8029 6.21598C18.5826 6.9057 18.1142 7.48454 17.5041 7.85027Z',
      fill: '#001E2B'
    }, void 0)
  }), void 0);
};

var ShareBar = function ShareBar(_a) {
  var title = _a.title,
      facebookUrl = _a.facebookUrl,
      linkedinUrl = _a.linkedinUrl,
      twitterUrl = _a.twitterUrl,
      isVisible = _a.isVisible;

  var _b = useState(0),
      scroll = _b[0],
      setScroll = _b[1];

  var debounceScrollEvent = useDebounce(function () {
    return listenToScrollEvent(setScroll);
  }, 15);
  useEffect(function () {
    document.addEventListener('scroll', debounceScrollEvent);
    return function () {
      document.removeEventListener('scroll', debounceScrollEvent);
    };
  }, []);

  var _c = useState(false),
      isOpen = _c[0],
      setIsOpen = _c[1];

  var toggleIsOpen = useCallback(function () {
    setIsOpen(!isOpen);
  }, [isOpen]);
  var titleRef = useRef(null);

  var _d = useDimension(titleRef),
      width = _d.width,
      height = _d.height;

  var _e = useState(),
      padding = _e[0],
      setPadding = _e[1];

  useEffect(function () {
    var _a = defaultTheme.breakpoints,
        mobile = _a[0],
        tablet = _a[2];
    var isMobile = width <= parseInt(mobile);
    var isTablet = width > parseInt(mobile) && width < parseInt(tablet);
    var isMoreThanOneLine = height > parseInt(defaultTheme.lineHeights.bodyL);

    if (isMoreThanOneLine) {
      if (isMobile) {
        setPadding('inc20');
      }

      if (isTablet) {
        setPadding('inc30');
      }
    } else {
      setPadding(null);
    }
  }, [titleRef, width, height]);
  var getPaddingY = useCallback(function () {
    if (isOpen) return 'inc40';
    if (padding) return padding;
    return ['inc30', 'inc50', 'inc60'];
  }, [isOpen, padding]);
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs("div", _assign({
      sx: {
        width: '100%',
        display: isVisible ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        position: 'fixed',
        boxShadow: 'level01',
        top: 0
      }
    }, {
      children: [jsxs("div", _assign({
        sx: {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          paddingY: getPaddingY(),
          paddingBottom: isOpen && 'inc40'
        }
      }, {
        children: [jsx("div", _assign({
          sx: {
            flex: 1,
            textAlign: ['left', null, null, 'center'],
            paddingLeft: 'elementMedium',
            display: isOpen && 'none'
          },
          ref: titleRef
        }, {
          children: jsx(TypographyScale, _assign({
            customStyles: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              '-webkit-line-clamp': '2',
              '-webkit-box-orient': 'vertical'
            }
          }, {
            children: title
          }), void 0)
        }), void 0), jsxs("div", _assign({
          sx: {
            marginRight: 'elementLarge',
            marginLeft: isOpen ? 'inc20' : 'elementLarge',
            flex: isOpen ? 1 : 0,
            display: 'flex',
            position: isOpen && 'relative'
          }
        }, {
          children: [jsx("button", _assign({
            "aria-label": 'Share menu',
            onClick: toggleIsOpen,
            sx: {
              display: isOpen ? 'none' : ['initial', 'none'],
              border: 'none',
              bg: 'white',
              cursor: 'pointer'
            }
          }, {
            children: jsx(SystemIcon, {
              name: ESystemIconNames.SHARE_OPTION
            }, void 0)
          }), void 0), (facebookUrl === null || facebookUrl === void 0 ? void 0 : facebookUrl.href) && jsx(ShareLink, _assign({
            label: 'Share on Facebook',
            isOpen: isOpen,
            href: facebookUrl.href,
            target: facebookUrl.target
          }, {
            children: jsx(FacebookIcon, {}, void 0)
          }), void 0), (linkedinUrl === null || linkedinUrl === void 0 ? void 0 : linkedinUrl.href) && jsx(ShareLink, _assign({
            label: 'Share on LinkedIn',
            isOpen: isOpen,
            href: linkedinUrl.href,
            target: linkedinUrl.target
          }, {
            children: jsx(LinkedInIcon, {}, void 0)
          }), void 0), (twitterUrl === null || twitterUrl === void 0 ? void 0 : twitterUrl.href) && jsx(ShareLink, _assign({
            label: 'Share on Twitter',
            isOpen: isOpen,
            href: twitterUrl.href,
            target: twitterUrl.target
          }, {
            children: jsx(TwitterIcon, {}, void 0)
          }), void 0), isOpen && jsx("button", _assign({
            "aria-label": 'Close menu',
            onClick: toggleIsOpen,
            sx: {
              marginLeft: 'elementMedium',
              border: 'none',
              bg: 'white',
              cursor: 'pointer',
              position: 'absolute',
              marginY: 'auto',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)'
            }
          }, {
            children: jsx(SystemIcon, {
              strokeWeight: 'medium',
              name: ESystemIconNames.CLOSE
            }, void 0)
          }), void 0)]
        }), void 0)]
      }), void 0), jsx("div", {
        sx: {
          alignSelf: 'flex-start',
          width: scroll + "%",
          height: '4px',
          bg: "background.selected"
        }
      }, void 0)]
    }), void 0)
  }), void 0);
};

var PromoImage = function PromoImage(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.image,
      image = _c === void 0 ? {} : _c,
      _d = _a.postSubmissionState,
      postSubmissionState = _d === void 0 ? false : _d,
      _e = _a.iconName,
      iconName = _e === void 0 ? ESystemIconNames.PLAY : _e,
      _f = _a.iconStrokeWeight,
      iconStrokeWeight = _f === void 0 ? 'medium' : _f,
      buttonText = _a.buttonText,
      flyoutHash = _a.flyoutHash,
      _g = _a.onClickPlay,
      onClickPlay = _g === void 0 ? function () {} : _g,
      _h = _a.theme,
      theme = _h === void 0 ? 'default' : _h,
      customStyles = _a.customStyles;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var buttonWrapperCommonStyles = {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  };
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      onClick: postSubmissionState ? onClickPlay : function () {},
      className: className,
      "aria-label": 'promo-image-wrapper',
      sx: _assign({
        cursor: postSubmissionState ? 'pointer' : 'default',
        position: 'relative',
        width: '100%',
        borderRadius: ['none', null, 'inc50', 'inc70'],
        overflow: 'hidden'
      }, customStyles)
    }, {
      children: [jsx(SingleImage, {
        variant: ESingleImageVariant.VIDEO,
        src: image.src || '',
        altText: image.alt
      }, void 0), postSubmissionState ? jsx(ButtonIcon, {
        iconName: iconName,
        iconStrokeWeight: iconStrokeWeight,
        customWrapperStyles: _assign({}, buttonWrapperCommonStyles)
      }, void 0) : buttonText && jsx(Button, _assign({
        onClick: onClickPlay,
        hasIcon: true,
        iconName: iconName,
        iconStrokeWeight: iconStrokeWeight,
        href: flyoutHash ? flyoutHash : '',
        customWrapperStyles: _assign({}, buttonWrapperCommonStyles)
      }, {
        children: buttonText
      }), void 0)]
    }), void 0)
  }), void 0);
};

var getStyles$1 = function getStyles$1(formCustomStyles) {
  return {
    form: _assign({
      display: 'flex',
      width: '100%',
      //need to add token for maxWidth
      maxWidth: '456px',
      flexDirection: 'column',
      gap: ['inc40', null, null, '40px']
    }, formCustomStyles)
  };
};

var getFormFields = function getFormFields(formData) {
  return Object.keys(formData).map(function (name) {
    return formData[name];
  });
};

var getFormRecord = function getFormRecord(formData, key) {
  return getFormFields(formData).reduce(function (prev, cur) {
    var _a;

    return _assign(_assign({}, prev), (_a = {}, _a[cur.name] = cur[key], _a));
  }, {});
};

var getFormValues = function getFormValues(formData) {
  return getFormRecord(formData, 'value');
};

var updateFieldValues = function updateFieldValues(name, newFieldValues) {
  return function (formData) {
    var _a;

    return _assign(_assign({}, formData), (_a = {}, _a[name] = _assign(_assign({}, formData[name]), newFieldValues), _a));
  };
};

var updateAllFields = function updateAllFields(formData) {
  return function (callback) {
    var keys = Object.keys(formData);
    return keys.reduce(function (prev, key) {
      var _a;

      return _assign(_assign({}, prev), (_a = {}, _a[key] = _assign(_assign({}, formData[key]), callback(formData[key])), _a));
    }, {});
  };
};

var validate = function validate(value, validators) {
  if (validators && validators.length) {
    var validateErrors = validators.map(function (validator) {
      return validator(value);
    });
    return validateErrors.filter(Boolean);
  }
};

var appendAsteriskIfRequired = function appendAsteriskIfRequired(label, validators) {
  var isRequired = validators === null || validators === void 0 ? void 0 : validators.find(function (validator) {
    var _a;

    return (_a = validator.rule) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes('required');
  });
  return isRequired && typeof label === 'string' ? label + "*" : label;
};

var FormContextActions = {
  setSubmitFlag: function setSubmitFlag(shouldSubmit) {
    return function (state) {
      return _assign(_assign({}, state), {
        shouldSubmit: shouldSubmit
      });
    };
  },
  setChangeFlag: function setChangeFlag(shouldChange) {
    return function (state) {
      return _assign(_assign({}, state), {
        shouldChange: shouldChange
      });
    };
  },
  validateAllFields: function validateAllFields() {
    return function (state) {
      return _assign(_assign({}, state), {
        formData: updateAllFields(state.formData)(function (_a) {
          var value = _a.value,
              validators = _a.validators,
              name = _a.name;
          return {
            name: name,
            errors: validate(value || '', validators),
            isValidated: true
          };
        }),
        shouldSubmit: true
      });
    };
  },
  fieldRegister: function fieldRegister(name, field) {
    return function (state) {
      return _assign(_assign({}, state), {
        formData: updateFieldValues(name, _assign(_assign({}, field), {
          errors: [],
          isValidated: false
        }))(state.formData)
      });
    };
  },
  fieldHandleChange: function fieldHandleChange(name, value) {
    return function (state) {
      return _assign(_assign({}, state), {
        shouldChange: true,
        formData: updateFieldValues(name, {
          value: value,
          isValidated: false
        })(state.formData)
      });
    };
  },
  fieldHandleValidate: function fieldHandleValidate(name, errors) {
    return function (state) {
      return _assign(_assign({}, state), {
        formData: updateFieldValues(name, {
          errors: errors,
          isValidated: true
        })(state.formData)
      });
    };
  }
};
var FormStateContext = React.createContext({});
var FormUpdaterContext = React.createContext({});

var useFormState = function useFormState() {
  return React.useContext(FormStateContext);
};

var useFormUpdater = function useFormUpdater() {
  return React.useContext(FormUpdaterContext);
};

var useFormActions = function useFormActions() {
  var setFormState = useFormUpdater();
  return React.useMemo(function () {
    return {
      submit: function submit() {
        return setFormState(FormContextActions.setSubmitFlag(true));
      }
    };
  }, [setFormState]);
};

var useFormFieldActions = function useFormFieldActions(name) {
  var setFormState = useFormUpdater();
  return React.useMemo(function () {
    return {
      change: function change(value) {
        return setFormState(FormContextActions.fieldHandleChange(name, value));
      },
      validate: function validate(errors) {
        return setFormState(FormContextActions.fieldHandleValidate(name, errors));
      },
      register: function register(field) {
        return setFormState(FormContextActions.fieldRegister(name, field));
      }
    };
  }, [setFormState]);
};

var INITIAL_STATE = {
  inverse: false,
  shouldChange: false,
  shouldSubmit: false,
  formData: {}
};

var FormProvider = function FormProvider(_a) {
  var onChange = _a.onChange,
      onSubmit = _a.onSubmit,
      onValidate = _a.onValidate,
      children = _a.children,
      initialState = _a.initialState;

  var _b = React.useState(_assign(_assign({}, INITIAL_STATE), initialState)),
      formState = _b[0],
      setFormState = _b[1];

  var shouldSubmit = formState.shouldSubmit,
      shouldChange = formState.shouldChange,
      formData = formState.formData;
  var isInvalid = React.useMemo(function () {
    return getFormFields(formData).some(function (_a) {
      var errors = _a.errors;
      return errors === null || errors === void 0 ? void 0 : errors.length;
    });
  }, [formData]);
  var isValidated = React.useMemo(function () {
    return getFormFields(formData).every(function (_a) {
      var isValidated = _a.isValidated;
      return isValidated;
    });
  }, [formData]);
  React.useEffect(function () {
    if (shouldSubmit) {
      setFormState(FormContextActions.setSubmitFlag(false));

      if (!isInvalid && isValidated) {
        onSubmit(getFormValues(formData));
      } else if (!isValidated) {
        setFormState(FormContextActions.validateAllFields());
      } else if (isValidated) {
        onValidate && onValidate(getFormFields(formData));
      }
    }
  }, [shouldSubmit, isInvalid, isValidated, onSubmit, formData]);
  React.useEffect(function () {
    if (shouldChange) {
      onChange(getFormValues(formData));
      setFormState(FormContextActions.setChangeFlag(false));
    }
  }, [shouldChange, onChange]);
  return React.createElement(FormStateContext.Provider, {
    value: formState
  }, React.createElement(FormUpdaterContext.Provider, {
    value: setFormState
  }, children));
};

var ForwardFormWithContext = function ForwardFormWithContext(_a, ref) {
  var id = _a.id,
      name = _a.name,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      customStyles = _a.customStyles,
      children = _a.children;
  var styles = getStyles$1(customStyles);
  var submit = useFormActions().submit;

  var handleFormSubmit = function handleFormSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    submit();
  };

  return jsx("form", _assign({
    ref: ref,
    id: id,
    name: name,
    onSubmit: handleFormSubmit,
    className: className,
    sx: styles.form
  }, {
    children: children
  }), void 0);
};

var FormWithContext = forwardRef(ForwardFormWithContext);

var ForwardFormGeneric = function ForwardFormGeneric(_a, ref) {
  var _b = _a.onSubmit,
      onSubmit = _b === void 0 ? function (_values) {
    return null;
  } : _b,
      _c = _a.onChange,
      onChange = _c === void 0 ? function (_values) {
    return null;
  } : _c,
      onValidate = _a.onValidate,
      inverse = _a.inverse,
      props = __rest(_a, ["onSubmit", "onChange", "onValidate", "inverse"]);

  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsx(FormProvider, _assign({
      initialState: {
        inverse: inverse
      },
      onSubmit: onSubmit,
      onChange: onChange,
      onValidate: onValidate
    }, {
      children: jsx(FormWithContext, _assign({
        ref: ref
      }, props), void 0)
    }), void 0)
  }), void 0);
};

var FormGeneric = forwardRef(ForwardFormGeneric);

var CheckboxWrapper = function CheckboxWrapper(_a) {
  var onChange = _a.onChange,
      props = __rest(_a, ["onChange"]);

  var handleToggle = function handleToggle(value) {
    var event = {
      target: {
        value: value
      }
    };
    onChange(event);
  };

  return jsx(Checkbox, _assign({}, props, {
    onToggle: handleToggle
  }), void 0);
};

var SelectWrapper = function SelectWrapper(_a) {
  var onChange = _a.onChange,
      props = __rest(_a, ["onChange"]);

  var handleSelect = function handleSelect(value) {
    var event = {
      target: {
        value: value
      }
    };
    onChange(event);
  };

  return jsx(Select, _assign({}, props, {
    onSelect: handleSelect
  }), void 0);
};

var NO_DELAY = undefined;
var DEFAULT_DELAY = 800;
var CHECKBOX_DELAY = 500;
var ComponentProps = {
  'text-input': {
    element: TextInput,
    delayTime: DEFAULT_DELAY
  },
  'text-area': {
    element: TextArea,
    delayTime: DEFAULT_DELAY
  },
  select: {
    element: SelectWrapper,
    delayTime: NO_DELAY
  },
  checkbox: {
    element: CheckboxWrapper,
    delayTime: CHECKBOX_DELAY
  }
};

var MemoizedField = function MemoizedField(_a) {
  var validators = _a.validators,
      _b = _a.component,
      component = _b === void 0 ? 'text-input' : _b,
      _c = _a.fieldData,
      fieldData = _c === void 0 ? {} : _c,
      hidden = _a.hidden,
      props = __rest(_a, ["validators", "component", "fieldData", "hidden"]);

  var validateTimeout = useRef();
  var errors = fieldData.errors;

  var _d = useMemo(function () {
    return ComponentProps[component];
  }, [component]),
      element = _d.element,
      delayTime = _d.delayTime;

  var formFieldActions = useFormFieldActions(props.name);

  var handleChange = function handleChange(event) {
    var errors = validate(event.target.value, validators);
    handleValidate(errors, delayTime);
    formFieldActions.change(event.target.value);

    if (props.onChange) {
      props.onChange(event);
    }
  };

  var triggerValidate = function triggerValidate(errors) {
    formFieldActions.validate(errors);

    if (props.onValidate) {
      props.onValidate(errors);
    }
  };

  var handleValidate = function handleValidate(errors, delay) {
    if (delay) {
      if (validateTimeout.current) {
        clearTimeout(validateTimeout.current);
      }

      validateTimeout.current = setTimeout(function () {
        triggerValidate(errors);
      }, delay);
      return;
    }

    triggerValidate(errors);
  };

  useEffect(function () {
    formFieldActions.register({
      name: props.name,
      validators: validators
    });
  }, []);

  var renderComponent = function renderComponent() {
    return React.createElement(element, _assign(_assign({}, props), {
      onChange: handleChange,
      inverse: props.inverse,
      invalid: Boolean(errors === null || errors === void 0 ? void 0 : errors.length),
      label: appendAsteriskIfRequired(props.label, validators),
      errors: fieldData.errors
    }));
  };

  var renderErrors = function renderErrors() {
    if (errors === null || errors === void 0 ? void 0 : errors.length) {
      return jsx("div", _assign({
        sx: {
          display: 'flex',
          flexDirection: 'column'
        }
      }, {
        children: errors.map(function (error) {
          return jsx(HelperText, {
            color: component === 'checkbox' ? 'secondary' : 'default',
            inverse: props.inverse,
            text: error
          }, error);
        })
      }), void 0);
    }

    return null;
  };

  return jsxs("div", _assign({
    sx: {
      display: hidden ? 'none' : 'block'
    }
  }, {
    children: [renderComponent(), renderErrors()]
  }), void 0);
};

var Field = function Field(props) {
  var _a = useFormState(),
      inverse = _a.inverse,
      formData = _a.formData;

  var iconName = props.iconName;
  var fieldData = useMemo(function () {
    return formData[props.name] || {};
  }, [formData[props.name]]);
  return useMemo(function () {
    return jsx(MemoizedField, _assign({}, props, {
      inverse: inverse,
      fieldData: fieldData
    }), void 0);
  }, [fieldData, inverse, iconName]);
};

var Article = function Article(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.inverse,
      inverse = _c === void 0 ? false : _c,
      heading = _a.heading,
      subheading = _a.subheading,
      content = _a.content;
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsx(VerticalSectionSpacing, _assign({
      top: 'large',
      bottom: 'large'
    }, {
      children: jsxs("article", _assign({
        className: className,
        sx: {
          maxWidth: '816px',
          wordBreak: 'break-word'
        }
      }, {
        children: [heading && jsx(TypographyScale, _assign({
          variant: 'heading2',
          customStyles: {
            fontFamily: 'body',
            fontSize: ['inc50', null, null, 'inc80'],
            lineHeight: ['inc30', null, null, 'inc50'],
            marginBottom: ['inc40', null, 'inc50', 'inc60']
          },
          inverse: inverse
        }, {
          children: heading
        }), void 0), subheading && jsx(TypographyScale, _assign({
          variant: 'heading3',
          customStyles: {
            fontFamily: 'body',
            fontSize: ['inc30', null, null, 'inc50'],
            lineHeight: ['inc20', null, null, 'inc30'],
            marginBottom: ['inc40', null, 'inc50', 'inc60']
          },
          inverse: inverse
        }, {
          children: subheading
        }), void 0), content && jsx(TypographyScale, _assign({
          variant: 'body1',
          customStyles: {
            color: inverse ? 'black00' : 'green80',
            marginBottom: ['inc70', 'inc80', null]
          }
        }, {
          children: content
        }), void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
};

var EAsideVariant;

(function (EAsideVariant) {
  EAsideVariant["ERROR"] = "error";
  EAsideVariant["TIP"] = "tip";
  EAsideVariant["DEEP_DIVE"] = "deep dive";
  EAsideVariant["NEXT_STEPS"] = "next steps";
})(EAsideVariant || (EAsideVariant = {}));

var getBackgroundColor$1 = function getBackgroundColor$1(variant) {
  switch (variant) {
    case EAsideVariant.ERROR:
      return 'red10';

    case EAsideVariant.TIP:
      return 'purple10';

    case EAsideVariant.DEEP_DIVE:
      return 'blue10';

    case EAsideVariant.NEXT_STEPS:
      return 'black15';
  }
};

var getTextColor = function getTextColor(variant) {
  switch (variant) {
    case EAsideVariant.ERROR:
      return 'red80';

    case EAsideVariant.TIP:
      return 'purple80';

    case EAsideVariant.DEEP_DIVE:
      return 'blue70';

    case EAsideVariant.NEXT_STEPS:
      return 'blue80';
  }
};

var getAccentColor = function getAccentColor(variant) {
  switch (variant) {
    case EAsideVariant.ERROR:
      return 'red30';

    case EAsideVariant.TIP:
      return 'purple60';

    case EAsideVariant.DEEP_DIVE:
      return 'blue60';

    case EAsideVariant.NEXT_STEPS:
      return 'blue80';
  }
};

var getIconName = function getIconName(variant) {
  switch (variant) {
    case EAsideVariant.ERROR:
      return ESystemIconNames.CIRCLE_ALERT;

    case EAsideVariant.TIP:
      return ESystemIconNames.LIGHTBULB;

    case EAsideVariant.DEEP_DIVE:
      return ESystemIconNames.ACADEMIC_CAP;

    case EAsideVariant.NEXT_STEPS:
      return ESystemIconNames.MEGAPHONE;
  }
};

var Aside = function Aside(_a) {
  var variant = _a.variant,
      _b = _a.text,
      text = _b === void 0 ? '' : _b,
      customStyles = _a.customStyles;
  var header = variant[0].toUpperCase() + variant.substring(1);
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs("div", _assign({
      className: 'aside-container',
      sx: _assign({
        borderRadius: '2px 16px 16px 2px',
        backgroundColor: 'background.body',
        filter: 'drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1))',
        borderLeftColor: getAccentColor(variant),
        borderLeftWidth: '3px',
        borderLeftStyle: 'solid',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box'
      }, customStyles)
    }, {
      children: [jsx("div", _assign({
        sx: {
          position: 'absolute',
          top: '-16px',
          left: '-16px',
          width: '32px',
          height: '32px',
          background: 'black00',
          borderRadius: 'circle',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      }, {
        children: jsx(SystemIcon, {
          name: getIconName(variant),
          color: variant === EAsideVariant.ERROR ? 'error' : undefined,
          size: 'medium'
        }, void 0)
      }), void 0), jsx("div", _assign({
        sx: {
          backgroundColor: getBackgroundColor$1(variant),
          display: 'flex',
          alignItems: 'center',
          padding: '12px 24px',
          borderRadius: '2px 16px 0px 0px'
        }
      }, {
        children: jsx(TypographyScale, _assign({
          variant: 'body1',
          customStyles: {
            color: getTextColor(variant)
          }
        }, {
          children: header
        }), void 0)
      }), void 0), jsx("div", _assign({
        sx: {
          padding: '16px 24px',
          display: 'flex',
          alignItems: 'center'
        }
      }, {
        children: jsx(TypographyScale, _assign({
          variant: 'body2'
        }, {
          children: text
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
};

var defaultIconConfig = {
  name: 'mdb_backup',
  size: 'medium'
};
var defaultImageConfig$2 = {
  src: 'https://webimages.mongodb.com/_com_assets/cms/kpn3bw5aefoqlwbcy-04textsearch.png?auto=format%252Ccompress',
  variant: ESingleImageVariant.LETTERBOX
};
var cardWidthBreakpoints$1 = {
  large: 540,
  medium: 434,
  small: 328
};

var getCardPadding = function getCardPadding(width, theme, background) {
  if (background === void 0) {
    background = true;
  }

  var large = cardWidthBreakpoints$1.large,
      small = cardWidthBreakpoints$1.small;
  if (width >= large) return background ? theme.space.cards.paddingXL : theme.space.cards.paddingXL + " 0";
  if (width >= small && width < large) return background ? theme.space.cards.paddingXL + " " + theme.space.cards.paddingM : theme.space.cards.paddingXL + " 0";
  if (width < small) return background ? theme.space.cards.paddingS + " " + theme.space.cards.paddingXXS : theme.space.cards.paddingS + " 0";
};

var getBackgroundStyles$1 = function getBackgroundStyles$1(background, inverse) {
  if (background) {
    return inverse ? 'card.inverse.bg' : 'card.default.bg';
  }

  return 'transparent';
};

var getBorderStyles$1 = function getBorderStyles$1(background, inverse) {
  return {
    borderStyle: 'solid',
    borderWidth: background ? '1px' : '0',
    borderColor: inverse ? 'card.inverse.border' : 'card.default.border',
    borderRadius: ['cardResponsive', 'cardResponsive', 'cardResponsive', 'card']
  };
};

var getTypographyVariant = function getTypographyVariant(size, type) {
  var isHeading = type === 'heading';
  var TypographyVariant = {
    small: isHeading ? 'heading6' : 'body3',
    large: isHeading ? 'heading5' : 'body1'
  };
  return TypographyVariant[size];
};

var getImageryElement = function getImageryElement(props, inverse) {
  var _a = props.imageryType,
      imageryType = _a === void 0 ? 'icon' : _a,
      _b = props.iconConfig,
      iconConfig = _b === void 0 ? defaultIconConfig : _b,
      _c = props.imageConfig,
      imageConfig = _c === void 0 ? defaultImageConfig$2 : _c;
  var imgStyles = {
    width: '100%'
  };
  var ImageryElement = {
    icon: jsx(BrandedIcon, {
      name: iconConfig.name || defaultIconConfig.name,
      size: iconConfig.size || 'medium',
      inverse: inverse
    }, void 0),
    image: jsx("div", _assign({
      sx: imgStyles
    }, {
      children: jsx(SingleImage, {
        lazyLoad: imageConfig.lazyLoad,
        src: imageConfig.src || defaultImageConfig$2.src,
        altText: imageConfig.altText,
        variant: imageConfig.variant || defaultImageConfig$2.variant
      }, void 0)
    }), void 0)
  };
  return ImageryElement[imageryType];
};

var getCardHeaderWidthVariantStyles = function getCardHeaderWidthVariantStyles(width, theme, pillText, horizontalCard) {
  var medium = cardWidthBreakpoints$1.medium;
  var largeCard = width >= medium;
  var hasMarginBottom = largeCard || !pillText;
  return {
    cardHeaderStyles: {
      marginBottom: hasMarginBottom && !horizontalCard ? 'inc40' : 0
    },
    pillStyles: largeCard ? {
      position: 'absolute',
      left: 'inc60',
      top: 'inc60'
    } : {
      margin: theme.space.inc30 + " 0"
    }
  };
};

var CardContent = function CardContent(_a) {
  var _b = _a.inverse,
      inverse = _b === void 0 ? false : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _d = _a.alignment,
      alignment = _d === void 0 ? 'center' : _d,
      text = _a.text,
      _e = _a.typographySize,
      typographySize = _e === void 0 ? 'small' : _e,
      _f = _a.listItems,
      listItems = _f === void 0 ? [] : _f,
      _g = _a.listGlyph,
      listGlyph = _g === void 0 ? 'circle' : _g;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var hasItems = listItems.length !== 0;
  return jsxs(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: [jsx(TypographyScale, _assign({
      "aria-label": 'text-content',
      customStyles: {
        marginBottom: hasItems ? 0 : selectedTheme.space.inc40,
        textAlign: alignment
      },
      color: 'secondary',
      variant: getTypographyVariant(typographySize, 'body'),
      inverse: inverse
    }, {
      children: text
    }), void 0), hasItems && jsx(List, {
      textSize: typographySize,
      items: listItems,
      glyph: listGlyph,
      inverse: inverse
    }, void 0)]
  }), void 0);
};

var CardFooter = function CardFooter(_a) {
  var _b = _a.inverse,
      inverse = _b === void 0 ? false : _b,
      _c = _a.cta,
      cta = _c === void 0 ? {} : _c;
  var _d = cta.type,
      type = _d === void 0 ? 'link-arrow' : _d,
      text = cta.text,
      _e = cta.config,
      config = _e === void 0 ? {} : _e,
      _f = cta.disableExpand,
      disableExpand = _f === void 0 ? false : _f;
  var arrowOnly = type === 'arrow';
  var showCTA = text || arrowOnly;
  var CTAElement = {
    button: jsx(ThemeProvider, _assign({
      theme: defaultTheme
    }, {
      children: jsx(Button, _assign({
        inverse: inverse,
        variant: config.variant || 'primary',
        href: config.href,
        target: config.target,
        onClick: config.onClick,
        customWrapperStyles: _assign({}, getMobileButtonStyle())
      }, {
        children: text
      }), void 0)
    }), void 0),
    'link-arrow': jsx(ThemeProvider, _assign({
      theme: defaultTheme
    }, {
      children: jsx(Link, _assign({
        variant: ELinkVariant.SMALL,
        linkIcon: 'arrow',
        inverse: inverse,
        href: config.href,
        target: config.target,
        onClick: config.onClick,
        linkIconDisableExpand: disableExpand
      }, {
        children: text
      }), void 0)
    }), void 0),
    'link-chevron': jsx(ThemeProvider, _assign({
      theme: defaultTheme
    }, {
      children: jsx(Link, _assign({
        variant: ELinkVariant.SMALL,
        linkIcon: 'chevron',
        inverse: inverse,
        href: config.href,
        target: config.target,
        onClick: config.onClick,
        linkIconDisableExpand: disableExpand
      }, {
        children: text
      }), void 0)
    }), void 0),
    arrow: jsx(ThemeProvider, _assign({
      theme: defaultTheme
    }, {
      children: jsx(Link, {
        variant: ELinkVariant.SMALL,
        linkIcon: 'arrow',
        arrowOnly: true,
        inverse: inverse,
        href: config.href,
        target: config.target,
        onClick: config.onClick
      }, void 0)
    }), void 0)
  };
  return showCTA && CTAElement[type] || null;
};

var CardHeader = function CardHeader(_a) {
  var _b = _a.inverse,
      inverse = _b === void 0 ? false : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      pillText = _a.pillText,
      _d = _a.imageryType,
      imageryType = _d === void 0 ? 'none' : _d,
      horizontalCard = _a.horizontalCard,
      iconConfig = _a.iconConfig,
      imageConfig = _a.imageConfig,
      _e = _a.cardWidth,
      cardWidth = _e === void 0 ? 0 : _e;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var hasImagery = !!imageryType && imageryType !== 'none';
  var imageryProps = {
    imageryType: imageryType,
    iconConfig: iconConfig,
    imageConfig: imageConfig
  };
  var ImageryElement = getImageryElement(imageryProps, inverse);

  var _f = getCardHeaderWidthVariantStyles(cardWidth, selectedTheme, pillText, horizontalCard),
      cardHeaderStyles = _f.cardHeaderStyles,
      pillStyles = _f.pillStyles;

  return jsxs("div", _assign({
    "aria-label": 'card-header',
    sx: _assign({
      order: horizontalCard ? 2 : 0,
      width: horizontalCard ? '50%' : '100%',
      height: horizontalCard ? '100%' : null,
      display: 'inherit',
      flexDirection: 'inherit',
      flexWrap: 'inherit',
      alignItems: 'inherit'
    }, cardHeaderStyles)
  }, {
    children: [hasImagery && ImageryElement, pillText && !horizontalCard && jsx(Pill, {
      sx: _assign({}, pillStyles),
      variant: 'identifier',
      text: pillText,
      inverse: inverse
    }, void 0)]
  }), void 0);
};

var CardTitles = function CardTitles(_a) {
  var _b = _a.inverse,
      inverse = _b === void 0 ? false : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      _d = _a.alignment,
      alignment = _d === void 0 ? 'center' : _d,
      _e = _a.typographySize,
      typographySize = _e === void 0 ? 'small' : _e,
      largeTitle = _a.largeTitle,
      titleMinHeight = _a.titleMinHeight,
      title = _a.title,
      useTitleRef = _a.useTitleRef,
      subtitle = _a.subtitle;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var titleRef = useRef(null);
  var hasSubtitle = subtitle && subtitle !== '';
  useEffect(function () {
    useTitleRef && useTitleRef(titleRef);
  });
  return jsxs(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: [jsx("div", _assign({
      ref: titleRef,
      sx: {
        height: 'fit-content',
        marginBottom: selectedTheme.space.inc40
      }
    }, {
      children: jsx(TypographyScale, _assign({
        customStyles: {
          minHeight: [null, null, null, titleMinHeight],
          textAlign: alignment,
          fontWeight: '500'
        },
        variant: largeTitle ? 'heading5' : getTypographyVariant(typographySize, 'heading'),
        inverse: inverse
      }, {
        children: title
      }), void 0)
    }), void 0), hasSubtitle && jsx(TypographyScale, _assign({
      customStyles: {
        marginBottom: selectedTheme.space.inc40,
        textAlign: alignment,
        fontWeight: '500',
        color: inverse ? 'card.inverse.textSub' : 'card.default.textSub'
      },
      variant: 'body4',
      inverse: inverse
    }, {
      children: subtitle
    }), void 0)]
  }), void 0);
};

var FlashCard = function FlashCard(_a) {
  var _b, _c, _d;

  var _e = _a.className,
      className = _e === void 0 ? '' : _e,
      customWrapperStyles = _a.customWrapperStyles,
      _f = _a.inverse,
      inverse = _f === void 0 ? false : _f,
      _g = _a.theme,
      theme = _g === void 0 ? 'default' : _g,
      _h = _a.background,
      background = _h === void 0 ? true : _h,
      _j = _a.divider,
      divider = _j === void 0 ? false : _j,
      pillText = _a.pillText,
      _k = _a.alignment,
      alignment = _k === void 0 ? 'center' : _k,
      title = _a.title,
      _l = _a.typographySize,
      typographySize = _l === void 0 ? 'small' : _l,
      largeTitle = _a.largeTitle,
      horizontalLayout = _a.horizontalLayout,
      subtitle = _a.subtitle,
      text = _a.text,
      _m = _a.listItems,
      listItems = _m === void 0 ? [] : _m,
      _o = _a.listGlyph,
      listGlyph = _o === void 0 ? 'circle' : _o,
      _p = _a.imageryType,
      imageryType = _p === void 0 ? 'none' : _p,
      _q = _a.iconConfig,
      iconConfig = _q === void 0 ? defaultIconConfig : _q,
      _r = _a.imageConfig,
      imageConfig = _r === void 0 ? defaultImageConfig$2 : _r,
      titleMinHeight = _a.titleMinHeight,
      _s = _a.useTitleRef,
      useTitleRef = _s === void 0 ? function () {} : _s,
      _t = _a.cta,
      cta = _t === void 0 ? {
    type: 'none',
    text: '',
    config: {}
  } : _t;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var centerAlign = alignment === 'center';
  var hasCTA = cta.type !== 'none';
  var isLink = hasCTA && cta.type !== 'button';
  var isClickable = isLink && !['', '#'].includes(((_b = cta === null || cta === void 0 ? void 0 : cta.config) === null || _b === void 0 ? void 0 : _b.href) || '');
  var hasContent = !!text || listItems.length !== 0;
  var hasTitles = !!title || !!subtitle;
  var ref = useRef(null);
  var width = useDimension(ref).width;
  var medium = cardWidthBreakpoints$1.medium;
  var largeCard = width >= medium;
  var horizontalCard = horizontalLayout && largeCard;
  var headerProps = {
    inverse: inverse,
    alignment: alignment,
    pillText: pillText,
    title: title,
    typographySize: typographySize,
    subtitle: subtitle,
    horizontalCard: horizontalCard,
    imageryType: imageryType,
    iconConfig: iconConfig,
    imageConfig: imageConfig,
    cardWidth: width
  };
  var titleProps = {
    titleMinHeight: titleMinHeight,
    inverse: inverse,
    theme: theme,
    alignment: alignment,
    typographySize: typographySize,
    largeTitle: largeTitle,
    title: title,
    subtitle: subtitle,
    useTitleRef: useTitleRef
  };
  var contentProps = {
    inverse: inverse,
    alignment: alignment,
    text: text,
    typographySize: typographySize,
    listItems: listItems,
    listGlyph: listGlyph
  };
  var footerProps = {
    inverse: inverse,
    cta: cta
  };
  var TagName = isClickable ? 'a' : 'div';
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      ref: ref,
      sx: _assign({}, customWrapperStyles)
    }, {
      children: [jsxs(TagName, _assign({
        href: isClickable ? (_c = cta.config) === null || _c === void 0 ? void 0 : _c.href : undefined,
        target: isClickable ? (_d = cta.config) === null || _d === void 0 ? void 0 : _d.target : undefined,
        className: className,
        sx: _assign({
          color: 'inherit',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'none'
          },
          position: 'relative',
          display: 'flex',
          flexDirection: horizontalCard ? 'row' : 'column',
          flexWrap: horizontalCard ? 'nowrap' : 'wrap',
          minHeight: '100%',
          width: '100%',
          alignItems: horizontalCard ? 'center' : centerAlign ? 'center' : 'start',
          padding: getCardPadding(width, selectedTheme, background),
          boxShadow: background ? 'level01' : 'none',
          backgroundColor: getBackgroundStyles$1(background, inverse)
        }, getBorderStyles$1(background, inverse))
      }, {
        children: [jsx(CardHeader, _assign({}, headerProps), void 0), jsxs("div", _assign({
          sx: {
            order: 1,
            height: '100%',
            width: horizontalCard ? '50%' : '100%',
            alignItems: centerAlign ? 'center' : 'start',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            minHeight: [null, null, null, '248px']
          }
        }, {
          children: [jsxs("div", _assign({
            sx: {
              display: 'flex',
              flexDirection: 'column',
              alignItems: centerAlign ? 'center' : 'start',
              maxWidth: horizontalCard ? null : [null, null, '232px', null, '100%']
            }
          }, {
            children: [hasTitles && jsx(CardTitles, _assign({}, titleProps), void 0), hasContent && jsx(CardContent, _assign({}, contentProps), void 0)]
          }), void 0), hasCTA && jsx(CardFooter, _assign({}, footerProps), void 0)]
        }), void 0)]
      }), void 0), divider && !background && jsx(HorizontalRule, {
        spacing: 'none',
        inverse: inverse
      }, void 0)]
    }), void 0)
  }), void 0);
};

var Card = function Card(_a) {
  var className = _a.className,
      _b = _a.direction,
      direction = _b === void 0 ? 'row' : _b,
      customCardWrapperStyles = _a.customCardWrapperStyles,
      children = _a.children;
  return jsx(Panel, _assign({
    className: className,
    sx: _assign({
      display: 'flex',
      flexDirection: direction,
      justifyContent: 'space-between',
      borderColor: 'card.default.border',
      bg: 'card.default.bg',
      boxShadow: 'level01'
    }, customCardWrapperStyles)
  }, {
    children: children
  }), void 0);
};

var defaultImageConfig$1 = {
  src: 'https://webimages.mongodb.com/_com_assets/cms/ktir2qw25e1dt5hyb-payment_terminal.png?auto=format%252Ccompress',
  variant: ESingleImageVariant.SQUARE,
  bleed: true
};

var getPadding$1 = function getPadding$1(width, theme) {
  var tokens = getSelectedToken(theme);
  var breakpoint = tokens.sizing.breakpoint;
  var spacing = tokens.spacing;
  var cards = spacing.cards;

  if (width >= breakpoint.small && width < breakpoint.medium) {
    return spacing.inc70 + "px " + cards.paddingS + "px";
  }

  return spacing.inc60 + "px " + cards.paddingXXS + "px";
};

var StackedCard = function StackedCard(_a) {
  var className = _a.className,
      title = _a.title,
      subtitle = _a.subtitle,
      _b = _a.imageConfig,
      imageConfig = _b === void 0 ? defaultImageConfig$1 : _b,
      _c = _a.alignment,
      alignment = _c === void 0 ? 'center' : _c,
      width = _a.width,
      _d = _a.cta,
      cta = _d === void 0 ? {
    type: 'none',
    text: '',
    config: {}
  } : _d,
      _e = _a.theme,
      theme = _e === void 0 ? 'default' : _e,
      customCardWrapperStyles = _a.customCardWrapperStyles;
  var hasCTA = cta.type !== 'none';
  var padding = getPadding$1(width, theme);
  return jsxs(Card, _assign({
    className: className,
    direction: 'column',
    sx: _assign({
      padding: padding,
      alignItems: 'center',
      textAlign: 'center'
    }, customCardWrapperStyles)
  }, {
    children: [jsx("div", _assign({
      sx: {
        maxWidth: '292px',
        width: '100%'
      }
    }, {
      children: jsx(SingleImage, _assign({}, imageConfig), void 0)
    }), void 0), jsxs("div", _assign({
      sx: {
        textAlign: alignment
      }
    }, {
      children: [jsx(TypographyScale, _assign({
        variant: 'heading5',
        customStyles: {
          marginTop: 'inc40',
          fontWeight: '500'
        }
      }, {
        children: title
      }), void 0), jsx(TypographyScale, _assign({
        variant: 'body3',
        color: 'secondary',
        sx: {
          display: 'flex',
          marginTop: 'inc40',
          justifyContent: 'center'
        }
      }, {
        children: subtitle
      }), void 0)]
    }), void 0), hasCTA && jsx("div", _assign({
      sx: {
        marginTop: 'inc40',
        width: '100%'
      }
    }, {
      children: jsx(CardFooter, {
        cta: cta
      }, void 0)
    }), void 0)]
  }), void 0);
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


var getPadding = function getPadding(width, token) {
  var breakpoint = token.sizing.breakpoint;
  var spacing = token.spacing;
  var cards = token.spacing.cards;

  if (width >= breakpoint.medium && width < breakpoint.large) {
    return spacing.inc50 + "px " + cards.paddingXL + "px";
  }

  return spacing.inc130 + "px " + cards.paddingXXL + "px";
};

var DefaultCard = function DefaultCard(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      title = _a.title,
      subtitle = _a.subtitle,
      _c = _a.imageConfig,
      imageConfig = _c === void 0 ? defaultImageConfig$1 : _c,
      _d = _a.alignment,
      alignment = _d === void 0 ? 'center' : _d,
      width = _a.width,
      _e = _a.cta,
      cta = _e === void 0 ? {
    type: 'none',
    text: '',
    config: {}
  } : _e,
      _f = _a.theme,
      theme = _f === void 0 ? 'default' : _f,
      customCardWrapperStyles = _a.customCardWrapperStyles;
  var token = getSelectedToken(theme);
  var padding = getPadding(width, token);
  var imgSize = width < token.sizing.breakpoint.large ? 280 : 448;
  var bleedSize = (imageConfig === null || imageConfig === void 0 ? void 0 : imageConfig.bleed) ? 64 : 0;
  var hasCTA = cta.type !== 'none';
  return jsxs(Card, _assign({
    sx: _assign({}, customCardWrapperStyles),
    className: className
  }, {
    children: [jsxs("div", _assign({
      sx: {
        padding: padding,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: 'inc40',
        flexGrow: 1,
        alignItems: alignment === 'left' ? 'flex-start' : 'center',
        textAlign: alignment
      }
    }, {
      children: [jsx(TypographyScale, _assign({
        variant: 'heading5',
        customStyles: {
          fontWeight: '500'
        }
      }, {
        children: title
      }), void 0), jsx(TypographyScale, _assign({
        color: 'secondary',
        variant: 'body3'
      }, {
        children: subtitle
      }), void 0), hasCTA && jsx(CardFooter, {
        cta: cta
      }, void 0)]
    }), void 0), jsx("div", _assign({
      sx: {
        maxHeight: imgSize + bleedSize + "px",
        maxWidth: imgSize + "px",
        width: '100%',
        marginTop: -bleedSize + "px",
        marginRight: 'inc80',
        div: {
          display: 'flex',
          height: '100%',
          borderBottomRightRadius: 'inc50'
        }
      }
    }, {
      children: jsx(SingleImage, _assign({}, imageConfig), void 0)
    }), void 0)]
  }), void 0);
};

var getCardLayout = function getCardLayout(width) {
  return width < sizing$1.breakpoint.medium ? StackedCard : DefaultCard;
};

var getSelectedTheme$1 = function getSelectedTheme$1(theme) {
  if (theme === void 0) {
    theme = 'default';
  }

  return theme === 'legacy' ? legacyTheme : defaultTheme;
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


var getSelectedToken = function getSelectedToken(theme) {
  if (theme === void 0) {
    theme = 'default';
  }

  return theme === 'legacy' ? legacyTokens : defaultTokens;
};

var FeaturedCard = function FeaturedCard(props) {
  var _a, _b, _c;

  var cta = props.cta;
  var hasCTA = (cta === null || cta === void 0 ? void 0 : cta.type) !== 'none';
  var isLink = hasCTA && (cta === null || cta === void 0 ? void 0 : cta.type) !== 'button';
  var isClickable = isLink && !['', '#'].includes(((_a = cta === null || cta === void 0 ? void 0 : cta.config) === null || _a === void 0 ? void 0 : _a.href) || '');
  var ref = useRef(null);
  var width = useDimension(ref).width;
  var CardLayout = getCardLayout(width);
  var TagName = isClickable ? 'a' : 'div';
  return jsx(ThemeProvider, _assign({
    theme: getSelectedTheme$1(props.theme)
  }, {
    children: jsx("div", _assign({
      sx: _assign({
        width: '100%'
      }, props.customWrapperStyles),
      ref: ref
    }, {
      children: jsx(TagName, _assign({
        href: isClickable ? (_b = cta === null || cta === void 0 ? void 0 : cta.config) === null || _b === void 0 ? void 0 : _b.href : undefined,
        target: isClickable ? (_c = cta === null || cta === void 0 ? void 0 : cta.config) === null || _c === void 0 ? void 0 : _c.target : undefined,
        sx: {
          color: 'inherit',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'none'
          },
          width: '100%',
          height: '100%'
        }
      }, {
        children: jsx(CardLayout, _assign({}, props, {
          width: width
        }), void 0)
      }), void 0)
    }), void 0)
  }), void 0);
};

var defaultImageConfig = {
  src: 'https://webimages.mongodb.com/_com_assets/cms/kufhp8s27alno4hjr-Cluster%20Chart.png?auto=format%252Ccompress',
  variant: ESingleImageVariant.NO_RATIO
};
var defaultListConfig = {
  items: ['Take the difficulty out of data.', 'Fit any workload with a single, flexible API and architecture.', 'Automate repetitive (but vital) tasks.']
};
var cardWidthBreakpoints = {
  large: 927,
  medium: 622,
  small: 462,
  xsmall: 320
};

var widthToCardSize = function widthToCardSize(width) {
  var large = cardWidthBreakpoints.large,
      medium = cardWidthBreakpoints.medium,
      small = cardWidthBreakpoints.small,
      xsmall = cardWidthBreakpoints.xsmall;
  if (width >= large) return 'large';
  if (width >= medium) return 'medium';
  if (width >= small) return 'small';
  if (width >= xsmall) return 'xsmall';
  return 'xxsmall';
};

var getFlexWrap = function getFlexWrap(width) {
  var cardWidth = widthToCardSize(width);
  return cardWidth === 'xsmall' || cardWidth === 'xxsmall' ? 'wrap' : 'nowrap';
};

var getContentWrapperMaxWidth = function getContentWrapperMaxWidth(width, hasImage) {
  var commonMaxWidth = hasImage ? '50%' : '100%';
  var ContentWrapperMaxWidth = {
    large: commonMaxWidth,
    medium: commonMaxWidth,
    small: commonMaxWidth,
    xsmall: '100%',
    xxsmall: '100%'
  };
  var cardSize = widthToCardSize(width);
  return ContentWrapperMaxWidth[cardSize];
};

var getImageWrapperResponsiveStyles = function getImageWrapperResponsiveStyles(width, imageWidth) {
  // the marginRight calc will handle how much of the image will be cut off based on card width
  var ImageWrapperStyles = {
    large: {
      maxWidth: '734px',
      marginRight: -(imageWidth / 3)
    },
    medium: {
      maxWidth: '600px',
      marginRight: -(imageWidth / 2)
    },
    small: {
      maxWidth: '600px',
      marginRight: -(imageWidth / 3) * 2
    },
    xsmall: {
      minWidth: '300%',
      marginRight: -(imageWidth / 4)
    },
    xxsmall: {
      minWidth: '300%',
      marginRight: -(imageWidth / 4)
    }
  };
  var cardSize = widthToCardSize(width);
  return ImageWrapperStyles[cardSize];
};

var getListWrapperResponsiveStyles = function getListWrapperResponsiveStyles(width) {
  var ListWrapperStyles = {
    large: {
      width: '50%',
      borderLeft: "1px solid " + defaultTheme.colors.black30,
      paddingLeft: 'inc90'
    },
    medium: {
      width: '50%',
      borderLeft: "1px solid " + defaultTheme.colors.black30,
      paddingLeft: 'inc50'
    },
    small: {
      width: '50%',
      paddingLeft: 'inc50',
      borderLeft: "1px solid " + defaultTheme.colors.black30
    },
    xsmall: {
      width: '100%',
      paddingLeft: undefined
    },
    xxsmall: {
      width: '100%',
      paddingLeft: undefined
    }
  };
  var cardSize = widthToCardSize(width);
  return ListWrapperStyles[cardSize];
};

var getBackgroundStyles = function getBackgroundStyles(background, inverse) {
  if (background) {
    return inverse ? 'card.inverse.bg' : 'card.default.bg';
  }

  return 'transparent';
};

var getBorderStyles = function getBorderStyles(background, inverse) {
  return {
    borderStyle: 'solid',
    borderWidth: background ? '1px' : '0',
    borderColor: inverse ? 'card.inverse.border' : 'card.default.border',
    borderRadius: 'card'
  };
};

var MainContent = function MainContent(_a) {
  var _b = _a.inverse,
      inverse = _b === void 0 ? false : _b,
      _c = _a.theme,
      theme = _c === void 0 ? 'default' : _c,
      title = _a.title,
      eyebrow = _a.eyebrow,
      description = _a.description,
      _d = _a.iconConfig,
      iconConfig = _d === void 0 ? {} : _d,
      _e = _a.hasImage,
      hasImage = _e === void 0 ? false : _e,
      _f = _a.cardWidth,
      cardWidth = _f === void 0 ? cardWidthBreakpoints.large : _f,
      _g = _a.cta,
      cta = _g === void 0 ? {
    type: 'none',
    text: '',
    config: {}
  } : _g;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var hasCTA = cta.type !== 'none';
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsxs("div", _assign({
      "aria-label": 'content-container',
      sx: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        gap: ['inc100', null, null, 'inc110'],
        maxWidth: getContentWrapperMaxWidth(cardWidth, hasImage)
      }
    }, {
      children: [iconConfig.name && jsx(BrandedIcon, {
        name: iconConfig.name,
        size: iconConfig.size || 'medium',
        inverse: inverse
      }, void 0), jsxs("div", _assign({
        sx: {
          display: 'flex',
          flexGrow: 1,
          flexDirection: 'column',
          justifyContent: 'space-between',
          gap: 'colGapMedium'
        }
      }, {
        children: [jsxs("div", _assign({
          sx: {
            display: 'inherit',
            flexDirection: 'inherit',
            gap: 'colGapMedium'
          }
        }, {
          children: [jsx(TypographyScale, _assign({
            variant: 'mono3',
            sx: {
              textTransform: 'uppercase'
            },
            inverse: inverse,
            customElement: 'h5'
          }, {
            children: jsx(Mark, _assign({
              inverse: inverse
            }, {
              children: eyebrow
            }), void 0)
          }), void 0), jsx(TypographyScale, _assign({
            sx: {
              wordBreak: 'break-word'
            },
            variant: 'heading5',
            inverse: inverse
          }, {
            children: title
          }), void 0), jsx(TypographyScale, _assign({
            sx: {
              wordBreak: 'break-word'
            },
            variant: 'body1',
            color: 'secondary',
            inverse: inverse
          }, {
            children: description
          }), void 0)]
        }), void 0), hasCTA && jsx(CardFooter, {
          inverse: inverse,
          cta: cta,
          theme: selectedTheme
        }, void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
};

var MasonryCard = function MasonryCard(_a) {
  var _b, _c, _d;

  var _e = _a.variant,
      variant = _e === void 0 ? 'default' : _e,
      _f = _a.className,
      className = _f === void 0 ? '' : _f,
      customWrapperStyles = _a.customWrapperStyles,
      _g = _a.inverse,
      inverse = _g === void 0 ? false : _g,
      _h = _a.theme,
      theme = _h === void 0 ? 'default' : _h,
      _j = _a.background,
      background = _j === void 0 ? true : _j,
      title = _a.title,
      eyebrow = _a.eyebrow,
      description = _a.description,
      _k = _a.iconConfig,
      iconConfig = _k === void 0 ? {
    name: ''
  } : _k,
      _l = _a.imageConfig,
      imageConfig = _l === void 0 ? {} : _l,
      _m = _a.listConfig,
      listConfig = _m === void 0 ? {} : _m,
      _o = _a.cta,
      cta = _o === void 0 ? {
    type: 'none',
    text: '',
    config: {}
  } : _o;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var hasImage = !!imageConfig.src;
  var hasCTA = cta.type !== 'none';
  var isLink = hasCTA && cta.type !== 'button';
  var isClickable = isLink && !['', '#'].includes(((_b = cta === null || cta === void 0 ? void 0 : cta.config) === null || _b === void 0 ? void 0 : _b.href) || '');
  var isListVariant = variant === 'list';
  var cardWrapperRef = useRef(null);
  var imageWrapperRef = useRef(null);
  var cardWidth = useDimension(cardWrapperRef).width;
  var imageWidth = useDimension(imageWrapperRef).width;
  var mainContentProps = {
    inverse: inverse,
    title: title,
    eyebrow: eyebrow,
    description: description,
    iconConfig: iconConfig,
    cta: cta,
    cardWidth: cardWidth,
    hasImage: hasImage
  };
  var TagName = isClickable ? 'a' : 'div';
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("div", _assign({
      ref: cardWrapperRef,
      sx: _assign({}, customWrapperStyles)
    }, {
      children: jsxs(TagName, _assign({
        href: isClickable ? (_c = cta.config) === null || _c === void 0 ? void 0 : _c.href : undefined,
        target: isClickable ? (_d = cta.config) === null || _d === void 0 ? void 0 : _d.target : undefined,
        className: className,
        sx: _assign({
          color: 'inherit',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'none'
          },
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          height: '100%',
          overflow: 'hidden',
          gap: ['inc40', 'inc40', 'inc50', 'inc50'],
          alignContent: 'space-between',
          boxShadow: background ? 'level01' : 'none',
          padding: ['cards.paddingXXS', 'cards.paddingXS', 'cards.paddingS', 'cards.paddingM', 'cards.paddingL'],
          backgroundColor: getBackgroundStyles(background, inverse),
          flexWrap: getFlexWrap(cardWidth)
        }, getBorderStyles(background, inverse))
      }, {
        children: [jsx(MainContent, _assign({}, mainContentProps), void 0), !isListVariant && imageConfig.src && jsx("div", _assign({
          "aria-label": 'image-container',
          sx: {
            width: '50%',
            display: 'flex'
          }
        }, {
          children: jsx("div", _assign({
            ref: imageWrapperRef,
            sx: _assign({
              display: 'flex',
              flexGrow: 1,
              flexDirection: 'column',
              justifyContent: 'center'
            }, getImageWrapperResponsiveStyles(cardWidth, imageWidth))
          }, {
            children: jsx(SingleImage, {
              lazyLoad: imageConfig.lazyLoad,
              src: imageConfig.src,
              altText: imageConfig.altText,
              variant: imageConfig.variant || defaultImageConfig.variant
            }, void 0)
          }), void 0)
        }), void 0), isListVariant && jsx("div", _assign({
          "data-testid": 'list-wrapper',
          sx: _assign({
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }, getListWrapperResponsiveStyles(cardWidth))
        }, {
          children: jsx(List, {
            inverse: inverse,
            items: listConfig.items || defaultListConfig.items
          }, void 0)
        }), void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
};

var getBorderColor = function getBorderColor(inverse) {
  return inverse ? defaultTheme.colors.card.inverse.borderLighter : defaultTheme.colors.card.inverse.border;
};

var getBgColor = function getBgColor(inverse) {
  return inverse ? defaultTheme.colors.card.inverse.bg : defaultTheme.colors.card.default.bg;
};

var getPaddingBottom = function getPaddingBottom(ctaType) {
  if (ctaType === 'none' || ctaType === undefined) return '32px';
  return '12px';
};

var addMarginTop = function addMarginTop(showBrandedIcon, selectedTheme) {
  if (!showBrandedIcon) return '0';
  return [selectedTheme['space'].inc60, selectedTheme['space'].inc60, selectedTheme['space'].inc60, selectedTheme['space'].inc80];
};

var ScrollyStoryCard = function ScrollyStoryCard(_a) {
  var _b, _c, _d;

  var _e = _a.className,
      className = _e === void 0 ? '' : _e,
      _f = _a.theme,
      theme = _f === void 0 ? 'default' : _f,
      _g = _a.inverse,
      inverse = _g === void 0 ? false : _g,
      _h = _a.variant,
      variant = _h === void 0 ? 'body1' : _h,
      title = _a.title,
      _j = _a.showBrandedIcon,
      showBrandedIcon = _j === void 0 ? true : _j,
      _k = _a.brandedIconName,
      brandedIconName = _k === void 0 ? 'mdb_backup' : _k,
      _l = _a.cta,
      cta = _l === void 0 ? {
    type: 'none',
    text: '',
    config: {}
  } : _l;
  var selectedTheme = theme === 'legacy' ? legacyTheme : defaultTheme;
  var hasCTA = cta.type !== 'none';
  var isClickable = hasCTA && !['', '#'].includes(((_b = cta === null || cta === void 0 ? void 0 : cta.config) === null || _b === void 0 ? void 0 : _b.href) || '');
  var footerProps = {
    inverse: inverse,
    cta: cta
  };
  var TagName = isClickable ? 'a' : 'div';
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx(Panel, _assign({
      gridColumn: ['span 3', 'span 3', 'span 2', 'span 2'],
      className: className,
      borderColor: getBorderColor(inverse),
      bgColor: getBgColor(inverse),
      sx: {
        position: 'relative',
        height: '100%'
      }
    }, {
      children: jsxs(TagName, _assign({
        href: isClickable ? (_c = cta.config) === null || _c === void 0 ? void 0 : _c.href : undefined,
        target: isClickable ? (_d = cta.config) === null || _d === void 0 ? void 0 : _d.target : undefined,
        sx: {
          color: 'inherit',
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'none'
          },
          paddingTop: 'inc50',
          paddingLeft: ['inc40', null, null, 'inc50'],
          paddingRight: ['inc40', null, null, 'inc50'],
          paddingBottom: getPaddingBottom(cta.type),
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexDirection: 'column',
          flexWrap: 'wrap',
          height: '100%',
          wordBreak: 'break-word',
          boxSizing: 'border-box'
        }
      }, {
        children: [showBrandedIcon && jsx(BrandedIcon, {
          "data-testid": 'branded-icon',
          inverse: inverse,
          name: brandedIconName,
          size: 'small'
        }, void 0), jsxs("div", _assign({
          sx: {
            marginTop: addMarginTop(showBrandedIcon, selectedTheme),
            display: 'flex',
            flexDirection: 'column'
          }
        }, {
          children: [title && jsx(TypographyScale, _assign({
            "aria-label": 'text-content',
            inverse: inverse,
            variant: variant
          }, {
            children: title
          }), void 0), hasCTA && jsx(CardFooter, _assign({}, footerProps), void 0)]
        }), void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
};

var exampleLinks = [{
  href: '#',
  text: 'Current releases & packages'
}, {
  href: '#',
  text: 'Documentation'
}];

var MenuButton = function MenuButton(_a) {
  var _b = _a.children,
      children = _b === void 0 ? 'More Options' : _b,
      _c = _a.links,
      links = _c === void 0 ? exampleLinks : _c,
      onClick = _a.onClick,
      customStyles = _a.customStyles;

  var _d = useState(false),
      isOpen = _d[0],
      setIsOpen = _d[1];

  var toggleIsOpen = function toggleIsOpen() {
    setIsOpen(!isOpen);
  };

  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs("div", _assign({
      sx: {
        position: 'relative'
      }
    }, {
      children: [jsx(Link, _assign({
        linkIcon: ESystemIconNames.MEATBALLS,
        onClick: toggleIsOpen
      }, {
        children: children
      }), void 0), jsx("div", _assign({
        "aria-label": 'menu-panel',
        sx: _assign({
          display: isOpen ? 'flex' : 'none',
          top: 0,
          left: 0,
          width: ['327px', null, null, '336px'],
          position: 'absolute'
        }, customStyles)
      }, {
        children: jsxs(Panel, _assign({
          boxShadow: 'level03',
          sx: {
            width: '100%',
            position: 'relative',
            borderRadius: 'inc30'
          }
        }, {
          children: [jsx("button", _assign({
            onClick: toggleIsOpen,
            sx: {
              display: ['flex', null, null, 'none'],
              border: 'none',
              bg: 'panels.default.bg',
              position: 'absolute',
              top: 28,
              right: 28,
              cursor: 'pointer'
            }
          }, {
            children: jsx(SystemIcon, {
              strokeWeight: 'medium',
              name: ESystemIconNames.CLOSE
            }, void 0)
          }), void 0), jsx("div", _assign({
            sx: {
              paddingTop: 'inc80',
              paddingBottom: 'inc50',
              paddingLeft: 'inc50'
            }
          }, {
            children: links.map(function (_a) {
              var href = _a.href,
                  text = _a.text,
                  target = _a.target;
              return jsx("div", _assign({
                sx: {
                  paddingBottom: 8
                }
              }, {
                children: jsx(Link, _assign({
                  href: href,
                  target: target,
                  onClick: onClick && function () {
                    return onClick({
                      href: href,
                      text: text,
                      target: target
                    });
                  }
                }, {
                  children: text
                }), void 0)
              }), text);
            })
          }), void 0)]
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0);
};

var Content$1 = function Content$1(_a) {
  var brandedIconName = _a.brandedIconName,
      eyebrow = _a.eyebrow,
      header = _a.header,
      body = _a.body,
      _b = _a.cta,
      cta = _b === void 0 ? {} : _b;
  return jsxs(Fragment, {
    children: [brandedIconName && jsx(BrandedIcon, {
      className: brandedIconName,
      name: brandedIconName,
      customStyles: {
        marginBottom: [defaultTheme.space.inc50, null, null, defaultTheme.space.inc70],
        width: defaultTheme.sizes.inc60,
        height: defaultTheme.sizes.inc50
      }
    }, void 0), eyebrow && jsx(Eyebrow, _assign({
      customStyles: {
        fontSize: defaultTheme.fontSizes.inc10,
        marginBottom: defaultTheme.space.inc40,
        opacity: defaultTheme.opacity.inc80
      }
    }, {
      children: eyebrow
    }), void 0), header && jsx(TypographyScale, _assign({
      variant: 'heading5',
      customStyles: {
        marginBottom: defaultTheme.space.inc40,
        fontWeight: 500
      }
    }, {
      children: header
    }), void 0), body && jsx(TypographyScale, _assign({
      variant: 'body3',
      sx: {
        marginBottom: [defaultTheme.space.inc40, null, null, defaultTheme.space.inc60],
        color: defaultTheme.colors.green80,
        opacity: defaultTheme.opacity.inc80
      }
    }, {
      children: body
    }), void 0), cta.type && cta.text && jsx(Link, _assign({
      variant: ELinkVariant.SMALL,
      linkIcon: cta === null || cta === void 0 ? void 0 : cta.type,
      href: cta === null || cta === void 0 ? void 0 : cta.href,
      target: cta === null || cta === void 0 ? void 0 : cta.target,
      sx: {
        marginBottom: defaultTheme.space.inc60
      }
    }, {
      children: cta === null || cta === void 0 ? void 0 : cta.text
    }), void 0)]
  }, void 0);
};

var localeSort = function localeSort(arr, locales, options) {
  if (locales === void 0) {
    locales = undefined;
  }

  if (options === void 0) {
    options = undefined;
  }

  return arr.sort(function (a, b) {
    return a.toLowerCase().localeCompare(b.toLowerCase(), locales, options);
  });
};

var getCurrent = function getCurrent(product, versions) {
  for (var _i = 0, versions_1 = versions; _i < versions_1.length; _i++) {
    var version = versions_1[_i];
    var _a = product[version].meta,
        meta = _a === void 0 ? {} : _a;

    if (meta.current) {
      return version;
    }
  }

  return versions[0];
};

var getVersionOptions = function getVersionOptions(product, versions) {
  var options = versions.map(function (version) {
    var _a = product[version].meta,
        meta = _a === void 0 ? {} : _a;
    var text = version;

    if (meta.developmentRelease) {
      text = text + " (development)";
    } else if (meta.releaseCandidate) {
      text = text + " (release candidate)";
    } else if (meta.current) {
      text = text + " (current)";
    }

    return {
      text: text,
      value: version
    };
  });
  return options;
};

var getPlatformMatch = function getPlatformMatch() {
  if (typeof navigator === 'undefined') return;
  var appVersion = navigator.appVersion;
  if (appVersion.includes('Win')) return /win/gi;
  if (appVersion.includes('Mac')) return /mac|os x/gi;
  if (appVersion.includes('Linux')) return /ubuntu|debian|redhat|suse|linux/gi;
};

var detectPlatform = function detectPlatform(platforms) {
  var match = getPlatformMatch();

  if (match) {
    return platforms.find(function (platform) {
      return match.test(platform);
    });
  }

  return platforms[0];
};

var bubbleUserPlatform = function bubbleUserPlatform(platforms) {
  var match = getPlatformMatch();
  if (!match) return platforms;
  return platforms.sort(function (a, b) {
    var matchA = match.test(a);
    var matchB = match.test(b);
    if (matchB && !matchA) return +1;
    if (matchA && !matchB) return -1;
    return 0;
  });
};

var createOpts = function createOpts(product) {
  var versions = Object.keys(product);
  return function (config) {
    var _a, _b;

    if (config === void 0) {
      config = {};
    }

    var _c = config.version,
        version = _c === void 0 ? getCurrent(product, versions) : _c,
        _d = config.platforms,
        platforms = _d === void 0 ? (product[version] || {}).sortedPlatforms || Object.keys((product[version] || {}).platforms || {}) : _d,
        _e = config.platform,
        platform = _e === void 0 ? platforms[0] : _e,
        _f = config.packages,
        packages = _f === void 0 ? Object.keys((product[version] || {}).platforms[platform] || {}) : _f,
        _g = config.pkg,
        pkg = _g === void 0 ? packages[0] : _g,
        _h = config.url,
        url = _h === void 0 ? product[version].platforms[platform][pkg] : _h,
        _j = config.userWarning,
        userWarning = _j === void 0 ? (_a = product[version].meta) === null || _a === void 0 ? void 0 : _a.userWarning : _j,
        _k = config.externalLinkText,
        externalLinkText = _k === void 0 ? (_b = product[version].meta) === null || _b === void 0 ? void 0 : _b.externalLinkText : _k;
    return {
      versions: versions,
      version: version,
      platforms: bubbleUserPlatform(platforms),
      platform: platform,
      packages: localeSort(packages),
      pkg: pkg,
      url: url,
      userWarning: userWarning,
      externalLinkText: externalLinkText
    };
  };
};

var SelectFields = function SelectFields(_a) {
  var product = _a.product,
      hasIcon = _a.hasIcon,
      trackingEvents = _a.trackingEvents,
      menuButton = _a.menuButton,
      downloadCta = _a.downloadCta;
  var opts = createOpts(product);

  var _b = useState(opts()),
      options = _b[0],
      setOptions = _b[1];

  var _c = useState(options.version || ''),
      newVersion = _c[0],
      setNewVersion = _c[1];

  var _d = useState(detectPlatform(options.platforms) || options.platforms[0]),
      newPlatform = _d[0],
      setNewPlatform = _d[1];

  var tempPkgs = Object.keys((product[newVersion] || {}).platforms[newPlatform] || {});

  var _e = useState(tempPkgs[0] || ''),
      newPkg = _e[0],
      setNewPkg = _e[1];

  var isExternalLink = Boolean(options.externalLinkText && options.packages.includes('externalLink'));

  var removeReleaseTxt = function removeReleaseTxt(version) {
    var cleanVersion = version.slice();

    if (version.includes('(development)')) {
      cleanVersion = version.slice(0, -14);
    } else if (version.includes('(release candidate)')) {
      cleanVersion = version.slice(0, -20);
    } else if (version.includes('(current)')) {
      cleanVersion = version.slice(0, -10);
    }

    return cleanVersion;
  };

  useEffect(function () {
    var currentVersion = options.version;
    if (newVersion === currentVersion) return;
    setOptions(opts({
      version: newVersion,
      platform: detectPlatform(Object.keys(product[newVersion].platforms))
    }));
  }, [newVersion]);
  useEffect(function () {
    var currentPlatform = options.platform;
    if (newPlatform === currentPlatform) return;
    setOptions(opts({
      version: options.version,
      platform: newPlatform
    }));
  }, [newPlatform]);
  useEffect(function () {
    var currentPkg = options.pkg;
    if (newPkg === currentPkg) return;
    setOptions(opts({
      version: newVersion,
      platform: newPlatform,
      pkg: newPkg
    }));
  }, [newPkg]); // versions are an object: {text: '5.0.5 (current)', value: '5.0.5'}
  // the component uses value as lookup, and text to display in the Select dropdown

  var versionOpts = getVersionOptions(product, options.versions);
  var versionItem = versionOpts.find(function (v) {
    return v['value'] === options.version;
  });
  var versionOptsTxt = versionOpts.map(function (v) {
    return v['text'];
  });

  var handleDownloadClick = function handleDownloadClick() {
    if (trackingEvents) {
      trackingEvents();
    }

    if (isExternalLink && (options === null || options === void 0 ? void 0 : options.url)) {
      window.open(options.url);
      return;
    } // final options to return on click
    // gate or download
    // console.log(options)

  };

  var downloadBtnText = function downloadBtnText() {
    var text = 'Download';

    if (isExternalLink && (options === null || options === void 0 ? void 0 : options.externalLinkText)) {
      text = options.externalLinkText;
    } else if (!options && (downloadCta === null || downloadCta === void 0 ? void 0 : downloadCta.text)) {
      text = downloadCta.text;
    }

    return text;
  };

  return jsxs(Fragment, {
    children: [jsx(Select, {
      id: 'download-version',
      name: 'version',
      label: 'Version',
      options: versionOptsTxt,
      width: '100%',
      value: versionItem === null || versionItem === void 0 ? void 0 : versionItem.text,
      onSelect: function onSelect(version) {
        return setNewVersion(removeReleaseTxt(version));
      },
      sx: {
        marginBottom: defaultTheme.space.inc40
      }
    }, void 0), options.platform !== 'all' && jsx(Select, {
      id: 'download-platform',
      name: 'platform',
      label: 'Platform',
      options: options.platforms,
      width: '100%',
      value: options.platform,
      onSelect: function onSelect(platform) {
        return setNewPlatform(platform);
      },
      sx: {
        marginBottom: defaultTheme.space.inc40
      }
    }, void 0), !isExternalLink && jsx(Select, {
      id: 'download-package',
      name: 'package',
      label: 'Package',
      options: options.packages,
      width: '100%',
      value: options.pkg,
      onSelect: function onSelect(pkg) {
        return setNewPkg(pkg);
      },
      sx: {
        marginBottom: defaultTheme.space.inc40
      }
    }, void 0), jsxs("div", _assign({
      sx: {
        display: 'flex',
        flexDirection: ['column', null, null, 'row'],
        justifyContent: [null, null, null, 'space-between'],
        alignItems: 'baseline',
        marginTop: options && defaultTheme.space.inc30,
        marginBottom: [0, null, null, defaultTheme.space.inc60]
      }
    }, {
      children: [jsx(Button, _assign({
        hasIcon: isExternalLink ? false : hasIcon,
        iconName: ESystemIconNames.DOWNLOAD,
        iconPosition: 'right',
        onClick: handleDownloadClick,
        href: downloadCta.href,
        target: downloadCta.target,
        customStyles: {
          marginBottom: [defaultTheme.space.inc60, null, null, 0],
          width: ['198px', null, '198px', '208px'],
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, {
        children: downloadBtnText()
      }), void 0), jsx(MenuButton, _assign({
        links: menuButton.links,
        customStyles: {
          top: ['-30px', 0, null, '45px'],
          left: [0, null, null, 'unset'],
          right: [0, null, null, null]
        }
      }, {
        children: menuButton.text
      }), void 0)]
    }), void 0)]
  }, void 0);
};

var DownloadItem = function DownloadItem(_a) {
  var _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.hasIcon,
      hasIcon = _c === void 0 ? false : _c,
      _d = _a.brandedIconName,
      brandedIconName = _d === void 0 ? 'mdb_backup' : _d,
      _e = _a.eyebrow,
      eyebrow = _e === void 0 ? '' : _e,
      _f = _a.header,
      header = _f === void 0 ? '' : _f,
      _g = _a.body,
      body = _g === void 0 ? '' : _g,
      _h = _a.cta,
      cta = _h === void 0 ? {
    type: 'chevron',
    text: '',
    href: '',
    target: '_blank'
  } : _h,
      _j = _a.downloadCta,
      downloadCta = _j === void 0 ? {
    text: '',
    href: '',
    target: '_blank'
  } : _j,
      _k = _a.menuButton,
      menuButton = _k === void 0 ? {
    text: '',
    links: []
  } : _k,
      _l = _a.product,
      product = _l === void 0 ? {} : _l,
      trackingEvents = _a.trackingEvents,
      customStyles = _a.customStyles;
  var hasProductData = Boolean(Object.keys(product).length);
  var contentProps = {
    brandedIconName: brandedIconName,
    eyebrow: eyebrow,
    header: header,
    body: body,
    cta: cta
  };
  var paddingVals = {
    mobile: null,
    tablet: defaultTheme.space.inc60,
    desktop: "\n            " + defaultTheme.space.inc90 + "\n            " + defaultTheme.space.inc160 + "\n            " + defaultTheme.space.inc90 + "\n            " + defaultTheme.space.inc160 + "\n        "
  };

  var handleDownloadClick = function handleDownloadClick() {
    if (trackingEvents) {
      trackingEvents();
    }
  };

  var downloadBtnText = function downloadBtnText() {
    var text = 'Download';

    if (downloadCta && (downloadCta === null || downloadCta === void 0 ? void 0 : downloadCta.text)) {
      text = downloadCta.text;
    }

    return text;
  };

  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs("div", _assign({
      className: className,
      sx: _assign({
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        maxWidth: ['327px', null, '431px', '816px'],
        padding: [paddingVals.mobile, null, paddingVals.tablet, paddingVals.desktop],
        margin: ['0 auto', 'unset', null, null]
      }, customStyles)
    }, {
      children: [jsx(Content$1, _assign({}, contentProps), void 0), hasProductData && jsx(SelectFields, {
        product: product,
        hasIcon: hasIcon,
        trackingEvents: trackingEvents,
        downloadCta: downloadCta,
        menuButton: menuButton
      }, void 0), !hasProductData && jsxs("div", _assign({
        sx: {
          display: 'flex',
          flexDirection: ['column', null, null, 'row'],
          justifyContent: [null, null, null, 'space-between'],
          alignItems: 'baseline',
          marginBottom: [0, null, null, defaultTheme.space.inc60]
        }
      }, {
        children: [jsx(Button, _assign({
          hasIcon: downloadCta && downloadCta.href ? hasIcon : false,
          iconName: ESystemIconNames.DOWNLOAD,
          iconPosition: 'right',
          onClick: handleDownloadClick,
          href: downloadCta.href,
          target: downloadCta.target,
          customStyles: {
            marginBottom: [defaultTheme.space.inc60, null, null, 0],
            width: ['198px', null, '198px', '208px'],
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }
        }, {
          children: downloadBtnText()
        }), void 0), jsx(MenuButton, _assign({
          links: menuButton.links,
          customStyles: {
            top: ['-30px', 0, null, '45px'],
            left: [0, null, null, 'unset'],
            right: [0, null, null, null]
          }
        }, {
          children: menuButton.text
        }), void 0)]
      }), void 0)]
    }), void 0)
  }), void 0);
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


var getSelectedTheme = function getSelectedTheme(theme) {
  if (theme === void 0) {
    theme = 'default';
  }

  return theme === 'default' ? defaultTheme : legacyTheme;
};

var findSelectedItem = function findSelectedItem(_a) {
  var currentUrl = _a.currentUrl,
      items = _a.items;
  var selectedItem = null;

  var find = function find(item, index, subItemIndex) {
    if (item.url === currentUrl) {
      selectedItem = {
        index: index,
        title: item.title,
        url: item.url,
        subItemIndex: subItemIndex
      };
      return true;
    }

    return false;
  };

  items.some(function (item, index) {
    var _a;

    var result = find(item, index);

    if (!result) {
      return ((_a = item.subItems) === null || _a === void 0 ? void 0 : _a.some(function (subItem, subItemIndex) {
        return find(subItem, index, subItemIndex);
      })) || false;
    }

    return result;
  });
  return selectedItem;
};

var NavItem = function NavItem(_a) {
  var index = _a.index,
      item = _a.item,
      _b = _a.theme,
      theme = _b === void 0 ? 'default' : _b,
      inverse = _a.inverse,
      subItem = _a.subItem,
      active = _a.active,
      redirect = _a.redirect,
      _c = _a.onClick,
      onClick = _c === void 0 ? function () {} : _c;
  var colors = getSelectedTheme(theme).colors;
  var url = item.url,
      title = item.title,
      icon = item.icon;

  var getBorderColor = function getBorderColor() {
    if (inverse) {
      return active ? colors.black00 : colors.green70;
    }

    return active ? colors.green60 : colors.black20;
  };

  var getColor = function getColor() {
    if (inverse) {
      return active ? 'default' : subItem ? 'secondary' : 'selected';
    }

    return active ? 'default' : subItem ? 'neutral' : 'mark';
  };

  var handleClick = function handleClick(e) {
    e.stopPropagation();
    onClick({
      item: item,
      index: index
    });
  };

  var Element = url && redirect ? 'a' : 'div';
  return jsxs(Element, _assign({
    "data-testid": item.title,
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 'inc30',
      borderLeftWidth: ['4px', null, '2px'],
      borderLeftStyle: 'solid',
      borderLeftColor: ['transparent', null, getBorderColor()],
      paddingTop: 'inc30',
      paddingBottom: 'inc30',
      paddingLeft: ['inc40', null, null, 'inc60'],
      paddingRight: ['inc40', null, null, 'inc60'],
      textDecoration: 'none',
      background: inverse ? colors.blue80 : colors.black00,
      '&:hover': {
        cursor: 'pointer',
        textDecoration: 'none'
      }
    },
    href: url || undefined,
    onClick: handleClick
  }, {
    children: [jsx(TypographyScale, _assign({
      inverse: inverse,
      color: getColor(),
      variant: 'body3',
      customStyles: {
        fontWeight: active ? '700' : '400'
      }
    }, {
      children: title
    }), void 0), icon && icon]
  }), void 0);
};

var Collapse = function Collapse(_a) {
  var open = _a.open,
      children = _a.children;

  var _b = useState('0'),
      maxHeight = _b[0],
      setMaxHeight = _b[1];

  useEffect(function () {
    setMaxHeight(open ? '100vh' : '0');
  }, [open]);
  return jsx("div", _assign({
    sx: {
      overflow: 'hidden',
      maxHeight: maxHeight,
      transition: 'max-height 0.5s ease'
    }
  }, {
    children: children
  }), void 0);
};

var SubItems = function SubItems(_a) {
  var theme = _a.theme,
      items = _a.items,
      parentIndex = _a.parentIndex,
      selectedItem = _a.selectedItem,
      redirect = _a.redirect,
      inverse = _a.inverse,
      _b = _a.onClickItem,
      onClickItem = _b === void 0 ? function () {} : _b;
  return React.createElement(Collapse, {
    open: parentIndex === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.index)
  }, items.map(function (item, index) {
    return React.createElement(NavItem, _assign({
      key: index
    }, {
      index: parentIndex,
      theme: theme,
      subItem: true,
      redirect: redirect,
      active: index === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.subItemIndex),
      inverse: inverse,
      item: item,
      onClick: function onClick(item) {
        return onClickItem(_assign(_assign({}, item), {
          subItemIndex: index
        }));
      }
    }));
  }));
};

var Content = function Content(_a) {
  var items = _a.items,
      theme = _a.theme,
      selectedItem = _a.selectedItem,
      inverse = _a.inverse,
      redirect = _a.redirect,
      _b = _a.onClickItem,
      onClickItem = _b === void 0 ? function () {} : _b;
  return React.createElement("div", {
    "data-testid": 'nav-content'
  }, items.map(function (item, index) {
    return React.createElement("div", {
      key: index
    }, React.createElement(NavItem, _assign({}, {
      active: index === (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.index) && selectedItem.subItemIndex === undefined,
      theme: theme,
      redirect: redirect,
      index: index,
      inverse: inverse,
      item: item,
      onClick: onClickItem
    })), (item === null || item === void 0 ? void 0 : item.subItems) && React.createElement(SubItems, _assign({}, {
      theme: theme,
      parentIndex: index,
      items: item.subItems,
      onClickItem: onClickItem,
      selectedItem: selectedItem,
      inverse: inverse,
      redirect: redirect
    })));
  }));
};

var DefaultLayout = function DefaultLayout(props) {
  return React.createElement(Content, _assign({}, props));
};

var Dropdown = function Dropdown(_a) {
  var inverse = _a.inverse,
      selectedItem = _a.selectedItem,
      _b = _a.theme,
      theme = _b === void 0 ? 'default' : _b,
      children = _a.children;

  if (!selectedItem) {
    return null;
  }

  var _c = useState(false),
      open = _c[0],
      setOpen = _c[1];

  var colors = getSelectedTheme(theme).colors;
  useEffect(function () {
    if (selectedItem.url) {
      setOpen(false);
    }
  }, [selectedItem]);
  return jsxs(Fragment, {
    children: [jsxs("div", _assign({
      "data-testid": 'nav-dropdown',
      sx: {
        borderLeft: "4px solid " + colors.green40,
        padding: 'section20',
        '&:hover': {
          cursor: 'pointer'
        },
        background: "" + (inverse ? colors.green80 : colors.black00),
        borderBottom: "1px solid " + (inverse ? colors.green70 : colors.black20),
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
      },
      onClick: function onClick() {
        return setOpen(!open);
      }
    }, {
      children: [jsx(TypographyScale, _assign({
        inverse: inverse,
        color: 'default',
        variant: 'body3'
      }, {
        children: selectedItem.title
      }), void 0), jsx(SystemIcon, {
        inverse: inverse,
        color: 'default',
        name: open ? ESystemIconNames.CHEVRON_UP : ESystemIconNames.CHEVRON_DOWN
      }, void 0)]
    }), void 0), open && children]
  }, void 0);
};

var MobileLayout = function MobileLayout(props) {
  var inverse = props.inverse,
      selectedItem = props.selectedItem;
  return React.createElement(Dropdown, _assign({}, {
    inverse: inverse,
    selectedItem: selectedItem
  }), React.createElement(Content, _assign({}, props)));
};

var SideNav = function SideNav(_a) {
  var _b = _a.theme,
      theme = _b === void 0 ? 'default' : _b,
      inverse = _a.inverse,
      items = _a.items,
      currentUrl = _a.currentUrl,
      _c = _a.onClick,
      onClick = _c === void 0 ? function () {} : _c,
      _d = _a.redirect,
      redirect = _d === void 0 ? true : _d,
      isMobile = _a.isMobile;

  var _e = useState(null),
      selectedItem = _e[0],
      setSelectedItem = _e[1];

  useEffect(function () {
    setSelectedItem(findSelectedItem({
      currentUrl: currentUrl,
      items: items
    }));
  }, []);

  var onClickItem = function onClickItem(_a) {
    var item = _a.item,
        index = _a.index,
        subItemIndex = _a.subItemIndex;
    var title = item.title,
        url = item.url;
    setSelectedItem({
      index: index,
      title: title,
      url: url,
      subItemIndex: subItemIndex
    });
    onClick({
      title: title,
      url: url
    });
  };

  var selectedTheme = getSelectedTheme(theme);
  var Layout = isMobile ? MobileLayout : DefaultLayout;
  return jsx(ThemeProvider, _assign({
    theme: selectedTheme
  }, {
    children: jsx("nav", _assign({
      sx: {
        display: 'flex',
        flexDirection: 'column',
        boxShadow: ['level01', null, 'none'],
        position: 'sticky',
        top: [0, null, '56px', '88px']
      }
    }, {
      children: jsx(Layout, _assign({}, {
        items: items,
        inverse: inverse,
        redirect: redirect,
        selectedItem: selectedItem,
        onClickItem: onClickItem
      }), void 0)
    }), void 0)
  }), void 0);
};

[{
  title: 'Atlas',
  url: '/atlas',
  subItems: [{
    title: 'Database',
    url: '/atlas/database'
  }, {
    title: 'Data Lake',
    url: '/atlas/data-lake',
    icon: jsx("div", _assign({
      sx: {
        fill: 'blue60',
        stroke: 'blue60',
        display: 'flex',
        alignItems: 'center'
      }
    }, {
      children: jsx(SystemIcon, {
        name: ESystemIconNames.EXTERNAL,
        inheritColor: true
      }, void 0)
    }), void 0)
  }, {
    title: 'Charts',
    url: '/products/charts'
  }]
}, {
  title: 'Enterprise Advanced',
  url: '/products/mongodb-enterprise-advanced',
  subItems: [{
    title: 'Enterprise Server',
    url: '/try/download/enterprise'
  }, {
    title: 'Ops Manager',
    url: '/products/ops-manager'
  }]
}, {
  title: 'Realm',
  url: '/realm',
  subItems: [{
    title: 'Edge-to-Cloud Sync',
    url: '/realm/mobile/sync'
  }, {
    title: 'Functions, APIs, and more',
    url: '/realm/appdev'
  }]
}, {
  title: 'Community Edition',
  url: '/try/download/community',
  subItems: [{
    title: 'Community Server',
    url: '/try/download/community'
  }, {
    title: 'Cloud Manager',
    url: '/cloud/cloud-manager'
  }]
}, {
  title: 'Tools',
  subItems: [{
    title: 'Compass',
    url: '/products/compass'
  }, {
    title: 'VS Code Plugin',
    url: '/products/vs-code'
  }]
}];

var getPages = function getPages(_a) {
  var currentPage = _a.currentPage,
      last = _a.pages,
      maxPages = _a.maxPages,
      isMobile = _a.isMobile;
  var range = Array();
  var responsiveMaxPages = isMobile ? 4 : maxPages;

  if (!responsiveMaxPages || responsiveMaxPages === last) {
    return __spreadArray([], Array(last)).map(function (_, index) {
      return index + 1;
    });
  }

  var limit = function limit(side) {
    var firstOrLast = currentPage === 1 || currentPage === last;
    var pages = firstOrLast ? responsiveMaxPages : responsiveMaxPages - 2;
    var even = pages % 2 === 0;
    var range = pages / 2;

    if (even) {
      return side === 'left' ? currentPage - range : currentPage + range;
    }

    return side === 'left' ? currentPage - Math.floor(range) : currentPage + Math.ceil(range);
  };

  var pageInsideTheLimit = function pageInsideTheLimit(page) {
    return page === 1 || page === last || page >= limit('left') && page <= limit('right') && range.length < responsiveMaxPages - 1;
  };

  for (var page = 1; page <= last; page++) {
    if (pageInsideTheLimit(page)) {
      range.push(page);
    }
  }

  var steps = Array();

  for (var index = 0; index < range.length; index++) {
    var prev = range[index - 1];
    var value = range[index];

    if (prev && prev !== value - 1) {
      steps.push('...');
    }

    steps.push(value);
  }

  return steps;
};

var getColor = function getColor(_a) {
  var active = _a.active,
      inverse = _a.inverse;

  if (inverse) {
    return active ? 'blue80' : 'black00';
  }

  return active ? 'black00' : 'blue80';
};

var getBackgroundColor = function getBackgroundColor(_a) {
  var active = _a.active,
      inverse = _a.inverse,
      dots = _a.dots;

  if (dots) {
    return active ? 'green40' : inverse ? 'green60' : 'blue10';
  }

  return inverse && active ? 'black00' : active ? 'blue80' : 'transparent';
};

var Dots = function Dots(_a) {
  var currentPage = _a.currentPage,
      pages = _a.pages,
      inverse = _a.inverse,
      _b = _a.onChangePage,
      onChangePage = _b === void 0 ? function () {} : _b;

  var _c = useState(currentPage),
      page = _c[0],
      setPage = _c[1];

  var handleOnClick = function handleOnClick(selectedPage) {
    setPage(selectedPage);
    onChangePage(selectedPage);
  };

  return jsx("div", _assign({
    "data-testid": 'dots-container',
    sx: {
      bg: inverse ? 'black10' : 'green80',
      borderRadius: 'inc40',
      padding: defaultTheme.space.section00 + " 12px",
      display: 'inline-flex',
      alignItems: 'center'
    }
  }, {
    children: __spreadArray([], Array(pages)).map(function (_, index) {
      var active = page - 1 === index;
      return jsx("div", {
        "aria-label": "page " + (index + 1),
        onClick: function onClick() {
          return !active && handleOnClick(index + 1);
        },
        sx: {
          backgroundColor: getBackgroundColor({
            active: active,
            inverse: inverse,
            dots: true
          }),
          borderRadius: '4px',
          width: active ? '26px' : '8px',
          height: '8px',
          marginLeft: index === 0 ? 0 : '6px'
        }
      }, index);
    })
  }), void 0);
};

var Arrow = function Arrow(_a) {
  var _b = _a.direction,
      direction = _b === void 0 ? 'left' : _b,
      inverse = _a.inverse,
      customStyles = _a.customStyles,
      isMobile = _a.isMobile,
      _c = _a.onClick,
      onClick = _c === void 0 ? function () {} : _c;
  var drawSpecs = {
    left: {
      desktop: 'M1.15003 14.2929C0.75951 14.6834 0.75951 15.3166 1.15003 15.7071L7.51399 22.0711C7.90452 22.4616 8.53768 22.4616 8.92821 22.0711C9.31873 21.6805 9.31873 21.0474 8.92821 20.6568L3.27135 15L8.92821 9.34314C9.31873 8.95261 9.31873 8.31945 8.92821 7.92892C8.53768 7.5384 7.90452 7.5384 7.51399 7.92892L1.15003 14.2929ZM49 14L1.85714 14L1.85714 16L49 16L49 14Z',
      mobile: 'M0.864323 14.2929C0.473797 14.6834 0.473797 15.3166 0.864323 15.7071L7.22828 22.0711C7.61881 22.4616 8.25197 22.4616 8.6425 22.0711C9.03302 21.6805 9.03302 21.0474 8.6425 20.6568L2.98564 15L8.6425 9.34314C9.03302 8.95262 9.03302 8.31945 8.6425 7.92893C8.25197 7.5384 7.61881 7.5384 7.22828 7.92893L0.864323 14.2929ZM33 14L1.57143 14L1.57143 16L33 16L33 14Z'
    },
    right: {
      desktop: 'M47.85 15.7071C48.2405 15.3166 48.2405 14.6834 47.85 14.2929L41.486 7.92894C41.0955 7.53842 40.4623 7.53841 40.0718 7.92894C39.6813 8.31946 39.6813 8.95263 40.0718 9.34315L45.7286 15L40.0718 20.6569C39.6813 21.0474 39.6813 21.6806 40.0718 22.0711C40.4623 22.4616 41.0955 22.4616 41.486 22.0711L47.85 15.7071ZM-1.3005e-07 16L47.1429 16L47.1429 14L1.3005e-07 14L-1.3005e-07 16',
      mobile: 'M32.1357 15.7071C32.5262 15.3166 32.5262 14.6834 32.1357 14.2929L25.7717 7.92894C25.3812 7.53841 24.748 7.53841 24.3575 7.92894C23.967 8.31946 23.967 8.95263 24.3575 9.34315L30.0144 15L24.3575 20.6569C23.967 21.0474 23.967 21.6805 24.3575 22.0711C24.748 22.4616 25.3812 22.4616 25.7717 22.0711L32.1357 15.7071ZM-8.66998e-08 16L31.4286 16L31.4286 14L8.66998e-08 14L-8.66998e-08 16Z'
    }
  };
  var sizes = defaultTheme.sizes,
      colors = defaultTheme.colors;
  var width = isMobile ? sizes.inc30 : sizes.inc50;
  return jsx("svg", _assign({
    "aria-label": direction + " arrow",
    width: width,
    viewBox: "0 0 " + width + " 30",
    height: '30',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
    sx: _assign({
      '&:hover': {
        cursor: 'pointer'
      }
    }, customStyles),
    onClick: onClick
  }, {
    children: jsx("path", {
      d: drawSpecs[direction][isMobile ? 'mobile' : 'desktop'],
      fill: inverse ? colors.green40 : colors.green60
    }, void 0)
  }), void 0);
};

var Default = function Default(_a) {
  var inverse = _a.inverse,
      currentPage = _a.currentPage,
      pages = _a.pages,
      maxPages = _a.maxPages,
      isMobile = _a.isMobile,
      _b = _a.onChangePage,
      onChangePage = _b === void 0 ? function () {} : _b;

  var _c = useState(currentPage),
      page = _c[0],
      setPage = _c[1];

  var handleOnClick = function handleOnClick(selectedPage) {
    if (selectedPage <= 0 || selectedPage > pages || typeof selectedPage === 'string') {
      return;
    }

    setPage(selectedPage);
    onChangePage(selectedPage);
  };

  return jsxs("div", _assign({
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center'
    }
  }, {
    children: [jsx(Arrow, {
      inverse: inverse,
      customStyles: {
        marginRight: ['inc40', null, 'inc70']
      },
      onClick: function onClick() {
        return handleOnClick(page - 1);
      }
    }, void 0), jsx("div", _assign({
      sx: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline'
      }
    }, {
      children: getPages({
        currentPage: page,
        pages: pages,
        maxPages: maxPages,
        isMobile: isMobile
      }).map(function (value, index) {
        var active = page === value;
        return jsx("div", _assign({
          "aria-label": "page " + value,
          onClick: function onClick() {
            return handleOnClick(value);
          },
          sx: {
            width: 'inc30',
            height: 'inc30',
            lineHeight: 'inc30',
            textAlign: 'center',
            bg: getBackgroundColor({
              active: active,
              inverse: inverse
            }),
            borderRadius: 'circle',
            marginLeft: value === 0 ? '0' : 'inc20',
            '&:hover': {
              cursor: typeof value === 'number' ? 'pointer' : 'default'
            }
          }
        }, {
          children: jsx(TypographyScale, _assign({
            variant: 'body3',
            customStyles: {
              color: getColor({
                active: active,
                inverse: inverse
              })
            }
          }, {
            children: value
          }), void 0)
        }), index);
      })
    }), void 0), jsx(Arrow, _assign({}, {
      inverse: inverse,
      direction: 'right'
    }, {
      customStyles: {
        marginLeft: ['inc40', null, 'inc70']
      },
      onClick: function onClick() {
        return handleOnClick(page + 1);
      }
    }), void 0)]
  }), void 0);
};

var Pagination = function Pagination(_a) {
  var _b = _a.type,
      type = _b === void 0 ? 'default' : _b,
      inverse = _a.inverse,
      currentPage = _a.currentPage,
      pages = _a.pages,
      maxPages = _a.maxPages,
      isMobile = _a.isMobile,
      _c = _a.onChangePage,
      onChangePage = _c === void 0 ? function () {} : _c;
  var Layout = type === 'default' ? Default : Dots;
  return React.createElement(ThemeProvider, {
    theme: defaultTheme
  }, React.createElement(Layout, _assign({}, {
    inverse: inverse,
    currentPage: currentPage,
    pages: pages,
    onChangePage: onChangePage,
    maxPages: maxPages,
    isMobile: isMobile
  })));
};

var AUTO_DISMISS_DELAY = 3000;

var getStyles = function getStyles(styleState, theme) {
  var postSubmissionState = styleState.postSubmissionState;
  return {
    wrapper: {
      width: ['100%', null, null, 584],
      height: 'fit-content',
      minHeight: '100vh',
      backgroundColor: theme.colors.background.containerInverse,
      padding: ['inc40', null, null, theme.space.inc70 + " " + theme.space.inc90],
      display: 'flex',
      flexDirection: 'column'
    },
    closeButtonContainer: {
      marginLeft: 'auto',
      marginBottom: 'inc80'
    },
    contentContainer: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      margin: 'auto'
    },
    titleContainer: {
      marginBottom: postSubmissionState ? ['inc30', null, null, 'inc50'] : 'inc60'
    },
    subtitle: {
      marginBottom: ['inc60', null, null, 'inc80']
    },
    descriptionContainer: {
      textAlign: 'center'
    },
    postSubmissionButtonContainer: {
      marginTop: ['inc60', null, null, 'inc80']
    }
  };
};

var Flyout = function Flyout(_a) {
  var children = _a.children,
      flyoutLink = _a.flyoutLink,
      open = _a.open,
      handleState = _a.handleState;

  if (!flyoutLink) {
    return jsx(Fragment, {
      children: children
    }, void 0);
  }

  var handleFlyout = function handleFlyout(e) {
    e.preventDefault();
    handleState(true);
  };

  useEffect(function () {
    if (flyoutLink) {
      document.querySelectorAll("a[href=\"#" + flyoutLink + "\"]").forEach(function (link) {
        link.addEventListener('click', handleFlyout);
      });
      return function () {
        document.querySelectorAll("a[href=\"#" + flyoutLink + "\"]").forEach(function (link) {
          link.removeEventListener('click', handleFlyout);
        });
      };
    }
  }, [flyoutLink]);
  return jsx("div", _assign({
    "data-testid": "form-panel-" + (open ? 'open' : 'close'),
    sx: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: '1000000'
    }
  }, {
    children: jsx("div", _assign({
      sx: {
        position: 'fixed',
        width: '100%'
      }
    }, {
      children: jsx("div", _assign({
        sx: {
          position: 'absolute',
          transition: "right " + defaultTheme.motion.inc10 + " ease",
          right: open ? '0' : '-100%',
          top: 0,
          maxWidth: ['100%', null, '375px', '584px'],
          width: '100vw',
          height: '100vh',
          overflowY: 'auto',
          overflowX: 'hidden'
        }
      }, {
        children: children
      }), void 0)
    }), void 0)
  }), void 0);
};

var FormPanel = function FormPanel(_a) {
  var _b = _a.inverse,
      inverse = _b === void 0 ? true : _b,
      _c = _a.postSubmissionState,
      postSubmissionState = _c === void 0 ? false : _c,
      children = _a.children,
      onClose = _a.onClose,
      onPostSubmissionButtonClick = _a.onPostSubmissionButtonClick,
      postSubmissionTitle = _a.postSubmissionTitle,
      postSubmissionDescription = _a.postSubmissionDescription,
      postSubmissionButtonText = _a.postSubmissionButtonText,
      title = _a.title,
      subtitle = _a.subtitle,
      flyoutLink = _a.flyoutLink,
      _d = _a.dismissPanelOnPostSubmissionClick,
      dismissPanelOnPostSubmissionClick = _d === void 0 ? false : _d,
      _e = _a.autoDismissPanel,
      autoDismissPanel = _e === void 0 ? false : _e;
  var styles = getStyles({
    postSubmissionState: postSubmissionState
  }, defaultTheme);
  var ref = useRef(null);

  var _f = useState(false),
      flyoutState = _f[0],
      setFlyoutState = _f[1];

  useOnClickOutside(ref, function () {
    return setFlyoutState(false);
  });
  var escapeHandler = useCallback(function (event) {
    if (event.key === 'Escape') {
      setFlyoutState(false);
    }
  }, []);
  useEffect(function () {
    document.addEventListener('keydown', escapeHandler);
    return function () {
      document.removeEventListener('keydown', escapeHandler);
    };
  }, []);
  useEffect(function () {
    if (autoDismissPanel) {
      var timeId_1 = setTimeout(function () {
        setFlyoutState(false);
      }, AUTO_DISMISS_DELAY);
      return function () {
        clearTimeout(timeId_1);
      };
    }
  }, [autoDismissPanel]);
  var renderTitle = useCallback(function (titleText) {
    if (titleText) {
      return jsx("div", _assign({
        "aria-label": 'panel-title',
        sx: styles.titleContainer
      }, {
        children: jsx(TypographyScale, _assign({
          variant: 'heading4',
          inverse: inverse,
          customStyles: {
            fontWeight: 'normal'
          },
          customElement: 'span'
        }, {
          children: titleText
        }), void 0)
      }), void 0);
    }

    return null;
  }, [inverse, styles.titleContainer]);

  var renderSubtitle = function renderSubtitle(subtitle) {
    if (subtitle) {
      return jsx(TypographyScale, _assign({
        sx: styles.subtitle,
        variant: 'body2',
        inverse: inverse
      }, {
        children: subtitle
      }), void 0);
    }

    return null;
  };

  var renderPanelContent = function renderPanelContent() {
    if (postSubmissionState) {
      return jsxs(Fragment, {
        children: [renderTitle(postSubmissionTitle), postSubmissionDescription && jsx("div", _assign({
          "aria-label": 'post-submission-description',
          sx: styles.descriptionContainer
        }, {
          children: jsx(TypographyScale, _assign({
            variant: 'body1',
            inverse: inverse
          }, {
            children: postSubmissionDescription
          }), void 0)
        }), void 0), !!onPostSubmissionButtonClick && postSubmissionButtonText && jsx("div", _assign({
          "aria-label": 'post-submission-button',
          sx: styles.postSubmissionButtonContainer
        }, {
          children: jsx(Button, _assign({
            onClick: function onClick() {
              onPostSubmissionButtonClick();

              if (dismissPanelOnPostSubmissionClick) {
                !!onClose && onClose(true);
                setFlyoutState(false);
              }
            },
            inverse: inverse,
            size: 'large'
          }, {
            children: postSubmissionButtonText
          }), void 0)
        }), void 0)]
      }, void 0);
    }

    return jsxs(Fragment, {
      children: [renderTitle(title), renderSubtitle(subtitle), children]
    }, void 0);
  };

  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsx(Flyout, _assign({}, {
      flyoutLink: flyoutLink,
      open: flyoutState,
      handleState: function handleState(state) {
        return setFlyoutState(state);
      }
    }, {
      children: jsxs("div", _assign({
        ref: ref,
        sx: styles.wrapper
      }, {
        children: [jsx("span", _assign({
          sx: styles.closeButtonContainer
        }, {
          children: jsx(ButtonIcon, {
            iconName: ESystemIconNames.CLOSE,
            onClick: function onClick() {
              setFlyoutState(false);
              !!onClose && onClose(true);
            },
            inverse: inverse,
            variant: 'outline',
            size: 'large',
            keepMobileOutline: true
          }, void 0)
        }), void 0), jsx("div", _assign({
          sx: styles.contentContainer
        }, {
          children: renderPanelContent()
        }), void 0)]
      }), void 0)
    }), void 0)
  }), void 0);
};

var isRequired = function isRequired() {
  var required = function required(value) {
    return !value || value === '' ? 'This field is required' : '';
  };

  required.rule = 'required';
  return required;
};

var hasMinimumLength = function hasMinimumLength(minimumLength) {
  var message = "This field must have at least " + minimumLength + " characters.";
  return function hasMinimumLength(value) {
    return value.trim().length < minimumLength ? message : '';
  };
};

var doesNotContainEmail = function doesNotContainEmail(email) {
  var message = 'This field cannot contain your email address.';
  var splitEmail = email.split('@');
  return function doesNotContainEmail(value) {
    return email && splitEmail && value.includes(splitEmail[0]) ? message : '';
  };
};

var containsEmail = function containsEmail() {
  var emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+([.][a-zA-Z0-9-]{2,})+$/;
  return function containsEmail(value) {
    return value.match(emailRegex) ? '' : 'Please include a valid domain in the email address.';
  };
};

var passwordRequirementsDefault = {
  title: 'Your password must:',
  list: ['Contain at least 8 characters.', 'Contain unique characters, numbers, or symbols.', ' Not contain your email address.']
};
var termsDefault = jsxs(Fragment$1, {
  children: ["I agree to the", ' ', jsx("a", _assign({
    sx: {
      textDecoration: 'none',
      color: 'text.default',
      fontWeight: 'bold'
    },
    href: 'https://www.mongodb.com/legal/privacy-policy'
  }, {
    children: "Terms & Conditions"
  }), void 0), ' ', "and", ' ', jsx("a", _assign({
    sx: {
      textDecoration: 'none',
      color: 'text.default',
      fontWeight: 'bold'
    },
    href: 'https://cloud.mongodb.com/links/terms-of-service'
  }, {
    children: "Privacy Policy"
  }), void 0)]
}, void 0);
var formDefaultProps = {
  passwordRequirements: passwordRequirementsDefault,
  accountSignInLink: 'https://account.mongodb.com/account/login',
  accountSignInText: 'Sign in',
  accountText: 'Already have an account? ',
  googleSSOText: 'Sign up with Google',
  separatorText: 'or',
  submitButtonText: 'Create your Atlas account',
  terms: termsDefault
};

var GoogleSSOButton = function GoogleSSOButton(_a) {
  var _b = _a.text,
      text = _b === void 0 ? 'Sign up with Google' : _b,
      target = _a.target,
      disabled = _a.disabled,
      onClick = _a.onClick,
      href = _a.href,
      customStyles = _a.customStyles;
  return jsx(ThemeProvider, _assign({
    theme: defaultTheme
  }, {
    children: jsxs(Button, _assign({
      target: target,
      disabled: disabled,
      customStyles: _assign({
        backgroundColor: 'black00',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }, customStyles),
      onClick: onClick,
      href: href
    }, {
      children: [jsx(ThirdPartyLogo, {
        alt: 'Google Logo',
        variant: EThirdPartyLogoVariant.GOOGLE_ICON,
        imageWidth: '16px'
      }, void 0), text]
    }), void 0)
  }), void 0);
};

var SignUpForm = function SignUpForm(_a) {
  var _b;

  var formId = _a.formId,
      formName = _a.formName,
      onSubmit = _a.onSubmit,
      isSubmitting = _a.isSubmitting,
      _c = _a.passwordRequirements,
      passwordRequirements = _c === void 0 ? formDefaultProps.passwordRequirements : _c,
      _d = _a.accountSignInLink,
      accountSignInLink = _d === void 0 ? formDefaultProps.accountSignInLink : _d,
      _e = _a.accountSignInText,
      accountSignInText = _e === void 0 ? formDefaultProps.accountSignInText : _e,
      _f = _a.accountText,
      accountText = _f === void 0 ? formDefaultProps.accountText : _f,
      _g = _a.googleSSOText,
      googleSSOText = _g === void 0 ? formDefaultProps.googleSSOText : _g,
      googleSSOHref = _a.googleSSOHref,
      googleSSOOnClick = _a.googleSSOOnClick,
      _h = _a.separatorText,
      separatorText = _h === void 0 ? formDefaultProps.separatorText : _h,
      _j = _a.submitButtonText,
      submitButtonText = _j === void 0 ? formDefaultProps.submitButtonText : _j,
      _k = _a.terms,
      terms = _k === void 0 ? formDefaultProps.terms : _k;

  var _l = useState(''),
      email = _l[0],
      setEmail = _l[1];

  var _m = useState(false),
      passwordShow = _m[0],
      setPasswordShow = _m[1];

  var onClickPasswordIcon = useCallback(function (passwordFlag) {
    setPasswordShow(!passwordFlag);
  }, [setPasswordShow]);
  var passwordIcon = passwordShow ? ESystemIconNames.PASSWORD_HIDE : ESystemIconNames.PASSWORD_VIEW;

  var _o = useState(false),
      passwordHintVisibility = _o[0],
      setPasswordHintVisibility = _o[1];

  var onValidatePasswordField = useCallback(function (errors) {
    if (errors === void 0) {
      errors = [];
    }

    errors.length > 0 ? setPasswordHintVisibility(true) : setPasswordHintVisibility(false);
  }, [setPasswordHintVisibility]);
  var onValidatePasswordForm = useCallback(function (formData) {
    formData.every(function (_a) {
      var isValidated = _a.isValidated;
      return isValidated;
    }) > 0 ? setPasswordHintVisibility(true) : setPasswordHintVisibility(false);
  }, [setPasswordHintVisibility]);
  return jsxs(FormGeneric, _assign({
    id: formId,
    name: formName,
    onSubmit: onSubmit,
    onChange: function onChange(form) {
      setEmail(form.email || '');
    },
    onValidate: onValidatePasswordForm,
    customStyles: {
      gridColumn: ['1/ span 6', null, null, '2/span 4'],
      margin: 'auto'
    }
  }, {
    children: [jsx(Field, {
      component: 'text-input',
      validators: [isRequired()],
      name: 'firstName',
      label: 'First Name',
      autoFocus: true
    }, void 0), jsx(Field, {
      component: 'text-input',
      validators: [isRequired()],
      name: 'lastName',
      label: 'Last Name'
    }, void 0), jsx(Field, {
      component: 'text-input',
      name: 'company',
      label: 'Company'
    }, void 0), jsx(Field, {
      component: 'text-input',
      validators: [isRequired(), containsEmail()],
      name: 'email',
      label: 'Email',
      type: 'email'
    }, void 0), jsx(Field, {
      component: 'text-input',
      validators: [isRequired(), hasMinimumLength(8), doesNotContainEmail(email)],
      name: 'password',
      label: 'Password',
      type: passwordShow ? 'text' : 'password',
      iconPosition: 'right',
      iconName: passwordIcon,
      onIconClick: function onIconClick() {
        return onClickPasswordIcon(passwordShow);
      },
      onValidate: onValidatePasswordField
    }, void 0), passwordHintVisibility && jsxs(Panel, _assign({
      borderRadius: 'inc30',
      borderColor: 'black20',
      bgColor: 'black00',
      sx: {
        padding: '24px'
      }
    }, {
      children: [(passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.title) && jsx(TypographyScale, _assign({
        variant: 'body4',
        customStyles: {
          fontWeight: 500
        }
      }, {
        children: passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.title
      }), void 0), (passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.list) && jsx("ul", _assign({
        sx: {
          paddingX: 'inc30'
        }
      }, {
        children: (_b = passwordRequirements === null || passwordRequirements === void 0 ? void 0 : passwordRequirements.list) === null || _b === void 0 ? void 0 : _b.map(function (requirement, index) {
          return jsx("li", _assign({
            sx: {
              listStyleType: 'disc'
            }
          }, {
            children: jsx(TypographyScale, _assign({
              variant: 'body4',
              customStyles: {
                lineHeight: '24px'
              }
            }, {
              children: requirement
            }), void 0)
          }), "requirement-" + index);
        })
      }), void 0)]
    }), void 0), jsx(Field, {
      component: 'checkbox',
      validators: [isRequired()],
      name: 'terms',
      label: terms
    }, void 0), jsxs("div", _assign({
      sx: {
        display: 'flex',
        flexDirection: 'column'
      }
    }, {
      children: [jsx(Button, _assign({
        type: 'submit',
        customStyles: {
          width: '100%',
          justifyContent: 'center'
        },
        disabled: isSubmitting
      }, {
        children: submitButtonText
      }), void 0), jsx(TypographyScale, _assign({
        variant: 'body4',
        customStyles: {
          display: 'block',
          textAlign: 'center',
          marginTop: 'inc30',
          marginBottom: 'inc30'
        }
      }, {
        children: separatorText
      }), void 0), jsx(GoogleSSOButton, {
        onClick: googleSSOOnClick,
        href: googleSSOHref,
        text: googleSSOText,
        disabled: isSubmitting
      }, void 0), jsxs(TypographyScale, _assign({
        variant: 'body4',
        customStyles: {
          display: 'block',
          textAlign: 'center',
          marginTop: ['inc50', 'inc60']
        }
      }, {
        children: [accountText, ' ', jsx("a", _assign({
          sx: {
            textDecoration: 'none',
            color: 'text.default',
            fontWeight: 'bold'
          },
          href: accountSignInLink
        }, {
          children: accountSignInText
        }), void 0)]
      }), void 0)]
    }), void 0)]
  }), void 0);
};

var SignUpCard = function SignUpCard(_a) {
  var onSubmit = _a.onSubmit,
      isSubmitting = _a.isSubmitting,
      _b = _a.title,
      title = _b === void 0 ? 'Sign Up' : _b,
      _c = _a.description,
      description = _c === void 0 ? 'See what Atlas is capable of for free' : _c,
      atlasError = _a.atlasError,
      props = __rest(_a, ["onSubmit", "isSubmitting", "title", "description", "atlasError"]);

  var BASE_GRID_COLUMN = '2/span 4';
  return jsxs(Panel, _assign({
    borderRadius: 'inc70',
    borderColor: 'black20',
    bgColor: 'black00',
    boxShadow: 'level01',
    sx: {
      display: 'grid',
      gridTemplateColumns: 'repeat(6, 1fr)',
      gap: 'inc40',
      padding: ['24px', null, '40px', '64px 0px'],
      width: '100%',
      maxWidth: '700px',
      margin: ['auto', null, null, '0']
    }
  }, {
    children: [title && jsx(TypographyScale, _assign({
      variant: 'heading4',
      customStyles: {
        gridColumn: BASE_GRID_COLUMN,
        textAlign: 'center',
        fontWeight: 400
      }
    }, {
      children: title
    }), void 0), description && jsx(TypographyScale, _assign({
      variant: 'body2',
      customStyles: {
        gridColumn: BASE_GRID_COLUMN,
        fontWeight: 400,
        color: 'green80',
        display: 'block',
        textAlign: 'center',
        paddingBottom: '40px',
        paddingTop: '16px'
      }
    }, {
      children: description
    }), void 0), atlasError && jsx("div", _assign({
      sx: {
        gridColumn: ['1/ span 6', null, null, '2/span 4'],
        width: '100%',
        //need to add token for maxWidth
        maxWidth: '456px',
        marginBottom: 'inc60',
        marginLeft: 'auto',
        marginRight: 'auto'
      }
    }, {
      children: jsx(Aside, {
        variant: EAsideVariant.ERROR,
        text: atlasError
      }, void 0)
    }), void 0), jsx(SignUpForm, _assign({
      onSubmit: onSubmit,
      isSubmitting: isSubmitting
    }, props), void 0)]
  }), void 0);
};

export { ARROW_DIRECTION, Accordion, Article, Aside, BrandedIcon, Button, ButtonIcon, CTALockup, Checkbox, CodePanel, CodeSnippet, DownloadItem, EBrandedIcons, ELanguageModeMap, ELinkVariant, ELogoVariant, ESingleImageVariant, ESystemIconNames, EThirdPartyLogoVariant, Eyebrow, FeaturedCard, Field, FlashCard, FormGeneric, FormPanel, Globals, GoogleSSOButton, GridLayout, HorizontalRule, LeadPageInfoSideBar, Lightbox, Link, List, MDBLogo, Mark, MasonryCard, Pagination, Panel, Pill, PromoImage, ScrollyStoryCard, SectionIntro, Select, ShareBar, SideNav, SignUpCard, SingleImage, SpeakerLockup, SystemIcon, Tag, TextArea, TextInput, ThirdPartyLogo, Tooltip, TypographyScale, VerticalSectionSpacing };